var salestoolkitStartTime = new Date();
window.forceLibraryUpdate = false; //Variable set to override the "doNotServerUpdate" when a tag is applied in the preview page.
/**
 * Notification Translation Keys
 *
 * notificationFavouritesAdded			Added {0} to Favourites
 * notificationFavouritesrtAdded		Added {0} to Cart
 * notificationCarRemoved				Removed {0} from Favourites
 * notificationCatRemoved				Removed {0} from Cart
 * notificationCartRemovedAll			Removed all items from Cart
 * notificationCartShareSuccess			Cart contents sent successfully
 * notificationCartShareSuccessPartial	Cart contents sent to {0} of {1} recipients
 * notificationCartShareFailure			Cart contents could not be sent
 * notificationCartShareOffline			Cart contents will be sent when you are next online
 * notificationDownloading				{0} is downloading...
 * notificationProfileUpdated			Profile was successfully updated
 * notificationProfileVerification		Password successfully updated
 *
 * toolkitNotificationHeadingCart		Cart
 * toolkitNotificationHeadingDownloads	Downloads
 * toolkitNotificationHeadingFavourites	Favourites
 * toolkitNotificationHeadingInfo		Info
 * toolkitNotificationHeadingProfile	Profile
 * toolkitNotificationHeadingSystem		System
 * toolkitNotificationHeadingConsent	Consent
 */

//MODAL BRIDGE
/**
 * =================================================================================
 * Generic & Safe jQuery Bridge for Bootstrap 5 Modal
 *
 * This script checks if the Bootstrap 3 $.fn.modal plugin already exists.
 * If it doesn't, and if Bootstrap 5 is present, it creates a compatibility
 * bridge. This allows the same script to be used on pages with B3 or B5.
 * =================================================================================
 */
(function ($) {
  "use strict";

  // 1. Check if the B3 modal plugin already exists OR if B5 is not loaded.
  if (typeof $.fn.modal !== "undefined" || typeof bootstrap === "undefined") {
    return;
  }

  // 2. If we're here, it means B5 is loaded and there's no B3 modal plugin.
  const PLUGIN_NAME = "modal";
  const DATA_KEY = "bs.modal"; // Bootstrap 5's internal data key

  $.fn[PLUGIN_NAME] = function (config) {
    return this.each(function () {
      const $this = $(this);
      let instance = $this.data(DATA_KEY);

      // Initialize the modal instance if it doesn't exist
      if (!instance) {
        const options = typeof config === "object" ? config : {};
        instance = new bootstrap.Modal(this, options);
        $this.data(DATA_KEY, instance);
      }

      // Handle commands ('show', 'hide', etc.)
      if (typeof config === "string") {
        const command = config;
        if (typeof instance[command] === "undefined") {
          throw new TypeError(`No method named "${command}"`);
        }
        instance[command]();
      } else if (config === undefined || typeof config === "object") {
        // If called with no argument or with an options object, show the modal by default
        instance.show();
      }
    });
  };

  /* ========================================================================
   * BRIDGE 2: Dropdown Hover Fix (Metronic Navbar)
   * Replicates behavior of bootstrap-hover-dropdown.min.js for BS5
   * ======================================================================== */
  $(function() {
      var hoverTimeout;
      
      // Select only the dropdowns in the top navigation bar
      var navDropdowns = document.querySelectorAll('.page-header .navbar-nav .dropdown');

      navDropdowns.forEach(function(dropdown) {
          var toggleBtn = dropdown.querySelector('.dropdown-toggle');
          
          // Safety check
          if (!toggleBtn) return;

          // Initialize BS5 dropdown
          var bsDropdown = bootstrap.Dropdown.getOrCreateInstance(toggleBtn);

          dropdown.addEventListener('mouseenter', function() {
              // If user returns to the trigger/menu before timeout finishes, cancel hide
              if (hoverTimeout) clearTimeout(hoverTimeout);
              bsDropdown.show();
          });

          dropdown.addEventListener('mouseleave', function() {
              // Add 300ms delay to allow crossing the gap
              hoverTimeout = setTimeout(function() {
                  bsDropdown.hide();
              }, 100);
          });
      });
  });
})(jQuery);

var settings = window.toolkitSettings || {};
if (!settings.baseUrl) {
  settings.baseUrl =
    "https://www.atheneum.co/restful/d7f5760b6e5f3cc7016e88acfcf10f97";
}

var activePresentationId = null;

SalesToolkit = new Atheneum(settings);

SalesToolkit.getHomeCollectionID = function () {
  var homeCollectionId =
    SalesToolkit.User.startupCollection ||
    SalesToolkit.Theme.getStringProperty("startupCollection");
  return homeCollectionId;
};

function toggleTestMode(e) {
  if (e) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
  }

  let body = document.body;
  body.classList.toggle("testMode");
  if (body.classList.contains("testMode")) {
    localStorage["testMode"] = "true";
  } else {
    delete localStorage["testMode"];
  }

  let borderUp = document.querySelector("#testModeBorderUp");
  if (!borderUp) {
    borderUp = htmlToElement(
      '<div id="testModeBorderUp" class="testModeBorder"></div>'
    );
    body.appendChild(borderUp);
  }

  let borderDown = document.querySelector("#testModeBorderDown");
  if (!borderDown) {
    borderDown = htmlToElement(
      '<div id="testModeBorderDown" class="testModeBorder"></div>'
    );
    body.appendChild(borderDown);
  }

  let borderLeft = document.querySelector("#testModeBorderLeft");
  if (!borderLeft) {
    borderLeft = htmlToElement(
      '<div id="testModeBorderLeft" class="testModeBorder"></div>'
    );
    body.appendChild(borderLeft);
  }

  let borderRight = document.querySelector("#testModeBorderRight");
  if (!borderRight) {
    borderRight = htmlToElement(
      '<div id="testModeBorderRight" class="testModeBorder"></div>'
    );
    body.appendChild(borderRight);
  }
}

if (
  !SalesToolkit.User.permissions.canUseTestMode &&
  !SalesToolkit.Theme.getBooleanProperty("forceTestModeCapability", false)
) {
  delete localStorage["testMode"];
}

if (
  localStorage["testMode"] === "true" &&
  window.location.href.indexOf("login") < 0
) {
  toggleTestMode();
}

function applySafeAreaMargins() {
  if (SalesToolkit.Theme.getBooleanProperty("kioskMode", false)) {
    return;
  }

  window.safeAreaMargins = {};

  if (SalesToolkit.CrossPlatform.enabled) {
    if (window.location.href.indexOf("index") >= 0) {
      safeAreaMargins = SalesToolkit.CrossPlatform.getSafeAreaMargins();
      localStorage["safeAreaMargins"] = safeAreaMargins;
    } else {
      safeAreaMargins = localStorage["safeAreaMargins"];
    }

    try {
      safeAreaMargins = JSON.parse(safeAreaMargins);
    } catch (err) {
      safeAreaMargins = {};
      safeAreaMargins.top = 0;
      safeAreaMargins.bottom = 0;
    }
  } else {
    safeAreaMargins.top = 0;
    safeAreaMargins.bottom = 0;
  }

  if (window.location.href.indexOf("index") >= 0) {
    safeAreaMargins = {};
    safeAreaMargins.top = 0;
    safeAreaMargins.bottom = 0;
  }

  if (safeAreaMargins.top == 0 && safeAreaMargins.bottom == 0) return;

  $(".portlet-body").each(function () {
    $(this).css("min-height", "");
    let minHeight = $(this).css("min-height");
    try {
      minHeight = parseInt(minHeight);
      if (minHeight > 300) {
        minHeight -= safeAreaMargins.top;
        minHeight -= safeAreaMargins.bottom;

        $(this).css("min-height", minHeight);
      }
    } catch (err) {}
  });

  if (
    window.location.href.indexOf("viewAsset") >= 0 ||
    window.location.href.indexOf("viewForm") >= 0
  ) {
    $(".portlet.light .portlet-body .row").each(function () {
      $(this).css("height", "");
      let height = $(this).css("height");
      try {
        height = parseInt(height);
        if (height > 300) {
          height -= safeAreaMargins.top;
          height -= safeAreaMargins.bottom;
          height += 3; //No idea why
          $(this).css("height", height);
        }
      } catch (err) {}
    });
  }

  if (SalesToolkit.CrossPlatform.isIOS()) iOSMinHeightCorrection();
}

$(window).on("resize", function () {
  if (document.fullscreenElement || 
      document.webkitFullscreenElement || 
      document.mozFullScreenElement || 
      document.msFullscreenElement) {
      return;
  }
  
  setupProfileFeature();

  if (SalesToolkit.CrossPlatform.enabled) applySafeAreaMargins();
});

if (SalesToolkit.CrossPlatform.enabled) applySafeAreaMargins();

function setupHomeCollection() {
  if (!SalesToolkit.Theme.overridingCollectionId) {
    // No Overriding Collection Set

    if (SalesToolkit.getHomeCollectionID()) {
      var homeCollection =
        SalesToolkit.Library.collections[SalesToolkit.getHomeCollectionID()];

      if (homeCollection != null && SalesToolkit.User.canSee(homeCollection)) {
        localStorage["salestoolkitCollectionThemeOverrideId"] =
          SalesToolkit.getHomeCollectionID();
        try {
          let themeObject = {};
          themeObject.theme = homeCollection.theme || {};
          themeObject.id = homeCollection.id;
          localStorage["salestoolkitCollectionThemeOverrideProperties"] =
            JSON.stringify(themeObject);
        } catch (err) {
          console.log(err);
        }

        SalesToolkit.Theme.setOverridingCollection(
          SalesToolkit.getHomeCollectionID()
        );
      }
    }
  }
}

function loginFromParameters(json) {
  // couldn't locate the server for the user
  let atheneum = SalesToolkit;

  var loggedInUserName = json.userName;
  if (atheneum.API.BASE_URL != json.baseURL) {
    if (atheneum.Plugins) {
      atheneum.Plugins.plugins = [];
      atheneum.Plugins.activeElementId = null;
      atheneum.Plugins.activePluginId = null;
      atheneum.Plugins.activePluginParameters = null;
      atheneum.Plugins.saveToStorage();
    }
  }

  if (
    SalesToolkit.User.isLoggedIn &&
    json.userName === SalesToolkit.User.username
  ) {
    window.apiKey = SalesToolkit.User.apikey;
    if (
      json.hasOwnProperty("veeva") &&
      (json.veeva == "true" || json.veeva == true)
    ) {
      SalesToolkit.User.veevaUser = true;
      if (json.hasOwnProperty("veevaID") && typeof json.veevaID === "string")
        SalesToolkit.User.veevaID = json.veevaID;
      else SalesToolkit.User.veevaID = undefined;
      SalesToolkit.User.saveToStorage();
    }
  } else if (
    SalesToolkit.User.isLoggedIn &&
    window.userName !== SalesToolkit.User.username
  ) {
    let atheneumUser = SalesToolkit.User;
    atheneumUser.isLoggedIn = false;
    atheneumUser.apikey = "";
    atheneumUser.permissions = {
      canFavourite: true,
      canInvite: false,
      canRate: false,
      canShare: false,
    };
    atheneumUser.emailConfirmed = false;
    atheneumUser.logoUrl = "";
    atheneumUser.logoLastModified = 0;
    atheneumUser.groups = [];
    atheneumUser.username = undefined;
    atheneumUser.preferences = { language: atheneumUser.preferences.language };
    atheneumUser.ratings = {};
    atheneumUser.id = undefined;
    atheneumUser.isLocked = false;
    atheneumUser.startupCollection = null;
    atheneumUser.kioskMode = false;
    atheneumUser.isPasswordChangeNeeded = false;
    atheneumUser.loggedInWithParams = false;

    if (
      json.hasOwnProperty("veeva") &&
      (json.veeva == "true" || json.veeva == true)
    ) {
      atheneumUser.veevaUser = true;
    }

    if (json.hasOwnProperty("veevaID") && typeof json.veevaID === "string")
      atheneumUser.veevaID = json.veevaID;
    else atheneumUser.veevaID = undefined;

    atheneumUser.saveToStorage();
  }

  if (SalesToolkit.CrossPlatform.enabled) {
    var loginObj = typeof json === "string" ? JSON.parse(json) : json;
    //loginObj.baseURL = loginObj.baseURL + "/" + settings.appId;

    window.apiKey = json.apikey || "";
    window.userName = loggedInUserName;

    let redirectURL = rewriteSpaUrl(loginObj.goToURL || undefined);

    if (
      window.location.href.indexOf("login") >= 0 &&
      SalesToolkit.User.isLoggedIn &&
      loggedInUserName === SalesToolkit.User.username &&
      redirectURL &&
      !loginObj.changePassword
    ) {
      try {
        trackLoginFromParams(true);
        window.location.href = redirectURL;
        return;
      } catch (err) {}
    }
  }

  atheneum.API.BASE_URL = json.baseURL;
  atheneum.API.BASE_URL_NO_PROXY = json.baseURL;

  var offline =
    JSON.parse(
      atheneum.LocalStorage.get(
        "atheneumOfflineUserDataForUser_" + loggedInUserName
      ) || "{}"
    ) || {};
  if (!offline) offline = {};

  if (json.permissions) {
    json.permissions.canShare = json.permissions.canVend || false;
  }

  var offlineData = {
    permissions: json.permissions || {},
    emailConfirmed: json.emailConfirmed || false,
    logoUrl: json.registrarLogo ? json.registrarLogo.url : null,
    logoLastModified: json.registrarLogo ? json.registrarLogo.modified : 0,
    groups: json.groups || [],
    userId: json.userId || "",
    startupCollection:
      json.startupCollection ||
      SalesToolkit.Theme.getStringProperty("startupCollection"),
    baseUrl: atheneum.API.BASE_URL,
    kioskMode: json.kioskMode || false,
    preferences: offline.preferences || atheneum.User.preferences,
  };

  var password = "";
  var hashForApiKey = atheneum.Crypto.hash(
    password + "_apikey",
    loggedInUserName + "_apikey"
  );
  var apikey = json.apikey || "";
  window.paramsApikey = apikey;
  if (apikey) {
    offlineData.encryptedApiKey = Atheneum.Crypto.xor(apikey, hashForApiKey);
  }

  var stringifiedOfflineData = JSON.stringify(offlineData);
  atheneum.LocalStorage.set(
    "atheneumOfflineUserDataForUser_" + loggedInUserName,
    stringifiedOfflineData
  );

  var savedProperly =
    stringifiedOfflineData ==
    atheneum.LocalStorage.get(
      "atheneumOfflineUserDataForUser_" + loggedInUserName
    );

  if (typeof json.baseUrl !== "undefined") atheneum.API.BASE_URL = json.baseUrl;

  atheneum.User.loggedInWithParams = true;
  atheneum.User.isLoggedIn = true;
  atheneum.User.isLocked = false;
  atheneum.User.apikey = json.apikey || "";
  atheneum.User.permissions = json.permissions || {};
  atheneum.User.permissions.canShare =
    atheneum.User.permissions.canVend || false;
  atheneum.User.emailConfimed = json.emailConfirmed || false;
  atheneum.User.logoUrl = json.registrarLogo
    ? json.registrarLogo.url
    : undefined;
  atheneum.User.logoLastModfied = json.registrarLogo
    ? json.registrarLogo.modified
    : 0;
  atheneum.User.groups = json.groups || [];
  atheneum.User.username = loggedInUserName;
  atheneum.User.id = json.userId;
  atheneum.User.kioskMode = json.kioskMode || false;
  atheneum.User.isPasswordChangeNeeded = json.changePassword == true;
  if (
    json.hasOwnProperty("veeva") &&
    (json.veeva == "true" || json.veeva == true)
  ) {
    atheneum.User.veevaUser = true;
    if (json.hasOwnProperty("veevaID") && typeof json.veevaID === "string")
      atheneum.User.veevaID = json.veevaID;
    else atheneum.User.veevaID = undefined;
  } else {
    atheneum.User.veevaUser = false;
    atheneum.User.veevaID = undefined;
  }

  let cachedStartupCollectionId =
    localStorage["salestoolkitCollectionThemeOverrideId"];
  atheneum.User.startupCollection =
    json.startupCollection ||
    SalesToolkit.Theme.__getProperty("startupCollection");

  if (
    !atheneum.User.startupCollection ||
    atheneum.User.startupCollection == null
  ) {
    delete localStorage["salestoolkitCollectionThemeOverrideProperties"];
    delete localStorage["salestoolkitCollectionThemeOverrideId"];
    SalesToolkit.Theme.clearOverridingCollection();
  }

  atheneum.User.baseUrl = atheneum.API.BASE_URL;
  atheneum.User.preferences =
    offlineData.preferences || atheneum.User.preferences;
  atheneum.User.saveToStorage();

  if (atheneum.UI && atheneum.UI.Notifications) {
    atheneum.UI.Notifications.hasNotPolledSinceLastLogin = true;
  }

  try {
    var cookieValue = SalesToolkit.API.BASE_URL + "|" + json.apikey;
    document.cookie =
      "resourcecentre-api" +
      "=" +
      encodeURIComponent(cookieValue) +
      "; path=/; SameSite=None; Secure";
  } catch (err) {}

  trackLoginFromParams();

  $("#lockScreenButton").hide();
  $("#lockScreenPopupButton").hide();
  setupHomeCollection();

  SalesToolkit.Translation.update({
    success: function () {
      languageUpdateCallback();
      SalesToolkit.Theme.update(applyThemeToToolkit);
    },
    failure: function () {
      languageUpdateCallback();
      SalesToolkit.Theme.update(applyThemeToToolkit);
    },
  });
}

function checkForLoginFromParams() {
  try {
    window.userJSON = SalesToolkit.Pages.CurrentPage.getQueryParam("userJSON");
    window.apiKey = SalesToolkit.Pages.CurrentPage.getQueryParam("apikey");
    window.userName = SalesToolkit.Pages.CurrentPage.getQueryParam("userName");
    window.baseURL = SalesToolkit.Pages.CurrentPage.getQueryParam("baseURL");
    window.isVeevaUser =
      SalesToolkit.Pages.CurrentPage.getQueryParam("veeva") == "true";
    window.veevaID = SalesToolkit.Pages.CurrentPage.getQueryParam("veevaID");

    if (userName == null || apiKey == null || userName == "" || apiKey == "") {
      if (SalesToolkit.User.isLoggedIn) {
        window.apiKey = SalesToolkit.User.apikey;
      }
      return;
    }

    if (
      SalesToolkit.User.isLoggedIn &&
      window.userName === SalesToolkit.User.username
    ) {
      window.apiKey = SalesToolkit.User.apikey;
      if (window.isVeevaUser) {
        SalesToolkit.User.veevaUser = true;
        if (window.veevaID) SalesToolkit.User.veevaID = window.veevaID;
        else SalesToolkit.User.veevaID = undefined;
        SalesToolkit.User.saveToStorage();
      } else {
        SalesToolkit.User.veevaUser = false;
        SalesToolkit.User.veevaID = undefined;
        SalesToolkit.User.saveToStorage();
      }
    } else if (
      SalesToolkit.User.isLoggedIn &&
      window.userName !== SalesToolkit.User.username
    ) {
      let atheneumUser = SalesToolkit.User;
      atheneumUser.isLoggedIn = false;
      atheneumUser.apikey = "";
      atheneumUser.permissions = {
        canFavourite: true,
        canInvite: false,
        canRate: false,
        canShare: false,
      };
      atheneumUser.emailConfirmed = false;
      atheneumUser.logoUrl = "";
      atheneumUser.logoLastModified = 0;
      atheneumUser.groups = [];
      atheneumUser.username = undefined;
      atheneumUser.preferences = {
        language: atheneumUser.preferences.language,
      };
      atheneumUser.ratings = {};
      atheneumUser.id = undefined;
      atheneumUser.isLocked = false;
      atheneumUser.startupCollection = null;
      atheneumUser.kioskMode = false;
      atheneumUser.isPasswordChangeNeeded = false;
      atheneumUser.loggedInWithParams = false;

      if (window.isVeevaUser) {
        atheneumUser.veevaUser = true;
        if (window.veevaID) atheneumUser.veevaID = window.veevaID;
        else atheneumUser.veevaID = undefined;
      } else {
        atheneumUser.veevaUser = false;
        atheneumUser.veevaID = undefined;
        atheneumUser.saveToStorage();
      }

      atheneumUser.saveToStorage();
      window.location.reload();
    }

    var error = SalesToolkit.Pages.CurrentPage.getQueryParam("error");
    var errorDescription =
      SalesToolkit.Pages.CurrentPage.getQueryParam("error_description");

    if (error && errorDescription && error != "") {
      if (SalesToolkit.CrossPlatform.enabled) {
        SalesToolkit.CrossPlatform.logMessage(
          "LOGIN FROM PARAMS ERROR " + error
        );
        SalesToolkit.CrossPlatform.logMessage(
          "LOGIN FROM PARAMS ERROR DESC " + errorDescription
        );
      }
      window.location = "login.html?error=" + error + "-" + errorDescription;
      return;
    }

    window.userJSON = decodeURI(userJSON);
    window.apiKey = decodeURI(apiKey);
    window.userName = decodeURI(userName);
    window.baseURL = decodeURI(baseURL);

    try {
      window.userJSON = atob(userJSON);
    } catch (err) {
      window.userJSON = decodeURIComponent(userJSON);
      window.userJSON = atob(userJSON);
    }

    var error = SalesToolkit.Translation.getOrGetThemeKey(
      "ssoUnknownError",
      "Uknown error while signing in with SSO"
    );

    if (baseURL != null && baseURL != "") {
      if (baseURL.indexOf("/restful") < 0) baseURL += "/restful";
      else if (!baseURL.endsWith("/restful")) {
        baseURL = baseURL.substring(0, baseURL.indexOf("/restful"));
        baseURL += "/restful";
      }
    }

    if (userJSON == null) {
      //TODO get form permissions api call
    }

    var loginObj = JSON.parse(userJSON);
    loginObj.baseURL = baseURL + "/" + settings.appId;
    loginObj.userName = userName;

    let redirectURL = rewriteSpaUrl(
      SalesToolkit.Pages.CurrentPage.getQueryParam("goToURL") ||
        SalesToolkit.Pages.CurrentPage.getQueryParam("goToUrl")
    );

    if (
      window.location.href.indexOf("login") >= 0 &&
      SalesToolkit.User.isLoggedIn &&
      userName === SalesToolkit.User.username &&
      redirectURL &&
      !loginObj.changePassword
    ) {
      try {
        trackLoginFromParams(true);
        window.location.href = redirectURL;
        return;
      } catch (err) {}
    }

    if (window.isVeevaUser) {
      loginObj.veeva = true;
    }

    if (window.veevaID) {
      loginObj.veevaID = window.veevaID;
    }

    loginFromParameters(loginObj);
  } catch (err) {
    if (SalesToolkit.CrossPlatform.enabled) {
      SalesToolkit.CrossPlatform.logMessage(
        "JAVASCRIPT CAUGHT ERROR RESULTING LOGOUT MESSAGE" + err.message
      );
      SalesToolkit.CrossPlatform.logMessage(
        "JAVASCRIPT CAUGHT ERROR RESULTING LOGOUT CAUSE" + err.cause
      );
      SalesToolkit.CrossPlatform.logMessage(err);
    }
    window.location = "login.html?error=" + err;
  }
}

if (SalesToolkit.CrossPlatform.enabled) {
  var loginWithParametersJSON = SalesToolkit.CrossPlatform.getLoginJSON();
  if (loginWithParametersJSON) loginFromParameters(loginWithParametersJSON);
} else {
  checkForLoginFromParams();
}

let redirectURL = rewriteSpaUrl(
  SalesToolkit.Pages.CurrentPage.getQueryParam("goToURL") ||
    SalesToolkit.Pages.CurrentPage.getQueryParam("goToUrl")
);

if (window.location.href.indexOf("login") < 0 && redirectURL) {
  try {
    window.location.href = redirectURL;
  } catch (err) {}
}

if (SalesToolkit.CrossPlatform.enabled) {
  var maxUserDownloadSize = SalesToolkit.User.getPreference(
    "salestoolkitAppSettingMobileMaxSize",
    "0",
    false
  );
  maxUserDownloadSize = parseFloat(maxUserDownloadSize);
  SalesToolkit.CrossPlatform.setUserMaxMobileDownloadSize(maxUserDownloadSize);
}

setupHomeCollection();

SalesToolkit.User.timestampPreferenceGroups = {
  salestoolkitAppSettingsLastModified: [
    "salestoolkitAppSettingShowNotifications",
    "salestoolkitAppSettingShowNewsTicker",
    "salestoolkitAppSettingEnableTreeView",
    "salestoolkitAppSettingStickySideMenu",
    "salestoolkitAppSettingSideMenuInitiallyShown",
    "salestoolkitAppSettingShowCartHistoryDirectLink",
    "salestoolkitAppSettingDownloadOnMobile",
    "salestoolkitAppSettingMobileMaxSize",
  ],
};

updateProfileHistoryLink();
updateFormHistoryLink();

window.ignoreUpdate = localStorage["doNotServerUpdate"] || false;
if (window.ignoreUpdate == "true") window.ignoreUpdate = true;

if (
  !SalesToolkit.LocalStorage.db ||
  !SalesToolkit.Theme.getBooleanProperty("allowIgnoreUpdates", false)
) {
  window.ignoreUpdate = false;
}

localStorage.removeItem("doNotServerUpdate");
let ignoreUpdatesTimer = SalesToolkit.Theme.getIntegerProperty(
  "ignoreUpdatesForHours",
  0
);
let lastUpdate = localStorage["lastUpdateDate"];
if (lastUpdate == undefined) lastUpdate = new Date();
else lastUpdate = Date.parse(lastUpdate);

let hours = Math.abs(new Date() - lastUpdate) / (60 * 60 * 1000);

if (ignoreUpdate && ignoreUpdatesTimer > 0 && hours > ignoreUpdatesTimer) {
  window.ignoreUpdate = true;
}

if (
  SalesToolkit.Theme.getBooleanProperty("ignoreTagUpdatesWithoutTimer", true) &&
  hours > 5 * 24
) {
  window.updateTagHistory = true;
} else {
  window.updateTagHistory = false;
}

if (window.location.href.indexOf("login") < 0)
  localStorage["lastUpdateDate"] = new Date();
SalesToolkit.User.update(function () {
  let isHome =
    window.location.href.indexOf("index.html") >= 0 ||
    window.location.pathname == "/";

  if (
    ignoreUpdate ||
    (!isHome &&
      SalesToolkit.Theme.getBooleanProperty("onlyUpdateAdminItemsOnHome", true))
  ) {
    return;
  }

  if (
    SalesToolkit.User.permissions.libraryTags_update ||
    SalesToolkit.User.permissions.libraryTags_updateAll
  ) {
    if (
      !updateTagHistory &&
      (localStorage["adminTagHistory"] == undefined ||
        localStorage["adminTagHistory"].length == 0)
    )
      SalesToolkit.Admin.updateTagHistory();
  }

  if (
    SalesToolkit.User.permissions.users_read ||
    SalesToolkit.User.permissions.users_readAll
  )
    SalesToolkit.Admin.updateUsers();
  if (
    SalesToolkit.User.permissions.userGroups_read ||
    SalesToolkit.User.permissions.userGroups_readAll
  )
    SalesToolkit.Admin.updateUserGroups();
  if (
    SalesToolkit.User.permissions.userRegistrations_read ||
    SalesToolkit.User.permissions.userRegistrations_readAll
  )
    SalesToolkit.Admin.updateUserRegistrations();
  if (
    SalesToolkit.User.permissions.users_read ||
    SalesToolkit.User.permissions.users_readAll
  )
    SalesToolkit.Admin.updatePermissionSets();
  if (
    SalesToolkit.User.permissions.libraryTags_read ||
    SalesToolkit.User.permissions.libraryTags_readAll
  )
    SalesToolkit.Admin.updateTags();
});

SalesToolkit.Summary.update(function () {
  updateProfileHistoryLink();
});

var filters = SalesToolkit.Filters.getFilters();
if (
  filters &&
  filters.length > 0 &&
  SalesToolkit.Theme.getBooleanProperty("useFilters", false)
) {
  $(".filterdropdown").css("display", "flex");
  $(".filterdropdown").toggleClass("disabled", true);
}

if (
  SalesToolkit.CrossPlatform.enabled &&
  window.location.href.indexOf("viewAsset.html") < 0 &&
  !document.body.classList.contains("module-previewAsset")
) {
  SalesToolkit.CrossPlatform.clearPageNumber();
}

function libraryFullCollectionsLoaded() {
  if (typeof SalesToolkit.Filters == "undefined") {
    setTimeout(libraryFullCollectionsLoaded, 1000);
    return;
  }

  $("body").removeClass("loadingDB");

  document.dispatchEvent(
    new CustomEvent(SalesToolkitApplication.Events.LIBRARY_LOADED)
  );

  if (
    window.location.href.indexOf("viewAsset.html") >= 0 ||
    document.body.classList.contains("module-previewAsset")
  ) {
    if (typeof populateRelatedAssetsPanel === "function")
      populateRelatedAssetsPanel();

    $("#lfclRoller").hide();
  } else {
    $("#lfclRoller").hide();
  }
}

if (SalesToolkit.LocalStorage.db) {
  $("body").append(
    '<div id="lfclRoller" class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>'
  );
  $("body").addClass("loadingDB");
} else {
  if (ignoreUpdate) {
    document.dispatchEvent(
      new CustomEvent(SalesToolkitApplication.Events.INIT_FILTERS)
    );
  } else {
    document.dispatchEvent(
      new CustomEvent(SalesToolkitApplication.Events.UPDATE_FILTERS)
    );
  }
}

var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
if (SalesToolkit.CrossPlatform.enabled && !iOS)
  iOS = SalesToolkit.CrossPlatform.isIOS();

if (iOS) {
  document.body.classList.add("ios");
}

if (
  SalesToolkit.CrossPlatform.enabled &&
  SalesToolkit.CrossPlatform.isAndroid()
)
  document.body.classList.add("android");

purgeCacheIfBefore = new Date("2020-02-01").getTime();

const localStorageLastCachePurge = (localStorage["lastCachePurge"] || "0") | 0;
localStorageApproxTotalSize = 0;
for (var prop in localStorage) {
  if (!localStorage.hasOwnProperty(prop)) {
    continue;
  }
  approxSize = prop.length * 2 + (localStorage[prop] || "").length * 2;
  localStorageApproxTotalSize += approxSize;
}

if (localStorageApproxTotalSize > 1024 * 1024) {
  localStorageApproxTotalString =
    ((localStorageApproxTotalSize / 1024) | 0) / 1024 + "MB";
} else if (localStorageApproxTotalSize > 1024) {
  localStorageApproxTotalString =
    ((localStorageApproxTotalSize * 1024) | 0) / 1024 + "KB";
} else {
  localStorageApproxTotalString = localStorageApproxTotalSize + "B";
}

var initialSideMenuState = SalesToolkit.User.getPreference(
  "salestoolkitAppSettingSideMenuInitiallyShown",
  undefined,
  true
);
var sideMenuOpen =
  Atheneum.Theme.TRUE_VALUES.indexOf(initialSideMenuState) != -1;

if (sideMenuOpen) initialSideMenuState = "open";
else initialSideMenuState = localStorage["appSetting_sideMenuState"] || "open";

if (
  sideMenuCompact == "fullscreen" ||
  window.matchMedia("(max-width:767px)").matches
) {
  initialSideMenuState = "closed";
} else {
  localStorage["appSetting_sideMenuState"] = initialSideMenuState;
}

document.body.classList.remove("sidemenu-closed");
document.body.classList.remove("sidemenu-open");
document.body.classList.add("sidemenu-" + initialSideMenuState);

if (SalesToolkit.Theme.getBooleanProperty("showSortIcon", false)) {
  $("#sort-action-wrapper").show();
} else {
  $("#sort-action-wrapper").hide();
}

const purgeDateString = SalesToolkit.Theme.getStringProperty("purgeCacheDate", 'never');
if (purgeDateString !== "never") {
  const themePurgeDate = new Date(purgeDateString);
  if (!isNaN(themePurgeDate.getTime())) {
    const themePurgeTimestamp = themePurgeDate.getTime();
      if (localStorageLastCachePurge === 0 || localStorageLastCachePurge < themePurgeTimestamp) {

          console.log("Cache purge required: Purge date threshold met.");
          SalesToolkit.CrossPlatform.purgeCache(function() {
              localStorage.clear();
              localStorage['lastCachePurge'] = new Date().getTime();
              window.location.href = 'login.html';
          });

      } else {
          console.log("Cache is already up-to-date. No purge needed.");
      }
  }else{
    console.warn("Invalid date format in 'purgeCacheDate' theme property:", purgeDateString);
  }
}else{
  console.log("Cache purge setting is 'never'. Skipping check.");
}

var renderUserIconWithTheme = false;

// set the version number of the AtheneumInstance
if (!SalesToolkit.CrossPlatform.enabled || !SalesToolkit.version)
  SalesToolkit.version = "v1.20.02 b184.16";

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

/**
 * External helper function to try dismissing a notification.
 * It checks for a valid notification ID, calls SalesToolkit.dismissNotification,
 * and logs the outcome to the console.
 *
 * @param {object} notification - The notification object, expected to have an 'id' property.
 */
function tryDismissNotification(notification) {
    
    try {
        if (!notification || !notification.id) {
            return;
        }
        const notificationId = notification.id;

        if(notificationId.startsWith("notif")){
            return;
        }

        const callbackHandlers = {
            success: function (json) {
                console.log(
                    "Successfully dismissed notification (ID: " + notificationId + ").",
                    json
                );
            },
            
            failure: function (reason, httpStatus, errorCode) {
                console.error(
                    "Failed to dismiss notification (ID: " + notificationId + "):", 
                    { 
                        reason: reason, 
                        httpStatus: httpStatus, 
                        errorCode: errorCode 
                    }
                );
            }
        };

        SalesToolkit.API.dismissNotification(notificationId, callbackHandlers);

    } catch (error) {
        console.error(
            "An unexpected synchronous error occurred while trying to dismiss notification:", 
            error, 
            notification
        );
    }
}

SalesToolkit.DefaultImages.Asset = "img/asset.png";
SalesToolkit.DefaultImages.PluginIcon = "img/default/comparator_menu.svg";
SalesToolkit.DefaultImages.PluginLibrary = "img/default/comparator_library.svg";
SalesToolkit.DefaultImages.PluginSmallIcon =
  "img/default/comparator_topbar.svg";
SalesToolkit.DefaultImages.Collection = "img/collection.png";
SalesToolkit.DefaultImages.Form = "img/default/Form_Default.svg";
let ignoreTimestamp = localStorage["ignoreTimestamp"];
if (typeof ignoreTimestamp !== "string") ignoreTimestamp = true;
else if (ignoreTimestamp === "false") ignoreTimestamp = false;
else ignoreTimestamp = true;
SalesToolkit.Library.ignoreTimestamp = ignoreTimestamp;

let urlIgnoreTimestamp = getUrlParameter("recache");

if (SalesToolkit.Theme.getBooleanProperty("forceIgnoreTimestamps", false)) {
  SalesToolkit.Library.ignoreTimestamp = true;
} else if (urlIgnoreTimestamp === "true") {
  SalesToolkit.Library.ignoreTimestamp = true;
}

// set the login page url
// AtheneumInstance will automatically redirect to this page if the user is not logged in
// If a page is meant to be visible to the public, AtheneumInstance.Pages.CurrentPage.declarePublic();
SalesToolkit.Pages.LoginPage.url = "login.html";

// SadefaultlesToolkit has a special lock page
SalesToolkit.Pages.LockPage.url = "extra_lock.html";

SalesToolkit.Pages.PreviewAssetPage.url =
  "index.html?startingModule=previewAsset";
SalesToolkit.Pages.PreviewAssetPage.buildUrl = function (params) {
  return SalesToolkit.HttpUtils.appendQueryParamsToUrl(
    SalesToolkit.Pages.PreviewAssetPage.url,
    params
  );
};

SalesToolkit.Pages.ExploreCollectionPage.url = "index.html";
SalesToolkit.Pages.ExploreCollectionPage.buildUrl = function (params) {
  return SalesToolkit.HttpUtils.appendQueryParamsToUrl(
    SalesToolkit.Pages.ExploreCollectionPage.url,
    params
  );
};

var containers = ["page-footer-inner", "page-footer-custom", "copyright"];
for (var c = 0; c < containers.length; c++) {
  var versionNumbers = document.getElementsByClassName(containers[c]);
  for (var i = 0; i < versionNumbers.length; i++) {
    versionNumbers[i].innerHTML = versionNumbers[i].innerHTML.replace(
      /v([0-9]+)(\.[0-9]+)?(\.[0-9]+)?/g,
      SalesToolkit.version.startsWith("v")
        ? SalesToolkit.version
        : "v" + SalesToolkit.version
    );
  }
}

if (SalesToolkit.User && SalesToolkit.User.loggedInWithParams) {
  //Remove lock screen access
  $("#lockScreenButton").hide();
  $("#lockScreenPopupButton").hide();
} else {
  $("#lockScreenButton").show();
  $("#lockScreenPopupButton").show();
}

if (SalesToolkit.Theme.getBooleanProperty("hideLockScreen", false)) {
  $("#lockScreenButton").hide();
  $("#lockScreenPopupButton").hide();
}
//poll for new notifications once every 47 seconds
SalesToolkit.UI.Notifications.setPollInterval(47000);

try {
  SalesToolkit.UI.Notifications.history =
    JSON.parse(
      SalesToolkit.LocalStorage.get(
        "atheneumNotificationHistoryForUser_" + SalesToolkit.User.username,
        "[]"
      )
    ) || [];
} catch (e) {
  SalesToolkit.UI.Notifications.history = [];
}

if (SalesToolkit.User.isLoggedIn)
  SalesToolkit.UI.Notifications.startPolling(10, {
    success: function () {
      var latestNotifications = SalesToolkit.UI.Notifications.history;

      // for each notification history
      // if notification not acknowledged and not displayed:

      if (SalesToolkit.User.username)
        SalesToolkit.LocalStorage.set(
          "atheneumNotificationHistoryForUser_" + SalesToolkit.User.username,
          JSON.stringify(SalesToolkit.UI.Notifications.history)
        );
      SalesToolkit.UI.Notifications.renderList();
    },
  });

if (!ignoreUpdate && SalesToolkit.User.username) {
  SalesToolkit.User.update({
    success: function () {
      var usernameDisplay = document.querySelector(
        ".username.username-hide-on-mobile"
      );
      if (usernameDisplay)
        usernameDisplay.innerHTML =
          SalesToolkit.User.preferences.firstName ||
          SalesToolkit.User.username ||
          "Guest";
    },

    failure: function () {
      var usernameDisplay = document.querySelector(
        ".username.username-hide-on-mobile"
      );
      if (usernameDisplay)
        usernameDisplay.innerHTML =
          SalesToolkit.User.preferences.firstName ||
          SalesToolkit.User.username ||
          "Guest";
    },
  });
} else {
  var usernameDisplay = document.querySelector(
    ".username.username-hide-on-mobile"
  );
  if (usernameDisplay) usernameDisplay.innerHTML = "Guest";
}

var clearAllText = document.querySelector("#header_inbox_bar li.external > a");
if (clearAllText) {
  clearAllText.setAttribute("data-translation-key", "repliesClearAll");
  clearAllText.setAttribute("data-translation-default", "clear all");
  clearAllText.innerHTML = SalesToolkit.Translation.getOrGetThemeKey(
    "repliesClearAll",
    "clear all"
  );
  clearAllText.href = undefined;
  clearAllText.removeAttribute("href");
}

clearAllText = document.querySelector(
  "#header_notification_bar li.external > a"
);
if (clearAllText) {
  clearAllText.innerHTML = SalesToolkit.Translation.getOrGetThemeKey(
    "notificationsClearAll",
    "clear all"
  );
  clearAllText.setAttribute("data-translation-key", "notificationsClearAll");
  clearAllText.setAttribute("data-translation-default", "clear all");
  clearAllText.style.display = "none";
  clearAllText.href = undefined;
  clearAllText.removeAttribute("href");
  clearAllText.onclick = function () {
    for (var i = 0; i < SalesToolkit.UI.Notifications.history.length; i++) {
      SalesToolkit.UI.Notifications.history[i].dismissed = true;
      SalesToolkit.UI.Notifications.history[i].acknowledged = true;
      tryDismissNotification(SalesToolkit.UI.Notifications.history[i]);
    }
    var stickyNotificationsOnScreen = document.querySelectorAll(
      ".jquery-notific8-close-sticky"
    );
    for (var i = 0; i < stickyNotificationsOnScreen.length; i++) {
      stickyNotificationsOnScreen[i].click();
    }
    var notificationsOnScreen = document.querySelectorAll(
      ".jquery-notific8-close"
    );
    for (var i = 0; i < notificationsOnScreen.length; i++) {
      notificationsOnScreen[i].click();
    }
    if (SalesToolkit.User.username != undefined)
      SalesToolkit.LocalStorage.set(
        "atheneumNotificationHistoryForUser_" + SalesToolkit.User.username,
        JSON.stringify(SalesToolkit.UI.Notifications.history)
      );

    SalesToolkit.UI.Notifications.renderList();
  };
}

SalesToolkit.UI.Notifications.types = {
  default: {
    sticky: false,
    life: SalesToolkit.Theme.getIntegerProperty(
      "defaultNotificationLife",
      5000
    ),
    horizontalEdge: "bottom",
    verticalEdge: "left",
    salestoolkitIcon: "fa-bell-o",
    salestoolkitIconBG: "#BBB",
  },

  cart: {
    heading: "Cart",
    headingTranslationKey: "toolkitNotificationHeadingCart",
    theme: "tangerine",
    salestoolkitIcon: "icon-basket",
    salestoolkitIconBG: "#DFBA49",
  },

  favourites: {
    heading: "Favourites",
    headingTranslationKey: "toolkitNotificationHeadingFavourites",
    theme: "ruby",
    salestoolkitIcon: "icon-heart",
    salestoolkitIconBG: "#F3565D",
  },

  download: {
    heading: "Downloads",
    headingTranslationKey: "toolkitNotificationHeadingDownloads",
    theme: "lime",
    salestoolkitIcon: "fa-long-arrow-down",
    salestoolkitIconBG: "#45B6AF",
  },

  system: {
    theme: "teal",
    heading: "System",
    headingTranslationKey: "toolkitNotificationHeadingSystem",
    sticky: true,
    salestoolkitIcon: "fa-exclamation",
  },

  asset: {
    theme: "teal",
    heading: "System",
    headingTranslationKey: "toolkitNotificationHeadingSystem",
    sticky: true,
    salestoolkitIcon: "fa-file-o",
  },

  collection: {
    theme: "teal",
    heading: "System",
    headingTranslationKey: "toolkitNotificationHeadingSystem",
    sticky: true,
    salestoolkitIcon: "fa-folder-o",
  },

  info: {
    theme: "teal",
    heading: "Info",
    headingTranslationKey: "toolkitNotificationHeadingInfo",
    salestoolkitIcon: "fa-info",
    salestoolkitIconBG: "#89C4F4",
  },

  consent: {
    theme: "teal",
    heading: "Consent",
    headingTranslationKey: "toolkitNotificationHeadingConsent",
    salestoolkitIcon: "fa-info",
    salestoolkitIconBG: "#89C4F4",
    sticky: true,
  },

  profile: {
    theme: "teal",
    heading: "Profile Updated",
    headingTranslationKey: "toolkitNotificationHeadingProfile",
    salestoolkitIcon: "fa-check",
  },

  admin: {
    theme: "teal",
    heading: "Admin",
    life: 5000,
    headingTranslationKey: "toolkitNotificationHeadingAdmin",
    salestoolkitIcon: "fa-check",
  },
};

SalesToolkit.UI.Notifications.showCustomNotification = function (
  type,
  message,
  title,
  link
) {
  var now = new Date().getTime();
  var notificationLifetimeMS = SalesToolkit.User.getPreference(
    "salestoolkitAppSettingNotificationLifetime",
    "24",
    false
  );
  notificationLifetimeMS = parseFloat(notificationLifetimeMS) * 3600000;

  var notification = {
    type: type,
    message: message,
    name: title,
    url: link,
    id: "notif" + new Date().getTime(),
    startDate: now,
    received: now,
    endDate: now + notificationLifetimeMS,
    expired: false,
    acknowledged: true,
    dismissed: false,
    source: "Custom",
  };

  if (!notification.url && type == "cart") {
    notification.url = "index.html?startingModule=cart";
  }
  if (!notification.url && type == "favourites") {
    notification.url = "index.html?startingModule=favourites";
  }
  if (!notification.url && type == "profile") {
    notification.url = "extra_profile.html";
  }

  SalesToolkit.UI.Notifications.history.unshift(notification);
  SalesToolkit.LocalStorage.set(
    "atheneumNotificationHistoryForUser_" + SalesToolkit.User.username,
    JSON.stringify(SalesToolkit.UI.Notifications.history)
  );

  SalesToolkit.UI.Notifications.render(notification);

  SalesToolkit.UI.Notifications.renderList();
};

SalesToolkit.UI.Notifications.handleClick = function (notificationId) {
  for (var i = 0; i < SalesToolkit.UI.Notifications.history.length; i++) {
    var notification = SalesToolkit.UI.Notifications.history[i];
    if (notification.id == notificationId) {
      notification.acknowledged = true;
      tryDismissNotification(notification);

      var query =
        '.jquery-notific8-notification[data-salestoolkit-notification-id="' +
        notification.id +
        '"] .jquery-notific8-close-sticky';
      var notificationCloseButton = document.querySelector(query);
      if (notificationCloseButton) notificationCloseButton.click();

      query =
        '.jquery-notific8-notification[data-salestoolkit-notification-id="' +
        notification.id +
        '"] .jquery-notific8-close';
      notificationCloseButton = document.querySelector(query);
      if (notificationCloseButton) notificationCloseButton.click();

      SalesToolkit.UI.Notifications.renderList();

      if (SalesToolkit.User.username)
        SalesToolkit.LocalStorage.set(
          "atheneumNotificationHistoryForUser_" + SalesToolkit.User.username,
          JSON.stringify(SalesToolkit.UI.Notifications.history)
        );

      var link;
      if (notification.url) {
        if (
          window.location.href.indexOf("index.html") &&
          notification.type == "cart"
        ) {
          SalesToolkitApplication.navigator.loadCartScreen(false);
          return;
        } else if (
          window.location.href.indexOf("index.html") >= 0 &&
          notification.type == "favourites"
        ) {
          SalesToolkitApplication.navigator.loadFavouritesScreen(false);
          return;
        }
        if (
          notification.type == "cart" ||
          notification.type == "favourites" ||
          notification.type == "profile"
        ) {
          link = notification.url;
        } else if (
          !notification.url.substring(0, 10).contains("//") &&
          !notification.url.startsWith("/")
        ) {
          link = "http://" + notification.url;
        } else {
          link = notification.url;
        }
      } else
        switch (notification.subjectType) {
          case "COLLECTION":
            link = "index.html?collectionId=" + notification.subjectId;
            if (window.location.href.indexOf("index.html") >= 0) {
              SalesToolkitApplication.navigator.loadIndexScreen(
                false,
                false,
                notification.subjectId
              );
              return;
            }
            break;
          case "ASSET":
            link =
              "index.html?startingModule=previewAsset&assetId=" +
              notification.subjectId +
              "&from=home";
            if (window.location.href.indexOf("index.html") >= 0) {
              SalesToolkitApplication.navigator.loadAssetScreen(
                notification.subjectId,
                "&from=home"
              );
              return;
            }
            break;
          case "FEED":
            link = "news.html";
            break;
          case "FEEDITEM":
            link = "page_news_item.html?newsItemId=" + notification.subjectId;
            break;
          case "CART":
            link =
              "index.html?startingModule=cart&loadCart=" +
              notification.subjectId;
            if (window.location.href.indexOf("index.html") >= 0) {
              SalesToolkitApplication.navigator.loadCartScreen(false);
              return;
            }
            break;
          default:
            link = undefined;
        }

      if (link) window.location = link;
      else SalesToolkit.UI.Notifications.renderList();
      break;
    }
  }
};

SalesToolkit.UI.Notifications.renderList = function () {
  if (
    SalesToolkit.Theme.getBooleanProperty(
      "salesToolkitToolbarNotificationsEnabled",
      false
    )
  ) {
    document.getElementById("header_notification_bar").style.display = "flex";
  } else {
    var notificationsBar = document.getElementById("header_notification_bar");
    try {
      document.getElementById("header_notification_bar").style.display = "none";
      if (notificationsBar) {
        notificationsBar.style.display = "none";
      }

      if (typeof renderNotificationsTable === "function")
        renderNotificationsTable();
    } catch (err) {}

    return;
  }

  var acknowledgedNotificationLimit = 10;

  var listElement = document.querySelector(
    "#header_notification_bar ul.dropdown-menu-list"
  );
  if (listElement == null) return;

  var html = "";

  var unacknowledged = 0;
  var acknowledgedNotifications = 0;

  for (var i = 0; i < SalesToolkit.UI.Notifications.history.length; i++) {
    var notification = SalesToolkit.UI.Notifications.history[i];

    if (notification.dismissed) continue;

    if (!notification.acknowledged) {
      unacknowledged += 1;
    } else {
      acknowledgedNotifications += 1;
      if (acknowledgedNotifications > acknowledgedNotificationLimit) continue; // skip the oldest already viewed notifications when we've exceeded the limit
    }

    var notificationType = {};
    for (var property in SalesToolkit.UI.Notifications.types[
      notification.type
    ] || {}) {
      if (
        SalesToolkit.UI.Notifications.types[notification.type].hasOwnProperty(
          property
        )
      ) {
        notificationType[property] =
          SalesToolkit.UI.Notifications.types[notification.type][property];
      }
    }
    for (var property in SalesToolkit.UI.Notifications.types.default) {
      if (
        SalesToolkit.UI.Notifications.types.default.hasOwnProperty(property)
      ) {
        if (!notificationType.hasOwnProperty(property)) {
          notificationType[property] =
            SalesToolkit.UI.Notifications.types.default[property];
        }
      }
    }

    var link;
    let dataattr = "";
    if (notification.url) {
      if (
        notification.type == "cart" ||
        notification.type == "favourites" ||
        notification.type == "profile"
      ) {
        link = notification.url;
      } else if (
        !notification.url.substring(0, 10).contains("://") &&
        !notification.url.startsWith("/")
      ) {
        link = "http://" + notification.url;
      } else {
        link = notification.url;
      }
    } else
      switch (notification.subjectType) {
        case "COLLECTION":
          link = "index.html?collectionId=" + notification.subjectId;
          if (window.location.href.indexOf("index.html") >= 0) {
            link = "javascript:;";
          }
          break;
        case "ASSET":
          link =
            "index.html?startingModule=previewAsset&assetId=" +
            notification.subjectId +
            "&from=home";
          if (window.location.href.indexOf("index.html") >= 0) {
            link = "javascript:;";
          }
          break;
        case "FEED":
          link = "news.html";

          break;
        case "FEEDITEM":
          link = "page_news_item.html?newsItemId=" + notification.subjectId;
          break;
        case "CART":
          link =
            "index.html?startingModule=cart&loadCart=" + notification.subjectId;
          if (window.location.href.indexOf("index.html") >= 0) {
            link = "javascript:;";
          }
          break;
        default:
          link = undefined;
      }

    html +=
      "<li" +
      (notification.acknowledged ? " " : "") +
      ' class="notification-type-' +
      notification.type +
      '">';
    html +=
      '<a href="' +
      (link ? link : "javascript:;") +
      '" onclick="event.preventDefault(); SalesToolkit.UI.Notifications.handleClick(\'' +
      notification.id +
      "'); return false;\">";
    html +=
      '<span class="time">' +
      toRelativeDateString(notification.startDate) +
      "</span>";
    html += '<span class="details">';
    html +=
      '<span style="display: inline-block; width: 22px; height: 22px; background-color: ' +
      notificationType.salestoolkitIconBG +
      '" class="label label-sm label-icon label-success">';
    html +=
      '<i class="fa ' +
      notificationType.salestoolkitIcon +
      '" style="margin-top: -1px; margin-right: 3px; margin-left: -3px;"></i>';
    html += "</span>";
    html += notification.message;
    html += "</span>";
    html += "</a>";
    html += "</li>";
  }

  var badge = document.querySelector("#header_notification_bar > a > .badge");
  badge.innerHTML = "" + unacknowledged;
  badge.style.display = unacknowledged == 0 ? "none" : "inline-block";

  var clearAllText = document.querySelector(
    "#header_notification_bar li.external > a"
  );
  clearAllText.style.display = html == "" ? "none" : "inline-block";

  var nPendingNotificationsText = document.querySelector(
    "#header_notification_bar li.external > h3 > .bold"
  );
  if (nPendingNotificationsText) {
    nPendingNotificationsText.innerHTML =
      SalesToolkit.Translation.getOrGetThemeKey(
        "notificationsNewCount",
        "{0} New"
      ).replace("{0}", "" + unacknowledged);
    nPendingNotificationsText.setAttribute(
      "data-translation-arg0-value",
      "" + unacknowledged
    );
  }

  listElement.innerHTML = html;
};

SalesToolkit.UI.Notifications.render = function (
  notificationOrType,
  message,
  title,
  link
) {
  var notificationsEnabled = SalesToolkit.User.getPreference(
    "salestoolkitAppSettingShowNotifications",
    "on",
    true
  );
  if (Atheneum.Theme.FALSE_VALUES.indexOf(notificationsEnabled) != -1) {
    return false;
  }

  var id = "";

  if (typeof notificationOrType === "object") {
    var notification = notificationOrType;
    var type = notification.type || "system";

    title = notification.name;
    message = notification.message;

    if (notification.url) {
      if (
        notification.type == "cart" ||
        notification.type == "favourites" ||
        notification.type == "profile"
      ) {
        link = notification.url;
      } else if (
        !notification.url.substring(0, 10).contains("://") &&
        !notification.url.startsWith("/")
      ) {
        link = "http://" + notification.url;
      } else {
        link = notification.url;
      }
    } else
      switch (notification.subjectType) {
        case "COLLECTION":
          link = "index.html?collectionId=" + notification.subjectId;
          if (window.location.href.indexOf("index.html") >= 0) {
            link = "javascript:;";
          }
          break;

        case "ASSET":
          link =
            "index.html?startingModule=previewAsset&assetId=" +
            notification.subjectId +
            "&from=home";
          if (window.location.href.indexOf("index.html") >= 0) {
            link = "javascript:;";
          }
          break;

        case "CART":
          link =
            "index.html?startingModule=cart&loadCart=" + notification.subjectId;
          if (window.location.href.indexOf("index.html") >= 0) {
            link = "javascript:;";
          }
          break;

        case "FEED":
          link = "news.html";
          break;

        case "FEEDITEM":
          link = "page_news_item.html?newsItemId=" + notification.subjectId;
          break;
        case "CONSENT":
          // TODO should also cancel polling for notifications at
          // increased rate, but there could be multiple if using create
          // meeting form, so just leaving it active for now
          link = undefined;
          break;
        case "SHARE":
          if (
            typeof pollingForRemoteConsentNotif !== "undefined" &&
            pollingForRemoteConsentNotif == true
          ) {
            // polling interval was increased to check for remote consent completion,
            // reset back to default polling interval
            pollingForRemoteConsentNotif = false;
            SalesToolkit.UI.Notifications.setPollInterval(
              prevNotifInterval || 47000
            );
          }
          link = undefined;
          break;
        default:
          link = undefined;
      }
  } else {
    type = notificationOrType;
  }

  var defaults = SalesToolkit.UI.Notifications.types.default;
  var notificationType = {};

  for (var property in SalesToolkit.UI.Notifications.types[type]) {
    if (SalesToolkit.UI.Notifications.types[type].hasOwnProperty(property)) {
      notificationType[property] =
        SalesToolkit.UI.Notifications.types[type][property];
    }
  }

  for (var property in defaults) {
    if (defaults.hasOwnProperty(property)) {
      if (!notificationType.hasOwnProperty(property)) {
        notificationType[property] = defaults[property];
      }
    }
  }

  if (window.jQuery && window.jQuery.notific8) {
    var notificationsBefore = document.querySelectorAll(
      ".jquery-notific8-notification"
    );

    window.jQuery.notific8(message, {
      heading:
        title ||
        SalesToolkit.Translation.get(
          notificationType.headingTranslationKey,
          notificationType.heading
        ),
      theme: notificationType.theme + " notification-type-" + type,
      sticky: notificationType.sticky,
      life: notificationType.life,
      horizontalEdge: notificationType.horizontalEdge,
      verticalEdge: notificationType.verticalEdge,
    });

    var notificationsAfter = document.querySelectorAll(
      ".jquery-notific8-notification"
    );

    var newNotification = null;
    for (var i = 0; i < notificationsAfter.length; i++) {
      var found = false;
      for (var j = 0; j < notificationsBefore.length; j++) {
        if (notificationsBefore[j] == notificationsAfter[i]) found = true;
        break;
      }
      if (!found) {
        newNotification = notificationsAfter[i];
        break;
      }
    }

    if (newNotification) {
      newNotification.setAttribute(
        "data-salestoolkit-notification-id",
        notification.id
      );

      if (link != undefined) {
        newNotification.setAttribute(
          "data-salestoolkit-notification-link",
          link
        );
      }

      if (
        SalesToolkit.Theme.getBooleanProperty(
          "autoAcknowledgeNotifications",
          true
        )
      ) {
        notification.acknowledged = true;
         tryDismissNotification(notification);
        if (SalesToolkit.User.username)
          SalesToolkit.LocalStorage.set(
            "atheneumNotificationHistoryForUser_" + SalesToolkit.User.username,
            JSON.stringify(SalesToolkit.UI.Notifications.history)
          );
      }

      newNotification.onclick = function (event) {
        var id = this.getAttribute("data-salestoolkit-notification-id");
        var link = this.getAttribute("data-salestoolkit-notification-link");
        var notification =
          SalesToolkit.UI.Notifications.history[
            SalesToolkit.UI.Notifications.getHistoryIndex(id)
          ];

        if (!notification) return; // this shouldn't be possible

        var et = event.target;
        while (
          et &&
          et.className !== undefined &&
          !(
            et.matches(".jquery-notific8-close-sticky") ||
            et.matches(".jquery-notific8-close")
          )
        ) {
          et = et.parentNode;
        }

        if (et && et.className) {
          // clicking the close button should just close the notification without following the link
          notification.acknowledged = true;
           tryDismissNotification(notification);
          if (SalesToolkit.User.username)
            SalesToolkit.LocalStorage.set(
              "atheneumNotificationHistoryForUser_" +
                SalesToolkit.User.username,
              JSON.stringify(SalesToolkit.UI.Notifications.history)
            );
          SalesToolkit.UI.Notifications.renderList();
          return false;
        }

        // following the link counts as acknowledging it
        if (link) {
          notification.acknowledged = true;
           tryDismissNotification(notification);
          if (SalesToolkit.User.username)
            SalesToolkit.LocalStorage.set(
              "atheneumNotificationHistoryForUser_" +
                SalesToolkit.User.username,
              JSON.stringify(SalesToolkit.UI.Notifications.history)
            );
          SalesToolkit.UI.Notifications.renderList();
          if (window.location.href.indexOf("index.html") >= 0) {
            if (link.indexOf("startingModule=cart") >= 0) {
              SalesToolkitApplication.navigator.loadCartScreen(false);
            } else if (link.indexOf("startingModule=favourites") >= 0) {
              SalesToolkitApplication.navigator.loadFavouritesScreen(false);
            } else {
              window.location = link;
            }
          }
        }

        // otherwise, they just clicked on a random part of the notification.
        // ignore it
      };
    }
  } else {
    console.log(
      "SalesToolkit " +
        (title || notificationType.heading) +
        " Notification: " +
        message
    );
  }
};

SalesToolkit.UI.ItemGroupDisplay.defaultRatingMaxStars = 5;
SalesToolkit.UI.ItemGroupDisplay.defaultRatingStarEmptyTemplate =
  '<img src="img/rating-star-empty.svg" style="max-height: 100%;" />';
SalesToolkit.UI.ItemGroupDisplay.defaultRatingStarHalfTemplate =
  '<img src="img/rating-star-half.svg" style="max-height: 100%;" />';
SalesToolkit.UI.ItemGroupDisplay.defaultRatingStarFullTemplate =
  '<img src="img/rating-star-full.svg" style="max-height: 100%;" />';
SalesToolkit.UI.ItemGroupDisplay.defaultUnratedTemplate =
  '<span class="unrated" title="Unrated">' +
  SalesToolkit.UI.ItemGroupDisplay.defaultRatingStarEmptyTemplate +
  SalesToolkit.UI.ItemGroupDisplay.defaultRatingStarEmptyTemplate +
  SalesToolkit.UI.ItemGroupDisplay.defaultRatingStarEmptyTemplate +
  SalesToolkit.UI.ItemGroupDisplay.defaultRatingStarEmptyTemplate +
  SalesToolkit.UI.ItemGroupDisplay.defaultRatingStarEmptyTemplate +
  "</span>";

SalesToolkit.UI.CollectionBrowser.setDefaultItemTemplate(
  "" +
    '<div class="col-sm-12 col-md-3 collection-browser-item collection-browser-{ item.type:format(id) } atheneum-item" data-atheneum-item-type="{ item.type:format(id) }" data-atheneum-item-id="{ item.id:format(id) }" data-atheneum-item="{item}" style="">' +
    '<div class="collection-style">' +
    '<div class="collectionIconContainer">' +
    '<div class="collectionIconInnerContainer">' +
    '<a class="thumbnail-and-text" class="atheneum-item-action homeheading" data-atheneum-item-action="view">' +
    '<div class="thumbnail-image-wrapper" />' +
    '<div class="thumbnail-image" data-background-image-url="{ item.imageUrl:format(url) }?keepRatio=true&shouldCrop=false&width=800&height=450"></div>' +
    "</div>" +
    '<div class="textbox-home">' +
    '<h4 align="center" class="collection-name atheneum-item-name hide-overflow-text">{ item.name }</h4>' +
    // +						'<div align="center" class="atheneum-item-description hide-overflow-text">{ item.description:60 }</div>'
    "</div>" +
    "</a>" +
    "</div>" +
    "</div>" +
    "</div>" +
    '<div class="asset-style">' +
    '<div class="collectionIconContainer">' +
    '<div class="collectionIconInnerContainer">' +
    '<div class="atheneum-item-action-btn-holder">' +
    '<a href="javascript:;" data-atheneum-item-action="toggle-info" class="atheneum-item-action info-btn tooltips btn btn-circle btn-icon-only btn-default" data-container="body" data-placement="top" data-html="true" data-original-title="Information" title="Information" data-toggle="tooltip"><img class="docimg fav-empty-icon" src="img/default/info_icon.svg"></a>' +
    '<a href="javascript:;" data-atheneum-item-action="toggle-favourite" class="atheneum-item-action tooltips btn btn-circle btn-icon-only btn-default" data-container="body" data-placement="top" data-html="true" data-original-title="Add to Favourites">' +
    '<img class="docimg fav-empty-icon" src="" />' +
    "</a>" +
    '<a href="javascript:;" style="{ if ( item.shareable ) }visibility:unset;{ else }visibility:hidden;{ end if }" data-atheneum-item-action="toggle-cart" class="atheneum-item-action tooltips btn btn-circle btn-icon-only btn-default" data-container="body" data-placement="top" data-html="true"  data-original-title="Add to Cart">' +
    '<img class="docimg" src="" />' +
    "</a>" +
    "</div>" +
    '<a href="javascript:;" data-atheneum-item-action="view" class="atheneum-item-action" data-container="body">' +
    '<div class="thumbnail favthumbnail" data-atheneum-item-action="view" data-background-image-url="{ item.imageUrl:format(url) }?keepRatio=true&shouldCrop=false&width=800&height=450">' +
    "</div>" +
    "</a>" +
    '<div class="assetThumbnailButtons carticons" style="text-align: center;" >' +
    '<div class="textstarsholder">' +
    '<div class="caption favcaption">' +
    '<h4 class="hide-overflow-text-fav text-left { if ( item.noPath ) } noPath { end if } atheneum-item-name atheneum-item-action" data-atheneum-item-action="view"  style="font-weight: 600;">{ item.name }</h4>' +
    "</div>" +
    //+ '<div class="asset-rating rating-mobile" title="{ item.rating }">{ item.starRating }</div>'

    "</div>" +
    '<a style="display:none;" onclick="showDescription(\'{ item.type:format(id) }\')" class="atheneum-item-action tooltips btn btn-circle btn-icon-only btn-default">' +
    //+						'<img class="docimg" src="{ if ( item.description:format(exists) ) }img/default/descr_icon.svg{ else }img/default/descr_icon-grey.svg{ end if }">'
    "</a>" +
    '<a style="display:none; href="javascript:;" data-atheneum-item-action="view" class="atheneum-item-action tooltips btn btn-circle btn-icon-only btn-default" data-container="body" data-placement="top" data-html="true" title="Preview"  data-original-title="Preview">' +
    '<img class="docimg" src="img/default/view_icon.svg">' +
    "</a>" +
    '<span  class="subtitleText hide-overflow-text-fav text-left atheneum-item-collectionPath">{ item.collectionPath }</span>' +
    "</div>" +
    '<div class="description thumbnail-description w3-animate-top" style="display:none">' +
    '<a class="description-clear" onclick="showDescription(\'{ item.type:format(id) }\')">' +
    '<img src="img/default/btn-close.svg" height = "14px"> </a>' +
    '<p class="description-text">{ item.description:default("&nbsp;") }</p></div>' +
    "</div>" +
    "</div>" +
    "</div>"
);

SalesToolkit.UI.Cart.setDefaultItemTemplate(
  "" +
    '<div class="col-sm-12 col-md-2 atheneum-item" data-atheneum-item-id="{ item.id:format(id) }" data-atheneum-item="{item}" style="display: inline-table; float: none; margin-bottom: 15px;">' +
    '<div class="asset-style">' +
    '<div class="collectionIconContainer">' +
    '<div class="collectionIconInnerContainer">' +
    '<div class="atheneum-item-action-btn-holder cart-holder">' +
    '<a href="javascript:;" data-atheneum-item-action="toggle-info" class="atheneum-item-action info-btn tooltips btn btn-circle btn-icon-only btn-default" data-container="body" data-placement="top" data-html="true" data-original-title="Information" title="Information" data-toggle="tooltip"><img class="docimg fav-empty-icon" src="img/default/info_icon.svg"></a>' +
    '<a href="javascript:;" data-atheneum-item-action="toggle-favourite" class="atheneum-item-action tooltips btn btn-circle btn-icon-only btn-default" data-container="body" data-placement="top" data-html="true" data-original-title="Add to Favourites">' +
    '<img class="docimg fav-empty-icon" src="{ if (item.inFavourites) }img/default/favourites_full_icon.svg{ else }img/default/favourites_empty_icon_sml.svg{ end if }" />' +
    "</a>" +
    '<a href="javascript:;" data-atheneum-item-action="remove-from-cart" class="atheneum-item-action tooltips btn btn-circle btn-icon-only btn-default" data-container="body" data-placement="top" data-html="true" title="Remove from Cart" data-original-title="Remove from Cart">' +
    '<img class="docimg remove-icon" src="">' +
    "</a>" +
    "</div>" +
    '<a href="javascript:;" data-atheneum-item-action="view" class="atheneum-item-action" data-container="body">' +
    '<div class="thumbnail favthumbnail" data-background-image-url="{ item.imageUrl:format(url) }?keepRatio=true&shouldCrop=false&width=800&height=450">' +
    "</div>" +
    "</a>" +
    '<div class="assetThumbnailButtons carticons" style="text-align: center;">' +
    '<div class="textstarsholder">' +
    '<div class="caption favcaption">' +
    '<h4 class="hide-overflow-text-fav text-left atheneum-item-name atheneum-item-action" data-atheneum-item-action="view" style="font-weight: 600;">{item.name}</h4>' +
    "</div>" +
    //+				'<div style="color: #0079ad" class="asset-rating rating-mobile" title="{item.rating}">{item.starRating}</div>'

    "</div>" +
    '<a   style="display:none;" onclick="showDescription(\'{ item.id:format(id) }\')" class="atheneum-item-action tooltips btn btn-circle btn-icon-only btn-default" >' +
    //	+						'<img class="docimg" src="{ if ( item.description:format(exists) ) }img/default/descr_icon.svg{ else }img/default/descr_icon-grey.svg{ end if }">'
    "</a>" +
    '<a style="display:none;" href="javascript:;" data-atheneum-item-action="view" class="atheneum-item-action tooltips btn btn-circle btn-icon-only btn-default" data-container="body" data-placement="top" data-html="true" title="Preview"  data-original-title="Preview">' +
    '<img class="docimg" src="img/default/view_icon.svg">' +
    "</a>" +
    "</div>" +
    '<div class="description thumbnail-description w3-animate-top" style="display:none">' +
    '<a class="description-clear" onclick="showDescription(\'{ item.id:format(id) }\')">' +
    '<img src="img/default/btn-close.svg" height = "14px"> </a>' +
    '<p class="description-text">{ item.description:default("&nbsp;") }</p></div>' +
    "</div>" +
    "</div>" +
    "</div>"
);

SalesToolkit.UI.Favourites.setDefaultItemTemplate(
  "" +
    '<div class="col-sm-12 col-md-2 atheneum-item" data-atheneum-item-id="{ item.id:format(id) }" data-atheneum-item="{item}" style="display: inline-table; float: none; margin-bottom: 15px;">' +
    '<div class="asset-style">' +
    '<div class="collectionIconContainer">' +
    '<div class="collectionIconInnerContainer">' +
    '<div class="atheneum-item-action-btn-holder favourite-holder">' +
    '<a href="javascript:;" data-atheneum-item-action="toggle-info" class="atheneum-item-action info-btn tooltips btn btn-circle btn-icon-only btn-default" data-container="body" data-placement="top" data-html="true" data-original-title="Information" title="Information" data-toggle="tooltip"><img class="docimg fav-empty-icon" src="img/default/info_icon.svg"></a>' +
    '<a href="javascript:;" style="{ if ( item.shareable ) }visibility:unset;{ else }visibility:hidden;{ end if }" data-atheneum-item-action="toggle-cart" class="atheneum-item-action tooltips btn btn-circle btn-icon-only btn-default" data-container="body" data-placement="top" data-html="true"  data-original-title="Add to Cart">' +
    '<img class="docimg" src="{ if (item.inCart) }img/default/shopping_cart_full_new.svg{ else }img/default/shopping_cart_new_blue.svg{ end if }" />' +
    "</a>" +
    '<a href="javascript:;" data-atheneum-item-action="remove-from-favourites" class="atheneum-item-action tooltips btn btn-circle btn-icon-only btn-default" data-container="body" data-placement="top" data-html="true" title="Remove from Favourites" data-original-title="Remove from Favourites">' +
    '<img class="docimg remove-icon" src="img/default/bin_icon.svg">' +
    "</a>" +
    "</div>" +
    '<a href="javascript:;" data-atheneum-item-action="view" class="atheneum-item-action" data-container="body">' +
    '<div class="thumbnail favthumbnail" data-background-image-url="{ item.imageUrl:format(url) }?keepRatio=true&shouldCrop=false&width=800&height=450">' +
    "</div>" +
    "</a>" +
    '<div class="assetThumbnailButtons carticons" style="text-align: center;">' +
    '<div class="textstarsholder">' +
    '<div class="caption favcaption">' +
    '<h4 class="hide-overflow-text-fav text-left atheneum-item-name atheneum-item-action" data-atheneum-item-action="view" style="font-weight: 600;">{item.name}</h4>' +
    "</div>" +
    //+ '<div style="color: #0079ad" class="asset-rating rating-mobile" title="{item.rating}">{item.starRating}</div>'
    "</div>" +
    '<a style="display:none;" onclick="showDescription(\'{ item.id:format(id) }\')" class="atheneum-item-action tooltips btn btn-circle btn-icon-only btn-default" >' +
    //+						'<img class="docimg" src="{ if ( item.description:format(exists) ) }img/default/descr_icon.svg{ else }img/default/descr_icon-grey.svg{ end if }">'
    "</a>" +
    '<a  style="display:none;" href="javascript:;" data-atheneum-item-action="view" class="atheneum-item-action tooltips btn btn-circle btn-icon-only btn-default" data-container="body" data-placement="top" data-html="true" title="Preview"  data-original-title="Preview">' +
    '<img class="docimg" src="img/default/view_icon.svg">' +
    "</a>" +
    "</div>" +
    '<div class="description thumbnail-description w3-animate-top" style="display:none">' +
    '<a class="description-clear" onclick="showDescription(\'{ item.id:format(id) }\')">' +
    '<img src="img/default/btn-close.svg" height = "14px"> </a>' +
    '<p class="description-text"> { item.description:default("&nbsp;") }</p> </div>' +
    "</div>" +
    "</div>" +
    "</div>"
);

function showDescription(id) {
  var description = document.querySelector(
    ".atheneum-item[data-atheneum-item-id=" + id + "] .description"
  );

  if (description.style.display === "none") {
    description.style.display = "block";
  } else {
    description.style.display = "none";
  }
}

SalesToolkit.UI.Cart.updateMenuCartBadge = function () {
  var salestoolkitCartBadge = document.getElementById(
    "salestoolkit-cart-badge"
  );
  if (salestoolkitCartBadge != null)
    salestoolkitCartBadge.innerHTML =
      SalesToolkit.Cart.getTotalItems() > 0
        ? SalesToolkit.Cart.getTotalItems()
        : "";

  if (typeof updateHeaderCartIcon === "function") {
    updateHeaderCartIcon();
  }
};

SalesToolkit.UI.Cart.updateMenuCartBadge();

var renderSalesToolkitLanguages = function () {
  var language;

  if (
    ((SalesToolkit.User.preferences || {}).language || "").toLowerCase() ==
    "debug"
  ) {
    language = { iso_code: "debug", name: "Debug" };
  } else {
    language =
      SalesToolkit.User.getLanguage() ||
      SalesToolkit.Language.getBrowserPreferred() ||
      SalesToolkit.Language.getDefault();
  }

  if (!document.querySelector(".dropdown-language")) return;

  // document.querySelector('.dropdown-language > a > img').src = "img/langs/" + language.iso_code.toLowerCase() + ".png";
  document.querySelector(".dropdown-language > a > .langname").innerHTML =
    SalesToolkit.Language.getNativeName(language) ||
    SalesToolkit.Language.getNativeName(
      SalesToolkit.Language.getBrowserPreferred()
    ) ||
    SalesToolkit.Language.getNativeName(SalesToolkit.Language.getDefault());

  var languageDropdown = document.querySelector(
    ".dropdown-language > .dropdown-menu"
  );
  languageDropdown.innerHTML = "";

  var input = document.querySelector(".dropdown-language > .wrapper > input");

  var listBuilder = document.createElement("DIV");

  var languageList = [];
  for (var i = 0; i < SalesToolkit.Language.list.length; i++) {
    languageList[languageList.length] = SalesToolkit.Language.list[i];
  }
  if (language && language.iso_code.toLowerCase() == "debug") {
    languageList.unshift(language);
  }

  for (var i = 0; i < languageList.length; i++) {
    var lang = languageList[i];

    var langSimplified = lang.iso_code.toLowerCase();
    langSimplified = langSimplified.substring(langSimplified.indexOf("-") + 1);

    listBuilder.innerHTML =
      "<li>" +
      '<a href="javascript:;" data-atheneum-language-iso-code="' +
      lang.iso_code +
      '" onclick="SalesToolkit.User.setLanguage(\'' +
      lang.iso_code +
      "', userChangedLanguageCallback );\">" +
      '<img class="language-flag" src="img/langs/' +
      langSimplified +
      '.png" alt="' +
      (lang.iso_code.toLowerCase() == "debug"
        ? "##"
        : SalesToolkit.Language.getNativeName(lang)) +
      '" title="' +
      (lang.iso_code.toLowerCase() == "debug"
        ? ""
        : SalesToolkit.Language.getNativeName(lang)) +
      '" />' +
      SalesToolkit.Language.getNativeName(lang) +
      "</a>" +
      "</li>";

    while (listBuilder.firstChild)
      languageDropdown.appendChild(listBuilder.firstChild);
  }

  if (SalesToolkit.Language.list.length == 0) {
    var lang =
      SalesToolkit.Language.getBrowserPreferred() ||
      SalesToolkit.Language.getDefault();
    var langSimplified = lang.iso_code.toLowerCase();
    langSimplified = langSimplified.substring(langSimplified.indexOf("-") + 1);

    listBuilder.innerHTML =
      "<li>" +
      '<a href="javascript:;" data-atheneum-language-iso-code="' +
      lang.iso_code +
      '" onclick="SalesToolkit.User.setLanguage(\'' +
      lang.iso_code +
      "', userChangedLanguageCallback );\">" +
      '<img class="language-flag" src="img/langs/' +
      langSimplified +
      '.png" alt="' +
      SalesToolkit.Language.getNativeName(lang) +
      '" title="' +
      SalesToolkit.Language.getNativeName(lang) +
      '" />' +
      SalesToolkit.Language.getNativeName(lang) +
      "</a>" +
      "</li>";
    while (listBuilder.firstChild)
      languageDropdown.appendChild(listBuilder.firstChild);
  }

  if (typeof input !== "undefined" && input) {
    input.disabled = false;
  }

  if (SalesToolkit.Theme.getBooleanProperty("showLanguagePicker", false)) {
    $("#languageSelector").css("display", "flex");
  } else {
    $("#languageSelector").css("display", "none");
  }
};

if (SalesToolkit.User.isLoggedIn) {
  renderSalesToolkitLanguages();
  if (!ignoreUpdate) {
    SalesToolkit.Language.update({
      success: function () {
        renderSalesToolkitLanguages();
      },
      failure: function () {
        renderSalesToolkitLanguages();
      },
    });
  }
}

renderTranslations = function (forceRerender = false) {
  if (true) {
    try {
      // special case for website link because I am not making a separate data-href-translation check
      if (SalesToolkit.Theme.getBooleanProperty("useLinkInFooter", true))
        (
          document.querySelector(
            ".page-footer-inner a, .copyright a, .page-footer-custom a"
          ) || {}
        ).href = SalesToolkit.Translation.get(
          "salestoolkitWebsiteLink",
          SalesToolkit.Theme.getStringProperty(
            "salestoolkitFooterLinkHref",
            "http://www.tangent90.co.uk"
          )
        );
      else
        (
          document.querySelector(
            ".page-footer-inner a, .copyright a, .page-footer-custom a"
          ) || {}
        ).removeAttribute("href");
    } catch (err) {}

    (
      document.querySelector(
        ".page-footer-inner a, .copyright a, .page-footer-custom a"
      ) || {}
    ).title = SalesToolkit.Translation.get(
      "salestoolkitWebsiteTitle",
      SalesToolkit.Theme.getStringProperty(
        "salestoolkitFooterLinkText",
        "http://www.tangent90.co.uk"
      )
    )
      .replace(/http[s]?:\/\//, "")
      .replace(/\/$/, "");

    $(".page-footer .page-footer-inner").show();
    $(".left-text-inner").hide();

    // $('[data-translation-defaults=autogenerate] [data-translation-key]:not([data-translation-default])').each(function () {
    // 	let element = this;
    // 	setTimeout(function(){ $(element).attr('data-translation-default', $(element).html()); }, 0);
    // });

    $(
      ".hasTranslationKey, [data-translation-key], [data-translation-default]"
    ).each(function () {
      let element = this;
      setTimeout(function () {
        if (
          !forceRerender &&
          $(element).attr("data-translation-rendered") == "true"
        )
          return;
        var translationKey = element.dataset.translationKey;

        var translationDefault = (element.dataset || {}).translationDefault;

        if (translationDefault == undefined) {
          if (
            $(element).parents("[data-translation-defaults=autogenerate]")
              .length > 0
          ) {
            $(element).attr("data-translation-default", $(element).html());
            translationDefault = $(element).html();
          } else {
            translationDefault =
              element.dataset.translationKey || element.dataset.translationkey;
          }
        }

        if (translationKey === "currentYear") {
          translationDefault = "" + new Date().getFullYear();
        }

        var translatedText = SalesToolkit.Translation.getOrGetThemeKey(
          translationKey,
          translationDefault
        );

        if (translationKey === "footerLeftTextForm") {
          if (SalesToolkit.Pages.CurrentPage.getQueryParam("formId")) {
            translationKey =
              "footerLeftText" +
              SalesToolkit.Pages.CurrentPage.getQueryParam("formId");
          }

          translatedText = SalesToolkit.Translation.getOrGetThemeKey(
            translationKey,
            translatedText
          );
          if (translatedText.length > 0) $(".left-text-inner").show();
        }

        if (
          translationKey.indexOf("footerLeftText") >= 0 &&
          translatedText.length == 0
        ) {
          translatedText = SalesToolkit.Translation.getOrGetThemeKey(
            "footerLeftText",
            translationDefault
          );
          if (translatedText.length > 0) $(".left-text-inner").show();
        }

        if (
          !(
            SalesToolkit.Translation.debug ||
            (
              (SalesToolkit.User.preferences || {}).language || ""
            ).toLowerCase() == "debug"
          ) &&
          element.dataset.translationArguments != undefined
        ) {
          try {
            var translationArgs = eval(element.dataset.translationArguments);

            if (typeof translationArgs !== "object") {
              translationArgs = [translationArgs];
            }

            for (var i = 0; i < translationArgs.length; i++) {
              translatedText = translatedText.replace(
                "{" + i + "}",
                translationArgs[i]
              );
            }
          } catch (e) {
            console.log(
              "Invalid Translation Arguments for key " +
                element.dataset.translationKey +
                ": " +
                element.dataset.translationArguments
            );
          }
        } else if (
          element.getAttribute("data-translation-arg0-value") != undefined
        ) {
          translatedText = translatedText.replace(
            "{0}",
            element.getAttribute("data-translation-arg0-value")
          );
          if (
            element.getAttribute("data-translation-arg1-value") != undefined
          ) {
            translatedText = translatedText.replace(
              "{1}",
              element.getAttribute("data-translation-arg0-value")
            );
          }
        }

        if (
          !(
            SalesToolkit.Translation.debug ||
            (
              (SalesToolkit.User.preferences || {}).language || ""
            ).toLowerCase() == "debug"
          ) &&
          element.dataset.translationCase != undefined
        ) {
          if (element.dataset.translationCase == "upper") {
            translatedText = translatedText.toUpperCase();
          } else if (element.dataset.translationCase == "lower") {
            translatedText = translatedText.toLowerCase();
          } else if (element.dataset.translationCase == "title") {
            translatedText = translatedText.toTitleCase();
          }
        }

        if ($(element).attr("data-translation-target")) {
          $(element).attr(
            $(element).attr("data-translation-target"),
            translatedText
          );
        } else {
          element.innerHTML = translatedText;
        }

        $(element).attr("data-translation-rendered", "true");
      }, 0);
    });

    $(
      "[data-tooltip-translation-key], [data-tooltip-translationkey], [data-tooltip-translation-default]"
    ).each(function () {
      let element = this;
      setTimeout(function () {
        var translationKey =
          element.dataset.tooltipTranslationkey ||
          element.dataset.tooltipTranslationKey;

        var translationDefault = (element.dataset || {})
          .tooltipTranslationDefault;

        if (translationDefault == undefined) {
          translationDefault =
            element.dataset.tooltipTranslationkey ||
            element.dataset.tooltipTranslationkey;
        }

        var translatedText = SalesToolkit.Translation.get(
          translationKey,
          translationDefault
        );

        if (
          !SalesToolkit.Translation.debug &&
          element.dataset.tooltipTranslationArguments != undefined
        ) {
          try {
            var translationArgs = eval(
              element.dataset.tooltipTranslationArguments
            );

            if (typeof translationArgs !== "object") {
              translationArgs = [translationArgs];
            }

            for (var i = 0; i < translationArgs.length; i++) {
              translatedText = translatedText.replace(
                "{" + i + "}",
                translationArgs[i]
              );
            }
          } catch (e) {
            console.log(
              "Invalid Tooltip Translation Arguments for key " +
                (element.dataset.tooltipTranslationKey ||
                  element.dataset.tooltipTranslationkey) +
                ": " +
                element.dataset.tooltipTranslationArguments
            );
          }
        }

        if (
          !SalesToolkit.Translation.debug &&
          element.dataset.tooltipTranslationCase != undefined
        ) {
          if (element.dataset.tooltipTranslationCase == "upper") {
            translatedText = translatedText.toUpperCase();
          } else if (element.dataset.tooltipTranslationCase == "lower") {
            translatedText = translatedText.toLowerCase();
          } else if (element.dataset.tooltipTranslationCase == "title") {
            translatedText = translatedText.toTitleCase();
          }
        }

        element.dataset.originalTitle = translatedText;
        $(element).attr("title", translatedText);
      }, 0);
    });

    $(
      "[data-placeholder-translation-key], [data-placeholder-translation-default]"
    ).each(function () {
      let element = this;

      setTimeout(function () {
        var translationKey = element.dataset.placeholderTranslationKey;

        var translationDefault = (element.dataset || {})
          .placeholderTranslationDefault;

        if (translationDefault == undefined) {
          translationDefault =
            element.dataset.placeholderTranslationKey ||
            element.dataset.placeholderTranslationkey;
        }

        var translatedText = SalesToolkit.Translation.get(
          translationKey,
          translationDefault
        );

        if (
          !SalesToolkit.Translation.debug &&
          element.dataset.placeholderTranslationArguments != undefined
        ) {
          try {
            var translationArgs = eval(
              element.dataset.placeholderTranslationArguments
            );

            if (typeof translationArgs !== "object") {
              translationArgs = [translationArgs];
            }

            for (var i = 0; i < translationArgs.length; i++) {
              translatedText = translatedText.replace(
                "{" + i + "}",
                translationArgs[i]
              );
            }
          } catch (e) {
            console.log(
              "Invalid Placeholder Translation Arguments for key " +
                placeholderTranslationKey +
                ": " +
                element.dataset.placeholderTranslationArguments
            );
          }
        }

        if (
          !SalesToolkit.Translation.debug &&
          element.dataset.placeholderTranslationCase != undefined
        ) {
          if (element.dataset.placeholderTranslationCase == "upper") {
            translatedText = translatedText.toUpperCase();
          } else if (element.dataset.placeholderTranslationCase == "lower") {
            translatedText = translatedText.toLowerCase();
          } else if (element.dataset.placeholderTranslationCase == "title") {
            translatedText = translatedText.toTitleCase();
          }
        }

        element.setAttribute("placeholder", translatedText);
      }, 0);
    });
  }
};

renderTranslations();

if (!ignoreUpdate && window.location.href.indexOf("/login.html") < 0) {
  SalesToolkit.Translation.update({
    success: function () {
      renderTranslations();
    },
    failure: function () {
      renderTranslations();
    },
  });
}

var userChangedLanguageCallback = function () {
  languageUpdateCallback(true);
};

languageUpdateCallback = function (forceRerender = false) {
  renderSalesToolkitLanguages();

  if (typeof updateTableLanguages === "function") updateTableLanguages();

  renderTranslations(forceRerender);

  setTimeout(function () {
    document.dispatchEvent(
      new CustomEvent(
        SalesToolkitApplication.Events.COLLECTION_BROWSER_REFRESH_PATH,
        {
          detail: {
            path: [],
            ignoreTracking: true,
          },
        }
      )
    );

    updateContactSessionInfoPopup();
    addFormsToSideMenu();
  }, 100);

  if (window.location.href.indexOf("/login.html") >= 0) {
    renderTranslations(forceRerender);
    return;
  }

  SalesToolkit.Translation.update({
    success: function () {
      renderTranslations(forceRerender);
      updateContactSessionInfoPopup();
      if (typeof updateTableLanguages === "function") updateTableLanguages();
    },
    failure: function () {
      renderTranslations(forceRerender);
      updateContactSessionInfoPopup();
      if (typeof updateTableLanguages === "function") updateTableLanguages();
    },
  });
};

if (!ignoreUpdate) SalesToolkit.Language.update(languageUpdateCallback);

renderSalesToolkitUserImage = function () {
  var salestoolkitImageSRC = null;

  var skipHeaderImage = false;
  if (document.getElementById("headerBarProfileImage") != null) {
    var img = document.getElementById("headerBarProfileImage");
    var src = img.getAttribute("src");
    if (
      (src && img.getAttribute("data-loaded-successfully")) ||
      img.getAttribute("data-loading")
    ) {
      // image loaded successfully
      salestoolkitImageSRC = src;
      skipHeaderImage = true;
    }
  }

  var profileImage = document.querySelector(
    ".dropdown-user #headerBarProfileImage.img-circle"
  );
  var otherPI = document.getElementById("salestoolkit-profile-image");
  var userProfileSrc = SalesToolkit.User.preferences.profileImg || "";
  var userId = SalesToolkit.User.id;
  var USER_ICON_DEFAULT = SalesToolkit.Theme.getStringProperty(
    "salestoolkitHeaderIconProfile",
    "img/default/user.svg"
  );

  var lastUpdateInPreferences =
    (SalesToolkit.User.preferences["profilePicLastUpdatedAt"] || "0") * 1;
  var lastUpdateInLocalStorage =
    (localStorage["profilePicLastUpdatedAt"] || "0") * 1;
  var lastProfilePicUpdate = Math.max(
    lastUpdateInPreferences,
    lastUpdateInLocalStorage
  );

  if (lastProfilePicUpdate == 0) {
    lastProfilePicUpdate = new Date().getTime();
  }

  var suffix = "";
  //"?_=" + lastProfilePicUpdate;

  if (SalesToolkit.CrossPlatform.enabled) {
    var xPlatformUserProfileSrc =
      SalesToolkit.CrossPlatform.GetUserProfileImage(userId);
    if (xPlatformUserProfileSrc != null) {
      userProfileSrc = xPlatformUserProfileSrc;
    }
    if (userProfileSrc && userProfileSrc.startsWith("iVBOR")) {
      userProfileSrc = "data:image/png;base64, " + userProfileSrc;
    } else if (userProfileSrc && !userProfileSrc.startsWith("data")) {
      userProfileSrc = userProfileSrc + suffix;
    } else {
      userProfileSrc = USER_ICON_DEFAULT;
    }
  } else if (userProfileSrc && userProfileSrc.startsWith("iVBOR")) {
    userProfileSrc = "data:image/png;base64, " + userProfileSrc;
  } else if (userProfileSrc) {
    userProfileSrc = userProfileSrc + suffix;
  } else if (SalesToolkit.Proxy.enabled) {
    userProfileSrc = "restful/imageCache/user/" + SalesToolkit.User.id + suffix;
  } else if (
    userProfileSrc &&
    !userProfileSrc.endsWith("png") &&
    !userProfileSrc.endsWith("jpg")
  ) {
    if (!userProfileSrc.startsWith("data:image/")) {
      userProfileSrc = "data:image/png;base64, " + userProfileSrc;
    }
    //		userProfileSrc = userProfileSrc;
  } else {
    userProfileSrc = USER_ICON_DEFAULT;
  }

  if (
    userProfileSrc == USER_ICON_DEFAULT &&
    SalesToolkit.CrossPlatform.enabled
  ) {
    if (!skipHeaderImage) renderUserIconWithTheme = true;
    //If it's the default icon leave it to theme to apply
    SalesToolkit.CrossPlatform.rewriteURLPromise(USER_ICON_DEFAULT).then(
      function (url) {
        userProfileSrc = url;

        if (otherPI) {
          otherPI.src = userProfileSrc;
        }

        if (profileImage && !skipHeaderImage) {
          profileImage.src = userProfileSrc;
          profileImage.style.display = "block";
        }
      },
      function (error) {
        if (otherPI) {
          otherPI.src = userProfileSrc;
        }

        if (profileImage && !skipHeaderImage) {
          profileImage.src = userProfileSrc;
          profileImage.style.display = "block";
        }
      }
    );
  } else {
    if (!skipHeaderImage && profileImage) {
      if (userProfileSrc.indexOf("?") != -1) {
        userProfileSrc += "&width=56&height=56";
      }
      profileImage.setAttribute("alt", "");
      renderUserIconWithTheme = false;
      profileImage.src = userProfileSrc;
      profileImage.classList.remove("defaultIcon");
    }

    if (otherPI) {
      let profileImage = userProfileSrc;

      if (SalesToolkit.CrossPlatform.enabled) {
        profileImage = SalesToolkit.CrossPlatform.GetUserProfileImage(
          SalesToolkit.User.id
        );
      }

      if (!profileImage || profileImage == null) profileImage = userProfileSrc;

      if (profileImage && profileImage.startsWith("iVBOR")) {
        profileImage = "data:image/png;base64, " + profileImage;
      } else if (
        profileImage &&
        !profileImage.startsWith("data") &&
        !profileImage.contains(suffix)
      ) {
        profileImage = profileImage + suffix;
      }

      if (profileImage.indexOf("file:") >= 0)
        profileImage += "?_=" + new Date().getTime();
      otherPI.src = profileImage;
    }

    if (profileImage) profileImage.style.display = "block";
  }

  //profileImage.style.visibility = 'visible';

  salestoolkitImageSRC = userProfileSrc;
  salestoolkitUserImageCache = new Image();
  salestoolkitUserImageCache.src = userProfileSrc;
};

renderSalesToolkitUserImage();

if (!ignoreUpdate) {
  SalesToolkit.User.update({
    success: function () {
      renderSalesToolkitUserImage();
    },
  });
}

compressLibraryData = function (data) {
  var replacementChar = "~";

  var keys = [
    replacementChar,
    SalesToolkit.API.BASE_URL_NO_PROXY,
    SalesToolkit.API.BASE_URL_NO_PROXY.replace("https", "http"),
    '"allowedGroups":[',
    '"allowedCountries":[',
    '"allowedLanguages":[',
    '"allowed',
    '"approvalDate":',
    '"assetOrder":',
    '"assets":[',
    '"asset_type":"',
    '"authors":"',
    '"avgRating":',
    '"canPreview":true,',
    '"canPreview":false,',
    '"canStream":true',
    '"canStream":false',
    '"containedBy":"',
    '"content":"',
    '"countries":',
    '"customType":"',
    '"description":"',
    '"docId":"',
    '"fileModified":',
    '"guestAccess":true',
    '"guestAccess":false',
    '"id":',
    '"icon":',
    '"image":',
    '"keywords":"',
    '"languages":[',
    '"mimetype":"application/pdf"',
    '"mimetype":"',
    '"modified":',
    '"name":"',
    '"noPages":',
    '"properties":"',
    '"properties":{',
    '"published":',
    '"publishDate":',
    '"ratingCount":',
    '"ratingTotal":',
    '"related":[',
    '"shareByEmail":true',
    '"shareByEmail":false',
    '"shareByFacebook":true',
    '"shareByFacebook":false',
    '"shareByLinkedIn":true',
    '"shareByLinkedIn":false',
    '"shareByTwitter":true',
    '"shareByTwitter":false',
    '"shareByGoogle":true',
    '"shareByGoogle":false',
    '"shareBy',
    '"size":',
    '"summary":"',
    '"thumb":{',
    '"timestamp":',
    '"translations":[',
    '"url":"',
    '"visible":true',
    '"visible":false',
    '"views":',
  ];

  for (var i = 0; i < keys.length; i++) {
    var regex = new RegExp(
      keys[i].replace("[", "\\[").replace("{", "\\{"),
      "g"
    );
    var replacement;

    if (i < 26) {
      replacement = replacementChar + String.fromCharCode(65 + i);
    } else if (i < 52) {
      replacement = replacementChar + String.fromCharCode(71 + i);
    } else if (i < 62) {
      replacement = replacementChar + String.fromCharCode(i - 4);
    } else {
      replacement = replacementChar + String.fromCharCode(i + 63);
    }

    data = data.replace(regex, replacement);
  }

  newData = data.replace(/\|/g, "|_");
  newData = data.replace(/,~/g, "|");
  if (newData.length <= data.length) data = newData;
  else
    console.log(
      "Sanity Error:  " +
        keys[i] +
        "   -->   " +
        replacement +
        "   increases size"
    );

  return data;
};

salestoolkitSyncStopped = false;
salestoolkitSyncStopAfter = 0;
salestoolkitSyncLastTotalAssets = 0;

SalesToolkit.Cache.onSyncFinished = function (where) {
  SalesToolkit.UI.Cart.updateMenuCartBadge();
  // console.log("sync finished: " + where );

  if (!ignoreUpdate) SalesToolkit.Library.update();
};

salestoolkitSyncClickCallback = function (manualSync) {
  if (
    (!SalesToolkit.Proxy.enabled && !SalesToolkit.CrossPlatform.enabled) ||
    !SalesToolkit.User.isLoggedIn
  )
    return;

  if (manualSync)
    trackAppClick(
      $("#salestoolkit-cache-start-sync-div"),
      "#salestoolkit-cache-start-sync-div",
      "trackingManualSyncButton",
      SalesToolkit.Translation.get(
        "trackingManualSyncButton",
        "trackingManualSyncButton"
      )
    );

  SalesToolkit.Cache.setPollInterval(327);

  SalesToolkit.Cache.initiateSync();

  cacheIcon = document.getElementById("salestoolkit-cache-icon");

  if (cacheIcon != null) {
    document.getElementById("salestoolkit-cache-state").className =
      "badge salestoolkit-cache-state-syncing";
    document.getElementById("salestoolkit-cache-state").innerHTML = "SYNCING";
    cacheIcon.firstElementChild.classList.add("fa-spin");
    cacheIcon.className = "icon-settings";

    document.getElementById("salestoolkit-cache-start-sync-div").style.display =
      "none";
    document.getElementById("salestoolkit-cache-progress-div").style.display =
      "block";
    document.getElementById("salestoolkit-cache-progress-bar").style.width =
      "0%";
    document.getElementById(
      "salestoolkit-cache-progress-percentage"
    ).innerHTML = "0%";

    if (
      SalesToolkit.CrossPlatform.enabled &&
      !SalesToolkit.CrossPlatform.isOnline()
    ) {
      SalesToolkit.Cache.state = SalesToolkit.Translation.get(
        "syncStatusOffline",
        "offline"
      );
      cacheIcon.className = "icon-settings";
      var state = SalesToolkit.Cache.state;
      if (state == "calculating") state = "syncing";
      document.getElementById("salestoolkit-cache-state").className =
        "badge salestoolkit-cache-state-" + state;
      document.getElementById("salestoolkit-cache-state").innerHTML =
        SalesToolkit.Translation.get(
          "syncState" + SalesToolkit.Cache.state,
          SalesToolkit.Cache.state.toUpperCase()
        );
      document.getElementById(
        "salestoolkit-cache-start-sync-div"
      ).style.display = "block";
      document.getElementById("salestoolkit-cache-progress-div").style.display =
        "none";
      document.getElementById("salestoolkit-cache-assets-total").innerHTML =
        SalesToolkit.Cache.assetsTotal || "unknown";
      document.getElementById("salestoolkit-cache-assets-failed").innerHTML =
        SalesToolkit.Cache.assetsFailed;
      document.getElementById(
        "salestoolkit-cache-assets-downloaded"
      ).innerHTML = SalesToolkit.Cache.assetsDownloaded;
      document.getElementById("salestoolkit-cache-sync-date").innerHTML =
        SalesToolkit.Cache.syncDateFormatted;
      cacheIcon.firstElementChild.classList.remove("fa-spin");
      renderPlugins();
      SalesToolkit.Cache.stopPolling();
      return;
    }

    SalesToolkit.Cache.startPolling({
      success: function (json) {
        if (
          (SalesToolkit.CrossPlatform.enabled &&
            !SalesToolkit.CrossPlatform.isOnline()) ||
          (json.progress && json.progress.offline)
        ) {
          SalesToolkit.Cache.state = SalesToolkit.Translation.get(
            "syncStatusOffline",
            "offline"
          );
          cacheIcon.className = "icon-settings";
          var state = SalesToolkit.Cache.state;
          if (state == "calculating") state = "syncing";
          document.getElementById("salestoolkit-cache-state").className =
            "badge salestoolkit-cache-state-" + state;
          document.getElementById("salestoolkit-cache-state").innerHTML =
            SalesToolkit.Translation.get(
              "syncState" + SalesToolkit.Cache.state,
              SalesToolkit.Cache.state.toUpperCase()
            );
          document.getElementById(
            "salestoolkit-cache-start-sync-div"
          ).style.display = "block";
          document.getElementById(
            "salestoolkit-cache-progress-div"
          ).style.display = "none";
          document.getElementById("salestoolkit-cache-assets-total").innerHTML =
            SalesToolkit.Cache.assetsTotal || "unknown";
          document.getElementById(
            "salestoolkit-cache-assets-failed"
          ).innerHTML = SalesToolkit.Cache.assetsFailed;
          document.getElementById(
            "salestoolkit-cache-assets-downloaded"
          ).innerHTML = SalesToolkit.Cache.assetsDownloaded;
          document.getElementById("salestoolkit-cache-sync-date").innerHTML =
            SalesToolkit.Cache.syncDateFormatted;
          cacheIcon.firstElementChild.classList.remove("fa-spin");
          renderPlugins();
          SalesToolkit.Cache.stopPolling();
          return;
        }

        if (
          salestoolkitSyncLastTotalAssets != SalesToolkit.Cache.assetsTotal &&
          SalesToolkit.Cache.assetsTotal != 0
        ) {
          // console.log("Sync: Total Assets Changed From " + salestoolkitSyncLastTotalAssets + " To " + SalesToolkit.Cache.assetsTotal);
          salestoolkitSyncStopAfter = new Date().getTime() + 900;
          salestoolkitSyncLastTotalAssets = SalesToolkit.Cache.assetsTotal;
        }

        if (
          SalesToolkit.Cache.started &&
          (!SalesToolkit.Cache.finished ||
            salestoolkitSyncStopAfter > new Date().getTime())
        ) {
          cacheIcon.firstElementChild.classList.add("fa-spin");
          cacheIcon.className = "icon-settings";
          document.getElementById(
            "salestoolkit-cache-start-sync-div"
          ).style.display = "none";
          document.getElementById(
            "salestoolkit-cache-progress-div"
          ).style.display = "block";
        } else if (SalesToolkit.Cache.finished) {
          cacheIcon.className = "icon-settings";
          cacheIcon.firstElementChild.classList.remove("fa-spin");
          renderPlugins();
          document.getElementById(
            "salestoolkit-cache-start-sync-div"
          ).style.display = "block";
          document.getElementById(
            "salestoolkit-cache-progress-div"
          ).style.display = "none";
          document.getElementById(
            "salestoolkit-cache-progress-percentage"
          ).innerHTML = "0%";
        }

        // update the sync display

        document.getElementById("salestoolkit-cache-state").className =
          "badge salestoolkit-cache-state-" + SalesToolkit.Cache.state;
        document.getElementById("salestoolkit-cache-state").innerHTML =
          SalesToolkit.Cache.state.toUpperCase();

        if (
          !SalesToolkit.Cache.finished &&
          SalesToolkit.Cache.assetsTotal == 0
        ) {
          document.getElementById("salestoolkit-cache-assets-total").innerHTML =
            "Calculating";
          document.getElementById(
            "salestoolkit-cache-assets-failed"
          ).innerHTML = "Calculating";
          document.getElementById(
            "salestoolkit-cache-assets-downloaded"
          ).innerHTML = "Calculating";
        } else {
          document.getElementById("salestoolkit-cache-assets-total").innerHTML =
            SalesToolkit.Cache.assetsTotal;
          document.getElementById(
            "salestoolkit-cache-assets-failed"
          ).innerHTML = SalesToolkit.Cache.assetsFailed;
          document.getElementById(
            "salestoolkit-cache-assets-downloaded"
          ).innerHTML = SalesToolkit.Cache.assetsDownloaded;
        }

        document.getElementById(
          "salestoolkit-cache-progress-percentage"
        ).innerHTML = SalesToolkit.Cache.progressPercentage;
        document.getElementById("salestoolkit-cache-progress-bar").style.width =
          SalesToolkit.Cache.progressPercentage;

        document.getElementById("salestoolkit-cache-sync-date").innerHTML =
          SalesToolkit.Cache.syncDateFormatted;

        if (
          !ignoreUpdate &&
          SalesToolkit.Cache.polling &&
          SalesToolkit.Cache.finished &&
          new Date().getTime() > salestoolkitSyncStopAfter
        ) {
          // console.log("Sync Finished: Downloaded " + SalesToolkit.Cache.assetsDownloaded + " of " + SalesToolkit.Cache.assetsTotal);

          SalesToolkit.Library.update({
            success: function () {
              if (
                SalesToolkit.Theme.getBooleanProperty(
                  "disableFeatureNews",
                  false
                )
              ) {
                SalesToolkit.Cache.onSyncFinished("library only");
                updateNewsTicker();
                return;
              }
              SalesToolkit.NewsFeed.update({
                success: function () {
                  SalesToolkit.Cache.onSyncFinished("both");
                  updateNewsTicker();
                },
                failure: function (reason, httpStatus, errorCode) {
                  Atheneum.Callbacks.logFailureDetails(
                    reason,
                    httpStatus,
                    errorCode
                  );
                  SalesToolkit.Cache.onSyncFinished("library only");
                },
              });

              if (typeof reloadTables === "function") reloadTables();
            },
            failure: function (reason, httpStatus, errorCode) {
              SalesToolkit.Cache.onSyncFinished("neither");
            },
          });
          SalesToolkit.Cache.stopPolling();
        }
      },

      failure: function (reason, httpStatus, errorCode) {
        // someone has killed the java applet
        if (
          SalesToolkit.CrossPlatform.enabled &&
          !SalesToolkit.CrossPlatform.isOnline()
        ) {
          SalesToolkit.Cache.state = SalesToolkit.Translation.get(
            "syncStatusOffline",
            "offline"
          );
          cacheIcon.className = "icon-settings";
          var state = SalesToolkit.Cache.state;
          if (state == "calculating") state = "syncing";
          document.getElementById("salestoolkit-cache-state").className =
            "badge salestoolkit-cache-state-" + state;
          document.getElementById("salestoolkit-cache-state").innerHTML =
            SalesToolkit.Translation.get(
              "syncState" + SalesToolkit.Cache.state,
              SalesToolkit.Cache.state.toUpperCase()
            );
          document.getElementById(
            "salestoolkit-cache-start-sync-div"
          ).style.display = "block";
          document.getElementById(
            "salestoolkit-cache-progress-div"
          ).style.display = "none";
          document.getElementById("salestoolkit-cache-assets-total").innerHTML =
            SalesToolkit.Cache.assetsTotal || "unknown";
          document.getElementById(
            "salestoolkit-cache-assets-failed"
          ).innerHTML = SalesToolkit.Cache.assetsFailed;
          document.getElementById(
            "salestoolkit-cache-assets-downloaded"
          ).innerHTML = SalesToolkit.Cache.assetsDownloaded;
          document.getElementById("salestoolkit-cache-sync-date").innerHTML =
            SalesToolkit.Cache.syncDateFormatted;
          cacheIcon.firstElementChild.classList.remove("fa-spin");
          SalesToolkit.Cache.stopPolling();
          return;
        }
        document.getElementById("salestoolkit-cache-icon").className =
          "icon-settings";
        document.getElementById(
          "salestoolkit-cache-start-sync-div"
        ).style.display = "block";
        document.getElementById(
          "salestoolkit-cache-progress-div"
        ).style.display = "none";

        document.getElementById("salestoolkit-cache-state").className =
          "badge salestoolkit-cache-state-" + SalesToolkit.Cache.state;
        document.getElementById("salestoolkit-cache-state").innerHTML =
          SalesToolkit.Cache.state.toUpperCase();

        document.getElementById("salestoolkit-cache-assets-total").innerHTML =
          SalesToolkit.Cache.assetsTotal || "unknown";
        document.getElementById("salestoolkit-cache-assets-failed").innerHTML =
          SalesToolkit.Cache.assetsFailed;
        document.getElementById(
          "salestoolkit-cache-assets-downloaded"
        ).innerHTML = SalesToolkit.Cache.assetsDownloaded;

        document.getElementById(
          "salestoolkit-cache-progress-percentage"
        ).innerHTML = SalesToolkit.Cache.progressPercentage;
        document.getElementById("salestoolkit-cache-progress-bar").style.width =
          SalesToolkit.Cache.progressPercentage;

        document.getElementById("salestoolkit-cache-sync-date").innerHTML =
          SalesToolkit.Cache.syncDateFormatted;

        SalesToolkit.Cache.stopPolling();
        Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode);
      },
    });
  }
};

//SalesToolkit.Cache.unknown  true;
salestoolkitSyncOnPageLoad = function () {
  var timeout = 200;
  if (typeof SalesToolkit.Cache.neverSynced === "undefined") timeout = 2000;

  setTimeout(function () {
    if (
      ignoreUpdate ||
      !SalesToolkit.User.isLoggedIn ||
      SalesToolkit.User.isLocked ||
      (!SalesToolkit.Proxy.enabled && !SalesToolkit.CrossPlatform.enabled)
    )
      return;

    SalesToolkit.Cache.getSyncProgress({
      success: function () {
        SalesToolkit.Cache.unknown = false;
        if (SalesToolkit.Cache.neverSynced) {
          SalesToolkit.Cache.initialSync = true;
          localStorage.initialSync = "true";
        }
        if (localStorage.initialSync == "true" && SalesToolkit.Cache.finished) {
          delete localStorage.initialSync;
          SalesToolkit.Cache.initialSync = false;
        } else if (localStorage.initialSync == "true") {
          SalesToolkit.Cache.initialSync = true;
        }
        salestoolkitSyncClickCallback();
      },

      failure: function () {
        if (
          new Date().getTime() <
          SalesToolkit.Cache.pageLoadSyncStartedAt + 10000
        )
          setTimeout(salestoolkitSyncOnPageLoad, 23);
      },
    });
  }, timeout); // give it 200ms or so, so any auto-logout on page load scripts can run
};
SalesToolkit.Cache.pageLoadSyncStartedAt = new Date().getTime();
setTimeout(salestoolkitSyncOnPageLoad, 1000);

function toRelativeDateString(date) {
  if (typeof date == "number") {
    date = new Date(date);
  }

  var now = new Date();
  var difference = now.getTime() - date.getTime();
  if (difference < 0 && difference > -10000) return "Any Moment Now";
  if (difference < 0) return "In The Future";
  //	if (difference < 10000)
  //		return "Just Now";
  if (difference < 60000) return Math.floor(difference / 1000) + "s";
  if (difference < 3600000) return Math.floor(difference / 60000) + "m";
  if (difference < 86400000) return Math.floor(difference / 3600000) + "h";

  var midnightTonight = new Date();
  midnightTonight.setHours(0, 0, 0, 0);
  var midnightTonightDayOfMonth = midnightTonight.getDate();

  var midnightYesterday = new Date();
  midnightYesterday.setDate(midnightTonight.getDate() - 1);
  midnightYesterday.setHours(0, 0, 0, 0);

  if (midnightYesterday.getTime() <= date.getTime()) return "Yesterday";

  var daysInThePast = 2;
  while (daysInThePast < 8) {
    var pastDate = new Date();
    pastDate.setDate(midnightTonightDayOfMonth - daysInThePast);
    if (pastDate.getTime() <= date.getTime()) return daysInThePast + " Days";
    daysInThePast += 1;
  }
  var pastDate = new Date();
  pastDate.setHours(0, 0, 0, 0);
  while (daysInThePast < now.getDate() && daysInThePast < 31) {
    pastDate.setDate(midnightTonightDayOfMonth - daysInThePast);
    if (pastDate.getTime() <= date.getTime()) return daysInThePast + " Days";
    daysInThePast += 1;
  }

  var monthsInThePast = 1;
  pastDate = new Date();
  pastDate.setHours(0, 0, 0, 0);
  pastDate.setDate(1);
  pastDate.setMonth(pastDate.getMonth() - monthsInThePast);
  if (pastDate.getTime() <= date.getTime()) return "Last Month";
  monthsInThePast += 1;

  while (monthsInThePast < 4) {
    pastDate.setMonth(pastDate.getMonth() - monthsInThePast);
    if (pastDate.getTime() <= date.getTime())
      return monthsInThePast + " Months";
    monthsInThePast += 1;
  }
  while (monthsInThePast < now.getMonth() && monthsInThePast < 13) {
    pastDate.setMonth(pastDate.getMonth() - monthsInThePast);
    if (pastDate.getTime() <= date.getTime())
      return monthsInThePast + " Months";
    monthsInThePast += 1;
  }

  var yearsInThePast = 1;
  pastDate = new Date();
  pastDate.setHours(0, 0, 0, 0);
  pastDate.setFullYear(now.getFullYear() - 1, 0, 1);
  if (pastDate.getTime() <= date.getTime()) return "Last Year";
  yearsInThePast += 1;
  while (yearsInThePast < 3000) {
    pastDate.setFullYear(pastDate.getFullYear() - yearsInThePast);
    if (pastDate.getTime() <= date.getTime()) return yearsInThePast + " Years";
    yearsInThePast += 1;
  }

  return "The Distant Past";
}

SalesToolkit.NewsFeed.checkForReplies = function () {
  if (SalesToolkit.Theme.getBooleanProperty("disableFeatureNews", false))
    return;

  this.onReplyUpdate();
  this.enableAutoUpdate();
  this.update();
};

function escapeHtml(unsafe) {
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

SalesToolkit.NewsFeed.onReplyUpdate = function () {
  var unreadReplies = this.getUnreadReplies();

  var newRepliesBadge = document.querySelector("#header_inbox_bar > a .badge");

  if (newRepliesBadge == null) return;

  var clearAllDropdownButton = document.querySelector(
    "#header_inbox_bar > ul > li:first-child > a"
  );
  if (clearAllDropdownButton) {
    clearAllDropdownButton.innerHTML =
      SalesToolkit.Translation.getOrGetThemeKey("repliesClearAll", "clear all");
    clearAllDropdownButton.href = "#";
    clearAllDropdownButton.setAttribute(
      "data-translation-key",
      "repliesClearAll"
    );
    clearAllDropdownButton.setAttribute(
      "data-translation-default",
      "clear all"
    );
    clearAllDropdownButton.onclick = function () {
      SalesToolkit.NewsFeed.markAllUnreadRepliesAsRead();
    };
    clearAllDropdownButton.style.display =
      unreadReplies.length == 0 ? "none" : "inline-block";
  }

  newRepliesBadge.innerHTML = unreadReplies.length;
  newRepliesBadge.style.display =
    unreadReplies.length == 0 ? "none" : "inline-block";

  var newRepliesBoldTag = document.querySelector(
    "#header_inbox_bar > ul > li > h3 > span.bold"
  );
  newRepliesBoldTag.setAttribute(
    "data-translation-arg0-value",
    "" + unreadReplies.length
  );
  newRepliesBoldTag.innerHTML = SalesToolkit.Translation.getOrGetThemeKey(
    "repliesNewCount",
    "{0} New"
  ).replace("{0}", "" + unreadReplies.length);

  var newRepliesHTML = "";
  var totalReplies = unreadReplies.length;
  for (var i = 0; i < unreadReplies.length; i++) {
    var comment = unreadReplies[i];

    if (comment == null) {
      totalReplies = totalReplies - 1;
      newRepliesBadge.innerHTML = totalReplies;
      newRepliesBoldTag.setAttribute(
        "data-translation-arg0-value",
        "" + totalReplies
      );
      newRepliesBoldTag.innerHTML = SalesToolkit.Translation.getOrGetThemeKey(
        "repliesNewCount",
        "{0} New"
      ).replace("{0}", "" + totalReplies);
      newRepliesBadge.style.display =
        totalReplies == 0 ? "none" : "inline-block";
      continue;
    }

    var userImage = comment.user.image || comment.user.profileImage;

    if (SalesToolkit.Proxy.enabled) {
      userImage = "restful/imageCache/user/" + comment.user.id;
    }

    if (userImage == undefined) userImage = USER_ICON_DEFAULT;

    var commentPostedBy = comment.user.fullName;
    if (!commentPostedBy && comment.user.firstName && comment.user.lastName)
      commentPostedBy = comment.user.firstName + " " + comment.user.lastName;
    if (!commentPostedBy && comment.user.firstName)
      commentPostedBy = comment.user.firstName;
    if (!commentPostedBy && comment.user.title && comment.user.lastName)
      commentPostedBy = comment.user.title + " " + comment.user.lastName;
    if (!commentPostedBy && comment.user.lastName)
      commentPostedBy = comment.user.lastName;
    if (!commentPostedBy)
      commentPostedBy = SalesToolkit.Translation.getOrGetThemeKey(
        "unknownUser",
        "Unknown"
      );
    commentPostedBy = escapeHtml(commentPostedBy);

    newRepliesHTML +=
      "" +
      "<li>" +
      '<a href="page_news_item.html?newsItemId=' +
      comment.newsItemId +
      '">' +
      '<span class="photo">' +
      "<img src=" +
      userImage +
      ' class="img-circle" alt="">' +
      "</span>" +
      '<span class="subject">' +
      '<span class="from">' +
      commentPostedBy +
      "</span>" +
      '<span class="time">' +
      toRelativeDateString(comment.postedAt) +
      "</span>" +
      "</span>" +
      '<span class="message">' +
      escapeHtml(comment.comment) +
      "</span>" +
      "</a>" +
      "</li>";
  }

  document.querySelector("#header_inbox_bar > ul ul").innerHTML =
    newRepliesHTML;
};

if (window.location.href.indexOf("login") < 0) {
  for (var i = 0; i < SalesToolkit.UI.Notifications.history.length; i++) {
    if (!SalesToolkit.UI.Notifications.history[i].acknowledged) {
      SalesToolkit.UI.Notifications.render(
        SalesToolkit.UI.Notifications.history[i]
      );
    }
  }
}

if (document.getElementsByTagName("html")[0].className.contains("ie9")) {
  var ie9AimationFix = function () {
    var spinners = document.querySelectorAll(".fa-spin");
    for (var i = 0; i < spinners.length; i++) {
      var element = spinners[i];
      if (!element.className.contains("ie9-spinfixed"))
        element.className += " ie9-spinfixed";
      var angle = parseInt(
        element.getAttribute("data-ie9-spinfix-angle") || "0"
      );
      element.style.msTransform = "rotate(" + angle + "deg)";
      element.setAttribute("data-ie9-spinfix-angle", (angle + 2) % 360);
    }
    var stoppers = document.querySelectorAll(".ie9-spinfixed:not(.fa-spin)");
    for (var i = 0; i < stoppers.length; i++) {
      element.style.msTransform = "rotate(0deg)";
    }
  };

  ie9AnimationFixInterval = setInterval(ie9AimationFix, 4);
}

if (!ignoreUpdate && SalesToolkit.User.isLoggedIn) {
  SalesToolkit.Theme.update(applyThemeToToolkit);
}
if (SalesToolkit.Theme.exists) {
  applyThemeToToolkit();
} else {
  loadDefaultTheme();
}

var salestoolkitEndTime = new Date();

function hasSimplifiedCartSavingPermission() {
  return (
    SalesToolkit.Theme.getBooleanProperty(
      "simplifiedCartSavingSharingPermission",
      false
    ) && SalesToolkit.User?.permissions?.canSaveCarts
  );
}

function hasSimplifiedCartSharingPermission() {
  return (
    SalesToolkit.Theme.getBooleanProperty(
      "simplifiedCartSavingSharingPermission",
      false
    ) && SalesToolkit.User?.permissions?.canShareCarts
  );
}

function setupProfileFeature() {
  //PROFILE
  $(".top-menu ul li").removeClass("allowAfter");
  if (SalesToolkit.Theme.getBooleanProperty("disableProfileTopbar", false)) {
    $("body").addClass("profileDisabled");
    $(".top-menu ul li:visible:not(:last)").toggleClass("allowAfter", true);
  } else {
    $("body").removeClass("profileDisabled");
    $(".top-menu ul li:visible:not(:last)").toggleClass("allowAfter", false);
  }
}

function setupMainFeatures() {
  var sideMenu = $(".page-sidebar-menu");

  setupProfileFeature();

  //Favourites
  if (
    !SalesToolkit.User.permissions.canFavourite ||
    SalesToolkit.Theme.getBooleanProperty("disableFeatureFavourites", false)
  ) {
    $("body").addClass("favouritesDisabled");
  } else {
    $("body").removeClass("favouritesDisabled");
  }

  //Meetings
  if (
    !SalesToolkit.Theme.getBooleanProperty("showMeetingsButton", true) ||
    SalesToolkit.Theme.getBooleanProperty("disableFeatureMeetings", false)
  )
    $("body").addClass("meetingsDisabled");
  else $("body").removeClass("meetingsDisabled");

  //Contacts Screen
  if (
    SalesToolkit.Theme.getBooleanProperty("disableFeatureContactsScreen", false)
  )
    $("body").addClass("contactsScreenDisabled");
  else $("body").removeClass("contactsScreenDisabled");

  //Cart
  if (
    (!SalesToolkit.User.permissions.canShare &&
      !SalesToolkit.User.permissions.canRegisterInterest &&
      !SalesToolkit.User.permissions.canSaveCarts) ||
    SalesToolkit.Theme.getBooleanProperty("disableFeatureCart", false)
  ) {
    $("body").addClass("cartDisabled");
  } else {
    $("body").removeClass("cartDisabled");
  }

  //Inbox
  if (
    SalesToolkit.Theme.getBooleanProperty("disabledInbox", false) ||
    !SalesToolkit.User.permissions.canViewCarts
  )
    $("body").addClass("inboxDisabled");
  else $("body").removeClass("inboxDisabled");

  if (SalesToolkit.Theme.getBooleanProperty("hideSideMenuCart", false)) {
    $("body").addClass("hideSideMenuCart");
  } else {
    $("body").removeClass("hideSideMenuCart");
  }

  if (SalesToolkit.Theme.getBooleanProperty("hideTopBarCart", false)) {
    $("body").addClass("hideTopBarCart");
  } else {
    $("body").removeClass("hideTopBarCart");
  }

  //News
  if (SalesToolkit.Theme.getBooleanProperty("disableFeatureNews", false)) {
    $("body").addClass("newsDisabled");
  } else {
    $("body").removeClass("newsDisabled");
  }

  //Generic tracking
  if (!SalesToolkit.Theme.getBooleanProperty("allowGenericTracking", false)) {
    SalesToolkit.Offline.deleteGenericTrackingActions();
  }

  if (!SalesToolkit.User.isAdmin()) {
    $("body").addClass("adminDisabled");
    setupAdminFeatures();
  } else {
    setupAdminFeatures();
    $("body").removeClass("adminDisabled");
  }

  if (
    SalesToolkit.Theme.getBooleanProperty("disabledFAQs", true) ||
    getFAQs().length === 0
  ) {
    $("body").addClass("faqsDisabled");
  } else {
    $("body").removeClass("faqsDisabled");
  }

  if (SalesToolkit.Theme.getBooleanProperty("disableInformationIcons", true)) {
    $("body").addClass("infoIconDisabled");
  } else {
    $("body").removeClass("infoIconDisabled");
  }

  if (SalesToolkit.Theme.getBooleanProperty("hideLanguageFlags", false)) {
    $("body").addClass("languageFlagsDisabled");
  } else {
    $("body").removeClass("languageFlagsDisabled");
  }

  if (SalesToolkit.Theme.getBooleanProperty("hideEmailButtonsOnForms", false)) {
    $("body").addClass("hideFormContactsButton");
  } else {
    $("body").removeClass("hideFormContactsButton");
  }

  if (
    (typeof SalesToolkit.Forms.userDetails === "undefined" ||
      SalesToolkit.Theme.getBooleanProperty(
        "dontShowUserDetailsSession",
        true
      )) &&
    SalesToolkit.Theme.getBooleanProperty("disableScanningUserQRCodes", true)
  ) {
    $("body").addClass("userQRScanDisabled");
  } else {
    $("body").removeClass("userQRScanDisabled");
  }

  var lastVisibleMenuItem = null;
  for (let i = 0; i < sideMenu.children().length; i++) {
    let menuItem = sideMenu.children()[i];
    if ($(menuItem).css("display") != "none") lastVisibleMenuItem = menuItem;
  }

  if (
    SalesToolkit.Theme.getBooleanProperty("addLastItemLine", false) &&
    lastVisibleMenuItem != null
  ) {
    let colour = SalesToolkit.Theme.getStringProperty(
      "salestoolkitSideMenuItemSeparatorColour",
      "ceeaf3"
    );
    $(lastVisibleMenuItem).css("border-bottom", "1px solid #" + colour);
  }
}

function setupAdminFeatures() {
  //TODO: Not sure what is this for.
  /*accounts_read 

	accounts_readAll (same as read but access to all accounts not just ones they are in)

	accounts_create

	accounts_update

	accounts_updateAll (same as update but access to all accounts not just ones they are in)

	accounts_delete

	accounts_deleteAll (same as delete but access to all accounts not just ones they are in)
	*/

  //TODO ADD A CHECK TO DO THIS ONLY IF THE PAGE IS THE ADMIN PAGE.

  var adminMenu = $("body");

  /* Users */

  /*READ*/
  if (
    !SalesToolkit.User.permissions.users_read &&
    !SalesToolkit.User.permissions.users_readAll
  ) {
    adminMenu.addClass("usersDisabled");
  } else {
    adminMenu.removeClass("usersDisabled");
  }

  /*CREATE*/

  if (!SalesToolkit.User.permissions.users_create) {
    $(".addUserButton").hide();
  } else {
    $(".addUserButton").show();
  }

  /*UPDATE*/
  if (
    !SalesToolkit.User.permissions.users_update &&
    !SalesToolkit.User.permissions.users_updateAll
  ) {
    //TODO Handle not update permissions
  } else {
    //TODO: Handle update permissions
  }

  /*DELETE*/
  if (
    !SalesToolkit.User.permissions.users_delete &&
    !SalesToolkit.User.permissions.users_deleteAll
  ) {
    $(".usersDeleteCell").hide();
  } else {
    $(".usersDeleteCell").show();
  }

  /* User Groups*/
  if (
    !SalesToolkit.User.permissions.userGroups_read &&
    !SalesToolkit.User.permissions.userGroups_readAll
  ) {
    adminMenu.addClass("groupsDisabled");
  } else {
    adminMenu.removeClass("groupsDisabled");
  }

  /*userGroups_create

	userGroups_update

	userGroups_updateAll (same as update but access to all accounts not just ones they are in)

	userGroups_delete

	userGroups_deleteAll (same as delete but access to all accounts not just ones they are in)
	
	/* Registration approvals*/
  if (
    !SalesToolkit.User.permissions.userRegistrations_read &&
    !SalesToolkit.User.permissions.userRegistrations_readAll
  ) {
    adminMenu.addClass("registrationsDisabled");
  } else {
    adminMenu.removeClass("registrationsDisabled");
  }

  /*
	userRegistrations_read

	userRegistrations_readAll (same as read but access to all accounts not just ones they are in)

	userRegistrations_approve

	userRegistrations_approveAll (same as approve but access to all accounts not just ones they are in)

	userRegistrations_reject

	userRegistrations_rejectAll (same as reject but access to all accounts not just ones they are in)
	*/

  /* Library Tags*/
  if (
    !SalesToolkit.User.permissions.libraryTags_read &&
    !SalesToolkit.User.permissions.libraryTags_readAll
  ) {
    adminMenu.addClass("tagsDisabled");
  } else {
    adminMenu.removeClass("tagsDisabled");
  }

  /*libraryTags_create

	libraryTags_update

	libraryTags_updateAll (same as update but access to all accounts not just ones they are in)

	libraryTags_delete

	libraryTags_deleteAll (same as delete but access to all accounts not just ones they are in)

	canTagLibraryContent (this is the one to say whether the user can apply a tag)*/
}

function showAdminScreen() {
  window.location = "admin.html";
}

function setupSession() {
  //TODO remove when sessions needed
  return true;
  SalesToolkit.Session.start({ email: SalesToolkit.User.username });
}

function applyPostInjectionScripts() {
  try {
    //Obtain all PostJS theme properties
    var filteredPostJS = Object.keys(SalesToolkit.Theme.properties)
      .filter(function (key) {
        return key.indexOf("PostJS") >= 0;
      })
      .reduce(function (obj, key) {
        obj[key] = SalesToolkit.Theme.properties[key];
        return obj;
      }, {});

    for (var key in filteredPostJS) {
      if (filteredPostJS.hasOwnProperty(key)) {
        console.log(key);
        try {
          eval(filteredPostJS[key]);
        } catch (evalError) {
          console.log(evalError);
        }
      }
    }
  } catch (err) {
    console.log(err);
  }
}

function applyThemeToToolkit() {
  if (typeof renderSalesToolkitUserImage !== "undefined")
    renderSalesToolkitUserImage();

  renderPlugins();

  let pathName = window.location.pathname;
  if (SalesToolkit.CrossPlatform.enabled) {
    pathName = pathName
      .split("/")
      .filter(function (c) {
        return c.length;
      })
      .pop();
  } else {
    pathName = pathName.replaceAll("/", "");
  }

  pathName = pathName.replaceAll(".html", "");

  if (
    SalesToolkit.Theme.getBooleanProperty(
      "forceListView_" + pathName,
      SalesToolkit.Theme.getBooleanProperty("forceListView", false)
    )
  ) {
    $("body").toggleClass("showing-list-view", true);
  } else if (
    SalesToolkit.Theme.getBooleanProperty(
      "forceThumbView_" + pathName,
      SalesToolkit.Theme.getBooleanProperty("forceThumbView", false)
    )
  ) {
    $("body").toggleClass("showing-list-view", false);
  }

  if (
    SalesToolkit.Theme.getBooleanProperty(
      "hideListViewSwitcher_" + pathName,
      SalesToolkit.Theme.getBooleanProperty("hideListViewSwitcher", false)
    )
  ) {
    $("#list-view-icon").parent().hide();
  } else if (!$("body").hasClass("showing-list-view")) {
    $("#list-view-icon").show();
    $("#thumbnail-icon").hide();
    localStorage.toggleListView = "";
  } else {
    $("#thumbnail-icon").show();
    $("#list-view-icon").hide();
    localStorage.toggleListView = "showing-list-view";
  }

  if (!SalesToolkit.Theme.overridingCollectionId) {
    // No Overriding Collection Set

    if (SalesToolkit.getHomeCollectionID()) {
      var homeCollection =
        SalesToolkit.Library.collections[SalesToolkit.getHomeCollectionID()];

      if (SalesToolkit.getHomeCollectionID()) {
        try {
          SalesToolkit.User.startupCollection =
            SalesToolkit.getHomeCollectionID();
          SalesToolkit.User.saveToStorage();
        } catch (err) {}
      }

      if (homeCollection != null && SalesToolkit.User.canSee(homeCollection)) {
        SalesToolkit.Theme.setOverridingCollection(
          SalesToolkit.getHomeCollectionID()
        );
      }
    }
  }

  document.dispatchEvent(
    new CustomEvent(SalesToolkitApplication.Events.APPLY_THEME)
  );
  setupMainFeatures();
  setupSession();
  addCustomUrlsToSideMenu();
  addFormsToSideMenu();

  if (SalesToolkit.Theme.getBooleanProperty("autoLoadContacts", true)) {
    SalesToolkit.Contacts.__preferLiveQueryToCache = false;
  } else {
    SalesToolkit.Contacts.__preferLiveQueryToCache = true;
  }

  css = [];

  var customFontFamily = SalesToolkit.Theme.getStringProperty(
    "salesToolkitFontFamilyOverride",
    ""
  );
  if (customFontFamily.length > 0) {
    css.push(
      '* { font-family: "' +
        customFontFamily +
        '", "Open Sans", sans-serif !important; }'
    );
  }

  if (SalesToolkit.Theme.getBooleanProperty("hideJWPlayerFullScreen", false)) {
    css.push(".jw-icon-fullscreen { display:none !important; }");
  }

  /**ANDROID SCROLL FIX */
  if (SalesToolkit.Theme.getBooleanProperty("useOverscrollOnAndroid", true)) {
    // Target the specific container for Android
    css.push("body.android .page-content { overscroll-behavior: auto !important; }");
    
    // Apply inheritance to all children within that container
    css.push("body.android .page-content * { overscroll-behavior: inherit !important; }");
  }

  /** GRID MODE */
  const useGridMode = SalesToolkit.Theme.getBooleanProperty(
    "useGridModeForCollectionBrowser",
    false
  );

  if (useGridMode) {
    document.body.classList.add("gridMode");

    const columnTemplate = SalesToolkit.Theme.getStringProperty(
      "gridModeColumnTemplate",
      "repeat(auto-fit, minmax(250px, 1fr))"
    );
    const gridGap = SalesToolkit.Theme.getIntegerProperty("gridModeGap", 15);

    const gridSelectors = [
      "body.gridMode:not(.showing-list-view) #salestoolkit-favourites",
      "body.gridMode:not(.showing-list-view) #salestoolkit-cart-portlet",
      "body.gridMode:not(.showing-list-view) #atheneum-home-page",
    ].join(",\n");

    css.push(`
			${gridSelectors} {
				grid-template-columns: ${columnTemplate};
				gap: ${gridGap}px;
			}
		`);
  }

  applyThemeToFavIcon("salestoolkitFavIcon");

  var cssPropertyName = "Desktop";
  if (screen.width <= 1024) {
    //Tablet
    cssPropertyName = "Tablet";

    //Mobile
    if (screen.width <= 720) {
      cssPropertyName = "Mobile";
    }
  }

  let backgroundColourDefault = SalesToolkit.Theme.getColourProperty(
    "salestoolkitSideMenuItemBackgroundColour"
  );

  if (backgroundColourDefault) {
    let initialLoadColour = SalesToolkit.Theme.getColourProperty(
      "intiialLoadingColour",
      colourString(backgroundColourDefault)
    );

    if (initialLoadColour) {
      css.push(
        ".placeholder-wrapper .loading-spinner { border-top-color: " +
          colourString(initialLoadColour) +
          " !important; }"
      );
    }
  }

  let galleryModeLeftStyle = SalesToolkit.Theme.getStringProperty(
    "galleryModeLeftStyle",
    ""
  );
  css.push("#galleryNavLeft { " + galleryModeLeftStyle + " }");

  let galleryModeRightStyle = SalesToolkit.Theme.getStringProperty(
    "galleryModeRightStyle",
    ""
  );
  css.push("#galleryNavRight { " + galleryModeRightStyle + " }");

  let whatIsRCDialogStyle = SalesToolkit.Theme.getStringProperty(
    "whatIsRCDialogStyle" + cssPropertyName,
    ""
  );
  css.push("#whatIsRCModal .modal-dialog { " + whatIsRCDialogStyle + " }");

  let whatIsRCContentStyle = SalesToolkit.Theme.getStringProperty(
    "whatIsRCContentStyle" + cssPropertyName,
    ""
  );
  css.push(
    "#whatIsRCModal .modal-dialog .modal-content { " +
      whatIsRCContentStyle +
      " }"
  );

  let whatIsRCHeaderStyle = SalesToolkit.Theme.getStringProperty(
    "whatIsRCHeaderStyle" + cssPropertyName,
    ""
  );
  css.push("#whatIsRCModalLabel span { " + whatIsRCHeaderStyle + " }");

  //Contacts traffic lights and status
  applyColour(
    css,
    "contactsTrafficLightColourRed",
    ".contactsTableTotalSubCountColumn.trafficLightColourRed",
    "background-color",
    "#ff0000"
  );
  applyColour(
    css,
    "contactsTrafficLightColourRedText",
    ".contactsTableTotalSubCountColumn.trafficLightColourRed",
    "color",
    "#ffffff"
  );

  applyColour(
    css,
    "contactsTrafficLightColourAmber",
    ".contactsTableTotalSubCountColumn.trafficLightColourAmber",
    "background-color",
    "#F2F262"
  );
  applyColour(
    css,
    "contactsTrafficLightColourAmberText",
    ".contactsTableTotalSubCountColumn.trafficLightColourAmber",
    "color",
    "#ffffff"
  );

  applyColour(
    css,
    "contactsTrafficLightColourGreen",
    ".contactsTableTotalSubCountColumn.trafficLightColourGreen",
    "background-color",
    "#00ba00"
  );
  applyColour(
    css,
    "contactsTrafficLightColourGreenText",
    ".contactsTableTotalSubCountColumn.trafficLightColourGreen",
    "color",
    "#ffffff"
  );

  applyColour(
    css,
    "contactStatusSubscribed",
    ".SUBSCRIBED",
    "background-color",
    "#00ba00"
  );
  applyColour(
    css,
    "contactStatusSubscribedText",
    ".SUBSCRIBED",
    "color",
    "#ffffff"
  );
  applyColour(
    css,
    "contactStatusSubscribedPending",
    ".SUBSCRIBED_PENDING",
    "background-color",
    "#00ba00"
  );
  applyColour(
    css,
    "contactStatusSubscribedPendingText",
    ".SUBSCRIBED_PENDING",
    "color",
    "#ffffff"
  );

  applyColour(
    css,
    "contactStatusPending",
    ".PENDING",
    "background-color",
    "#ffa500"
  );
  applyColour(css, "contactStatusPendingText", ".PENDING", "color", "#ffffff");
  applyColour(
    css,
    "contactStatusVerbal",
    ".VERBAL",
    "background-color",
    "#ffa500"
  );
  applyColour(css, "contactStatusVerbalText", ".VERBAL", "color", "#ffffff");

  applyColour(
    css,
    "contactStatusUnsubscribed",
    ".UNSUBSCRIBED",
    "background-color",
    "#db2300"
  );
  applyColour(
    css,
    "contactStatusUnsubscribedText",
    ".UNSUBSCRIBED",
    "color",
    "#ffffff"
  );
  applyColour(
    css,
    "contactStatusUnsubscribed",
    ".DECLINED",
    "background-color",
    "#db2300"
  );
  applyColour(
    css,
    "contactStatusUnsubscribedText",
    ".DECLINED",
    "color",
    "#ffffff"
  );

  //Verrtical Switch
  applyColour(
    css,
    "verticalCartSwitchTrackColour",
    ".switch-vertical .toggle-outside",
    "background-color",
    "#ffffff"
  );
  applyColour(
    css,
    "verticalCartSwitchBallColour",
    ".toggle-switch .toggle-inside",
    "background-color",
    "#ff3300"
  );
  applyRoundedEdges(
    css,
    "verticalCartSwitchBorderRadius",
    ".toggle-switch .toggle-outside",
    17
  );
  applyColour(
    css,
    "verticalSwitchBorderColour",
    ".toggle-switch .toggle-outside",
    "border-color",
    "#084E9B"
  );
  applyColour(
    css,
    "verticalSwitchSelectedColour",
    " .toggle-switch label",
    "color",
    "#084E9B"
  );
  applyColour(
    css,
    "verticalSwitchSelectedColour",
    ".toggle-switch input:checked + label",
    "color",
    "#ff3300"
  );
  css.push(
    " .toggle-switch label{ " +
      SalesToolkit.Theme.getStringProperty(
        "verticalSwitchLabelStyle",
        "font-weight:600;"
      ) +
      " }"
  );

  //Contact filter modal
  applyRoundedEdges(
    css,
    "contactFilterModalBorderRadius",
    ".contactFilterOption",
    5
  );
  applyColour(
    css,
    "contactFilterModalBorderColour",
    ".contactFilterOption",
    "border-color",
    "#cccccc"
  );
  applyColour(
    css,
    "contactFilterModalBackgroundColour",
    ".contactFilterOption",
    "background-color",
    "#eeeeee"
  );
  applyColour(
    css,
    "contactFilterModalBackgroundColour",
    ".contactFilterOption",
    "color",
    "#000000"
  );

  //Forms font sizes
  applyFontSizeCSS(
    css,
    "formsFieldInputFontSize" + cssPropertyName,
    ".atheneum-form-field input",
    "1.2rem"
  );
  applyFontSizeCSS(
    css,
    "formsFieldSelectFontSize" + cssPropertyName,
    ".atheneum-form-field select",
    "1.2rem"
  );
  applyFontSizeCSS(
    css,
    "formsFieldLabelFontSize" + cssPropertyName,
    ".atheneum-form-label, .atheneum-form-field label",
    "1.2rem"
  );
  applyFontSizeCSS(
    css,
    "formsFieldTextAreaFontSize" + cssPropertyName,
    ".atheneum-form-field textarea",
    "1.2rem"
  );

  //Forms readonly
  applyColour(
    css,
    "formsInputReadonlyBackground",
    ".atheneum-form-field input[readonly], .atheneum-form-field select[disabled]",
    "background-color",
    "#f6f8fa"
  );
  applyColour(
    css,
    "formsInputReadonlyColour",
    ".atheneum-form-field input[readonly], .atheneum-form-field select[disabled]",
    "color",
    "#505458"
  );
  css.push(
    ".atheneum-form-field input[readonly], .atheneum-form-field select[disabled] { opacity:1; cursor: " +
      SalesToolkit.Theme.getStringProperty(
        "formsInputReadonlyCursor",
        "not-allowed"
      ) +
      " }"
  );

  applyThemeToImage("salestoolkitBannerImage", ".page-header img.banner");
  applyThemeToImage("salestoolkitLogoTopLeft", ".page-logo img.logo-default");
  applyThemeToImage(
    "salestoolkitLoginLogo",
    ".page-lock .page-logo img, .login .logo img"
  );
  applyThemeToImage(
    "salestoolkitToggleSideMenuIcon",
    ".sidebar-toggler img.sidebar-toggler-icon",
    "img/default/menu_icon.svg"
  );
  applyThemeToImage(
    "salestoolkitToggleSideMenuIcon",
    "#page-logo-id",
    "img/default/menu_icon.svg"
  );
  applyThemeToImage(
    "salestoolkitToggleSideMenuIconCross",
    "#page-logo-id-cross",
    "metronic/layout/img/close_btn.svg"
  );

  /** Saved Carts */
  applyColour(
    css,
    "savedCartWrapperBackgroundRegular",
    ".saved-cart-wrapper",
    "background-color",
    "#efefef"
  );
  applyColour(
    css,
    "savedCartWrapperTextRegular",
    ".saved-cart-wrapper",
    "color",
    "#000"
  );

  applyColour(
    css,
    "savedCartWrapperBackgroundCurrent",
    ".saved-cart-wrapper.current",
    "background-color",
    "#333"
  );
  applyColour(
    css,
    "savedCartWrapperTextCurrent",
    ".saved-cart-wrapper.current",
    "color",
    "#fff"
  );

  applyColour(
    css,
    "savedCartWrapperBackgroundActive",
    ".saved-cart-wrapper.active",
    "background-color",
    "#ccc"
  );
  applyColour(
    css,
    "savedCartWrapperTextActive",
    ".saved-cart-wrapper.active",
    "color",
    "#000"
  );

  css.push(
    ".saved-cart-wrapper { border-bottom: " +
      SalesToolkit.Theme.getStringProperty(
        "savedCartsWrapperBottomBorder",
        "black 1px solid"
      ) +
      " }"
  );

  /** Journals / Toplevel tabs */
  applyColour(
    css,
    "topLevelSectionsBackgroundColour",
    "#page-calview-tabs .journalTab",
    "background-color"
  );
  applyColour(
    css,
    "topLevelSectionsActiveBackgroundColour",
    "#page-calview-tabs .journalTab.active",
    "background-color"
  );
  applyColour(
    css,
    "topLevelSectionsTextColour",
    "#page-calview-tabs .journalTab",
    "color"
  );
  applyColour(
    css,
    "topLevelSectionsActiveTextColour",
    "#page-calview-tabs .journalTab.active",
    "color"
  );
  applyTopRoundedEdges(
    css,
    "topLevelSectionsRoundedCorners",
    "#page-calview-tabs .journalTab",
    15
  );
  applyFontSizeCSS(
    css,
    "topLevelSectionsFontSize" + cssPropertyName,
    "#page-calview-tabs .journalTab",
    "1.3rem"
  );
  applyColour(
    css,
    "topLevelSectionsActiveBorderColour",
    "#page-calview-tabs .journalTab.active",
    "border-color"
  );
  applyBorderWidth(
    css,
    "topLevelSectionsActiveBorderWidth",
    "#page-calview-tabs .journalTab.active",
    1
  );
  applyColour(
    css,
    "topLevelSectionsBorderColour",
    "#page-calview-tabs .journalTab",
    "border-color"
  );
  applyBorderWidth(
    css,
    "topLevelSectionsBorderWidth",
    "#page-calview-tabs .journalTab",
    1
  );

  /*Filtered Dropdowns */
  applyColour(
    css,
    "filteredDropdownButtonBackgroundColour",
    ".filteredDropdownBtn",
    "background-color"
  );
  applyColour(
    css,
    "filteredDropdownButtonTextColour",
    ".filteredDropdownBtn",
    "color"
  );
  applyColour(
    css,
    "filteredDropdownButtonActiveBackgroundColour",
    ".filteredDropdownBtn.filteredDropdownActive",
    "background-color"
  );
  applyColour(
    css,
    "filteredDropdownButtonActiveTextColour",
    ".filteredDropdownBtn.filteredDropdownActive",
    "color"
  );
  applyColour(
    css,
    "filteredDropdownButtonHoverBackgroundColour",
    ".filteredDropdownBtn:hover",
    "background-color"
  );
  applyColour(
    css,
    "filteredDropdownButtonHoverTextColour",
    ".filteredDropdownBtn:hover",
    "color"
  );
  applyColour(
    css,
    "filteredDropdownButtonActiveHoverBackgroundColour",
    ".filteredDropdownBtn.filteredDropdownActive:hover",
    "background-color"
  );
  applyColour(
    css,
    "filteredDropdownButtonActiveHoverTextColour",
    ".filteredDropdownBtn.filteredDropdownActive:hover",
    "color"
  );

  applyColour(
    css,
    "filteredDropdownClearButtonBackgroundColour",
    ".filteredDropdown-content .clearAllButton",
    "background-color"
  );
  applyColour(
    css,
    "filteredDropdownClearButtonTextColour",
    ".filteredDropdown-content .clearAllButton",
    "color"
  );
  applyColour(
    css,
    "filteredDropdownClearButtonHoverBackgroundColour",
    ".filteredDropdown-content .clearAllButton:hover",
    "background-color"
  );
  applyColour(
    css,
    "filteredDropdownClearButtonHoverTextColour",
    ".filteredDropdown-content .clearAllButton:hover",
    "color"
  );

  applyColour(
    css,
    "filteredDropdownSearchBackgroundColour",
    ".filteredDropdownSearchInput",
    "background-color"
  );
  applyColour(
    css,
    "filteredDropdownSearchTextColour",
    ".filteredDropdownSearchInput",
    "color"
  );
  applyColour(
    css,
    "filteredDropdownSearchFocusBackgroundColour",
    ".filteredDropdownSearchInput:focus",
    "background-color"
  );
  applyColour(
    css,
    "filteredDropdownSearchFocusTextColour",
    ".filteredDropdownSearchInput:focus",
    "color"
  );

  applyColour(
    css,
    "filteredDropdownContentBackgroundColour",
    ".filteredDropdown-content",
    "background-color"
  );

  applyColour(
    css,
    "filteredDropdownEntryBackgroundColour",
    ".filteredDropdown-content a",
    "background-color"
  );
  applyColour(
    css,
    "filteredDropdownEntryTextColour",
    ".filteredDropdown-content a",
    "color"
  );
  applyColour(
    css,
    "filteredDropdownEntryHoverBackgroundColour",
    ".filteredDropdown-content a:hover",
    "background-color"
  );
  applyColour(
    css,
    "filteredDropdownEntryHoverTextColour",
    ".filteredDropdown-content a:hover",
    "color"
  );

  applyColour(
    css,
    "filteredDropdownSelectedEntryBackgroundColour",
    ".filteredDropdown-content a.selected",
    "background-color"
  );
  applyColour(
    css,
    "filteredDropdownSelectedEntryTextColour",
    ".filteredDropdown-content a.selected",
    "color"
  );
  applyColour(
    css,
    "filteredDropdownSelectedEntryHoverBackgroundColour",
    ".filteredDropdown-content a.selected:hover",
    "background-color"
  );
  applyColour(
    css,
    "filteredDropdownSelectedEntryHoverTextColour",
    ".filteredDropdown-content a.selected:hover",
    "color"
  );

  applyColour(
    css,
    "filteredDropdownResultsTextBackgroundColour",
    ".filteredDropdown-content .resultsText",
    "background-color"
  );
  applyColour(
    css,
    "filteredDropdownResultsTextTextColour",
    ".filteredDropdown-content .resultsText",
    "color"
  );

  applyRoundedEdges(
    css,
    "filtersSelectBorderRadius",
    ".filteredDropdownBtn",
    5
  );
  applyFontSizeCSS(
    css,
    "filtersHeaderFontSize" + cssPropertyName,
    ".filteredDropdownBtn",
    "1.3rem"
  );
  applyFontSizeCSS(
    css,
    "filtersSearchFontSize" + cssPropertyName,
    ".filteredDropdownSearchInput",
    "1.3rem"
  );
  applyFontSizeCSS(
    css,
    "filtersFontSize" + cssPropertyName,
    ".filteredDropdown-content a",
    "1.2rem"
  );
  applyFontSizeCSS(
    css,
    "filtersResultsTextFontSize" + cssPropertyName,
    ".filteredDropdown-content .resultsText",
    "1.2rem"
  );
  applyFontSizeCSS(
    css,
    "filtersClearAllFontSize" + cssPropertyName,
    ".filteredDropdown-content .clearAllButton",
    "1.3rem"
  );
  applybgImageStyle(
    css,
    "salestoolkitFilterDropdownArrowIconDown",
    ".filteredDropdownBtn",
    "img/default/arrow_small_down.svg"
  );

  applyColour(
    css,
    "filteredDropdownQuickDeleteBackgroundColour",
    ".filters-quick-delete div",
    "background-color",
    "#eeeeee"
  );
  applyColour(
    css,
    "filteredDropdownQuickDeleteTextColour",
    ".filters-quick-delete div",
    "color",
    "#000000"
  );

  applyRoundedEdges(
    css,
    "filtersQuickDeleteBorderRadius",
    ".filters-quick-delete div",
    5
  );
  applyFontSizeCSS(
    css,
    "filtersQuickDeleteFontSize" + cssPropertyName,
    ".filters-quick-delete div",
    "1rem"
  );

  applyColour(
    css,
    "filteredDropdownQuickDeleteXTextColour",
    ".filters-quick-delete div:after",
    "color",
    "#000000"
  );
  applyFontSizeCSS(
    css,
    "filtersQuickDeleteXFontSize" + cssPropertyName,
    ".filters-quick-delete div:after",
    "2rem"
  );

  applyFontWeightCSS(
    css,
    "filtersClearAllFontWeight",
    "#clearAllFiltersButton",
    "700"
  );
  applyColour(
    css,
    "filtersClearAllBackgroundColour",
    "#clearAllFiltersButton.salestoolkit-blue.btn",
    "background-color",
    "#ffffff"
  );
  applyColour(
    css,
    "filtersClearAllTextColour",
    "#clearAllFiltersButton.salestoolkit-blue.btn",
    "color",
    "#000000"
  );
  applyFontSizeCSS(
    css,
    "filtersClearAllTextSize" + cssPropertyName,
    "#clearAllFiltersButton",
    "17px"
  );

  css.push(
    "#clearAllFiltersButton { text-decoration:" +
      SalesToolkit.Theme.getStringProperty(
        "filtersClearAllTextDecoration",
        "underline"
      ) +
      " }"
  );
  css.push(
    "#clearAllFiltersButton { text-underline-position:" +
      SalesToolkit.Theme.getStringProperty(
        "filtersClearAllTextUnderlinePosition",
        "under"
      ) +
      " }"
  );

  /*Filtered Dropdowns END */

  /*Form history Filtered Dropdowns */
  applyColour(
    css,
    "formHistoryFilteredDropdownButtonBackgroundColour",
    "#formHistoryDropdown .filteredDropdownBtn",
    "background-color"
  );
  applyColour(
    css,
    "formHistoryFilteredDropdownButtonTextColour",
    "#formHistoryDropdown .filteredDropdownBtn",
    "color"
  );
  applyColour(
    css,
    "formHistoryFilteredDropdownButtonActiveBackgroundColour",
    "#formHistoryDropdown .filteredDropdownBtn.filteredDropdownActive",
    "background-color"
  );
  applyColour(
    css,
    "formHistoryFilteredDropdownButtonActiveTextColour",
    "#formHistoryDropdown .filteredDropdownBtn.filteredDropdownActive",
    "color"
  );
  applyColour(
    css,
    "formHistoryFilteredDropdownButtonHoverBackgroundColour",
    "#formHistoryDropdown .filteredDropdownBtn:hover",
    "background-color"
  );
  applyColour(
    css,
    "formHistoryFilteredDropdownButtonHoverTextColour",
    "#formHistoryDropdown .filteredDropdownBtn:hover",
    "color"
  );
  applyColour(
    css,
    "formHistoryFilteredDropdownButtonActiveHoverBackgroundColour",
    "#formHistoryDropdown .filteredDropdownBtn.filteredDropdownActive:hover",
    "background-color"
  );
  applyColour(
    css,
    "formHistoryFilteredDropdownButtonActiveHoverTextColour",
    "#formHistoryDropdown .filteredDropdownBtn.filteredDropdownActive:hover",
    "color"
  );
  applyFontWeightCSS(
    css,
    "formHistoryFilteredDropdownButtonFontWeight",
    "#formHistoryDropdown .filteredDropdownBtn",
    "700"
  );

  applyColour(
    css,
    "formHistoryFilteredDropdownClearButtonBackgroundColour",
    "#formHistoryDropdown .filteredDropdown-content .clearAllButton",
    "background-color"
  );
  applyColour(
    css,
    "formHistoryFilteredDropdownClearButtonTextColour",
    "#formHistoryDropdown .filteredDropdown-content .clearAllButton",
    "color"
  );
  applyColour(
    css,
    "formHistoryFilteredDropdownClearButtonHoverBackgroundColour",
    "#formHistoryDropdown .filteredDropdown-content .clearAllButton:hover",
    "background-color"
  );
  applyColour(
    css,
    "formHistoryFilteredDropdownClearButtonHoverTextColour",
    "#formHistoryDropdown .filteredDropdown-content .clearAllButton:hover",
    "color"
  );

  applyColour(
    css,
    "formHistoryFilteredDropdownSearchBackgroundColour",
    "#formHistoryDropdown .filteredDropdownSearchInput",
    "background-color"
  );
  applyColour(
    css,
    "formHistoryFilteredDropdownSearchTextColour",
    "#formHistoryDropdown .filteredDropdownSearchInput",
    "color"
  );
  applyColour(
    css,
    "formHistoryFilteredDropdownSearchFocusBackgroundColour",
    "#formHistoryDropdown .filteredDropdownSearchInput:focus",
    "background-color"
  );
  applyColour(
    css,
    "formHistoryFilteredDropdownSearchFocusTextColour",
    "#formHistoryDropdown .filteredDropdownSearchInput:focus",
    "color"
  );

  applyColour(
    css,
    "formHistoryFilteredDropdownContentBackgroundColour",
    "#formHistoryDropdown .filteredDropdown-content",
    "background-color"
  );

  applyColour(
    css,
    "formHistoryFilteredDropdownEntryBackgroundColour",
    "#formHistoryDropdown .filteredDropdown-content a",
    "background-color"
  );
  applyColour(
    css,
    "formHistoryFilteredDropdownEntryTextColour",
    "#formHistoryDropdown .filteredDropdown-content a",
    "color"
  );
  applyColour(
    css,
    "formHistoryFilteredDropdownEntryHoverBackgroundColour",
    "#formHistoryDropdown .filteredDropdown-content a:hover",
    "background-color"
  );
  applyColour(
    css,
    "formHistoryFilteredDropdownEntryHoverTextColour",
    "#formHistoryDropdown .filteredDropdown-content a:hover",
    "color"
  );

  applyColour(
    css,
    "formHistoryFilteredDropdownSelectedEntryBackgroundColour",
    "#formHistoryDropdown .filteredDropdown-content a.selected",
    "background-color"
  );
  applyColour(
    css,
    "formHistoryFilteredDropdownSelectedEntryTextColour",
    "#formHistoryDropdown .filteredDropdown-content a.selected",
    "color"
  );
  applyColour(
    css,
    "formHistoryFilteredDropdownSelectedEntryHoverBackgroundColour",
    "#formHistoryDropdown .filteredDropdown-content a.selected:hover",
    "background-color"
  );
  applyColour(
    css,
    "formHistoryFilteredDropdownSelectedEntryHoverTextColour",
    "#formHistoryDropdown .filteredDropdown-content a.selected:hover",
    "color"
  );

  applyColour(
    css,
    "formHistoryFilteredDropdownResultsTextBackgroundColour",
    "#formHistoryDropdown .filteredDropdown-content .resultsText",
    "background-color"
  );
  applyColour(
    css,
    "formHistoryFilteredDropdownResultsTextTextColour",
    "#formHistoryDropdown .filteredDropdown-content .resultsText",
    "color"
  );

  applyRoundedEdges(
    css,
    "formHistoryFiltersSelectBorderRadius",
    "#formHistoryDropdown .filteredDropdownBtn",
    5
  );
  applyFontSizeCSS(
    css,
    "formHistoryFiltersHeaderFontSize" + cssPropertyName,
    "#formHistoryDropdown .filteredDropdownBtn",
    "1.3rem"
  );
  applyFontSizeCSS(
    css,
    "formHistoryFiltersSearchFontSize" + cssPropertyName,
    "#formHistoryDropdown .filteredDropdownSearchInput",
    "1.3rem"
  );
  applyFontSizeCSS(
    css,
    "formHistoryFiltersFontSize" + cssPropertyName,
    "#formHistoryDropdown .filteredDropdown-content a",
    "1.2rem"
  );
  applyFontSizeCSS(
    css,
    "formHistoryFiltersResultsTextFontSize" + cssPropertyName,
    "#formHistoryDropdown .filteredDropdown-content .resultsText",
    "1.2rem"
  );
  applybgImageStyle(
    css,
    "salestoolkitFormHistoryFilterDropdownArrowIconDown",
    "#formHistoryDropdown .filteredDropdownBtn",
    "img/default/arrow_small_down.svg"
  );

  if (
    SalesToolkit.Theme.getIntegerProperty("formHistoryBGPositionX", -1) >= 0
  ) {
    css.push(
      "#formHistoryDropdown .filteredDropdownBtn { background-position-x:" +
        SalesToolkit.Theme.getIntegerProperty("formHistoryBGPositionX", -1) +
        "px; }"
    );
  }

  if (
    SalesToolkit.Theme.getStringProperty(
      "formHistoryMobileStyling",
      "padding:7px 0px; margin-bottom:5px;"
    ).length > 0
  ) {
    css.push(
      "@media (max-width: 450px) { #formHistoryDropdown { " +
        SalesToolkit.Theme.getStringProperty(
          "formHistoryMobileStyling",
          "padding:7px 0px; margin-bottom:5px;"
        ) +
        " } }"
    );
  }

  if (SalesToolkit.Theme.getIntegerProperty("formHistoryContentTop", 25) >= 0) {
    css.push(
      "#formHistoryDropdown .filteredDropdown-content { top:" +
        SalesToolkit.Theme.getIntegerProperty("formHistoryContentTop", 25) +
        "px; }"
    );
  }

  if (
    SalesToolkit.Theme.getIntegerProperty("formHistoryItemsMaxWidth", 300) >= 0
  ) {
    let width = SalesToolkit.Theme.getIntegerProperty(
      "formHistoryItemsMaxWidth",
      300
    );
    let lines = SalesToolkit.Theme.getIntegerProperty(
      "formHistoryItemsMaxLines",
      2
    );
    css.push(
      "#formHistoryDropdown .filteredDropdown-items { max-width:" +
        width +
        "px; }"
    );
    css.push(
      "#formHistoryDropdown .filteredDropdown-items span.email { width:" +
        (width - 30) +
        "px; display:-webkit-box; overflow: hidden; -webkit-box-orient: vertical; overflow-wrap: break-word; -webkit-line-clamp: " +
        lines +
        "; }"
    );
  }

  /*Form history Filtered Dropdowns END */
  let hideOverflowTextLineClamp = SalesToolkit.Theme.getIntegerProperty(
  "hideOverflowLineClamp",
  2
);

  let defaultAutoHeight = false;// hideOverflowTextLineClamp > 0;

  let listViewAutoHeight = SalesToolkit.Theme.getBooleanProperty(
    "listViewAutoHeight", 
    defaultAutoHeight
  );

  if (hideOverflowTextLineClamp > 0) {
    css.push(
      ".hide-overflow-text-fav{ -webkit-line-clamp:" +
        hideOverflowTextLineClamp +
        " !important; } body.showing-list-view .hide-overflow-text-fav{ -webkit-line-clamp:" +
        hideOverflowTextLineClamp +
        " !important; }"
    );
  }

  if (listViewAutoHeight) {
    css.push(
      ".showing-list-view .hide-overflow-text-fav { height: auto !important; }"
    );
  }

  if (
    SalesToolkit.Theme.getBooleanProperty(
      "useCompactBrowserModeOnTablets",
      false
    )
  ) {
    css.push(
      "@media (min-width: 580px) { body.showing-list-view #atheneum-home-page .col-sm-12.col-md-3, body.showing-list-view #salestoolkit-favourites .col-sm-12.col-md-2.atheneum-item, body.showing-list-view #salestoolkit-cart-portlet .col-sm-12.col-md-2.atheneum-item { width: calc((100% - 30px - (15px * 1) + 15px) / 1) !important; }} @media (min-width: 620px) and (max-width: 1024px) { #atheneum-home-page .col-sm-12.col-md-3, #salestoolkit-cart-portlet .col-sm-12.col-md-2, #salestoolkit-favourites .col-sm-12.col-md-2 { width: calc((100% - 30px - (40px * 2) + 15px) / 2) !important; margin-left: 15px !important; margin-right: 30px !important; margin-bottom: 40px !important; }} @media (min-width: 620px) and (max-width: 1024px) { .hide-overflow-text-fav{ line-height: calc(1rem + 3px); }} #contactEmailHint { display:none !important; }"
    );
  }

  if (SalesToolkit.Theme.getBooleanProperty("hidePendingContactsKey", false)) {
    css.push(
      ".suggestion-list-consent-key .consent-group:has(.PENDING){ display:none !important; }"
    );
  }

  applyColour(css, "scanInfoTextColour", "span#scan-info", "color", "#ff0000");
  applyColour(
    css,
    "scanExplanationTextColour",
    "span#scan-explain",
    "color",
    "#000000"
  );

  if (SalesToolkit.CrossPlatform.enabled) {
    if (SalesToolkit.Theme.getBooleanProperty("hideSyncButtonOnApps", false)) {
      css.push(
        "li.dropdown.dropdown-user a { padding-right:5px; } li.dropdown.syncbuttontopbar { display: none !important } li.dropdown.dropdown-user::after { border-right:0px solid !important; }"
      );
    }
    applybgImageStyle(
      css,
      "radioButtonOff",
      ".atheneum-form-field input[type=radio] + label",
      "img/radio_button_off.png"
    );
    applybgImageStyle(
      css,
      "radioButtonOn",
      ".atheneum-form-field input[type=radio]:checked + label",
      "img/radio_button_on.png"
    );
    applybgImageStyle(
      css,
      "checkboxButtonOff",
      ".atheneum-form-field input[type=checkbox] + label",
      "img/checkmark_button_off.png"
    );
    applybgImageStyle(
      css,
      "checkboxButtonOn",
      ".atheneum-form-field input[type=checkbox]:checked + label",
      "img/checkmark_button_on.png"
    );
  } else {
    applybgImageStyle(
      css,
      "radioButtonOff",
      ".atheneum-form-field input[type=radio] + label",
      "/img/radio_button_off.png"
    );
    applybgImageStyle(
      css,
      "radioButtonOn",
      ".atheneum-form-field input[type=radio]:checked + label",
      "/img/radio_button_on.png"
    );
    applybgImageStyle(
      css,
      "checkboxButtonOff",
      ".atheneum-form-field input[type=checkbox] + label",
      "/img/checkmark_button_off.png"
    );
    applybgImageStyle(
      css,
      "checkboxButtonOn",
      ".atheneum-form-field input[type=checkbox]:checked + label",
      "/img/checkmark_button_on.png"
    );
  }

  applyThemeToImage(
    "salestoolkitHeaderIconSearch",
    "img.icon-search",
    "img/default/search_icon.svg"
  );
  applyThemeToImage(
    "salestoolkitHeaderIconNotification",
    "img.notification-icon",
    "img/default/announce.svg"
  );
  applyThemeToImage(
    "salestoolkitHeaderIconCart",
    "#headerCartLink img.cart-icon",
    "img/default/shopping_cart_header.svg"
  );
  if (SalesToolkit.Forms.userDetails) {
    applyThemeToImage(
      "salestoolkitHeaderIconQRPrefillCancel",
      "#headerPrefillQRCode img.qr-prefill-icon",
      "img/default/Form_QR.svg"
    );
  } else {
    applyThemeToImage(
      "salestoolkitHeaderIconQRPrefill",
      "#headerPrefillQRCode img.qr-prefill-icon",
      "img/default/Form_QR.svg"
    );
  }

  applyThemeToImage(
    "salestoolkitLanguageDropdownIcon",
    "#languageSelector img.language-dropdown-icon",
    "img/default/language_icon.svg"
  );

  applyThemeToImage(
    "salestoolkitHeaderIconEmailWarning",
    "img.img-circle.profile-warning-icon",
    "img/default/emailWarning.svg"
  );
  applyThemeToImage(
    "salestoolkitHeaderIconEmailWarning",
    "img.profile-warning-icon-list",
    "img/default/emailWarning.svg"
  );

  //TODO change for new icon
  applyThemeToImage(
    "salestoolkitHeaderIconFormWarning",
    "img.img-circle.profile-form-warning-icon",
    "img/default/emailWarning.svg"
  );
  applyThemeToImage(
    "salestoolkitHeaderIconFormWarning",
    "img.profile-form-warning-icon-list",
    "img/default/emailWarning.svg"
  );
  applyThemeToImage(
    "salestoolkitHeaderIconForm",
    "img.profile-form-history-icon-list",
    "img/default/form_history_icon.svg"
  );

  applyThemeToImage(
    "salestoolkitHeaderIconCartHistory",
    "img.profile-cart-history-icon-list",
    "img/default/menu_icon.svg"
  );
  applyThemeToImage(
    "salestoolkitHeaderIconFilter",
    "img.filter-icon",
    "img/default/filter_icon.svg"
  );

  applyThemeToImage(
    "whatsappIcon",
    "#whatsapp-icon",
    "img/default/whatsapp_icon.png"
  );
  applyThemeToImage(
    "wechatIcon",
    "#wechat-icon",
    "img/default/wechat_icon.png"
  );
  applyThemeToImage(
    "sharlinkEmailIcon",
    "#sharlink-email-icon",
    "img/default/email_icon.png"
  );

  applyThemeToImage(
    "salestoolkitHeaderIconTreeView",
    "img.treeView-icon",
    "img/default/tree_view.svg"
  );
  applyThemeToImage(
    "salestoolkitHeaderIconRelatedAssets",
    "img.related-assets-icon",
    "img/default/relatedAssets.svg"
  );

  if (renderUserIconWithTheme) {
    applyThemeToImage(
      "salestoolkitHeaderIconProfile",
      "img.img-circle.profile-icon",
      "img/default/user.svg"
    );
    var headerBarProfileIcon = document.getElementById("headerBarProfileImage");
    if (
      typeof headerBarProfileIcon !== "undefined" &&
      headerBarProfileIcon != null
    )
      document
        .getElementById("headerBarProfileImage")
        .classList.add("defaultIcon");
  }

  applyThemeToImage(
    "salestoolkitHeaderIconSync",
    "img.sync-icon",
    "img/default/cog_icon_new.svg"
  );

  applyThemeToImage(
    "salestoolkitHeaderIconProfile",
    "img.profile-user-icon",
    "img/default/user.svg"
  );
  applyThemeToImage(
    "salestoolkitHeaderIconLock",
    "img.profile-lock-icon",
    "img/default/lock.svg"
  );
  applyThemeToImage(
    "salestoolkitHeaderIconLegal",
    "img.profile-legal-icon",
    "img/default/tncs.svg"
  );

  applyColour(
    css,
    "salestoolkitHeaderIconSeparatorColour",
    "ul.nav.navbar-nav.pull-right > li:not(:last-child)::after",
    "border-color",
    "#000000"
  );

  if (
    SalesToolkit.User.permissions.canUseTestMode ||
    SalesToolkit.Theme.getBooleanProperty("forceTestModeCapability", false)
  ) {
    $("#profileTestModeDivider").show();
    $("#dropdownButtonTestMode").show();
  }

  var legalHtml = SalesToolkit.Translation.getOrGetThemeKey(
    "salesToolkitLegalHtml",
    ""
  );
  if (legalHtml == undefined || legalHtml == null || legalHtml.length == 0)
    $("#dropdownButtonLegal").hide();
  else $("#dropdownButtonLegal").show();

  applyThemeToImage(
    "salestoolkitHeaderIconLogout",
    "img.profile-logout-icon",
    "img/default/logout.svg"
  );

  applyThemeToImage(
    "salestoolkitIconEnterFullscreen",
    "img.zoomin-icon",
    "img/default/zoom_icon.svg"
  );
  applyThemeToImage(
    "salestoolkitIconExitFullscreen",
    "img.zoomout-icon",
    "img/default/zoom_out_icon.svg"
  );

  //Admin

  applyThemeToImage(
    "salestoolkitIconAdminAdd",
    "img.admin-add-icon",
    "img/default/adminAdd.svg"
  );
  applyColour(
    css,
    "salestoolkitIconAdminApproveBG",
    "td a.user-approval-approve-button",
    "background-color",
    "#00ba00"
  );
  applyColour(
    css,
    "salestoolkitIconAdminApproveText",
    "td a.user-approval-approve-button",
    "color",
    "#ffffff"
  );
  applyColour(
    css,
    "salestoolkitIconAdminApproveHoverBG",
    "body:not(.ios) td a.user-approval-approve-button:hover",
    "background-color",
    "#00ba00"
  );
  applyColour(
    css,
    "salestoolkitIconAdminApproveHoverText",
    "body:not(.ios) td a.user-approval-approve-button:hover",
    "color",
    "#ffffff"
  );

  applyColour(
    css,
    "salestoolkitIconAdminRejectBG",
    "td a.user-approval-reject-button",
    "background-color",
    "#bb0000"
  );
  applyColour(
    css,
    "salestoolkitIconAdminRejectText",
    "td a.user-approval-reject-button",
    "color",
    "#ffffff"
  );
  applyColour(
    css,
    "salestoolkitIconAdminRejectHoverBG",
    "body:not(.ios) td a.user-approval-reject-button:hover",
    "background-color",
    "#bb0000"
  );
  applyColour(
    css,
    "salestoolkitIconAdminRejectHoverText",
    "body:not(.ios) td a.user-approval-reject-button:hover",
    "color",
    "#ffffff"
  );

  applyColour(
    css,
    "salestoolkitIconAdminPopupText",
    "body.adminScreen input.profile-input, body.adminScreen label.profile-label",
    "color",
    "#000000"
  );

  // applyThemeToImage('salestoolkitAssetTileIconFavourites', 'img.docimg.fav-empty-icon', 'img/default/favourites_empty_icon_sml.svg');
  // applyThemeToImage('salestoolkitAssetTileIconFavouritesFilled', 'img.docimg.fav-empty-icon', 'img/default/zoom_out_icon.svg');
  // applyThemeToImage('salestoolkitAssetTileIconCart', 'img.zoomin-icon', 'img/default/zoom_icon.svg');
  // applyThemeToImage('salestoolkitAssetTileIconCartFilled', 'img.zoomout-icon', 'img/default/zoom_out_icon.svg');
  // applyThemeToImage('salestoolkitAssetTileIconRemove', 'img.remove-icon', 'img/default/bin_icon.svg');

  applyThemeToImage(
    "salestoolkitPreviewIconInfoAsset",
    "img#info-icon",
    "img/default/info_icon.svg"
  );
  applyThemeToImage(
    "salestoolkitPreviewIconDownloadAsset",
    "img.download-icon",
    "img/default/preview-icon-download-asset.svg"
  );
  applyThemeToImage(
    "salestoolkitPreviewIconRateAsset",
    "img.rate-icon",
    "img/default/star_icon_empty_new_1.svg"
  );
  applyThemeToImage(
    "salestoolkitPreviewIconChangeAssetRating",
    "img.rate-icon-already-rated",
    "img/rating-star-full.svg"
  );

  applyThemeToImage(
    "salestoolkitSideMenuIconHome",
    "img.side-bar-icon.home-icon",
    "img/default/home_new.svg"
  );
  applyThemeToImage(
    "salestoolkitSideMenuIconLibrary",
    "img.side-bar-icon.library-icon",
    "img/default/library.svg"
  );
  applyThemeToImage(
    "salestoolkitSideMenuIconFavourites",
    "img.side-bar-icon.favourites-icon",
    "img/default/favourites_empty_icon_new.svg"
  );
  applyThemeToImage(
    "salestoolkitSideMenuIconCart",
    "img.side-bar-icon.cart-icon",
    "img/default/shopping_cart_new.svg"
  );
  applyThemeToImage(
    "salestoolkitSideMenuIconInbox",
    "img.side-bar-icon.inbox-icon",
    "img/default/inbox_icon.svg"
  );
  applyThemeToImage(
    "salestoolkitSideMenuIconMeetings",
    "img.side-bar-icon.meetings-icon",
    "img/default/meeting1.svg"
  );
  applyThemeToImage(
    "salestoolkitSideMenuIconContacts",
    "img.side-bar-icon.contacts-icon",
    "img/default/contacts.svg"
  );
  applyThemeToImage(
    "salestoolkitSideMenuIconAdmin",
    "img.side-bar-icon.admin-icon",
    "img/default/admin.svg"
  );
  applyThemeToImage(
    "salestoolkitSideMenuIconFAQs",
    "img.side-bar-icon.faqs-icon",
    "img/default/faqs.svg"
  );

  applyThemeToImage(
    "salestoolkitSideMenuIconNews",
    "img.side-bar-icon.news-icon",
    "img/default/news_icon_white.svg"
  );

  applyFilterToActiveMenuItems(css);

  applyThemeToImage(
    "salestoolkitPortletBackButtonIcon",
    "img.backButtonIcon",
    "img/default/back_icon.svg"
  );

  applyThemeToImage(
    "salestoolkitCollectionBrowserToggleSortDefaultIcon",
    "img#default-sort-icon",
    "img/default/sortCollectionBrowserDefault.svg"
  );
  applyThemeToImage(
    "salestoolkitCollectionBrowserToggleSortAZIcon",
    "img#az-sort-icon",
    "img/default/sortCollectionBrowserAZ.svg"
  );
  applyThemeToImage(
    "salestoolkitCollectionBrowserToggleSortZAIcon",
    "img#za-sort-icon",
    "img/default/sortCollectionBrowserZA.svg"
  );

  applyThemeToImage(
    "salestoolkitCollectionBrowserToggleCalendarViewOnIcon",
    "img#calendar-icon-on",
    "img/default/calview_on.svg"
  );
  applyThemeToImage(
    "salestoolkitCollectionBrowserToggleCalendarViewOffIcon",
    "img#calendar-icon-off",
    "img/default/calview_off.svg"
  );

  applyThemeToImage(
    "salestoolkitCollectionBrowserToggleListViewIcon",
    "img#list-view-icon",
    "img/default/list_icon.svg"
  );
  applyThemeToImage(
    "salestoolkitCollectionBrowserToggleTileViewIcon",
    "img#thumbnail-icon",
    "img/default/thumbnails_icon.svg"
  );

  applybgImageStyle(
    css,
    "salestoolkitProfileSelectedSectionArrowIcon",
    "ul.nav-tabs.border-right li.active",
    "img/default/profile_pointingarrow.png",
    "@media (min-width: 992px)"
  );

  applybgImageStyle(
    css,
    "salestoolkitDropdownArrowIconDown",
    "ul.nav-tabs.border-right li.active",
    "img/default/arrow_small_down.svg",
    "@media (max-width: 991px)"
  );
  applybgImageStyle(
    css,
    "salestoolkitDropdownArrowIconDown",
    ".form-control.input-xsmall.input-inline",
    "img/default/arrow_small_down.svg"
  );
  applybgImageStyle(
    css,
    "salestoolkitDropdownArrowIconDown",
    ".form-control.input-variable.input-inline",
    "img/default/arrow_small_down.svg"
  );

  applybgImageStyle(
    css,
    "salestoolkitFilterDropdownArrowIconDown",
    "#filters-panel .form-control.input-variable.input-inline",
    "img/default/arrow_small_down.svg"
  );

  applybgImageStyle(
    css,
    "salestoolkitDropdownArrowIconDown",
    "div.sortby-title span.sortby-head",
    "img/default/arrow_small_down.svg"
  );
  applybgImageStyle(
    css,
    "salestoolkitDropdownArrowIconUp",
    "div.sortby-title.visible span.sortby-head",
    "img/default/arrow_small_up.svg"
  );

  applybgImageStyle(
    css,
    "salestoolkitSortArrowIconNeither",
    "th.sorting",
    "img/default/both_sort.svg"
  );
  applybgImageStyle(
    css,
    "salestoolkitSortArrowIconUp",
    "th.sorting_asc",
    "img/default/arrow_small_up.svg"
  );
  applybgImageStyle(
    css,
    "salestoolkitSortArrowIconDown",
    "th.sorting_desc",
    "img/default/arrow_small_down.svg"
  );

  applybgImageStyle(
    css,
    "salestoolkitDropdownArrowIconDown",
    ".profile-input.language-selector",
    "img/default/arrow_small_down.svg"
  );
  applybgImageStyle(
    css,
    "salestoolkitDropdownArrowIconDown",
    ".dynamicProfile select",
    "img/default/arrow_small_down.svg"
  );

  applyThemeToImage(
    "salestoolkitCartSendIcon",
    "img#cart-send-icon",
    "img/default/Cart_send.svg"
  );
  applyThemeToImage(
    "salestoolkitRegisterInterestIcon",
    "img#cart-registerInterest-icon",
    "img/default/Cart_ri.svg"
  );
  applyThemeToImage(
    "salestoolkitMLRSendIcon",
    "img#cart-mlr-icon",
    "img/default/Cart_mlr.svg"
  );

  applyThemeToImage(
    "salestoolkitCartEmptyIcon",
    "img#cart-empty-icon",
    "img/default/Cart_empty.svg"
  );
  applyThemeToImage(
    "salestoolkitCartSaveIcon",
    "img#save-cart-icon",
    "img/default/SavedCart.svg"
  );

  applyThemeToImage(
    "salestoolkitCartCameraIcon",
    "img#cart-camera-icon",
    "img/default/scan-icon.svg"
  );

  applyThemeToImage(
    "salestoolkitFormSendIcon",
    "img#form-send-icon",
    "img/default/Form_Send.svg"
  );
  applyThemeToImage(
    "salestoolkitFormCreateQRIcon",
    "img#form-qr-icon",
    "img/default/Form_QR.svg"
  );
  applyThemeToImage(
    "salestoolkitFormShareLinkIcon",
    "img#form-share-link-icon",
    "img/default/shareLink.svg"
  );
  applyThemeToImage(
    "salestoolkitFormClearIcon",
    "img#form-clear-icon",
    "img/default/Form_Clear.svg"
  );
  applyThemeToImage(
    "salestoolkitFormTermsIcon",
    "img#form-terms-icon",
    "img/default/Form_Terms.svg"
  );
  applyThemeToImage(
    "salestoolkitFormCameraIcon",
    "img#form-camera-icon",
    "img/default/scan-icon.svg"
  );
  applyThemeToImage(
    "salestoolkitAddIcon",
    "img#add-icon",
    "img/default/add_meeting.svg"
  );

  applyThemeToImage(
    "salestoolkitProfileSelectImageArrowIcon",
    "#salestoolkit-profile-select-image-arrow",
    "img/default/arrow_myprofile.png"
  );
  applyColour(
    css,
    "salestoolkitProfileSelectImageTextColour",
    "#salestoolkit-profile-select-image-text"
  );
  applyColour(
    css,
    "salestoolkitSearchBarCaretColour",
    "#search",
    "caret-color"
  );

  /* CONTACT SESSION STATUS */
  css.push(
    "#contactSessionStatus { border: " +
      SalesToolkit.Theme.getStringProperty(
        "salestoolkitContactSessionStatusBorder",
        "solid 2px #000000;"
      ) +
      " }"
  );
  applyRoundedEdges(
    css,
    "salestoolkitContactSessionStatusBorderRadius",
    "#contactSessionStatus",
    5
  );
  css.push(
    "#contactSessionStatus { max-width: " +
      SalesToolkit.Theme.getStringProperty(
        "salestoolkitContactSessionStatusMaxWidthDesktop",
        "unset"
      ) +
      " }"
  );
  css.push(
    "@media (max-width: 1024px) { #contactSessionStatus { max-width: " +
      SalesToolkit.Theme.getStringProperty(
        "salestoolkitContactSessionStatusMaxWidthTablet",
        "unset"
      ) +
      " } }"
  );
  css.push(
    "@media (max-width: 720px) { #contactSessionStatus { max-width: " +
      SalesToolkit.Theme.getStringProperty(
        "salestoolkitContactSessionStatusMaxWidthMobile",
        "unset"
      ) +
      " } }"
  );

  css.push(
    "#contactSessionStatus::after { top: " +
      SalesToolkit.Theme.getStringProperty(
        "salestoolkitContactSessionStatusTriangleTop",
        "calc(100% - 3px);"
      ) +
      " }"
  );
  /* END CONTACT SESSION STATUS */

  //Remove footer padding mobile
  if (
    SalesToolkit.Theme.getBooleanProperty(
      "removeFooterPaddingOnSmallScreens",
      false
    )
  ) {
    css.push(
      "@media (max-width: 767px) { .sidemenu-mode-toggle-compact.sidemenu-closed .page-footer{ padding-left:0px !important;  }  }"
    );
  }

  /* TEST MODE */

  //HEADER
  if (
    SalesToolkit.Theme.getStringProperty(
      "salestoolkitHeaderBarTestModeBackgroundGradient",
      "linear-gradient(to right, white 30%, red);"
    ).length > 0
  ) {
    css.push(
      "body.testMode .page-header.navbar .page-top { background-image:" +
        SalesToolkit.Theme.getStringProperty(
          "salestoolkitHeaderBarTestModeBackgroundGradient",
          "linear-gradient(to right, white 30%, red);"
        ) +
        " }"
    );
    css.push(
      "body.testMode .page-header.navbar .page-logo { background-color:transparent !important; }"
    );
  }

  // BORDERS
  let borderWidth = SalesToolkit.Theme.getIntegerProperty(
    "salestoolkitTestModeBodyBorderWidth",
    4
  );
  let borderColour = SalesToolkit.Theme.getColourProperty(
    "salestoolkitTestModeBodyBorderColour",
    "#ff0000"
  );
  css.push(
    "body.testMode .testModeBorder { background-color: " +
      colourString(borderColour) +
      " !important; }"
  );
  css.push(
    "body.testMode #testModeBorderUp, body.testMode #testModeBorderDown { height: " +
      borderWidth +
      "px !important; }"
  );
  css.push(
    "body.testMode #testModeBorderLeft, body.testMode #testModeBorderRight { width: " +
      borderWidth +
      "px !important; }"
  );

  if (
    SalesToolkit.Theme.getStringProperty(
      "salestoolkitTestModeFormSectionBorder",
      "solid 4px #ff0000 !important"
    ).length > 0
  ) {
    css.push(
      "body.testMode form .form-section { border:" +
        SalesToolkit.Theme.getStringProperty(
          "salestoolkitTestModeFormSectionBorder",
          "solid 4px #ff0000 !important;"
        ) +
        " }"
    );
  }

  let formTestModeTextColour = SalesToolkit.Theme.getColourProperty(
    "salestoolkitTestModeFormSectionTextColour",
    "#ff0000"
  );
  if (formTestModeTextColour) {
    css.push(
      "body.testMode form .form-section { color:" +
        colourString(formTestModeTextColour) +
        " !important; }"
    );
  }

  applyColour(
    css,
    "salestoolkitTestModeToggleColour",
    "body.testMode .toggleSlider",
    "background-color",
    "#ff0000"
  );

  //Contact info popup
  let contactInfoStatusBackgroundTestMode =
    SalesToolkit.Theme.getColourProperty(
      "salestoolkitTestModeContactSessionInfoBackgroundColour",
      "#ff0000"
    );
  let contactInfoStatusLabelColourTestMode =
    SalesToolkit.Theme.getColourProperty(
      "salestoolkitTestModeContactSessionInfoLabelColour",
      "#000000"
    );
  let contactInfoStatusSpanColourTestMode =
    SalesToolkit.Theme.getColourProperty(
      "salestoolkitTestModeContactSessionInfoSpanColour",
      "#ffffff"
    );
  let contactInfoStatusTestModeTextColour =
    SalesToolkit.Theme.getColourProperty(
      "salestoolkitTestModeContactSessionInfoTextModeTextColour",
      "#ffffff"
    );

  css.push(
    "body.testMode #contactSessionStatus { background-color:" +
      colourString(contactInfoStatusBackgroundTestMode) +
      " !important;  }"
  );
  css.push(
    "body.testMode #contactSessionStatus::after { background-color:" +
      colourString(contactInfoStatusBackgroundTestMode) +
      " !important;  }"
  );
  css.push(
    "body.testMode #contactSessionStatus label { color:" +
      colourString(contactInfoStatusLabelColourTestMode) +
      " !important;  }"
  );
  css.push(
    "body.testMode #contactSessionStatus span { color:" +
      colourString(contactInfoStatusSpanColourTestMode) +
      " !important;  }"
  );
  css.push(
    "body.testMode #contactSessionStatus #contactSessionInfoTestMode { color:" +
      colourString(contactInfoStatusTestModeTextColour) +
      " !important;  }"
  );

  //applyColour(css, 'salestoolkitHeaderBarTestModeBackgroundGradient', 'body.testMode .page-header.navbar .page-logo, body.testMode .page-header.navbar .page-top', 'background-color', '#ff0000')
  applyColour(
    css,
    "salestoolkitHeaderBarTestModeTextColour",
    "body.testMode .logo_text span",
    "color"
  );
  if (
    SalesToolkit.Theme.getStringProperty(
      "salestoolkitHeaderBarIconMode",
      "black"
    ) === "black"
  ) {
    css.push(
      "body.testMode .nav.navbar-nav.pull-right > li > a > img { filter: brightness(0) !important; }"
    );
  } else {
    css.push(
      "body.testMode .nav.navbar-nav.pull-right > li > a > img { filter: brightness(0) invert(1) !important; }"
    );
  }

  if (
    SalesToolkit.Theme.getStringProperty(
      "salestoolkitHeaderBarIconMode",
      "black"
    ) === "black"
  ) {
    css.push("body.testMode #sync-icon { filter: brightness(0) !important; }");
  } else {
    css.push(
      "body.testMode #sync-icon { filter: brightness(0) invert(1) !important; }"
    );
  }

  if (
    SalesToolkit.Theme.getStringProperty(
      "salestoolkitHeaderBarHamburgerIconMode",
      "black"
    ) === "black"
  ) {
    css.push(
      "body.testMode .sidebar-toggler-icon { filter: brightness(0) !important; }"
    );
  } else {
    css.push(
      "body.testMode .sidebar-toggler-icon { filter: brightness(0) invert(1) !important; }"
    );
  }
  //END HEADER

  /* CART SAVING */
  applyColour(
    css,
    "savedCartsCurrentBackgroundColour",
    "#atheneum-saved-carts-view .current",
    "background-color",
    "#ababab"
  );
  applyColour(
    css,
    "savedCartsCurrentTextColour",
    "#atheneum-saved-carts-view .current",
    "color",
    "#000000"
  );
  applyColour(
    css,
    "savedCartsRegularBackgroundColour",
    "#atheneum-saved-carts-view .mine",
    "background-color",
    "#efefef"
  );
  applyColour(
    css,
    "savedCartsRegularTextColour",
    "#atheneum-saved-carts-view .mine",
    "color",
    "#000000"
  );
  applyColour(
    css,
    "savedCartsSharedBackgroundColour",
    "#atheneum-saved-carts-view .shared",
    "background-color",
    "#cecece"
  );
  applyColour(
    css,
    "savedCartsSharedTextColour",
    "#atheneum-saved-carts-view .shared",
    "color",
    "#000000"
  );
  applyColour(
    css,
    "savedCartsActiveBackgroundColour",
    "#atheneum-saved-carts-view .active",
    "background-color",
    "#666666"
  );
  applyColour(
    css,
    "savedCartsActiveTextColour",
    "#atheneum-saved-carts-view .active",
    "color",
    "#ffffff"
  );
  applyColour(
    css,
    "savedCartsPageControlsColour",
    "#saved-carts-paging .pageControls div",
    "color",
    "#ff0000"
  );
  applyColour(
    css,
    "savedCartsPageControlsCurrentPageColour",
    "#saved-carts-paging .pageControls div.current",
    "color",
    "#000000"
  );

  css.push(
    "#saved-carts-paging.collectionBrowser-group-wrapper .pageControls { justify-content: " +
      SalesToolkit.Theme.getStringProperty(
        "savedCartsPageControlsJustifySetting" + cssPropertyName,
        "space-between"
      ) +
      " !important; }"
  );

  /* END CART SAVING */
  /* END TEST MODE */
  applyColour(
    css,
    "salestoolkitHeaderBarBackgroundColour",
    ".page-header.navbar .page-logo, .page-header.navbar .page-top",
    "background-color"
  );
  applyColour(
    css,
    "salestoolkitHeaderBarBackgroundColourHover",
    "body:not(.ios) .page-header .navbar-nav > li.dropdown .dropdown-toggle:hover, .page-header .navbar-nav > li.dropdown.open .dropdown-toggle",
    "background-color"
  );

  if (
    !SalesToolkit.CrossPlatform.enabled &&
    SalesToolkit.Theme.getBooleanProperty(
      "showSyncButtonOnWeb",
      SalesToolkit.Theme.getBooleanProperty("libraryApiIncremental", false)
    ) &&
    (window.location.href.indexOf("index.html") >= 0 ||
      window.location.pathname == "/")
  ) {
    css.push(
      ".salestoolkit_webapp .syncbuttontopbar { display: flex !important; }"
    );
    $('.syncbuttontopbar [data-translation-key="lastSync"]').parent().hide();
    $('.syncbuttontopbar [data-translation-key="missingAssets"]')
      .parent()
      .hide();
    $("#salestoolkit-cache-start-sync-div").hide();
    $('.syncbuttontopbar [data-translation-key="assetsCount"]').parent().hide();
    $('.syncbuttontopbar [data-translation-key="assetsDownloaded"]')
      .parent()
      .hide();
    $('.syncbuttontopbar [data-translation-key="collectionsTotal"]')
      .parent()
      .show();
    $('.syncbuttontopbar [data-translation-key="collectionsCached"]')
      .parent()
      .show();

    applyColour(
      css,
      "salestoolkitHeaderBarIconColour",
      "ul.nav.navbar-nav.pull-right > li.syncbuttontopbar::before",
      "border-color"
    );
  } else if (SalesToolkit.CrossPlatform.enabled) {
    $(".syncbuttontopbar").show();
    $('.syncbuttontopbar [data-translation-key="collectionsTotal"]')
      .parent()
      .hide();
    $('.syncbuttontopbar [data-translation-key="collectionsCached"]')
      .parent()
      .hide();
  }

  applyColour(
    css,
    "salestoolkitHeaderBarIconColour",
    "#salestoolkit-rate-asset-rating-chooser label .fa, #salestoolkit-rate-asset-rating-chooser label:hover"
  );

  applyColour(
    css,
    "salestoolkitHeaderBarIconColour",
    'input.searchbox[type="search"]',
    "border-color"
  );
  applyColour(
    css,
    "salestoolkitHeaderBarIconColour",
    "span#input-triangle::after",
    "border-bottom-color"
  );

  applyColour(
    css,
    "salestoolkitHeaderBarBadgeColour",
    ".page-header.navbar .navbar-nav > li.dropdown .dropdown-toggle .badge",
    "background-color"
  );

  applyColour(css, "salestoolkitPageDateColour", "#currentTime");

  applyThemeToButtons(
    css,
    "salestoolkitSyncIconBackgroundColour",
    "salestoolkitSyncIconBackgroundColourHover",
    "salestoolkitSyncIconColour",
    "salestoolkitSyncIconColourHover",
    ".theme-panel .toggler"
  );

  applyThemeToSyncPanel(
    css,
    "salestoolkitSyncPopupBackgroundColour",
    "salestoolkitSyncPopupTextColour"
  );
  //applyThemeToToggleSideMenuIcon( css, 'salestoolkitToggleSideMenuIcon', 'salestoolkitToggleSideMenuIconHover' );
  applyThemeToSideMenu(
    css,
    "salestoolkitSideMenuItemBackgroundColour",
    "salestoolkitSideMenuItemBackgroundColourHover",
    "salestoolkitSideMenuActiveItemBackgroundColour",
    "salestoolkitSideMenuItemIconColour",
    "salestoolkitSideMenuItemIconColourHover",
    "salestoolkitSideMenuActiveItemIconColour",
    "salestoolkitSideMenuItemTextColour",
    "salestoolkitSideMenuItemTextColourHover",
    "salestoolkitSideMenuActiveItemTextColour",
    "salestoolkitSideMenuItemSeparatorColour",
    "salestoolkitSideMenuItemBadgeColour",
    "salestoolkitSideMenuItemBadgeTextColour"
  );
  applyThemeToLinks(
    css,
    "salestoolkitLinkColour",
    "salestoolkitLinkColourHover"
  );

  applyColour(css, "salestoolkitPortletIconColour", ".font-blue");
  applyColour(
    css,
    "salestoolkitPortletBackgroundColour",
    ".portlet, .page-bar",
    "background-color"
  );
  applyColour(
    css,
    "salestoolkitPortletTitleColour",
    ".portlet-title, .portlet-title .caption, .page-bar .filters-title"
  );
  applyColour(
    css,
    "salestoolkitPortletLineColour",
    ".portlet-title",
    "border-bottom-color"
  );
  applyColour(
    css,
    "salestoolkitPortletLineColour",
    ".new-heading",
    "border-bottom-color"
  );
  applyColour(
    css,
    "salestoolkitPortletLineColour",
    ".libraryPageBar",
    "border-bottom-color"
  );
  applyColour(
    css,
    "salestoolkitPortletLineColour",
    "#searchbox-line",
    "border-top-color"
  );
  applyColour(
    css,
    "salestoolkitPortletLineColour",
    'input[type="text"]:focus',
    "border-color"
  );
  applyColour(
    css,
    "salestoolkitPortletLineColour",
    'input[type="email"]:focus',
    "border-color"
  );
  applyColour(
    css,
    "salestoolkitPortletLineColour",
    'input[type="datetime"]:focus',
    "border-color"
  );
  applyColour(
    css,
    "salestoolkitPortletLineColour",
    'input[type="number"]:focus',
    "border-color"
  );
  applyColour(
    css,
    "salestoolkitPortletLineColour",
    'input[type="password"]:focus',
    "border-color"
  );
  applyColour(
    css,
    "salestoolkitPortletLineColour",
    "textarea:focus",
    "border-color"
  );
  applyColour(
    css,
    "salestoolkitPortletLineColour",
    ".dropdown.dropdown-language.open input",
    "border-color"
  );
  applyColour(
    css,
    "salestoolkitPortletLineColour",
    ".page-toolbar.libraryPageToolbar",
    "border-top-color"
  );
  applyColour(
    css,
    "salestoolkitPortletHeadingColour",
    ".portlet h3, #salestoolkit-cart-portlet .thumbnail .caption, #salestoolkit-favourites .thumbnail .caption"
  );

  applyColour(
    css,
    "salestoolkitContactButtonBackground",
    ".contact-button-background",
    "background"
  );
  applyColour(
    css,
    "salestoolkitContactButtonBorderColour",
    ".contact-button-background",
    "border-color",
    "#bababa"
  );
  applyColour(
    css,
    "salestoolkitContactButtonBorderColourFocus",
    ".contact-button-background:focus",
    "border-color"
  );
  applyColour(
    css,
    "salestoolkitPortletLineColour",
    ".atheneum-form-field .input-group-addon:has(~ input[type=email]:focus)",
    "border-color"
  );
  applyColour(
    css,
    "salestoolkitContactButtonForeground",
    ".contact-button-foreground"
  );

  applyColour(
    css,
    "salestoolkitShareHistoryTableStatusFailedColour",
    ".cart-history-table-status-failed"
  );
  applyColour(
    css,
    "salestoolkitShareHistoryTableStatusSuccessColour",
    ".cart-history-table-status-successful"
  );
  applyColour(
    css,
    "salestoolkitShareHistoryTableStatusCancelledColour",
    ".cart-history-table-status-cancelled"
  );
  applyColour(
    css,
    "salestoolkitShareHistoryTableDocumentsCountColour",
    ".cart-history-documents-count",
    "color",
    "009fe3"
  );
  applyColour(
    css,
    "salestoolkitFormHistoryTableMobileHeadingColour",
    ".form-history-mobile-heading",
    "color",
    "009fe3"
  );

  applyColour(
    css,
    "salestoolkitNewsTickerLatestColour",
    "#salestoolkit-news-ticker-wrapper .ticker-title"
  );
  applyColour(
    css,
    "salestoolkitNewsTickerControlsColour",
    "#salestoolkit-news-ticker-wrapper .controls"
  );
  applyColour(
    css,
    "salestoolkitNewsTickerControlsColourHover",
    "body:not(.ios) #salestoolkit-news-ticker-wrapper .controls:hover"
  );
  applyColour(
    css,
    "salestoolkitNewsTickerBackgroundColour",
    ".news-ticker-page-bar.page-bar, .news-ticker-page-bar.page-bar .ticker-swipe, .news-ticker-page-bar.page-bar .ticker-swipe span",
    "background-color"
  );
  applyThemeToImage(
    "salestoolkitNewsTickerRightBackground",
    ".ticker-right-decoration",
    "metronic/layout/img/crumbflash.png"
  );
  applyColour(
    css,
    "salestoolkitNewsTickerTextColour",
    "#salestoolkit-news-ticker-wrapper .ticker-content"
  );
  applyColour(
    css,
    "salestoolkitNewsTickerTextColour",
    ".ticker-swipe span",
    "border-bottom-color"
  );

  applyThemeToSyncBadge(
    css,
    "salestoolkitSyncBadgeOnline",
    "salestoolkitSyncBadgeSyncing",
    "salestoolkitSyncBadgeOffline",
    "salestoolkitSyncBadgeTextColour"
  );

  applyColour(
    css,
    "salestoolkitLoginBackgroundColour",
    ".login .content, .lock-screen .lock-body, .lock-screen .page-body",
    "background-color"
  );
  applyColour(
    css,
    "salestoolkitLoginTitleColour",
    ".login .content .form-title, #salestoolkit-forgot-password-form h3"
  );
  applyColour(
    css,
    "salestoolkitLoginSubtitleColour",
    "#salestoolkit-forgot-password-form p"
  );
  css.push(
    "#salestoolkit-forgot-password-form p { text-align: " +
      SalesToolkit.Theme.getStringProperty(
        "salestoolkitLoginSubtitleAlign",
        "center"
      ) +
      " !important; }"
  );

  applyColour(
    css,
    "salestoolkitLoginRememberMeColour",
    ".login .content .check"
  );
  applyThemeToLoginForgotPasswordLink(
    css,
    "salestoolkitLoginForgotPasswordColour",
    "salestoolkitLoginForgotPasswordColourHover"
  );
  applyColour(
    css,
    "salestoolkitLoginPageBackgroundColour",
    "body.login, body.lock-screen",
    "background-color"
  );

  applyColour(
    css,
    "salestoolkitLockScreenTitleColour",
    ".lock-screen .lock-head"
  );
  applyColour(
    css,
    "salestoolkitLockScreenUsernameColour",
    ".lock-screen #salestoolkit-name"
  );
  applyColour(
    css,
    "salestoolkitLockScreenBorderColour",
    ".lock-screen .lock-head, .lock-screen .lock-bottom",
    "background-color"
  );
  applyThemeToLinks(
    css,
    "salestoolkitLockLogoutLinkColour",
    "salestoolkitLockLogoutLinkColourHover",
    ".lock-screen .lock-bottom a"
  );

  applyColour(
    css,
    "salestoolkitPageBackgroundColour",
    ".page-container-bg-solid .page-content",
    "background-color"
  );
  applyColour(
    css,
    "salestoolkitPageBackgroundColour",
    ".page-sidebar-menu .active .selected",
    "border-right-color"
  );

  applyThemeToProfileTabs(
    css,
    "salestoolkitProfileTabColourActive",
    "salestoolkitProfileTabColourHover",
    "salestoolkitProfileTabTextColour",
    "salestoolkitProfileTabTextColourActive",
    "salestoolkitProfileTabTextColourHover"
  );
  applyColour(
    css,
    "salestoolkitProfileFieldLabelColour",
    ".profile-content .control-label"
  );
  applyColour(
    css,
    "salestoolkitProfileUserNameColour",
    "#salestoolkit-profile-name"
  );
  applyColour(
    css,
    "salestoolkitProfileUserOccupationColour",
    "#salestoolkit-profile-jobTitle"
  );

  applyColour(
    css,
    "salestoolkitBreadcrumbIconColour",
    '.page-title .page-breadcrumb > li > i[class*="icon-"]'
  );
  applyColour(
    css,
    "salestoolkitBreadcrumbTextColour",
    ".page-title .page-breadcrumb > li > a, .page-title .page-breadcrumb > li > span, .breadsmall"
  );
  applyColour(
    css,
    "salestoolkitBreadcrumbSeparatorColour",
    ".page-title .page-breadcrumb > li > i.fa-angle-right"
  );

  applyColour(
    css,
    "salestoolkitSyncProgressColour",
    "#salestoolkit-cache-progress-bar, .progress-bar-salestoolkit, .pace-progress",
    "background-color"
  );
  applyColour(
    css,
    "salestoolkitSyncCloseColour",
    ".theme-panel > .toggler-close > i",
    "color"
  );
  applyColour(
    css,
    "salestoolkitSyncProgressBackgroundColour",
    ".salestoolkit-cache-progress-div .progress",
    "background-color"
  );

  applyThemeToCollectionBrowser(
    css,
    "salestoolkitCollectionBrowserAssetColour",
    "salestoolkitCollectionBrowserAssetTextColour",
    "salestoolkitCollectionBrowserCollectionColour",
    "salestoolkitCollectionBrowserCollectionTextColour",
    "salestoolkitCollectionBrowserItemColourHover",
    "salestoolkitCollectionBrowserItemTextColourHover",
    "salesToolkitCollectionBrowserFontFamilyOverride",
    "salesToolkitCollectionBrowserFontSize",
    "salesToolkitCollectionBrowserAssetFontSize",
    "salesToolkitCollectionBrowserAssetCursor",
    "salestoolkitCollectionBrowserItemAssetColourHover",
    "salestoolkitCollectionBrowserItemAssetTextColourHover",
    "salestoolkitCollectionBrowserCollectionBoxShadow",
    "salestoolkitCollectionBrowserAssetBoxShadow",
    "salestoolkitCollectionBrowserCollectionBorderRadius",
    "salestoolkitCollectionBrowserAssetBorderRadius"
  );

  applyThemeToCollectionBrowserListView(
    css,
    "salestoolkitCollectionBrowserAssetListViewColour",
    "salestoolkitCollectionBrowserAssetListViewTextColour",
    "salestoolkitCollectionBrowserCollectionListViewColour",
    "salestoolkitCollectionBrowserCollectionListViewTextColour",
    "salestoolkitCollectionBrowserItemListViewColourHover",
    "salestoolkitCollectionBrowserItemListViewTextColourHover",
    "salesToolkitCollectionBrowserListViewFontFamilyOverride",
    "salesToolkitCollectionBrowserListViewFontSize",
    "salesToolkitCollectionBrowserListViewAssetFontSize",
    "salesToolkitCollectionBrowserListViewAssetCursor",
    "salestoolkitCollectionBrowserItemListViewAssetColourHover",
    "salestoolkitCollectionBrowserItemListViewAssetTextColourHover",
    "salestoolkitCollectionBrowserListViewCollectionBoxShadow",
    "salestoolkitCollectionBrowserListViewAssetBoxShadow"
  );

  applyColour(
    css,
    "salestoolkitCollectionBrowserAssetThumbnailBackgroundColour",
    ".atheneum-item .asset-style .thumbnail",
    "background-color"
  );

  applyColour(
    css,
    "calviewActiveHeader",
    ".calview-header h1 a.active",
    "color",
    "#ff3300"
  );

  SalesToolkit.DefaultImages.Asset = SalesToolkit.Theme.getStringProperty(
    "salestoolkitDefaultAssetIcon",
    "img/asset.png"
  );
  SalesToolkit.DefaultImages.Collection = SalesToolkit.Theme.getStringProperty(
    "salestoolkitDefaultCollectionIcon",
    "img/collection.png"
  );
  SalesToolkit.DefaultImages.Form = SalesToolkit.Theme.getStringProperty(
    "salestoolkitDefaultFormIcon",
    "img/default/Form_Default.svg"
  );

  SalesToolkit.DefaultImages.MimeType = {};
  var defaultImageMimeTypes = [
    "application/pdf",
    "video/*",
    "application/vnd.ms-powerpoint",
  ];
  for (var i = 0; i < defaultImageMimeTypes.length; i++) {
    var mimetype = defaultImageMimeTypes[i];
    var mimetypeParts = mimetype.split("/");
    var mimetypeKey =
      "salesToolkitDefaultAssetIcon_" +
      mimetypeParts[0] +
      (mimetypeParts[1] && mimetypeParts[1] != "*"
        ? "/" + mimetypeParts[1]
        : "");
    var value = SalesToolkit.Theme.getStringProperty(mimetypeKey);
    if (value) {
      SalesToolkit.DefaultImages.MimeType[mimetype] = value;
    }
  }

  applyColour(
    css,
    "salestoolkitTreeViewIconColour",
    "#atheneum-tree-view .jstree-themeicon-custom"
  );
  applyColour(
    css,
    "salestoolkitTreeViewTextColour",
    "#atheneum-tree-view .jstree-anchor"
  );

  applyThemeToButtons(
    css,
    "salestoolkitButtonColour",
    "salestoolkitButtonColourHover",
    "salestoolkitButtonTextColour",
    "salestoolkitButtonTextColourHover",
    ".btn-success, .salestoolkit-blue.btn, .btn.blue"

    // #salestoolkit-share-cart
  );

  applyThemeToButtons(
    css,
    "salestoolkitSecondaryButtonColour",
    "salestoolkitSecondaryButtonColourHover",
    "salestoolkitSecondaryButtonTextColour",
    "salestoolkitSecondaryButtonTextColourHover",
    ".btn-default, .btn.default"
  );

  // action buttons like   fullscreen / download / toggle favourite / toggle cart / etc

  applyThemeToButtons(
    css,
    "salestoolkitActionButtonColour",
    "salestoolkitActionButtonColourHover",
    "salestoolkitActionButtonTextColour",
    "salestoolkitActionButtonTextColourHover",
    "salestoolkitActionButtonBorderColour",
    "salestoolkitActionButtonBorderColourHover"
    // '.actions .btn-circle, .atheneum-item-action.btn-circle, table .btn-circle',
  );
  applyThemeToButtons(
    css,
    "salestoolkitActionButtonSelectedColour",
    "salestoolkitActionButtonSelectedColourHover",
    "salestoolkitActionButtonSelectedTextColour",
    "salestoolkitActionButtonSelectedTextColourHover",
    "salestoolkitActionButtonSelectedBorderColour",
    "salestoolkitActionButtonSelectedBorderColourHover",
    ".actions .btn-circle.already-clicked, .actions .btn-circle.on, .atheneum-item-action.btn-circle.already-clicked, .atheneum-item-action.btn-circle.on, table .btn-circle.on, table .btn-circle.already-clicked"
  );

  // login + lock screen buttons

  applyThemeToButtons(
    css,
    "salestoolkitLoginButtonColour",
    "salestoolkitLoginButtonColourHover",
    "salestoolkitLoginButtonTextColour",
    "salestoolkitLoginButtonTextColourHover",
    "#salestoolkit-login-form .btn-success, #salestoolkit-registration-form .btn-success, #salestoolkit-forgot-password-form .btn-success, #salestoolkit-unlock-button"
  );

  applyThemeToButtons(
    css,
    "salestoolkitLoginBackButtonColour",
    "salestoolkitLoginBackButtonColourHover",
    "salestoolkitLoginBackButtonTextColour",
    "salestoolkitLoginBackButtonTextColourHover",
    "#salestoolkit-forgot-password-back"
  );

  applyThemeToButtons(
    css,
    "salestoolkitIgnoreFailedShareButtonColour",
    "salestoolkitIgnoreFailedShareButtonColourHover",
    "salestoolkitIgnoreFailedShareButtonTextColour",
    "salestoolkitIgnoreFailedShareButtonTextColourHover",
    "#redeliverShareModal #redeliverShareModalIgnoreFailedShareButton, #redeliverShareModal #ignoreFailedShareModalConfirmButton"

    // #salestoolkit-share-cart
  );

  applyThemeToFooterLink(
    css,
    "salestoolkitFooterLinkText",
    "salestoolkitFooterLinkHref",
    "salestoolkitFooterLinkColour",
    "salestoolkitFooterLinkColourHover",
    "salestoolkitFooterTextColour",
    "salestoolkitLoginFooterLinkColour",
    "salestoolkitLoginFooterLinkColourHover",
    "salestoolkitLoginFooterTextColour"
  );

  // tables

  applyColour(
    css,
    "salestoolkitTableHeaderIconColour",
    ".dataTables_wrapper th i"
  );
  applyColour(
    css,
    "salestoolkitTableHeaderBackgroundColour",
    ".dataTables_wrapper th",
    "background-color"
  );
  applyColour(
    css,
    "salestoolkitTableHeaderTextColour",
    ".dataTables_wrapper th"
  );

  applyColour(
    css,
    "salestoolkitTableOddRowBackgroundColour",
    ".dataTables_wrapper tbody tr.odd",
    "background-color"
  );
  applyColour(
    css,
    "salestoolkitTableOddRowBackgroundColourHover",
    "body:not(.ios) .dataTables_wrapper tbody tr.odd:hover",
    "background-color"
  );
  applyColour(
    css,
    "salestoolkitTableEvenRowBackgroundColour",
    ".dataTables_wrapper tbody tr.even",
    "background-color"
  );
  applyColour(
    css,
    "salestoolkitTableEvenRowBackgroundColourHover",
    "body:not(.ios) .dataTables_wrapper tbody tr.even:hover",
    "background-color"
  );

  applyColour(
    css,
    "salestoolkitTableBorderColour",
    ".dataTables_wrapper .table-scrollable",
    "border-color"
  );
  applyColour(
    css,
    "salestoolkitTableBorderColour",
    ".dataTables_wrapper td",
    "border-color"
  );
  applyColour(
    css,
    "salestoolkitTableBorderColour",
    ".dataTables_wrapper th",
    "border-color"
  );

  applyColour(css, "salestoolkitTableTextColour", ".dataTables_wrapper td");
  applyColour(
    css,
    "salestoolkitTableExternalTextColour",
    ".dataTables_wrapper .dataTables_info, .dataTables_wrapper .dataTables_length, .dataTables_wrapper .dataTables_filter"
  );

  applyColour(
    css,
    "salestoolkitTablePaginationButtonBorderColour",
    ".dataTables_wrapper .paginate_button a",
    "border-color"
  );

  applyColour(
    css,
    "salestoolkitTablePaginationButtonColour",
    ".dataTables_wrapper .paginate_button:not(.active):not(.disabled) a",
    "background-color"
  );
  applyColour(
    css,
    "salestoolkitTablePaginationButtonColourHover",
    "body:not(.ios) .dataTables_wrapper .paginate_button:not(.active):not(.disabled):hover a",
    "background-color"
  );
  applyColour(
    css,
    "salestoolkitTablePaginationButtonTextColour",
    ".dataTables_wrapper .paginate_button:not(.active):not(.disabled) a"
  );
  applyColour(
    css,
    "salestoolkitTablePaginationButtonTextColourHover",
    "body:not(.ios) .dataTables_wrapper .paginate_button:not(.active):not(.disabled):hover a"
  );
  applyColour(
    css,
    "salestoolkitTablePaginationButtonCurrentColour",
    ".dataTables_wrapper .paginate_button.active a",
    "background-color"
  );
  applyColour(
    css,
    "salestoolkitTablePaginationButtonCurrentTextColour",
    ".dataTables_wrapper .paginate_button.active a"
  );
  applyColour(
    css,
    "salestoolkitTablePaginationButtonDisabledColour",
    ".dataTables_wrapper .paginate_button.disabled a",
    "background-color"
  );
  applyColour(
    css,
    "salestoolkitTablePaginationButtonDisabledTextColour",
    ".dataTables_wrapper .paginate_button.disabled a"
  );

  //Attendee Table
  applyColour(
    css,
    "salestoolkitAttendeesTableOddRowBackgroundColour",
    ".attendeesTableWrapper div.odd",
    "background-color",
    "#fafafa"
  );
  applyColour(
    css,
    "salestoolkitAttendeesTableOddRowTextColour",
    ".attendeesTableWrapper div.odd",
    "color",
    "#000000"
  );
  applyColour(
    css,
    "salestoolkitAttendeesTableEvenRowBackgroundColour",
    ".attendeesTableWrapper div.even",
    "background-color",
    "#efefef"
  );
  applyColour(
    css,
    "salestoolkitAttendeesTableEvenRowTextColour",
    ".attendeesTableWrapper div.even",
    "color",
    "#000000"
  );

  // filters
  applyColour(
    css,
    "filtersTitleColour",
    "#filters-panel .portlet-title span",
    "color"
  );
  applyColour(
    css,
    "filtersSelectBackgroundColour",
    "#filters-panel select",
    "background-color"
  );
  applyColour(css, "filtersSelectTextColour", "#filters-panel select", "color");
  applyColour(
    css,
    "filtersOptionBackgroundColour",
    "#filters-panel select option",
    "background-color",
    "ffffff"
  );
  applyColour(
    css,
    "filtersOptionTextColour",
    "#filters-panel select option",
    "color",
    "000000"
  );

  applyRoundedEdges(
    css,
    "filtersSelectBorderRadius",
    "#filters-panel select",
    5
  );

  applyThemeToNotification(
    css,
    undefined,
    "salestoolkitNotificationTextColour",
    "salestoolkitNotificationOtherBackgroundColour",
    "salestoolkitNotificationOtherBorderColour",
    "salestoolkitNotificationOtherIconBackgroundColour"
  );
  applyThemeToNotification(
    css,
    "favourites",
    "salestoolkitNotificationTextColour",
    "salestoolkitNotificationFavouritesBackgroundColour",
    "salestoolkitNotificationFavouritesBorderColour",
    "salestoolkitNotificationFavouritesIconBackgroundColour"
  );
  applyThemeToNotification(
    css,
    "cart",
    "salestoolkitNotificationTextColour",
    "salestoolkitNotificationCartBackgroundColour",
    "salestoolkitNotificationCartBorderColour",
    "salestoolkitNotificationCartIconBackgroundColour"
  );
  applyThemeToNotification(
    css,
    "download",
    "salestoolkitNotificationTextColour",
    "salestoolkitNotificationDownloadsBackgroundColour",
    "salestoolkitNotificationDownloadsBorderColour",
    "salestoolkitNotificationDownloadsIconBackgroundColour"
  );
  applyThemeToNotification(
    css,
    "info",
    "salestoolkitNotificationTextColour",
    "salestoolkitNotificationInfoBackgroundColour",
    "salestoolkitNotificationInfoBorderColour",
    "salestoolkitNotificationInfoIconBackgroundColour"
  );

  applyColour(
    css,
    "libraryLoadingWheelColour",
    ".lds-roller.filters div:after",
    "background-color"
  );
  applyScaleCSS(css, "libraryLoadingWheelScale", ".lds-roller.filters", "0.4");

  applyColour(
    css,
    "filtersLoadingWheelColour",
    ".lds-roller.filters div:after",
    "background-color"
  );
  applyScaleCSS(
    css,
    "filtersLoadingWheelScale",
    ".filteredDropdownShow.loading .loading-wheel",
    "0.4"
  );

  applyColour(
    css,
    "infoModalLoadingWheelColour",
    ".lds-roller.filters div:after",
    "background-color"
  );
  applyScaleCSS(
    css,
    "infoModalLoadingWheelScale",
    "#documentInfoModal.loading .loading-wheel",
    "0.4"
  );

  applyColour(
    css,
    "documentTaggingAutomaticTagColor",
    ".ms-list li.automaticTag",
    "color",
    "#cccccc"
  );
  applyColour(
    css,
    "documentTaggingOptionGroupHeaderColor",
    ".ms-list li.ms-optgroup-label",
    "color",
    "#ff3300"
  );

  if (!SalesToolkit.Theme.getBooleanProperty("useFixedSuggestions", false)) {
    css.push(
      "@media (min-width:768px){    .atheneum-form-field .suggestion-wrapper {        width: 100% !important;        position: absolute !important;    }    .atheneum-form-field .contactInfoMode.suggestion-wrapper {        width: 100%;        position: absolute;    }}"
    );
  }

  css.push(
    ".filteredDropdown-items .headerOption{ " +
      SalesToolkit.Theme.getStringProperty(
        "filteredDropdownHeaderOptionStyle",
        "font-weight:600;"
      ) +
      " }"
  );
  css.push(
    ".filteredDropdown-items .suboption{ " +
      SalesToolkit.Theme.getStringProperty(
        "filteredDropdownSubOptionStyle",
        "font-weight:normal; padding-left:21px;"
      ) +
      " }"
  );
  css.push(
    ".filteredDropdown-items .headerOption .accordion-button{ " +
      SalesToolkit.Theme.getStringProperty(
        "filteredDropdownHeaderAccordionButtonStyle",
        "font-size:1.6rem;"
      ) +
      " }"
  );
  css.push(
    ".filteredDropdown-items .headerOption .accordion-button:hover{ " +
      SalesToolkit.Theme.getStringProperty(
        "filteredDropdownHeaderAccordionButtonHoverStyle",
        "background-color:rgba(0,0,0,.1);"
      ) +
      " }"
  );
  css.push(
    ".filteredDropdown-items .headerOption .accordion-button::before{ " +
      SalesToolkit.Theme.getStringProperty(
        "filteredDropdownHeaderAccordionButtonBeforeStyle",
        'content:"+";'
      ) +
      " }"
  );
  css.push(
    ".filteredDropdown-items .headerOption .open.accordion-button::before{ " +
      SalesToolkit.Theme.getStringProperty(
        "filteredDropdownHeaderAccordionButtonOpenBeforeStyle",
        'content:"-";'
      ) +
      " }"
  );

  css.push(
    ".assetSummary { margin-bottom: " +
      SalesToolkit.Theme.getIntegerProperty("assetSummaryMarginBottom", 20) +
      "px; }"
  );

  //Hidden filters panel
  //Bold
  applyColour(
    css,
    "hiddenFiltersH1Colour",
    "#hidden-filters-panel h1",
    "color",
    "black"
  );
  applyFontSizeCSS(
    css,
    "hiddenFiltersH1FontSize" + cssPropertyName,
    "#hidden-filters-panel h1",
    "2rem"
  );
  applyFontWeightCSS(
    css,
    "hiddenFiltersH1FontWeight",
    "#hidden-filters-panel h1",
    "600"
  );

  if (
    SalesToolkit.Theme.getBooleanProperty(
      "removeLeftPaddingFromHiddenFiltersButton",
      true
    )
  ) {
    css.push("#hidden-filters-panel button { padding-left: 0 !important; }");
  }
  applyColour(
    css,
    "hiddenFiltersH1Colour",
    "#hidden-filters-panel .filters h2",
    "color",
    "black"
  );
  applyFontSizeCSS(
    css,
    "hiddenFiltersH2FontSize" + cssPropertyName,
    "#hidden-filters-panel .filters h2",
    "1.5rem"
  );
  applyFontWeightCSS(
    css,
    "hiddenFiltersH2FontWeight",
    "#hidden-filters-panel .filters h2",
    "500"
  );

  applyColour(
    css,
    "hiddenFiltersSpanColour",
    "#hidden-filters-panel .filters span",
    "color",
    "black"
  );
  applyFontSizeCSS(
    css,
    "hiddenFiltersSpanFontSize" + cssPropertyName,
    "#hidden-filters-panel .filters span",
    "1.2rem"
  );
  applyFontWeightCSS(
    css,
    "hiddenFiltersH1FontWeight",
    "#hidden-filters-panel .filters span",
    "400"
  );

  applyColour(
    css,
    "hiddenFiltersSpanColour",
    "#hidden-filters-panel #hidden-filters-info",
    "color",
    "black"
  );
  applyFontSizeCSS(
    css,
    "hiddenFiltersSpanFontSize" + cssPropertyName,
    "#hidden-filters-panel #hidden-filters-info",
    "1.5rem"
  );
  applyFontWeightCSS(
    css,
    "hiddenFiltersH1FontWeight",
    "#hidden-filters-panel #hidden-filters-info",
    "400 	"
  );

  var styleElement = document.getElementById("salestoolkitThemeCSS");
  if (styleElement == null) {
    styleElement = document.createElement("STYLE");
    styleElement.setAttribute("id", "salestoolkitThemeCSS");
    styleElement.setAttribute("type", "text/css");
    document.head.appendChild(styleElement);
  }
  styleElement.innerHTML = css.join("\n");

  applyPostInjectionScripts();

  //check for kiosk mode
  setKioskMode();
}

var TRANSPARENT_IMAGE_32x32 =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAH0lEQVR42mNkoBAwjhowasCoAaMGjBowasCoAcPNAACOMAAhOO/A7wAAAABJRU5ErkJggg==";

//EX <div class="accordionGroup"><h1 class="accordionHeader">test q1</h1><p class="answerSection">what an answer!</p></div>
function getFAQs() {
  return SalesToolkit.Translation.getOrGetThemeKey("faqHtml", "").trim();
}

function applyThemeToFavIcon(themeKey) {
  var shortcutIcon = document.querySelector(
    "head > link[rel~=icon][rel~=shortcut]"
  );
  if (shortcutIcon == null) {
    shortcutIcon = document.createElement("LINK");
    shortcutIcon.setAttribute("rel", "shortcut icon");
    document.head.appendChild(shortcutIcon);
  }
  var shortcutIconHref = SalesToolkit.Theme.getStringProperty(themeKey);
  if (shortcutIconHref) {
    shortcutIcon.setAttribute("href", shortcutIconHref);
  } else if (
    SalesToolkit.Theme.getBooleanProperty("defaultToBlankFavIccon", false)
  ) {
    // if no icon set, leave the default
    console.log("No override for default fav icon");
  }
}

function applyFilterToActiveMenuItems(css) {
  var filter = SalesToolkit.Theme.getStringProperty(
    "activeMenuItemFilter",
    "none"
  );
  if (filter) {
    css.push(
      ".active img.side-bar-icon" +
        " { " +
        "filter" +
        ": " +
        filter +
        " !important; }"
    );
  }

  filter = SalesToolkit.Theme.getStringProperty(
    "activeMenuItemFilterHover",
    SalesToolkit.Theme.getStringProperty("activeMenuItemFilter", "none")
  );
  if (!SalesToolkit.CrossPlatform.enabled && filter) {
    css.push(
      "li:hover img.side-bar-icon" +
        " { " +
        "filter" +
        ": " +
        filter +
        " !important; }"
    );
  }
}

function colourString(colour) {
  if (colour && colour.alpha == 1) {
    return colour.toHexString();
  } else if (colour) {
    return colour.toString();
  } else {
    return null;
  }
}

function applyThemeToImage(themeKey, imgSelector, defaultValue) {
  if (arguments.length == 2) {
    defaultValue = TRANSPARENT_IMAGE_32x32;
  }
  var imgElement = document.querySelectorAll(imgSelector);

  var propertyValue = SalesToolkit.Theme.getStringProperty(
    themeKey,
    defaultValue
  );
  if (propertyValue) {
    propertyValue = SalesToolkit.CrossPlatform.rewriteURL(propertyValue);
  }

  for (var i = 0; i < imgElement.length; i++) {
    if (
      imgElement[i].getAttribute("src") &&
      imgElement[i].getAttribute("src") == propertyValue &&
      imgElement[i].getAttribute("data-loaded-successfully")
    )
      continue;
    imgElement[i].onerror = function () {
      this.onerror = null;
      this.src = defaultValue;
    };
    imgElement[i].setAttribute("src", propertyValue);
  }

  // if( imgElement ) {
  // 	imgElement.setAttribute('src', propertyValue);
  // }
}

function applyThemeTobgImage(themeKey, imgSelector, defaultValue) {
  if (arguments.length == 2) {
    defaultValue = TRANSPARENT_IMAGE_32x32;
  }
  var imgElement = document.querySelectorAll(imgSelector);
  var propertyValue = SalesToolkit.Theme.getStringProperty(
    themeKey,
    defaultValue
  );
  if (propertyValue) {
    propertyValue = SalesToolkit.CrossPlatform.rewriteURL(propertyValue);
  }
  for (var i = 0; i < imgElement.length; i++) {
    imgElement[i].style.backgroundImage = "url('" + propertyValue + "')";
  }

  // if( imgElement ) {
  // 	imgElement.style.backgroundImage = "url('" + propertyValue + "')";
  // }
}

function applyThemeToFooterLink(
  css,
  textTK,
  linkTK,
  colourTK,
  hoverColourTK,
  textColourTK,
  loginColourTK,
  loginColourHoverTK,
  loginTextColourTk
) {
  var footerLink = document.querySelector(
    ".page-footer-inner a, .copyright a, .page-footer-custom a"
  );
  if (!footerLink) return;
  footerLink.textContent = SalesToolkit.Translation.getOrGetThemeKey(
    textTK,
    ""
  );
  linkHref = SalesToolkit.Translation.getOrGetThemeKey(linkTK);
  if (
    linkHref &&
    SalesToolkit.Theme.getBooleanProperty("useLinkInFooter", true)
  ) {
    footerLink.href = linkHref;
    footerLink.title = footerLink.href
      .replace(/^http[s]?:\/\//, "")
      .replace(/\/$/, "");
  } else {
    css.push(
      ".copyright a:focus, .copyright a:hover, .page-footer-inner a:focus, .page-footer-inner a:hover, .page-footer-custom a:focus, .page-footer-custom a:hover { text-decoration:none !important; }"
    );
    footerLink.removeAttribute("href");
    footerLink.removeAttribute("title");
  }

  applyColour(css, textColourTK, ".page-footer-inner");
  var normalLinkColour = SalesToolkit.Theme.getColourProperty(colourTK);
  if (normalLinkColour) {
    css.push(
      ".page-footer-inner a { color: " +
        colourString(normalLinkColour) +
        " !important; }"
    );
  }
  var hoverLinkColour = SalesToolkit.Theme.getColourProperty(
    colourTK,
    normalLinkColour
  );
  if (hoverLinkColour) {
    css.push(
      "body:not(.ios) .page-footer-inner a:hover { color: " +
        colourString(hoverLinkColour) +
        " !important; }"
    );
  }

  applyColour(
    css,
    loginTextColourTk,
    ".page-lock .page-footer-custom, .login .copyright"
  );
  var normalLoginLinkColour =
    SalesToolkit.Theme.getColourProperty(loginColourTK);
  if (normalLoginLinkColour) {
    css.push(
      ".page-lock .page-footer-custom a, .login .copyright a { color: " +
        colourString(normalLoginLinkColour) +
        " !important; }"
    );
  }
  var hoverLoginLinkColour = SalesToolkit.Theme.getColourProperty(
    loginColourHoverTK,
    normalLoginLinkColour
  );
  if (hoverLoginLinkColour) {
    css.push(
      "body:not(.ios) .page-lock .page-footer-custom a:hover, body:not(.ios) .login .copyright a:hover { color: " +
        colourString(hoverLoginLinkColour) +
        " !important; }"
    );
  }
}

function applyThemeToToggleSideMenuIcon(css, normalTK, hoverTK) {
  var normalSideMenuTogglerBackground = SalesToolkit.Theme.getStringProperty(
    normalTK,
    "metronic/layout/img/sidebar-toggler.png"
  );
  var hoverSideMenuTogglerBackground = SalesToolkit.Theme.getStringProperty(
    hoverTK,
    normalSideMenuTogglerBackground
  );
  var fade = true;
  if (normalSideMenuTogglerBackground != hoverSideMenuTogglerBackground) {
    fade = false;
  }
  css.push(
    '.page-header.navbar .menu-toggler { background-image: url("' +
      normalSideMenuTogglerBackground +
      '");' +
      (fade ? "" : " opacity: 1;") +
      " }"
  );
  css.push(
    'body:not(.ios) .page-header.navbar .menu-toggler:hover { background-image: url("' +
      hoverSideMenuTogglerBackground +
      '"); opacity: 1; }'
  );
}

function applyThemeToLinks(css, normalTK, hoverTK, selector) {
  var important = " !important";
  if (selector == undefined) {
    selector = "a, .ticker-content a, .ticker-swipe span";
    important = "";
  }
  var normalLinkColour = SalesToolkit.Theme.getColourProperty(normalTK);
  if (normalLinkColour) {
    css.push(
      selector +
        " { color: " +
        colourString(normalLinkColour) +
        important +
        " }"
    );
  }
  var hoverLinkColour = SalesToolkit.Theme.getColourProperty(
    normalTK,
    normalLinkColour
  );
  if (hoverLinkColour) {
    css.push(
      selector.split(",").join(":hover,") +
        ":hover { color: " +
        colourString(hoverLinkColour) +
        important +
        " }"
    );
  }
}

function applyFontSizeCSS(css, normalTK, selector, defaultValue) {
  let important = " !important";

  let normalFontSize = SalesToolkit.Theme.getStringProperty(
    normalTK,
    defaultValue
  );
  if (normalFontSize) {
    css.push(selector + " { font-size: " + normalFontSize + important + " }");
  }
}

function applyFontWeightCSS(css, normalTK, selector, defaultValue) {
  let important = " !important";

  let fontWeight = SalesToolkit.Theme.getStringProperty(normalTK, defaultValue);
  if (fontWeight) {
    css.push(selector + " { font-weight: " + fontWeight + important + " }");
  }
}

function applyScaleCSS(css, scaleTK, selector, defaultValue) {
  let important = " !important";
  let scaleSize = SalesToolkit.Theme.getStringProperty(scaleTK, defaultValue);
  if (scaleSize) {
    css.push(
      selector + " { transform:scale(" + scaleSize + ") " + important + "; }"
    );
  }
}

function applyThemeToLoginForgotPasswordLink(css, normalTK, hoverTK) {
  var normalLinkColour = SalesToolkit.Theme.getColourProperty(normalTK);
  if (normalLinkColour) {
    css.push(
      "#salestoolkit-forgot-password-link { color: " +
        colourString(normalLinkColour) +
        " }"
    );
  }
  var hoverLinkColour = SalesToolkit.Theme.getColourProperty(
    hoverTK,
    normalLinkColour
  );
  if (hoverLinkColour) {
    css.push(
      "body:not(.ios) #salestoolkit-forgot-password-link:hover { color: " +
        colourString(hoverLinkColour) +
        " }"
    );
  }
}

function applyColour(css, themeKey, selector, property, defaultValue) {
  if (property == undefined || property == "colour") {
    property = "color";
  }
  var colour = SalesToolkit.Theme.getColourProperty(themeKey, defaultValue);
  if (colour) {
    css.push(
      selector +
        " { " +
        property +
        ": " +
        colourString(colour) +
        " !important; }"
    );
  }
}

function applyRoundedEdges(css, themeKey, selector, defaultValue) {
  var re = SalesToolkit.Theme.getIntegerProperty(themeKey, defaultValue);
  if (re) {
    css.push(selector + " { border-radius: " + re + "px !important; }");
  }
}

function applyTopRoundedEdges(css, themeKey, selector, defaultValue) {
  var re = SalesToolkit.Theme.getIntegerProperty(themeKey, defaultValue);
  if (re) {
    css.push(
      selector +
        " { border-top-left-radius: " +
        re +
        "px !important; border-top-right-radius: " +
        re +
        "px !important; }"
    );
  }
}

function applyBorderWidth(css, themeKey, selector, defaultValue) {
  var re = SalesToolkit.Theme.getIntegerProperty(themeKey, defaultValue);
  if (re) {
    css.push(selector + " { border-width: " + re + "px !important; }");
  }
}

function applybgImageStyle(css, themeKey, selector, defaultValue, mediaQuery) {
  var bg_image = SalesToolkit.Theme.getStringProperty(themeKey, defaultValue);
  if (bg_image) {
    bg_image = SalesToolkit.CrossPlatform.rewriteURL(bg_image);
    if (mediaQuery) {
      css.push(
        mediaQuery +
          "{" +
          selector +
          " { background-image: url(" +
          bg_image +
          ") !important; }}"
      );
    } else {
      css.push(
        selector + " { background-image: url(" + bg_image + ") !important; }"
      );
    }
  }
}

function applyThemeToButtons(
  css,
  bgTK,
  hoverBgTK,
  textTK,
  hoverTextTK,
  borderTK,
  borderHoverTK,
  buttonSelector
) {
  if (arguments.length == 5 || arguments.length == 6) {
    buttonSelector = borderTK;
    borderTK = undefined;
    borderHoverTK = undefined;
  }
  if (buttonSelector == undefined) {
    buttonSelector = ".btn";
  }
  var buttonHoverSelector = buttonSelector
    .split(",")
    .join(":hover, body:not(.ios) ");
  if (buttonHoverSelector) {
    buttonHoverSelector = "body:not(.ios) " + buttonHoverSelector + ":hover";
  }
  var buttonTextSelector =
    buttonSelector + ", " + buttonSelector.split(",").join(" > i,") + " > i";
  var buttonTextHoverSelector =
    buttonHoverSelector +
    ", " +
    buttonHoverSelector.split(",").join(" > i,") +
    " > i";

  var normalBtnColour = SalesToolkit.Theme.getColourProperty(bgTK);
  if (normalBtnColour) {
    css.push(
      buttonSelector +
        " { background-color: " +
        colourString(normalBtnColour) +
        " !important; }"
    );
  }
  var hoverBtnColour = SalesToolkit.Theme.getColourProperty(
    hoverBgTK,
    normalBtnColour
  );
  if (hoverBtnColour) {
    css.push(
      buttonHoverSelector +
        " { background-color: " +
        colourString(hoverBtnColour) +
        " !important; }"
    );
  }

  var normalBtnTextColour = SalesToolkit.Theme.getColourProperty(textTK);
  if (normalBtnTextColour) {
    css.push(
      buttonTextSelector +
        " { color: " +
        colourString(normalBtnTextColour) +
        " !important; }"
    );
  }
  var hoverBtnTextColour = SalesToolkit.Theme.getColourProperty(
    hoverTextTK,
    normalBtnTextColour
  );
  if (hoverBtnTextColour) {
    //if it's iOS try to use the normal text colour on hovers as hovers are a bit broken in iOS safari
    if (iOS && normalBtnTextColour)
      css.push(
        buttonTextHoverSelector +
          " { color: " +
          colourString(normalBtnTextColour) +
          " !important; }"
      );
    else
      css.push(
        buttonTextHoverSelector +
          " { color: " +
          colourString(hoverBtnTextColour) +
          " !important; }"
      );
  }
  var normalBorderColour =
    borderTK == undefined
      ? undefined
      : SalesToolkit.Theme.getColourProperty(borderTK);
  if (normalBorderColour) {
    css.push(
      buttonSelector +
        " { border-color: " +
        colourString(normalBorderColour) +
        " !important; }"
    );
  }
  var hoverBorderColour =
    borderHoverTK == undefined
      ? normalBorderColour
      : SalesToolkit.Theme.getColourProperty(borderHoverTK, normalBorderColour);
  if (hoverBorderColour) {
    css.push(
      buttonHoverSelector +
        " { border-color: " +
        colourString(hoverBorderColour) +
        " !important; }"
    );
  }
}

function applyThemeToProfileTabs(
  css,
  activeTK,
  hoverTK,
  textColour,
  activeTextColour,
  hoverTextColour
) {
  applyColour(
    css,
    hoverTK,
    "body:not(.ios) .tabbable-line > .nav-tabs > li:not(.active):hover",
    "border-bottom-color"
  );
  applyColour(
    css,
    activeTK,
    ".tabbable-line > .nav-tabs > li.active",
    "border-bottom-color"
  );

  applyColour(
    css,
    textColour,
    "body:not(.ios) .tabbable-line > .nav-tabs > li:not(.active):not(:hover) a"
  );
  applyColour(
    css,
    hoverTextColour,
    ".tabbable-line > .nav-tabs > li:not(.active):hover a"
  );
  applyColour(
    css,
    activeTextColour,
    ".tabbable-line > .nav-tabs > li.active a"
  );
}

function applyThemeToCollectionBrowser(
  css,
  assetTK,
  assetTextTK,
  collectionTK,
  collectionTextTK,
  hoverTK,
  hoverTextTK,
  fontFamilyTK,
  fontSizeTK,
  assetFontSizeTK,
  assetCursorTK,
  hoverAssetTK,
  hoverAssetTextTK,
  boxShadowCollectionTK,
  boxShadowAssetTK,
  borderRadiusCollectionTK,
  borderRadiusAssetTK
) {
  applyColour(css, assetTK, ".atheneum-item .asset-style", "background-color");
  applyColour(
    css,
    assetTextTK,
    ".atheneum-item .asset-style .atheneum-item-name",
    "color"
  );

  applyColour(
    css,
    collectionTK,
    ".atheneum-item .collection-style",
    "background-color"
  );
  applyColour(
    css,
    collectionTextTK,
    ".atheneum-item .collection-style .atheneum-item-name",
    "color"
  );

  applyColour(
    css,
    hoverTK,
    "body:not(.ios) .atheneum-item .collection-style:hover",
    "background-color"
  );
  applyColour(
    css,
    hoverTextTK,
    "body:not(.ios) .atheneum-item .collection-style:hover .atheneum-item-name",
    "color"
  );

  var customFontFamily = SalesToolkit.Theme.getStringProperty(fontFamilyTK, "");
  if (customFontFamily.length > 0) {
    css.push(
      '.atheneum-item .collection-style .atheneum-item-name, .atheneum-item .asset-style .atheneum-item-name { font-family: "' +
        customFontFamily +
        '", "Open Sans", sans-serif !important; }'
    );
  }

  var cssPropertyName = "Desktop";
  if (screen.width <= 1024) {
    //Tablet
    cssPropertyName = "Tablet";

    //Mobile
    if (screen.width <= 720) {
      cssPropertyName = "Mobile";
    }
  }

  applyFontSizeCSS(
    css,
    fontSizeTK + cssPropertyName,
    ".atheneum-item .collection-style .collection-name",
    "12px"
  );
  applyFontSizeCSS(
    css,
    assetFontSizeTK + cssPropertyName,
    ".atheneum-item .asset-style .atheneum-item-name",
    "12px"
  );

  applyFontWeightCSS(
    css,
    "salestoolkitCollectionFontWeight",
    ".atheneum-item .collection-style .collection-name",
    "600"
  );
  applyFontWeightCSS(
    css,
    "salestoolkitAssetFontWeight",
    ".atheneum-item .asset-style .atheneum-item-name",
    "600"
  );

  css.push(
    ".atheneum-item .asset-style .atheneum-item-name { cursor: " +
      SalesToolkit.Theme.getStringProperty(assetCursorTK, "text") +
      " }"
  );

  applyColour(
    css,
    hoverAssetTK,
    "body:not(.ios) .atheneum-item .asset-style:hover",
    "background-color"
  );
  applyColour(
    css,
    hoverAssetTextTK,
    "body:not(.ios) .atheneum-item .asset-style:hover .atheneum-item-name",
    "color"
  );

  css.push(
    ".salestoolkit-main-panel .col-sm-12.col-md-3.atheneum-item.collection-browser-collection { overflow:hidden; box-shadow: " +
      SalesToolkit.Theme.getStringProperty(
        boxShadowCollectionTK,
        "2px 2px 3px #d0d0d0"
      ) +
      " !important}"
  );
  css.push(
    ".salestoolkit-main-panel .col-sm-12.col-md-3.atheneum-item.collection-browser-asset { overflow:hidden; box-shadow: " +
      SalesToolkit.Theme.getStringProperty(
        boxShadowAssetTK,
        "2px 2px 3px #d0d0d0"
      ) +
      " !important}"
  );

  css.push(
    "#salestoolkit-cart-portlet .col-sm-12.col-md-2.atheneum-item { overflow:hidden; }"
  );
  css.push(
    "#salestoolkit-favourites .col-sm-12.col-md-2.atheneum-item { overflow:hidden; }"
  );

  applyRoundedEdges(
    css,
    borderRadiusCollectionTK,
    ".salestoolkit-main-panel .col-sm-12.col-md-3.atheneum-item.collection-browser-collection",
    0
  );
  applyRoundedEdges(
    css,
    borderRadiusAssetTK,
    ".salestoolkit-main-panel .col-sm-12.col-md-3.atheneum-item.collection-browser-asset",
    0
  );

  applyRoundedEdges(
    css,
    borderRadiusAssetTK,
    "#salestoolkit-cart-portlet .col-sm-12.col-md-2.atheneum-item",
    0
  );

  applyRoundedEdges(
    css,
    borderRadiusAssetTK,
    "#salestoolkit-favourites .col-sm-12.col-md-2.atheneum-item",
    0
  );
}

function applyThemeToCollectionBrowserListView(
  css,
  assetTK,
  assetTextTK,
  collectionTK,
  collectionTextTK,
  hoverTK,
  hoverTextTK,
  fontFamilyTK,
  fontSizeTK,
  assetFontSizeTK,
  assetCursorTK,
  hoverAssetTK,
  hoverAssetTextTK,
  boxShadowCollectionTK,
  boxShadowAssetTK
) {
  applyColour(
    css,
    assetTK,
    ".showing-list-view .atheneum-item .asset-style",
    "background-color"
  );
  applyColour(
    css,
    assetTextTK,
    ".showing-list-view .atheneum-item .asset-style .atheneum-item-name",
    "color"
  );

  applyColour(
    css,
    collectionTK,
    ".showing-list-view .atheneum-item .collection-style",
    "background-color"
  );
  applyColour(
    css,
    collectionTextTK,
    ".showing-list-view .atheneum-item .collection-style .atheneum-item-name",
    "color"
  );

  applyColour(
    css,
    hoverTK,
    "body.showing-list-view:not(.ios) .atheneum-item .collection-style:hover",
    "background-color"
  );
  applyColour(
    css,
    hoverTextTK,
    "body.showing-list-view:not(.ios) .atheneum-item .collection-style:hover .atheneum-item-name",
    "color"
  );

  var customFontFamily = SalesToolkit.Theme.getStringProperty(fontFamilyTK, "");
  if (customFontFamily.length > 0) {
    css.push(
      '.showing-list-view .atheneum-item .collection-style .atheneum-item-name, .showing-list-view  .atheneum-item .asset-style .atheneum-item-name { font-family: "' +
        customFontFamily +
        '", "Open Sans", sans-serif !important; }'
    );
  }

  var cssPropertyName = "Desktop";
  if (screen.width <= 1024) {
    //Tablet
    cssPropertyName = "Tablet";

    //Mobile
    if (screen.width <= 720) {
      cssPropertyName = "Mobile";
    }
  }

  applyFontSizeCSS(
    css,
    fontSizeTK + cssPropertyName,
    ".showing-list-view .atheneum-item .collection-style .collection-name",
    "12px"
  );
  applyFontSizeCSS(
    css,
    assetFontSizeTK + cssPropertyName,
    ".showing-list-view .atheneum-item .asset-style .atheneum-item-name",
    "12px"
  );

  applyFontWeightCSS(
    css,
    "salestoolkitListViewCollectionFontWeight",
    ".showing-list-view .atheneum-item .collection-style .collection-name",
    "600"
  );
  applyFontWeightCSS(
    css,
    "salestoolkitListViewAssetFontWeight",
    ".showing-list-view .atheneum-item .asset-style .atheneum-item-name",
    "600"
  );

  css.push(
    ".showing-list-view  .atheneum-item .asset-style .atheneum-item-name { cursor: " +
      SalesToolkit.Theme.getStringProperty(assetCursorTK, "text") +
      " }"
  );

  applyColour(
    css,
    hoverAssetTK,
    "body:not(.ios).showing-list-view .atheneum-item .asset-style:hover",
    "background-color"
  );
  applyColour(
    css,
    hoverAssetTextTK,
    "body:not(.ios).showing-list-view .atheneum-item .asset-style:hover .atheneum-item-name",
    "color"
  );

  css.push(
    "body.showing-list-view #atheneum-home-page .col-sm-12.col-md-3.atheneum-item.collection-browser-collection { margin-bottom: " +
      SalesToolkit.Theme.getStringProperty(
        "salestoolkitListViewMarginBottom",
        "15px"
      ) +
      " !important; box-shadow: " +
      SalesToolkit.Theme.getStringProperty(
        boxShadowCollectionTK,
        "2px 2px #fff"
      ) +
      " !important}"
  );
  css.push(
    "body.showing-list-view #atheneum-home-page .col-sm-12.col-md-3.atheneum-item.collection-browser-asset { margin-botton: " +
      SalesToolkit.Theme.getStringProperty(
        "salestoolkitListViewMarginBottom",
        "15px"
      ) +
      " !important; box-shadow: " +
      SalesToolkit.Theme.getStringProperty(boxShadowAssetTK, "2px 2px #fff") +
      " !important}"
  );
}

function applyThemeToSyncBadge(
  css,
  onlineTK,
  syncingTK,
  offlineTK,
  textColourTK
) {
  applyColour(
    css,
    onlineTK,
    ".salestoolkit-cache-state-online",
    "background-color"
  );
  applyColour(
    css,
    syncingTK,
    ".salestoolkit-cache-state-syncing",
    "background-color"
  );
  applyColour(
    css,
    offlineTK,
    ".salestoolkit-cache-state-offline",
    "background-color"
  );
  applyColour(
    css,
    textColourTK,
    ".salestoolkit-cache-state-online, .salestoolkit-cache-state-syncing, .salestoolkit-cache-state-offline"
  );
}

function applyThemeToSyncPanel(css, bgTK, textTK) {
  applyColour(
    css,
    bgTK,
    ".theme-panel > .theme-options > .theme-option",
    "background-color"
  );
  applyColour(css, textTK, ".theme-panel > .theme-options > .theme-option");
}

function applyThemeToSideMenu(
  css,
  bgTK,
  bgHoverTK,
  openBgTK,
  iconColourTK,
  iconColourHoverTK,
  openIconColourTK,
  textTK,
  textHoverTK,
  openTextTK,
  separatorTK,
  badgeBgTK,
  badgeTextTK
) {
  applyColour(
    css,
    bgTK,
    "body:not(.login):not(.lock-screen), body:not(.login):not(.lock-screen) .page-footer, .page-sidebar",
    "background-color"
  );
  if (!SalesToolkit.CrossPlatform.enabled)
    applyColour(
      css,
      bgHoverTK,
      "body:not(.ios) .page-sidebar-menu li:not(.active):hover a",
      "background-color"
    );
  else {
    applyColour(
      css,
      bgTK,
      "body:not(.ios) .page-sidebar-menu li:not(.active):hover a",
      "background-color"
    );
  }
  applyColour(
    css,
    openBgTK,
    ".page-sidebar-menu li.active a",
    "background-color"
  );
  applyColour(css, iconColourTK, ".page-sidebar-menu li a > i:first-child");
  applyColour(
    css,
    iconColourHoverTK,
    "body:not(.ios) .page-sidebar-menu li:not(.active):hover a > i:first-child"
  );
  applyColour(
    css,
    openIconColourTK,
    ".page-sidebar-menu li.active a > i:first-child"
  );
  applyColour(css, textTK, ".page-sidebar-menu > li:not(.active) .title");
  applyColour(
    css,
    textHoverTK,
    "body:not(.ios) .page-sidebar-menu > li:not(.active):hover .title"
  );
  applyColour(css, openTextTK, ".page-sidebar-menu > li.active .title");
  applyColour(
    css,
    separatorTK,
    ".page-sidebar-menu li a, .theme-options .theme-option",
    "border-top-color"
  );
  applyColour(
    css,
    separatorTK,
    ".page-sidebar .page-sidebar-menu > li:last-child > a, .theme-options .theme-option",
    "border-bottom-color"
  );
  applyColour(css, separatorTK, ".theme-options", "border-color");
  applyColour(
    css,
    badgeBgTK,
    ".page-sidebar-menu > li > a span.badge",
    "background-color"
  );
  applyColour(css, badgeTextTK, ".page-sidebar-menu > li > a span.badge");
  applyColour(
    css,
    badgeBgTK,
    "#salestoolkit-cart-header-badge",
    "background-color"
  );
  applyColour(css, badgeTextTK, "#salestoolkit-cart-header-badge");
}

function applyThemeToNotification(
  css,
  notificationType,
  textColourTK,
  bgColourTK,
  borderColourTK,
  iconColourTK
) {
  if (notificationType != undefined && notificationType.contains(",")) {
    var notificationTypes = notificationType.split(",");
    for (var t = 0; t < notificationTypes.length; t++) {
      applyThemeToNotification(
        css,
        notificationTypes[t].trim(),
        textColourTK,
        bgColourTK,
        borderColourTK,
        iconColourTK
      );
    }
    return;
  }

  var typeClass =
    notificationType == undefined
      ? ""
      : ".notification-type-" + notificationType;

  applyColour(
    css,
    textColourTK,
    ".jquery-notific8-notification" + typeClass,
    "color"
  );
  applyColour(
    css,
    bgColourTK,
    ".jquery-notific8-notification" + typeClass,
    "background-color"
  );
  applyColour(
    css,
    borderColourTK,
    ".jquery-notific8-notification" + typeClass,
    "border-color"
  );
  applyColour(
    css,
    textColourTK,
    "#header_notification_bar .dropdown-menu-list li" +
      typeClass +
      " .details > span:first-child"
  );
  applyColour(
    css,
    borderColourTK,
    "#header_notification_bar .dropdown-menu-list li" +
      typeClass +
      " .details > span:first-child",
    "background-color"
  );
}

// loaded if there is no theme at all in localStorage
function loadDefaultTheme() {
  var defaultThemePrimaryColour = "#00adef";
  var defaultThemePrimaryColourTint = "#008abc";

  SalesToolkit.Theme.properties = {
    salestoolkitPrimaryColour: defaultThemePrimaryColour,

    salestoolkitFavIcon: "img/default/favicon.ico",

    salestoolkitBannerImage: "",
    salestoolkitLogoTopLeft: "img/default/logo-default.png",

    salestoolkitLoginLogo: "img/default/rc_logo.svg",

    //salestoolkitLoginLogo: 'img/default/BMI-Login-Logo.png',

    //salestoolkitLoginLogo: 'img/default/TT-res-centre.svg',

    //salestoolkitLoginLogo: 'img/default/SalesProLogo.svg',

    salestoolkitHeaderBarBackgroundColour: "#ffffff",
    salestoolkitHeaderBarBackgroundColourHover: "#f9fafc",
    salestoolkitHeaderBarTextColour: "#7f96ac",
    salestoolkitHeaderBarIconColour: "#C0CDDC",
    salestoolkitHeaderBarBadgeColour: defaultThemePrimaryColour,

    salestoolkitToggleSideMenuIcon: "img/default/menu_icon.svg",
    salestoolkitToggleSideMenuIconHover: undefined,

    salestoolkitHeaderIconSearch: "img/default/search_icon.svg",
    salestoolkitHeaderIconNotification: "img/default/announce.svg",
    salestoolkitHeaderIconCart: "img/default/shopping_cart_header.svg",
    salestoolkitHeaderIconTreeView: "img/default/tree_view.svg",
    salestoolkitHeaderIconProfile: "img/default/user.svg",
    salestoolkitHeaderIconSync: "img/default/cog_icon_new.svg",
    salestoolkitHeaderIconLock: "img/default/lock.svg",
    salestoolkitHeaderIconLogout: "img/default/logout.svg",

    salestoolkitIconEnterFullscreen: "img/default/zoom_icon.svg",
    salestoolkitIconExitFullscreen: "img/default/zoom_out_icon.svg",

    salestoolkitPreviewIconRateAsset: "img/default/star_icon_empty_new_1.svg",

    salestoolkitPortletBackButtonIcon: "img/default/back_icon.svg",

    salestoolkitCartSendIcon: "img/default/Cart_send.svg",
    salestoolkitCartEmptyIcon: "img/default/Cart_empty.svg",

    salestoolkitFormSendIcon: "img/default/Form_Send.svg",
    salestoolkitFormClearIcon: "img/default/Form_Clear.svg",
    salestoolkitFormTermsIcon: "img/default/Form_Terms.svg",

    salestoolkitSyncIconColour: "#9fb3ca",
    salestoolkitSyncIconColourHover: "#ffffff",
    salestoolkitSyncIconBackgroundColour: "#ffffff",
    salestoolkitSyncIconBackgroundColourHover: "transparent",

    salestoolkitSideMenuItemBackground: "#4d5b69",
    salestoolkitSideMenuItemBackgroundHover: "#44515d",
    salestoolkitSideMenuActiveItemBackground: "#44515d",
    salestoolkitSideMenuItemIconColour: "#8cacc3",
    salestoolkitSideMenuItemIconColourHover: defaultThemePrimaryColour,
    salestoolkitSideMenuActiveItemIconColour: defaultThemePrimaryColour,
    salestoolkitSideMenuItemTextColour: "#f8f8f8",
    salestoolkitSideMenuItemTextColourHover: "#f8f8f8",
    salestoolkitSideMenuActiveItemTextColour: "#f8f8f8",
    salestoolkitSideMenuIconBadgeColour: "#dfba49",
    salestoolkitSideMenuItemSeparatorColour: "#536372",

    salestoolkitPageBackgroundColour: "#f1f3fa",
    salestoolkitPageDateColour: "#666666",

    salestoolkitLinkColour: defaultThemePrimaryColour,
    salestoolkitLinkColourHover: defaultThemePrimaryColourTint,

    salestoolkitPortletIconColour: defaultThemePrimaryColour,
    salestoolkitPortletLineColour: "#cccccc",
    salestoolkitPortletBackgroundColour: "#ffffff",
    salestoolkitPortletHeadingColour: "#333333",

    salestoolkitNewsTickerLatestColour: "#990000",
    salestoolkitNewsTickerControlsColour: defaultThemePrimaryColour,
    salestoolkitNewsTickerControlsColourHover: defaultThemePrimaryColourTint,
    salestoolkitNewsTickerBackgroundColour: "#FFFFFF",
    salestoolkitNewsTickerRightBackground: "img/default/crumbflash.png",
    salestoolkitNewsTickerTextColour: "#1F527B",

    salestoolkitSyncBadgeOnline: "#66AADD",
    salestoolkitSyncBadgeSyncing: "#44AA99",
    salestoolkitSyncBadgeOffline: "#BB4444",

    salestoolkitLoginPageBackgroundColour: "#ffffff",
    salestoolkitLoginRememberMeColour: "#8290a3",
    salestoolkitLoginBackgroundColour: "#eceef1",
    salestoolkitLoginTitleColour: defaultThemePrimaryColour,
    salestoolkitLoginForgotPasswordColour: defaultThemePrimaryColour,
    salestoolkitLoginForgotPasswordColourHover: defaultThemePrimaryColourTint,

    salestoolkitLockScreenTitleColour: "#ffffff",
    salestoolkitLockScreenUsernameColour: defaultThemePrimaryColour,
    salestoolkitLockScreenBorderColour: "#a8b1b8",
    salestoolkitLockLogoutLinkColour: "#ffffff",
    salestoolkitLockLogoutLinkColourHover: defaultThemePrimaryColour,

    salestoolkitProfileTabColourActive: defaultThemePrimaryColour,
    salestoolkitProfileTabColourHover: defaultThemePrimaryColour,
    salestoolkitProfileTabTextColour: "#666666",
    salestoolkitProfileTabTextColourActive: "#333333",
    salestoolkitProfileTabTextColourHover: "#333333",

    salestoolkitProfileFieldLabelColour: "#333333",
    salestoolkitProfileUserNameColour: "#5a7391",
    salestoolkitProfileUserOccupationColour: "#697d99",

    salestoolkitBreadcrumbIconColour: "#666666",
    salestoolkitBreadcrumbTextColour: "#666666",

    salestoolkitSyncProgressColour: defaultThemePrimaryColour,
    salestoolkitSyncProgressBackgroundColour: "#f5f5f5",

    salestoolkitCollectionBrowserAssetColour: "#f6f6f6",
    salestoolkitCollectionBrowserAssetTextColour: "#666666",
    salestoolkitCollectionBrowserCollectionColour: "#e8f2fc",
    salestoolkitCollectionBrowserCollectionTextColour: "#666666",
    salestoolkitCollectionBrowserItemColourHover: defaultThemePrimaryColour,
    salestoolkitCollectionBrowserItemTextColourHover: "#ffffff",

    salestoolkitTreeViewIconColour: defaultThemePrimaryColour,
    salestoolkitTreeViewTextColour: "#444444",

    salestoolkitButtonColour: defaultThemePrimaryColour,
    salestoolkitButtonColourHover: defaultThemePrimaryColourTint,
    salestoolkitButtonTextColour: "#ffffff",
    salestoolkitButtonTextColourHover: "#ffffff",

    salestoolkitSecondaryButtonColour: "#E5E5E5",
    salestoolkitSecondaryButtonColourHover: "#D3D3D3",
    salestoolkitSecondaryButtonTextColour: "#333333",
    salestoolkitSecondaryButtonTextColourHover: "#333333",

    salestoolkitActionButtonColour: "#ffffff",
    salestoolkitActionButtonColourHover: "#ededed",
    salestoolkitActionButtonBorderColour: "#cccccc",
    salestoolkitActionButtonBorderColourHover: "#b3b3b3",
    salestoolkitActionButtonTextColour: "#a0a0a0",
    salestoolkitActionButtonTextColourHover: "#666666",

    salestoolkitActionButtonSelectedColour: "#e8e8e8",
    salestoolkitActionButtonSelectedColourHover: "#d3d3d3",
    salestoolkitActionButtonSelectedBorderColour: "#cccccc",
    salestoolkitActionButtonSelectedBorderColourHover: "#b3b3b3",
    salestoolkitActionButtonSelectedTextColour: "#a0a0a0",
    salestoolkitActionButtonSelectedTextColourHover: "#666666",

    salestoolkitFooterLinkText: "Tangent90",
    salestoolkitFooterLinkHref: "http://www.tangent90.co.uk",
    salestoolkitFooterLinkColour: defaultThemePrimaryColour,
    salestoolkitFooterLinkColourHover: defaultThemePrimaryColourTint,
    salestoolkitFooterTextColour: "#d5dbe0",

    salestoolkitLoginFooterTextColour: "#7a8ca5",
    salestoolkitLoginFooterLinkColour: defaultThemePrimaryColour,
    salestoolkitLoginFooterLinkColourHover: defaultThemePrimaryColourTint,

    salestoolkitTableHeaderIconColour: defaultThemePrimaryColour,
    salestoolkitTableHeaderBackgroundColour: "#ffffff",
    salestoolkitTableHeaderTextColour: "#333333",
    salestoolkitTableOddRowBackgroundColour: "#f9f9f9",
    salestoolkitTableOddRowBackgroundColourHover: "#f5f5f5",
    salestoolkitTableEvenRowBackgroundColour: "#ffffff",
    salestoolkitTableEvenRowBackgroundColourHover: "#f5f5f5",
    salestoolkitTableBorderColour: "#dddddd",
    salestoolkitTableTextColour: "#333333",
    salestoolkitTableExternalTextColour: "#333333",
    salestoolkitTablePaginationButtonColour: "#ffffff",
    salestoolkitTablePaginationButtonColourHover: "#eeeeee",
    salestoolkitTablePaginationButtonTextColour: "#337ab7",
    salestoolkitTablePaginationButtonTextColourHover: "#23527c",
    salestoolkitTablePaginationButtonBorderColour: "#dddddd",
    salestoolkitTablePaginationButtonCurrentColour: "#eeeeee",
    salestoolkitTablePaginationButtonCurrentTextColour: "#333333",
    salestoolkitTablePaginationButtonDisabledColour: "#ffffff",
    salestoolkitTablePaginationButtonDisabledTextColour: "#777777",

    salestoolkitDefaultAssetIcon: "img/asset.png",
    salestoolkitDefaultCollectionIcon: "img/collection.png",
    salestoolkitDefaultFormIcon: "img/default/Form_Default.svg",

    salestoolkitNotificationTextColour: "#ffffff",
    salestoolkitNotificationFavouritesBackgroundColour: "#aa1100",
    salestoolkitNotificationFavouritesBorderColour: "#dd1100",
    salestoolkitNotificationFavouritesIconBackgroundColour: "#f3565d",
    salestoolkitNotificationCartBackgroundColour: "#e88f00",
    salestoolkitNotificationCartBorderColour: "#ffb23f",
    salestoolkitNotificationCartIconBackgroundColour: "#dfba49",
    salestoolkitNotificationDownloadsBackgroundColour: "#32b512",
    salestoolkitNotificationDownloadsBorderColour: "#38d315",
    salestoolkitNotificationDownloadsIconBackgroundColour: "#45b6af",
    salestoolkitNotificationInfoBackgroundColour: "#006699",
    salestoolkitNotificationInfoBorderColour: "#0099cc",
    salestoolkitNotificationInfoIconBackgroundColour: "#89c4f4",
    salestoolkitNotificationOtherBackgroundColour: "#006699",
    salestoolkitNotificationOtherBorderColour: "#0099cc",
    salestoolkitNotificationOtherIconBackgroundColour: "#bbbbbb",

    salestoolkitShareHistoryTableStatusFailedColour: "#cc0044",
    salestoolkitShareHistoryTableStatusSuccessColour: "#009fe3",
  };
  applyThemeToToolkit();
}

var rewriteMap = {};
var rewriteQueue = [];
var rewriteTimeout = null;

function addUrlToRewriteQueue(url, callback) {
  if (
    SalesToolkit.CrossPlatform.enabled &&
    SalesToolkit.CrossPlatform.urlRewriteCache.hasOwnProperty(url)
  ) {
    console.log("url '" + url + "' is already in the cache");
    if (callback) {
      var storedUrl = SalesToolkit.CrossPlatform.urlRewriteCache[url];
      if (
        storedUrl != null &&
        storedUrl.href != undefined &&
        storedUrl.href != null
      )
        storedUrl = storedUrl.href;

      var timestamp = new Date().getTime();
      if (storedUrl && storedUrl.indexOf("timestamp") < 0) {
        if (storedUrl.indexOf("?") >= 0) storedUrl += "&timestamp=" + timestamp;
        else storedUrl += "?timestamp=" + timestamp;
      }
      callback(storedUrl);
    }
    return;
  }
  var skip = true;
  if (typeof rewriteMap !== "undefined" && !rewriteMap.hasOwnProperty(url)) {
    rewriteMap[url] = [];
    skip = false;
  }
  if (typeof rewriteMap !== "undefined" && callback != null) {
    rewriteMap[url].push(callback);
  }
  //	console.log('added callback for url \'' + url + '\'');

  if (!skip) {
    rewriteQueue.push(url);
    rewriteAsyncWithInternalPromises();
  }
}

function rewriteAsync() {
  if (rewriteTimeout != null) {
    return;
  }
  var immediate =
    !SalesToolkit.CrossPlatform.enabled ||
    SalesToolkit.CrossPlatform.urlRewriteCache.hasOwnProperty(rewriteQueue[0]);
  rewriteTimeout = setTimeout(rewriteAsyncInternal, immediate ? 0 : 125);
}

// please please please let there be a way to disable visual studio's auto"formatting".
// it's determined to turn the function into a bizzare staircase

function rewriteAsyncWithInternalPromises() {
  var urlToRewrite = rewriteQueue.shift();
  if (urlToRewrite) {
    SalesToolkit.CrossPlatform.rewriteURLPromise(urlToRewrite)
      .then(
        function (rewrittenURL) {
          //console.log('url \'' + urlToRewrite + '\' rewritten to \'' + rewrittenURL + '\'');
          return rewrittenURL;
        },
        function (error) {
          console.error("url '" + urlToRewrite + "' could not be rewritten");
          console.error(error);
          return null;
        }
      )
      .then(function (rewrittenURL) {
        var callbacks = rewriteMap[urlToRewrite];
        if (callbacks) {
          for (var c = 0; c < callbacks.length; c++) {
            try {
              callbacks[c](rewrittenURL || urlToRewrite);
            } catch (e) {
              console.error(e);
            }
          }
        }
        delete rewriteMap[urlToRewrite];
        rewriteAsyncWithInternalPromises();
      });
  }
}

function rewriteAsyncInternal() {
  var urlToRewrite = rewriteQueue.shift();
  var immediate =
    !SalesToolkit.CrossPlatform.enabled ||
    SalesToolkit.CrossPlatform.urlRewriteCache.hasOwnProperty(urlToRewrite);
  var callbacks = rewriteMap[urlToRewrite];
  var rewrittenURL = SalesToolkit.CrossPlatform.rewriteURL(urlToRewrite);
  console.log("url '" + urlToRewrite + "' rewritten to '" + rewrittenURL + "'");
  if (callbacks) {
    for (var c = 0; c < callbacks.length; c++) {
      try {
        callbacks[c](rewrittenURL || urlToRewrite);
      } catch (e) {
        console.error(e);
      }
    }
  }

  delete rewriteMap[urlToRewrite];
  if (rewriteQueue.length == 0) {
    rewriteTimeout = null;
  } else {
    rewriteTimeout = window.setTimeout(
      rewriteAsyncInternal,
      immediate ? 0 : 125
    );
  }
}

function loadNews(elem, params) {
  console.log("NEW ITEM LOADING");
  if (SalesToolkit.Theme.getBooleanProperty("salesToolkitUrlNews", false)) {
    var url = SalesToolkit.Translation.getOrGetThemeKey(
      "salesToolkitNewsUrl",
      ""
    );
    console.log("LOADING URL " + url);
    if (url && typeof url === "string" && url.startsWith("http")) {
      if (SalesToolkit.CrossPlatform.isIOS()) {
        window.location.href = url;
      } else {
        window.open(url, "_blank");
      }
      return;
    }
  }

  if (params) {
    console.log("LOADING NEWS WITH PARAMS");
    if (SalesToolkit.CrossPlatform.isIOS()) {
      window.location.href = "news.html" + params;
    } else {
      window.open("news.html" + params, "_blank");
    }
  } else {
    console.log("LOADING NEWS WITHOUT PARAMS");
    if (SalesToolkit.CrossPlatform.isIOS()) {
      window.location.href = "news.html";
    } else {
      window.open("news.html", "_blank");
    }
  }
  return false;
}

function addCustomUrlsToSideMenu() {
  var $ul = $("ul.page-sidebar-menu");
  //Remove all customUrls
  $ul.find(".customUrl").remove();
  var customUrlIndex = 0;

  do {
    var customUrl = SalesToolkit.Theme.getStringProperty(
      "customUrl" + customUrlIndex
    );
    if (typeof customUrl === "string" && customUrl.startsWith("http")) {
      addCustomUrlToSideMenu(customUrl, customUrlIndex);
    }
    customUrlIndex += 1;
  } while (typeof customUrl !== "undefined");
}

function addCustomUrlToSideMenu(url, index) {
  var $ul = $("ul.page-sidebar-menu");
  var title =
    SalesToolkit.Translation.get("customUrl" + index + "Label") ||
    "Custom Url " + index;

  var liHtml =
    '<li class="customUrl customcolor">' +
    '<a href = "' +
    url +
    '" >' +
    '<div class="sidemenu-tile-contents">' +
    '<div class="sidemenu-icon-wrapper-outer">' +
    '<div class="sidemenu-icon-wrapper-inner">' +
    '<img alt="" class="side-bar-icon customUrl' +
    index +
    '-icon" style="width: 36px;" />' +
    "</div>" +
    "</div>" +
    '<span class="title">' +
    title +
    "</span>" +
    "</div>" +
    "</a >" +
    "</li >";

  $ul.append(liHtml);
  applyThemeToImage(
    "salesToolkitCustomUrlIcon",
    "img.side-bar-icon.customUrl" + index + "-icon",
    "img/default/home_new.svg"
  );

  return false;
}

function getTranslatedTitle(item) {
  if (!item.hasOwnProperty("title")) return "";

  let userLanguage =
    SalesToolkit.User.getLanguage() ||
    SalesToolkit.Language.getBrowserPreferred() ||
    SalesToolkit.Language.getDefault();

  if (
    !item.hasOwnProperty("translations") ||
    item.translations.findIndex(
      (x) =>
        x.languages
          .toString()
          .toLowerCase()
          .indexOf(userLanguage?.iso_code.toLowerCase()) >= 0
    ) == -1
  ) {
    return item.title;
  }

  let index = item.translations.findIndex(
    (x) =>
      x.languages
        .toString()
        .toLowerCase()
        .indexOf(userLanguage?.iso_code.toLowerCase()) >= 0
  );
  if (index < 0) return item.title;

  return item.translations[index].title || item.title;
}

/**
 * Renders a given list of forms into the sidebar menu.
 * This is a shared utility function.
 * @param {Array} forms - An array of form objects to render.
 */
function renderFormsToSideMenu(forms) {
  const $ul = $("ul.page-sidebar-menu");
  $ul.find(".form-item").remove(); // Clear existing form items

  const uniqueForms = [];
  const map = new Map();
  for (const item of forms) {
    if (!map.has(item.id)) {
      map.set(item.id, true);
      uniqueForms.push(item);
    }
  }

  uniqueForms.forEach((form) => {
    if (
      !SalesToolkit.User.canSee(form) ||
      form.type === SalesToolkit.Forms.Types.SHARE ||
      form.type === SalesToolkit.Forms.Types.SIGN_UP ||
      form.type === SalesToolkit.Forms.Types.SELF_REGISTRATION
    ) {
      return;
    }

    let title = SalesToolkit.Translation.get(
      getTranslatedTitle(form),
      getTranslatedTitle(form)
    );
    let formThumb = "img/default/Form_SideMenu.svg";

    if (
      form.thumb?.url &&
      SalesToolkit.Theme.getBooleanProperty("useFormThumbForSideMenu", true)
    ) {
      formThumb = form.thumb.url;
    }

    let activeClass =
      (window.location.href.indexOf("viewForm.html") >= 0 ||
        document.body.classList.contains("module-previewForm")) &&
      window.location.href.includes(form.id)
        ? "active"
        : "";

    const isIndexPage =
      window.location.pathname.endsWith("/") ||
      window.location.pathname.endsWith("/index.html");

    let liHtml = `
  <li class="form-item ${activeClass} customcolor">
    ${
      isIndexPage
        ? // If ON index.html, use the data-module-action
          `<a href="javascript:;" data-module-action="loadFormScreen" data-form-id="${form.id}">`
        : // If NOT on index.html, use the direct link
          `<a href="index.html?startingModule=previewForm&formId=${form.id}">`
    }
      <div class="sidemenu-tile-contents">
        <div class="sidemenu-icon-wrapper-outer">
          <div class="sidemenu-icon-wrapper-inner">
            <img alt="" class="side-bar-icon form-item form-thumb-${
              form.id
            }" style="width: 36px;" />
          </div>
        </div>
        <span class="title">${title}</span>
      </div>
    </a>
  </li>`;
    $ul.append(liHtml);

    if (
      form.thumb?.url &&
      SalesToolkit.Theme.getBooleanProperty("useFormThumbForSideMenu", true)
    ) {
      $(".form-thumb-" + form.id).attr("src", formThumb);
    } else {
      applyThemeToImage(
        "salesToolkitSideMenuFormIcon",
        ".form-thumb-" + form.id,
        formThumb
      );
    }
  });
}

/**
 * Main function to add forms to the side menu. It determines the context
 * and either dispatches an event for the index module or handles it directly.
 */
function addFormsToSideMenu() {
  if (document.body.classList.contains("module-index")) {
    // If we're on the index page, let the index module handle it.
    document.dispatchEvent(
      new CustomEvent(SalesToolkitApplication.Events.ADD_FORMS_TO_SIDE_MENU)
    );
  } else {
    // For any other page, use the simpler "home screen" logic.
    if (!SalesToolkit.Theme.getBooleanProperty("showFormsInSideMenu", false))
      return;
    const forms = SalesToolkit.Forms.getHomeScreenForms();
    renderFormsToSideMenu(forms);
  }
}

function goToProfile(loadHistory, loadLegal, loadFormHistory = false) {
  if (typeof loadLegal === "boolean" && loadLegal) {
    window.location = "extra_profile.html?loadLegal=true";
  } else if (typeof loadHistory === "boolean" && loadHistory) {
    window.location = "extra_profile.html?redeliveryNotification=true";
  } else if (typeof loadFormHistory === "boolean" && loadFormHistory) {
    window.location = "extra_profile.html?loadFormHistory=true";
  } else {
    window.location = "extra_profile.html";
  }
}

function updateFormHistoryLink() {
  if (document.getElementById("headerBarProfileFormHistoryImage") == null)
    return;

  if (
    SalesToolkit.Theme.getBooleanProperty("dontUseFormHistoryWarning", false)
  ) {
    document.getElementById("headerBarProfileFormHistoryImage").style.display =
      "none";
    document.getElementById("profileFormHistoryLink").style.display = "none";
    document.getElementById("profileFormHistoryLinkDivider").style.display =
      "none";
    return;
  }

  var userSettingShowFormHistory =
    Atheneum.Theme.TRUE_VALUES.indexOf(
      SalesToolkit.User.getPreference(
        "salestoolkitAppSettingShowFormHistoryDirectLink",
        "off",
        true
      )
    ) != -1;

  if (
    userSettingShowFormHistory ||
    typeof SalesToolkit.Forms.userDetails === "object"
  ) {
    if (typeof SalesToolkit.Forms.userDetails === "object") {
      document.getElementById(
        "headerBarProfileFormHistoryImage"
      ).style.display = "block";
      if (
        SalesToolkit.Theme.getBooleanProperty(
          "hideProfileImageUnderFormHistory",
          false
        )
      )
        document.body.classList.toggle("hideProfileOnFormHistory", true);
      $(".profile-form-history-icon-list").hide();
      $(".profile-form-warning-icon-list").show();
    } else {
      document.getElementById(
        "headerBarProfileFormHistoryImage"
      ).style.display = "none";
      if (
        SalesToolkit.Theme.getBooleanProperty(
          "hideProfileImageUnderFormHistory",
          false
        )
      )
        document.body.classList.toggle("hideProfileOnFormHistory", false);
      $(".profile-form-history-icon-list").show();
      $(".profile-form-warning-icon-list").hide();
    }
    document.getElementById("profileFormHistoryLink").style.display =
      "list-item";
    document.getElementById("profileFormHistoryLink").style.marginTop = "9px";
    document.getElementById("profileFormHistoryLinkDivider").style.display =
      "list-item";
    document.getElementById("profileFormHistoryLinkDivider").style.marginTop =
      "9px";
  } else {
    document.getElementById("headerBarProfileFormHistoryImage").style.display =
      "none";
    document.getElementById("profileFormHistoryLink").style.display = "none";
    document.getElementById("profileFormHistoryLinkDivider").style.display =
      "none";
    if (
      SalesToolkit.Theme.getBooleanProperty(
        "hideProfileImageUnderFormHistory",
        false
      )
    )
      document.body.classList.toggle("hideProfileOnFormHistory", false);
  }
}

function updateProfileHistoryLink() {
  if (document.getElementById("headerBarProfileWarningImage") == null) return;

  var userSettingShowCartHistory =
    Atheneum.Theme.TRUE_VALUES.indexOf(
      SalesToolkit.User.getPreference(
        "salestoolkitAppSettingShowCartHistoryDirectLink",
        "off",
        true
      )
    ) != -1;

  if (
    SalesToolkit.Theme.getBooleanProperty("dontUseCartHistoryWarning", false)
  ) {
    document.getElementById("headerBarProfileWarningImage").style.display =
      "none";
    document.getElementById("profileHistoryLink").style.display = "none";
    document.getElementById("profileHistoryLinkDivider").style.display = "none";
    return;
  }

  if (SalesToolkit.Summary.hasFailedShares()) {
    document.getElementById("headerBarProfileWarningImage").style.display =
      "block";
    if (
      SalesToolkit.Theme.getBooleanProperty(
        "hideProfileImageUnderShareHistory",
        false
      )
    )
      document.body.classList.toggle("hideProfileOnShareHistory", true);
  } else {
    document.getElementById("headerBarProfileWarningImage").style.display =
      "none";
    if (
      SalesToolkit.Theme.getBooleanProperty(
        "hideProfileImageUnderShareHistory",
        false
      )
    )
      document.body.classList.toggle("hideProfileOnShareHistory", false);
  }

  if (userSettingShowCartHistory || SalesToolkit.Summary.hasFailedShares()) {
    document.getElementById("profileHistoryLink").style.display = "list-item";
    document.getElementById("profileHistoryLink").style.marginTop = "9px";
    document.getElementById("profileHistoryLinkDivider").style.display =
      "list-item";
    document.getElementById("profileHistoryLinkDivider").style.marginTop =
      "9px";

    if (SalesToolkit.Summary.hasFailedShares()) {
      $(".profile-warning-icon-list").show();
      $(".profile-cart-history-icon-list").hide();
    } else {
      $(".profile-warning-icon-list").hide();
      $(".profile-cart-history-icon-list").show();
    }
  } else {
    document.getElementById("profileHistoryLink").style.display = "none";
    document.getElementById("profileHistoryLinkDivider").style.display = "none";
  }
}

function uuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Removes <code>&lt;script&gt;</code> and <code>&lt;script&gt;</code> tags from an html string.<br>
 * If the html string provided is <code>null</code> or <code>undefined</code>, returns the empty string.
 * @param {String} html
 * @returns {String}
 */
function sanitizeHTML(html) {
  if (html == null) return "";

  var fragmentUUID = uuid();
  var hasStyleSheet = false;

  // in some cases it is possible for usersubmitted html to contain script tags and iframes,
  // leaving them in could lead to anything from syntax errors to cross site scripting attacks,
  // hence the need for the h̡̟͙̦̫̩̞̱͈̕͢͜t̛҉͇͎̫̰͇͉̭̩̺̙̣̞̣̱̲͕̫͈͢m̴̞̞̜͕͎̣͟l̴͉̬̜͈͈̭͈̰̥̳͙͟ ̡͚̪̝͈̻̪̭͍̟͖͚ͅp̷̠̻̟͕͇̜̲̳̼̹̜̭ͅa̼͕͙̤̖̲̗̼͎͡ͅr̴̷̸̡̦͙̣͎̜̼̲ͅś̨̡̤͓͕̞̹͇̠́́į͝͏͈͕̯̭͖̝̞̹͖͉n҉̧̺̥̪͎̯͖͖͇̘͉ͅͅg̨̘̬̰̼̰̠͢ ̸̸̀͞҉͇̘͖̪̼̳͎̗̦̞̞ͅr̖̮͍͔̣̖̻̜̬̳̜͔̭̫̀͠e҉̶̶͖̱̦̲̟̤̦̹̰̩̩g̴҉̘̩̩̝̕͢ę̶̴͖̩̺̠̝̻̟͎́́x҉̨̢̟͎̟̬̹͕̩͈͝ - http://stackoverflow.com/questions/1732348#1732454

  var SCRIPT_REGEX =
    /(<\/script(?:\s+[^>]*)*\s*>)|(<script(?:\s+[^>]*)*\s*>((?!<\/script(?:\s+[^>]*)*\s*>)(?:(?!<\/script\s*>).)*)?)/gi;
  var IFRAME_REGEX =
    /(<\/iframe(?:\s+[^>]*)*\s*>)|(<iframe(?:\s+[^>]*)*\s*>((?!<\/iframe(?:\s+[^>]*)*\s*>)(?:(?!<\/iframe\s*>).)*)?)/gi;
  var STYLE_REGEX =
    /(<\/style(?:\s+[^>]*)*\s*>)|(<style(?:\s+[^>]*)*\s*>((?!<\/style(?:\s+[^>]*)*\s*>)(?:(?!<\/style\s*>).)*)?)/gi;

  html = html.replace(SCRIPT_REGEX, "");
  html = html.replace(IFRAME_REGEX, "");
  html = html.replace(STYLE_REGEX, function (match) {
    hasStyleSheet = true;
    try {
      var cssString = match
        .replace(/<\/style(?:\s+[^>]*)*\s*>/g, "")
        .replace(/<style(?:\s+[^>]*)*\s*>/g, "");
      return cssString == ""
        ? ""
        : "<style>" + window.css.scoped(cssString, fragmentUUID) + "</style>";
    } catch (e) {
      return "";
    }
  });

  // TODO - replace <html> tag with <span class="scope-UUID-html">
  var htmlRegex =
    /(?:<\/[Hh][Tt][Mm][Ll]\s*>)|(?:<[Hh][Tt][Mm][Ll](?:>|((?:\s+(?!class=)[^\s>]+(?:="[^"]*")?)*)(?:\s+(?:class="([^"]*)")?)?((?:\s+(?!class=)[^\s>]+(?:="[^"]*")?)*)\s*>))/;

  // TODO - replace <body> tag with <span class="scope-UUID-body">
  var bodyRegex =
    /(?:<\/[Bb][Oo][Dd][Yy]\s*>)|(?:<[Bb][Oo][Dd][Yy](?:>|((?:\s+(?!class=)[^\s>]+(?:="[^"]*")?)*)(?:\s+(?:class="([^"]*)")?)?((?:\s+(?!class=)[^\s>]+(?:="[^"]*")?)*)\s*>))/;

  if (hasStyleSheet) {
    html = '<span class="scope-' + fragmentUUID + '">' + html + "</span>";
  }
  return html;
}

function updateNewsTicker() {
  var enableNewsTicker = SalesToolkit.User.getPreference(
    "salestoolkitAppSettingShowNewsTicker",
    "on",
    true
  );
  var latestNewsItems = SalesToolkit.NewsFeed.getLatest(10);
  if (
    SalesToolkit.Theme.getBooleanProperty("disableFeatureNews", false) ||
    latestNewsItems.length == 0
  ) {
    enableNewsTicker = "off";
  }
  $("#salestoolkit-news-ticker-wrapper").css(
    "display",
    Atheneum.Theme.TRUE_VALUES.indexOf(enableNewsTicker) != -1
      ? "block"
      : "none"
  );
}

var enableNewsTicker = SalesToolkit.User.getPreference(
  "salestoolkitAppSettingShowNewsTicker",
  "on",
  true
);
var latestNewsItems = SalesToolkit.Theme.getBooleanProperty(
  "disableFeatureNews",
  false
)
  ? []
  : SalesToolkit.NewsFeed.getLatest(10);
if (latestNewsItems.length == 0) {
  enableNewsTicker = "off";
  setTimeout(updateNewsTicker, 1000);
}
$("#salestoolkit-news-ticker-wrapper").css(
  "display",
  Atheneum.Theme.TRUE_VALUES.indexOf(enableNewsTicker) != -1 ? "block" : "none"
);

var enableTreeView = SalesToolkit.User.getPreference(
  "salestoolkitAppSettingEnableTreeView",
  "on",
  true
);
var treeViewEnabled = Atheneum.Theme.TRUE_VALUES.indexOf(enableTreeView) != -1;
if (SalesToolkit.Theme.getBooleanProperty("forceHideTreeView", false))
  treeViewEnabled = false;

$("#tree-toggler").css("display", treeViewEnabled ? "flex" : "none");
if (!treeViewEnabled) {
  localStorage.hideTree = "true";
}

function setupRelatedToggler() {
  if (
    (document.body.classList.contains("module-previewAsset") ||
      window.location.href.indexOf("/viewAsset.html") >= 0) &&
    SalesToolkit.Theme.getBooleanProperty("useRelatedAssets", false)
  ) {
    $("#related-toggler").show();
  } else {
    $("#related-toggler").hide();
    if (window.location.href.indexOf("login") < 0)
      localStorage.hideRelated = "true";
  }
}

setupRelatedToggler();

var sideMenuCompact = SalesToolkit.User.getPreference(
  "salestoolkitAppSettingStickySideMenu",
  "on",
  true
);
var mode = "hide";
if (Atheneum.Theme.TRUE_VALUES.indexOf(sideMenuCompact) != -1) {
  mode = "compact";
}
localStorage["appSetting_sideMenuStyle"] = mode;
document.body.classList.remove("sidemenu-mode-toggle-hide");
document.body.classList.remove("sidemenu-mode-toggle-compact");
document.body.classList.add("sidemenu-mode-toggle-" + mode);

// since mobile always has fullscreen, always start with it closed
var initialSideMenuState = localStorage["appSetting_sideMenuState"] || "open";
if (mode == "fullscreen" || window.matchMedia("(max-width: 767px)").matches) {
  initialSideMenuState = "closed";
}
document.body.classList.add("sidemenu-" + initialSideMenuState);
localStorage["appSetting_sideMenuState"] = initialSideMenuState;

$(document)
  .off("click.sidebarToggle")
  .on("click.sidebarToggle", ".sidebar-toggler", function () {
    const body = $("body");
    if (body.hasClass("sidemenu-open")) {
      body.removeClass("sidemenu-open").addClass("sidemenu-closed");
      localStorage["appSetting_sideMenuState"] = "closed";
      if (typeof trackAppClick === "function") {
        trackAppClick(
          $(this),
          ".sidebar-toggler",
          "trackingSideBarClose",
          SalesToolkit.Translation.get(
            "trackingSideBarClose",
            "trackingSideBarClose"
          )
        );
      }
    } else {
      body.removeClass("sidemenu-closed").addClass("sidemenu-open");
      localStorage["appSetting_sideMenuState"] = "open";
      if (typeof trackAppClick === "function") {
        trackAppClick(
          $(this),
          ".sidebar-toggler",
          "trackingSideBarOpen",
          SalesToolkit.Translation.get(
            "trackingSideBarOpen",
            "trackingSideBarOpen"
          )
        );
      }
    }
  });
// metronic's scroll to top broke, so I commented it out and reimplemented it

$(document).on("scroll", "html, body, #main-div-center", function () {
  var space = $(this).scrollTop();
  var scrollContainer = document.getElementById("scroll-top-icon");
  if (space > 120) {
    $(scrollContainer).fadeIn(300);
  } else {
    $(scrollContainer).fadeOut(300);
  }
});

$(".scroll-to-top").click(function () {
  $("html, body, #main-div-center").animate(
    {
      scrollTop: 0,
    },
    250
  );
});

// metronic's sync panel broke, so I commented it out and reimplemented it

$(".syncbuttontopbar .theme-panel .toggler")
  .off("click")
  .on("click", function () {
    let unsyncedCount = this.unsyncedActions
      ? this.unsyncedActions.filter(
          (x) => x.name == "shareCart" || x.name == "submitForm"
        ).length
      : 0;

    if (unsyncedCount > 0) {
      $("#offlineTransactionsCount").show();
      $("#salestoolkit-cache-offline-transactions").html("" + unsyncedCount);
    } else {
      $("#offlineTransactionsCount").hide();
      $("#salestoolkit-cache-offline-transactions").html("0");
    }

    $(".syncbuttontopbar .theme-panel .theme-options").show();
    $(".syncbuttontopbar .theme-panel .toggler-close").show();
    $(".pull-right > li > a").css("pointerEvents", "none");
  });

$(".syncbuttontopbar .theme-panel .toggler-close .icon-close")
  .off("click")
  .on("click", function () {
    $(".syncbuttontopbar .theme-panel .theme-options").hide();
    $(".syncbuttontopbar .theme-panel .toggler-close").hide();
    $(".pull-right > li > a").css("pointerEvents", "all");
  });

// List view toggler

if (localStorage.toggleListView == undefined) {
  localStorage.toggleListView = "";
}

if (window.innerWidth < 400) {
  $("body").toggleClass("showing-list-view", true);
  $("#thumbnail-icon").show();
  $("#list-view-icon").hide();

  localStorage.toggleListView = "showing-list-view";
} else if (
  localStorage.toggleListView == "showing-list-view" &&
  SalesToolkit.Theme.getBooleanProperty("saveListViewSetting", true)
) {
  if (window.location.href.indexOf("viewAsset") < 0) {
    $("body").addClass("showing-list-view");
  }
}

if (SalesToolkit.Theme.getBooleanProperty("useCalview", false)) {
  if (
    localStorage.calViewActive == "true" ||
    (SalesToolkit.Theme.getBooleanProperty("useCalViewByDefault", true) &&
      localStorage.getItem("calViewActive") === null)
  ) {
    if (
      window.location.href.indexOf("index") >= 0 ||
      window.location.pathname == "/"
    ) {
      $("body").addClass("showing-cal-view");
    }
  }
}

// Listener for the Calendar view toggle
$(document)
  .off("click.calendarToggle") // Use a unique namespace to avoid conflicts
  .on(
    "click.calendarToggle",
    "#calendar-icon-on, #calendar-icon-off",
    function () {
      if (
        typeof localStorage.calViewActive === "undefined" ||
        localStorage.calViewActive === "false"
      ) {
        $("body").toggleClass("showing-cal-view", true);
        if (
          typeof trackAppClick === "function" &&
          typeof SalesToolkit !== "undefined"
        ) {
          trackAppClick(
            $("#calendar-icon-on"),
            "#calendar-icon-on",
            "trackingCalendarViewToggleOn",
            SalesToolkit.Translation.get(
              "trackingCalendarViewToggleOn",
              "trackingCalendarViewToggleOn"
            )
          );
        }
        localStorage.calViewActive = "true";
        document.dispatchEvent(
          new CustomEvent(SalesToolkitApplication.Events.CALVIEW_RESIZE)
        );
      } else {
        $("body").toggleClass("showing-cal-view", false);
        if (
          typeof trackAppClick === "function" &&
          typeof SalesToolkit !== "undefined"
        ) {
          trackAppClick(
            $("#calendar-icon-off"),
            "#calendar-icon-off",
            "trackingCalendarViewToggleOff",
            SalesToolkit.Translation.get(
              "trackingCalendarViewToggleOff",
              "trackingCalendarViewToggleOff"
            )
          );
        }
        document.dispatchEvent(
          new CustomEvent(SalesToolkitApplication.Events.LOAD_ARTICLE)
        );
        localStorage.calViewActive = "false";
      }
    }
  );

$(document)
  .off("click.viewToggle") // First, remove any previous listener to prevent duplicates
  .on("click.viewToggle", "#thumbnail-icon, #list-view-icon", function () {
    const body = $("body");
    const listViewIcon = $("#list-view-icon");
    const thumbnailIcon = $("#thumbnail-icon");

    if (!body.hasClass("showing-list-view")) {
      body.toggleClass("showing-list-view", true);
      thumbnailIcon.show();
      listViewIcon.hide();
      if (
        typeof trackAppClick === "function" &&
        typeof SalesToolkit !== "undefined"
      ) {
        trackAppClick(
          listViewIcon,
          "#list-view-icon",
          "trackingViewModeToggle",
          SalesToolkit.Translation.get(
            "trackingViewModeToggle",
            "trackingViewModeToggle"
          )
        );
      }
      localStorage.toggleListView = "showing-list-view";
    } else {
      body.toggleClass("showing-list-view", false);
      listViewIcon.show();
      thumbnailIcon.hide();
      if (
        typeof trackAppClick === "function" &&
        typeof SalesToolkit !== "undefined"
      ) {
        trackAppClick(
          thumbnailIcon,
          "#thumbnail-icon",
          "trackingViewModeToggle",
          SalesToolkit.Translation.get(
            "trackingViewModeToggle",
            "trackingViewModeToggle"
          )
        );
      }
      localStorage.toggleListView = "";
    }
  });

if (localStorage.sortMode) {
  localStorage.sortMode = parseInt(localStorage.sortMode) - 1;
  if (parseInt(localStorage.sortMode) < -1) localStorage.sortMode = -1;
  toggleSearchModeIcon();
}

function toggleSearchModeIcon() {
  let newSortMode;

  if (!localStorage.sortMode || localStorage.sortMode == 0) {
    // Logic to cycle to A-Z
    $("#default-sort-icon").hide();
    $("#az-sort-icon").show();
    $("#za-sort-icon").hide();
    trackAppClick(
      $("#default-sort-icon"),
      "#default-sort-icon",
      "trackingSortModeToggle1",
      SalesToolkit.Translation.get(
        "trackingSortModeToggle1",
        "trackingSortModeToggle1"
      )
    );
    newSortMode = 1;
  } else if (localStorage.sortMode == 1) {
    // Logic to cycle to Z-A
    $("#default-sort-icon").hide();
    $("#az-sort-icon").hide();
    $("#za-sort-icon").show();
    trackAppClick(
      $("#default-sort-icon"),
      "#default-sort-icon",
      "trackingSortModeToggle2",
      SalesToolkit.Translation.get(
        "trackingSortModeToggle2",
        "trackingSortModeToggle2"
      )
    );
    newSortMode = 2;
  } else {
    // Logic to cycle back to default
    $("#default-sort-icon").show();
    $("#az-sort-icon").hide();
    $("#za-sort-icon").hide();
    trackAppClick(
      $("#default-sort-icon"),
      "#default-sort-icon",
      "trackingSortModeToggle0",
      SalesToolkit.Translation.get(
        "trackingSortModeToggle0",
        "trackingSortModeToggle0"
      )
    );
    newSortMode = 0;
  }

  localStorage.sortMode = newSortMode;

  document.dispatchEvent(
    new CustomEvent(SalesToolkitApplication.Events.COLLECTION_BROWSER_REFRESH, {
      detail: { sortMode: newSortMode },
    })
  );

  if (typeof populateRelatedAssetsPanel === "function") {
    populateRelatedAssetsPanel();
  }
}

$(document).on(
  "click",
  "#default-sort-icon, #az-sort-icon, #za-sort-icon",
  function () {
    toggleSearchModeIcon();
  }
);

function getContactForButton(elem) {
  if (SalesToolkit.Theme.getBooleanProperty("disableContactLoading", false)) {
    return;
  }

  if (SalesToolkit.Theme.getBooleanProperty("useAtheneumContacts", true)) {
    showAllContactSuggestions($(elem).parent().find("input"));
    return;
  }

  if (SalesToolkit.CrossPlatform.enabled) {
    var emailInput = $(elem).next();

    var callbacks = {
      success: function (emailAddress) {
        emailInput.val(emailAddress);
        if (typeof emailInputChanged === "function")
          emailInputChanged(emailInput[0]);
      },

      failure: function () {},
    };

    SalesToolkit.CrossPlatform.selectContact(callbacks);
  }
}

function checkForOfflineLogout() {
  if (
    SalesToolkit.Atheneum.CrossPlatform.enabled &&
    !SalesToolkit.Atheneum.CrossPlatform.isOnline()
  ) {
    if (
      !SalesToolkit.Theme.getBooleanProperty(
        "allowsOfflineLogoutForSSO",
        false
      ) &&
      SalesToolkit.User.loggedInWithParams
    ) {
      //USER LOGGED IN WITH SSO AND OFFLINE LOGOUT IS DISABLED FOR IT
      $("#offlineLogoutNotAllowedModal").modal("show");
    } else {
      $("#offlineLogoutModal").modal("show");
    }

    return;
  }

  if (SalesToolkit.CrossPlatform.enabled) {
    SalesToolkit.CrossPlatform.logMessage(
      "LOGGING OUT FROM CHECKFOROFFLINELOGOUT"
    );
  }

  window.location = "login.html";
}

function updateHeaderCartIcon() {
  if (document.getElementById("salestoolkit-cart-header-badge") == null) return;

  var total = SalesToolkit.Cart.getTotalItems();
  applyThemeToImage(
    "salestoolkitHeaderIconCart",
    "#headerCartLink img.cart-icon",
    "img/default/shopping_cart_header.svg"
  );
  if (total == 0)
    document.getElementById("salestoolkit-cart-header-badge").innerHTML = "";
  else
    document.getElementById("salestoolkit-cart-header-badge").innerHTML = total;
}

updateHeaderCartIcon();

function updateCartToggle() {
  if (!SalesToolkit.Theme.getBooleanProperty("useCartToggle", false)) return;
  let loadedCart = SalesToolkit.Cart.getLoadedCart();

  $('label[for="toggle-saved-cart"]').html(
    SalesToolkit.Translation.get("savedCartOption", "Saved Cart")
  );
  $("#toggle-saved-cart").prop(
    "title",
    SalesToolkit.Translation.get(
      "toggleBetweenSavedCartAndCurrentCart",
      "Toggle between saved cart and current cart"
    )
  );
  $("#toggle-current-cart").prop(
    "title",
    SalesToolkit.Translation.get(
      "toggleBetweenSavedCartAndCurrentCart",
      "Toggle between saved cart and current cart"
    )
  );

  if (typeof localStorage["currentSavedCart"] !== "undefined") {
    window.currentSavedCartId = localStorage["currentSavedCart"];
    let savedCart = SalesToolkit.Cart.carts.find(
      (x) => x.id === window.currentSavedCartId
    );

    if (typeof savedCart == "undefined") {
      $(".toggle-switch-container").hide();
      return;
    }

    if (
      typeof loadedCart == "undefined" ||
      loadedCart?.name ==
        SalesToolkit.Translation.get("currentCart", "Current Cart")
    ) {
      $("input[type=radio][name=toggle-cart-switch]")
        .eq(1)
        .attr("checked", true);
    }

    if (
      typeof savedCart !== "undefined" &&
      SalesToolkit.Theme.getBooleanProperty(
        "useCartNameForSavedCartOption",
        true
      )
    ) {
      $('label[for="toggle-saved-cart"]').html(savedCart.name);
      $("#toggle-saved-cart").prop(
        "title",
        SalesToolkit.Translation.getFormatted(
          "toggleBetweenNamedSavedCartAndCurrentCart",
          "Toggle between {0} and current cart",
          [savedCart.name]
        )
      );
      $("#toggle-current-cart").prop(
        "title",
        SalesToolkit.Translation.getFormatted(
          "toggleBetweenNamedSavedCartAndCurrentCart",
          "Toggle between {0} and current cart",
          [savedCart.name]
        )
      );
    }

    $(".toggle-switch-container").show();

    return;
  }

  if (
    typeof loadedCart == "undefined" ||
    loadedCart?.name ==
      SalesToolkit.Translation.get("currentCart", "Current Cart")
  ) {
    $(".toggle-switch-container").hide();
  } else {
    if (
      SalesToolkit.Theme.getBooleanProperty(
        "useCartNameForSavedCartOption",
        true
      )
    ) {
      $('label[for="toggle-saved-cart"]').html(loadedCart.name);
      $("#toggle-saved-cart").prop(
        "title",
        SalesToolkit.Translation.getFormatted(
          "toggleBetweenNamedSavedCartAndCurrentCart",
          "Toggle between {0} and current cart",
          [loadedCart.name]
        )
      );
      $("#toggle-current-cart").prop(
        "title",
        SalesToolkit.Translation.getFormatted(
          "toggleBetweenNamedSavedCartAndCurrentCart",
          "Toggle between {0} and current cart",
          [loadedCart.name]
        )
      );
    }
    $(".toggle-switch-container").show();
    window.currentSavedCartId = loadedCart.id;
    localStorage["currentSavedCart"] = loadedCart.id;
  }
}

function updateAllItemsCartAndFavourites() {
  $("*[data-atheneum-item-id]").each(function () {
    let id = $(this).data("atheneum-item-id");
    let item = {};
    item.id = id;
    item.type = $(this).data("atheneum-item-type");
    if (typeof item.type === "undefined") item.type = "asset";
    document.dispatchEvent(
      new CustomEvent(SalesToolkitApplication.Events.UPDATE_CART_FAVS, {
        detail: { item: item },
      })
    );
  });

  if ($("#atheneum-calview-ui").length == 0) return;

  try {
    $(
      "#atheneum-calview-ui"
    )[0].contentWindow.updateAllItemsCartAndFavourites();
  } catch (err) {}
}

$(document).on(
  "change",
  "input[type=radio][name=toggle-cart-switch]",
  function () {
    if (this.value == "1") {
      // Saved Cart
      SalesToolkit.Cart.loadCart(window.currentSavedCartId);
    } else if (this.value == "2") {
      // Current Cart
      SalesToolkit.Cart.loadCart();
    }

    updateHeaderCartIcon();
    SalesToolkit.UI.Cart.updateMenuCartBadge();
    updateAllItemsCartAndFavourites();
  }
);

updateCartToggle();

$(document).on(
  "click",
  'a[href="javascript:;"][data-module-action="loadInbox"]:not([onclick])',
  function (event) {
    localStorage["salestoolkitCollectionThemeOverrideId"] =
      SalesToolkit.getHomeCollectionID();
  }
);

var renderingPlugins = false;

String.prototype.merge = function (str) {
  let match;
  for (let i = this.length; i >= 0; i--)
    str.startsWith(this.slice(i)) && (match = this.slice(i));

  return (
    this.slice(0, this.indexOf(match)) +
    str.slice(str.indexOf(match), str.length)
  );
};

function loadForm(formId, params) {
  // 1. Validate the form ID to ensure it exists.
  if (!formId) return;
  const form = SalesToolkit.Forms.formList[formId];
  if (!form) return;

  // 2. Prepare any additional parameters for the URL.
  const queryParams = new URLSearchParams(params);
  try {
    // Add collectionId for context, similar to the original function.
    const collectionId = form.collectionId || form.items[0];
    if (collectionId) {
      queryParams.set("collectionId", collectionId);
    }
  } catch (err) {
    // No collectionId found, which is fine.
  }
  if (SalesToolkitApplication.navigator) {
    // If on the index page with an active navigator, use the SPA navigation.
    SalesToolkitApplication.navigator.loadFormScreen(
      formId,
      queryParams.toString()
    );
  } else {
    // If on any other page, perform a full redirect to index.html.
    // Set the necessary parameters to instruct the app on what to load.
    queryParams.set("startingModule", "previewForm");
    queryParams.set("formId", formId);
    window.location.href = `index.html?${queryParams.toString()}`;
  }
}

function togglePluginsAccordion() {
  $("#sideMenu_plugins_accordion").slideToggle();
}

function createPluginElements(json) {
  if (json == null || json == undefined || json == "") {
    renderingPlugins = false;
    return;
  }

  try {
    var changes = false;
    if (
      SalesToolkit.Plugins.plugins &&
      SalesToolkit.Plugins.plugins.length == json.length
    ) {
      for (var i = 0; i < json.length; i++) {
        var plugin = json[i];

        if (plugin.ID == undefined) plugin.ID = plugin.id;

        var existingPlugin = SalesToolkit.Plugins.plugins.filter(function (
          item
        ) {
          return item.ID == plugin.ID;
        });

        if (!existingPlugin) {
          changes = true;
          break;
        }

        var existingModified = new Date(existingPlugin.Modified);
        var newModified = new Date(plugin.Modified);

        if (newModified > existingModified) {
          changes = true;
          break;
        }
      }
    } else {
      changes = true;
    }

    var reopenPlugin = false;
    if (
      $("#plugin-iframe").length != 0 &&
      $("#plugin-iframe").css("display") == "block"
    ) {
      //Plugin is showing must reload it
      reopenPlugin = true;
    }

    //If elements have been rendered already and there's no changes so far then dont rerender, onlly do icons
    if ($("#plugin-iframe").length != 0) {
      if (changes) {
        $("#plugin-iframe").remove();
        $("body").prepend(
          '<iframe id="plugin-iframe" style="display:none;" />'
        );
      }
    } else {
      $("body").prepend('<iframe id="plugin-iframe" style="display:none;" />');
    }

    let iframeSrc = $("#plugin-iframe").attr("src");

    if (
      (changes || typeof iframeSrc == "undefined") &&
      typeof SalesToolkit.Plugins.activePluginId === "string" &&
      SalesToolkit.Plugins.activePluginId.length > 0 &&
      SalesToolkit.Plugins.activePluginParameters !== null
    ) {
      loadPlugin(
        SalesToolkit.Plugins.activePluginId,
        SalesToolkit.Plugins.getActiveElementId(),
        !reopenPlugin,
        SalesToolkit.Plugins.activePluginParameters[
          SalesToolkit.Plugins.activePluginId
        ],
        true
      );
    }

    $(".pluginSideMenuIcon").remove();
    $(".pluginTopBarIcon").remove();
    $(".pluginGroupTopBarIcon").remove();
    $("#header_plugins_dropdown_icon").remove();
    $("#sideMenu_plugins_accordion").remove();
    SalesToolkit.UI.CollectionBrowser.Plugins = [];
    var pluginCSS = "";

    if (json.length > 1) {
      //More than one plugin, going to do a dropdown instead
      if ($("#header_plugins_dropdown_icon").length == 0) {
        var pluginsDropdownHtml =
          '<li class="dropdown dropdown-extended dropdown-plugins"' +
          '                            id="header_plugins_dropdown_icon">' +
          '                            <a title="' +
          SalesToolkit.Translation.get("plugins", "Plugins") +
          '" href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" data-hover="dropdown" data-close-others="true">' +
          '                                <img id="plugins-icon" class="plugins-icon" height="28px" />' +
          "                            </a>" +
          '                            <ul id="pluginsDropdownMenu" class="dropdown-menu">' +
          "                            </ul>" +
          "                        </li>";

        if (
          SalesToolkit.Theme.getBooleanProperty(
            "salesToolkitPluginsInTopBar",
            true
          )
        ) {
          var pluginsDropdownTopBar = $(pluginsDropdownHtml);
          $(pluginsDropdownTopBar).insertBefore("#headerCartLink");
          applyThemeToImage(
            "salestoolkitHeaderIconPlugins",
            "img.plugins-icon",
            SalesToolkit.DefaultImages.PluginSmallIcon
          );
        }
      } else if (
        SalesToolkit.Theme.getBooleanProperty(
          "salesToolkitPluginsInTopBar",
          true
        )
      ) {
        applyThemeToImage(
          "salestoolkitHeaderIconPlugins",
          "img.plugins-icon",
          SalesToolkit.DefaultImages.PluginSmallIcon
        );
      }

      if ($("#pluginSideMenuAccordionTitle").length == 0) {
        var pluginSideMenuAccordionTitle =
          '<li id="pluginSideMenuAccordionTitle" class="pluginSideMenuIcon customcolor">' +
          '<a id="sideMenu-accordion" href="#" onclick="togglePluginsAccordion()">' +
          '<div class="sidemenu-tile-contents">' +
          '<div class="sidemenu-icon-wrapper-outer">' +
          '<div class="sidemenu-icon-wrapper-inner">' +
          '<img id="sideMenuAccordionIcon" alt="" class="side-bar-icon" style="width: 36px;">' +
          " </div>" +
          "</div>" +
          '<span class="title">' +
          SalesToolkit.Theme.getStringProperty(
            "sideMenuPluginsAccordionTitle",
            "Plugins"
          ) +
          "</span>" +
          "</div>" +
          "</a>" +
          "</li>";

        $("#newsSideMenuIcon").css("border-bottom-width", "0");

        if (
          SalesToolkit.Theme.getBooleanProperty(
            "salesToolkitPluginsInSideMenu",
            true
          )
        ) {
          $(".page-sidebar-menu").append(pluginSideMenuAccordionTitle);
          applyThemeToImage(
            "salestoolkitSideMenuPlugins",
            "#sideMenuAccordionIcon",
            SalesToolkit.DefaultImages.PluginIcon
          );
        }
      }

      if ($("#sideMenu_plugins_accordion").length == 0) {
        var pluginSideMenuAccordion =
          '<div class="accordion-grouping" style="display:none;" id="sideMenu_plugins_accordion"></div>';
        if (
          SalesToolkit.Theme.getBooleanProperty(
            "salesToolkitPluginsInSideMenu",
            true
          )
        ) {
          $(".page-sidebar-menu").append(pluginSideMenuAccordion);
        }
      }
    }

    if ($("#header_plugins_dropdown_icon").length > 0) {
      $("#pluginsDropdownMenu").empty();
    }

    if ($("#sideMenu_plugins_accordion").length > 0) {
      $("#sideMenu_plugins_accordion").empty();
    }

    for (var i = 0; i < json.length; i++) {
      var plugin = json[i];

      if (plugin.ID == undefined) plugin.ID = plugin.id;
      if (plugin.Name == undefined) plugin.Name = plugin.name;

      if (plugin.ID == "debugComparator") {
        $(".demoComparatorSideMenu").addClass("demoModeOn");
        $(".demoComparatorTopBar").addClass("demoModeOn");
        break;
      }

      var pluginIcon = "";
      if (plugin.iconFilePath) {
        pluginIcon = plugin.iconFilePath;
      } else if (plugin.iconRemoteURL) {
        pluginIcon = plugin.iconRemoteURL;
      } else if (plugin.icon && plugin.icon.url) {
        pluginIcon =
          SalesToolkit.API.BASE_URL_NO_PROXY.merge(plugin.icon.url) +
          "?apikey=" +
          SalesToolkit.User.apikey;
      } else {
        pluginIcon = SalesToolkit.DefaultImages.PluginIcon;
      }

      var pluginSmallIcon = "";
      if (plugin.smallIconFilePath) {
        pluginSmallIcon = plugin.smallIconFilePath;
      } else if (plugin.smallIconRemoteURL) {
        pluginSmallIcon = plugin.smallIconRemoteURL;
      } else if (plugin.smallIcon && plugin.smallIcon.url) {
        pluginSmallIcon =
          SalesToolkit.API.BASE_URL_NO_PROXY.merge(plugin.smallIcon.url) +
          "?apikey=" +
          SalesToolkit.User.apikey;
      } else {
        pluginSmallIcon = SalesToolkit.DefaultImages.PluginSmallIcon;
      }

      var pluginThumb = "";
      if (plugin.thumbFilePath) {
        pluginThumb = plugin.thumbFilePath;
      } else if (plugin.thumbRemoteURL) {
        pluginThumb = plugin.thumbRemoteURL;
      } else if (plugin.thumbnail && plugin.thumbnail.url) {
        pluginThumb =
          SalesToolkit.API.BASE_URL_NO_PROXY.merge(plugin.thumbnail.url) +
          "?apikey=" +
          SalesToolkit.User.apikey;
      } else {
        pluginThumb = SalesToolkit.DefaultImages.PluginLibrary;
      }

      pluginCSS +=
        "." +
        plugin.ID +
        "::before { content:'' } ." +
        plugin.ID +
        " { background-image:url(" +
        pluginSmallIcon +
        ") !important} ";

      if (json.length > 1) {
        //Multiple plugins are to be added to dropdown instead of directly
        //Top bar
        let pluginTopBarIcon =
          ' <li class="pluginGroupTopBarIcon allowAfter">' +
          '                                    <a id="topBar-' +
          (plugin.ID || plugin.Name) +
          '" style="text-overflow:ellipsis; overflow:hidden;" href="#" onclick="loadPlugin(\'' +
          plugin.ID +
          "', this, false)\">" +
          ' <img id="plugin-' +
          plugin.ID +
          '-icon" style="position:relative; top:-1px; margin-right:9px;" class="plugin-' +
          plugin.ID +
          '-icon" height="28px" src=' +
          pluginSmallIcon +
          " />" +
          "                                        <span>" +
          (SalesToolkit.Theme.getBooleanProperty(
            "showPluginNameInDropdown",
            true
          )
            ? plugin.Name.replace("<br>", " ")
            : "") +
          "</span>" +
          "                                    </a>" +
          "                                </li>";

        if (
          SalesToolkit.Theme.getBooleanProperty(
            "salesToolkitPluginsInTopBar",
            true
          )
        )
          $("#pluginsDropdownMenu").append($(pluginTopBarIcon));

        //Side menu
        var pluginAccordionItemBG = colourString(
          SalesToolkit.Theme.getColourProperty(
            "accordionItemBackgroundColour",
            "#5f699c"
          )
        );
        var pluginAccordionItemTC = colourString(
          SalesToolkit.Theme.getColourProperty(
            "accordionItemTextColour",
            "#ffffff"
          )
        );

        var pluginSideMenu =
          '<li class="accordion-item pluginSideMenuIcon customcolor" style="display:block; background-color:' +
          pluginAccordionItemBG +
          ';">' +
          '<a id="sideMenu-' +
          (plugin.ID || plugin.Name) +
          '" href="#" onclick="loadPlugin(\'' +
          plugin.ID +
          "', this, false)\">" +
          '<div class="sidemenu-tile-contents">' +
          '<div class="sidemenu-icon-wrapper-outer">' +
          '<div class="sidemenu-icon-wrapper-inner">' +
          '<img alt="" class="side-bar-icon" src="' +
          pluginIcon +
          '" style="width: 36px;">' +
          " </div>" +
          "</div>" +
          '<span style="color:' +
          pluginAccordionItemTC +
          ';" class="title">' +
          plugin.Name +
          "</span>" +
          "</div>" +
          "</a>" +
          "</li>";

        if (
          SalesToolkit.Theme.getBooleanProperty(
            "salesToolkitPluginsInSideMenu",
            true
          )
        ) {
          $("#sideMenu_plugins_accordion").append(pluginSideMenu);
        }
      } else {
        //TOp bar
        let pluginTopBarIcon =
          '<li class="pluginTopBarIcon dropdown allowAfter">' +
          ' <a title="' +
          plugin.Name +
          '" id="topBar-' +
          (plugin.ID || plugin.Name) +
          '" href="#" onclick="loadPlugin(\'' +
          plugin.ID +
          '\', this, false)" class="dropdown-toggle" >' +
          ' <img id="plugin-' +
          plugin.ID +
          '-icon" class="plugin-' +
          plugin.ID +
          '-icon" height="28px" src=' +
          pluginSmallIcon +
          " />" +
          " </a>" +
          "</li>";

        if (
          SalesToolkit.Theme.getBooleanProperty(
            "salesToolkitPluginsInTopBar",
            true
          )
        )
          $(pluginTopBarIcon).insertBefore("#headerCartLink");

        //Side menu
        var pluginSideMenu =
          '<li class="pluginSideMenuIcon customcolor" >' +
          '<a id="sideMenu-' +
          (plugin.ID || plugin.Name) +
          '" href="#" onclick="loadPlugin(\'' +
          plugin.ID +
          "', this, false)\">" +
          '<div class="sidemenu-tile-contents">' +
          '<div class="sidemenu-icon-wrapper-outer">' +
          '<div class="sidemenu-icon-wrapper-inner">' +
          '<img alt="" class="side-bar-icon" src="' +
          pluginIcon +
          '" style="width: 36px;">' +
          " </div>" +
          "</div>" +
          '<span class="title">' +
          plugin.Name +
          "</span>" +
          "</div>" +
          "</a>" +
          "</li>";

        if (
          SalesToolkit.Theme.getBooleanProperty(
            "salesToolkitPluginsInSideMenu",
            true
          )
        )
          $(".page-sidebar-menu").append(pluginSideMenu);
      }

      var atheneumItem = JSON.stringify(plugin).replace(/"/g, "&quot;");
      var pluginLibrary =
        '<div id="libraryLaunch' +
        plugin.ID +
        '" onclick="loadPlugin(\'' +
        plugin.ID +
        '\', this, false)" class="col-sm-12 col-md-3 collection-browser-item collection-browser-collection atheneum-item" data-atheneum-item="' +
        atheneumItem +
        '" data-atheneum-item-type="collection" data-atheneum-item-id="' +
        plugin.ID +
        '" style="">' +
        '<div class="collection-style">' +
        '<div class="collectionIconContainer">' +
        '<div class="collectionIconInnerContainer">' +
        '<a class="thumbnail-and-text" data-atheneum-item-action="view">' +
        '<div class="thumbnail-image-wrapper">' +
        '<div class="thumbnail-image data-background-update-queued" style="background-image: url(\'' +
        pluginThumb +
        "'); opacity: 1;\">" +
        "</div>" +
        "</div>" +
        '<div class="textbox-home">' +
        '<h4 align="center" class="collection-name atheneum-item-name hide-overflow-text">' +
        plugin.Name +
        "</h4>" +
        "</div>" +
        "</a>" +
        "</div>" +
        "</div>" +
        "</div>" +
        "</div>";

      var pluginItem = {
        id: plugin.ID,
        html: pluginLibrary,
        plugin: plugin,
      };

      if (
        SalesToolkit.Theme.getBooleanProperty(
          "salesToolkitPluginsInLibrary",
          true
        )
      )
        SalesToolkit.UI.CollectionBrowser.Plugins.push(pluginItem);

      document.dispatchEvent(
        new CustomEvent(SalesToolkitApplication.Events.RENDER_PLUGINS)
      );
    }

    var styleElement = document.getElementById("salesToolkitPluginsCSS");
    if (styleElement == null) {
      styleElement = document.createElement("STYLE");
      styleElement.setAttribute("id", "salesToolkitPluginsCSS");
      styleElement.setAttribute("type", "text/css");
      document.head.appendChild(styleElement);
    }
    styleElement.innerHTML = pluginCSS;
  } catch (err) {
    renderingPlugins = false;
  }

  renderingPlugins = false;
}

function renderPlugins() {
  if (renderingPlugins) return;

  renderingPlugins = true;

  let debugPluginObject = {};
  debugPluginObject["ID"] = "debugComparator";
  //TEMP Testing localhost for CORS  debugPluginObject["filePath"] = indexFilePath;
  //debugPluginObject["filePath"] = "../hexvixig/index.html";
  //debugPluginObject["filePath"] = "../scpSearch/index.html";
  //FOR PHOTOCURE builds debugPluginObject["filePath"] = "https://resourcecentre-staging.trustrack.com/hexvixig/index.html";
  debugPluginObject["iconRemoteURL"] = "img/default/comparator_menu.svg";
  debugPluginObject["thumbRemoteURL"] = "img/default/comparator_library.svg";
  debugPluginObject["smallIconRemoteURL"] = "img/default/comparator_topbar.svg";

  //RELEASE Change to false
  let demoPlugin = false; // SalesToolkit.API.BASE_URL==  "https://qa-demo.trustrack.com/restful/54a6377877b043e60177b051d1e0012c";
  //SalesToolkit.API.BASE_URL == "https://photocure.atheneum.co/restful/54a6377877b043e60177b051d1e0012c";

  if (
    SalesToolkit.Plugins.plugins != undefined &&
    SalesToolkit.Plugins.plugins.length > 0
  ) {
    //Make sure th cached plugins are ones the user can see in case of generic apps where users are logging in to different accounts
    var plugins = SalesToolkit.Plugins.plugins;
    plugins = plugins.filter(function (obj) {
      if (!obj || typeof obj.instance === "undefined") {
        return false;
      }

      if (SalesToolkit.API.BASE_URL.contains(obj.instance))
        return SalesToolkit.User.canSee(obj);
      else return false;
    });

    if (demoPlugin) plugins.push(debugPluginObject);

    if (plugins != undefined && plugins.length > 0)
      createPluginElements(plugins);
  }

  SalesToolkit.Plugins.getPlugins({
    success: function (json) {
      if (demoPlugin) json.push(debugPluginObject);
      createPluginElements(json);
    },
    failure: function (reason, httpStatus, errorCode) {
      //TODO error message
      renderingPlugins = false;
    },
  });
}

function loadPlugin(pluginId, element, dontShow, parameters, animated) {
  if (!pluginId) return;
  if (parameters == undefined && SalesToolkit.Plugins.activePluginParameters) {
    parameters = SalesToolkit.Plugins.activePluginParameters[pluginId];
  }

  if (animated == undefined) animated = true;

  if (parameters == undefined || parameters == null || parameters.length == 0)
    parameters = "?screenWidth=" + screen.width;
  else parameters += "&screenWidth=" + screen.width;

  var iframe = $("#plugin-iframe")[0];

  for (var i = 0; i < SalesToolkit.Plugins.plugins.length; i++) {
    var plugin = SalesToolkit.Plugins.plugins[i];
    if (plugin.ID == undefined) plugin.ID = plugin.id;

    if (plugin.ID == pluginId && SalesToolkit.User.canSee(plugin)) {
      $(iframe).attr("data-plugin-id", pluginId);
      if (
        !SalesToolkit.CrossPlatform.enabled &&
        plugin.ID !== "debugComparator"
      ) {
        var src = SalesToolkit.API.BASE_URL.merge(plugin.zipUrl);
        src = src.replace("contents", "unzipped-contents");

        if (
          SalesToolkit.Theme.getBooleanProperty(
            "usePluginLocalSrcForWeb",
            false
          )
        ) {
          rc_base_url = window.location.origin;
          src = rc_base_url + "/static/plugins/" + plugin.ID + "/index.html";
        }

        if (!iframe.src.startsWith(src)) {
          SalesToolkit.Plugins.setActivePluginId(pluginId);
          iframe.src =
            parameters == undefined
              ? src
              : parameters.contains(".html")
              ? src.replace("index.html", parameters)
              : src + parameters;
        }

        if (!dontShow) showPluginIframe(element, animated);
      } else if (plugin.filePath) {
        if (!iframe.src.startsWith(plugin.filePath)) {
          SalesToolkit.Plugins.setActivePluginId(pluginId);

          iframe.src =
            parameters == undefined
              ? plugin.filePath
              : parameters.contains(".html")
              ? plugin.filePath.replace("index.html", parameters)
              : plugin.filePath + parameters;
        }

        if (!dontShow) showPluginIframe(element, animated);
      }
      break;
    }
  }
}

//Plugin callbacks
window.updatePluginParameters = function (parameters) {
  this.SalesToolkit.Plugins.setActivePluginParameters(parameters);
};

window.getPluginParameters = function () {
  let parameters =
    SalesToolkit.Plugins.activePluginParameters[
      SalesToolkit.Plugins.activePluginId
    ];
  if (parameters == undefined || parameters == null || parameters.length == 0)
    parameters = "?screenWidth=" + screen.width;
  else parameters += "&screenWidth=" + screen.width;
  return parameters;
};

window.pluginTracking = function (eventProperties) {
  SalesToolkit.Tracking.trackGeneric(
    eventProperties,
    SalesToolkit.Tracking.Type.PLUGIN,
    SalesToolkit.Tracking.PluginSubtype.CONTENT_INTERACTION,
    SalesToolkit.Plugins.activePluginId,
    SalesToolkit.Tracking.Status.ONLINE,
    new Date().getTime()
  );
};

window.hidePluginIframe = function (element, callback) {
  if (
    element == undefined &&
    typeof SalesToolkit.Plugins.getActiveElementId() === "string"
  ) {
    element = $("#" + SalesToolkit.Plugins.getActiveElementId());
    if (element.length == 0) element = undefined;
  }

  var top = 0;
  var left = 0;
  var widthOffset = 0;
  var heightOffset = 0;
  if (typeof element === "object") {
    top = $(element).offset().top;
    left = $(element).offset().left;
    widthOffset = $(element).width();
    if (widthOffset > 0) widthOffset = widthOffset / 2;
    heightOffset = $(element).height();
    if (heightOffset > 0) heightOffset = heightOffset / 2;
  }

  SalesToolkit.Tracking.trackGeneric(
    {},
    SalesToolkit.Tracking.Type.PLUGIN,
    SalesToolkit.Tracking.PluginSubtype.CLOSED,
    SalesToolkit.Plugins.activePluginId,
    SalesToolkit.Tracking.Status.ONLINE,
    new Date().getTime()
  );

  $("#plugin-iframe").css("transform-origin-x", left + widthOffset + "px");
  $("#plugin-iframe").css("transform-origin-y", top + heightOffset + "px");

  $("#plugin-iframe").removeClass("minimise");
  $("#plugin-iframe").removeClass("maximize");

  $("#plugin-iframe")[0].addEventListener("animationend", function () {
    $("#plugin-iframe").css("display", "none");
    $("#plugin-iframe")[0].removeEventListener(
      "animationend",
      arguments.callee
    );
    if (callback && typeof callback === "function") callback();
  });
  $("#plugin-iframe").addClass("minimise");

  if (SalesToolkit.CrossPlatform.enabled) {
    SalesToolkit.CrossPlatform.rewriteURLPromise(
      SalesToolkit.API.BASE_URL +
        "/tracking/generic/placeholder?apikey=" +
        SalesToolkit.User.apikey +
        "&username=" +
        SalesToolkit.User.username +
        "&pluginId=" +
        $("#plugin-iframe").attr("data-plugin-id") +
        "&timestamp=" +
        new Date().getTime() +
        "&eventType=pluginClose",
      true
    );
  }
};

window.showPluginIframe = function (element, animated) {
  if (element != undefined) {
    SalesToolkit.Plugins.setActiveElementId(element);
  }

  if (animated == undefined) animated = true;

  var top = 0;
  var left = 0;
  var widthOffset = 0;
  var heightOffset = 0;
  if (typeof element === "object") {
    top = $(element).offset().top;
    left = $(element).offset().left;
    widthOffset = $(element).width();
    if (widthOffset > 0) widthOffset = widthOffset / 2;
    heightOffset = $(element).height();
    if (heightOffset > 0) heightOffset = heightOffset / 2;
  }

  if (SalesToolkit.Plugins.activePluginId)
    SalesToolkit.Tracking.trackGeneric(
      {},
      SalesToolkit.Tracking.Type.PLUGIN,
      SalesToolkit.Tracking.PluginSubtype.OPENED,
      SalesToolkit.Plugins.activePluginId,
      SalesToolkit.Tracking.Status.ONLINE,
      new Date().getTime()
    );

  $("#plugin-iframe").css("transform-origin-x", left + widthOffset + "px");
  $("#plugin-iframe").css("transform-origin-y", top + heightOffset + "px");

  $("#plugin-iframe").removeClass("minimise");
  $("#plugin-iframe").removeClass("maximize");

  $("#plugin-iframe").css("display", "block");

  if (animated) $("#plugin-iframe").addClass("maximize");
  else {
  }

  if (SalesToolkit.CrossPlatform.enabled) {
    SalesToolkit.CrossPlatform.rewriteURLPromise(
      SalesToolkit.API.BASE_URL +
        "/tracking/generic/placeholder?apikey=" +
        SalesToolkit.User.apikey +
        "&username=" +
        SalesToolkit.User.username +
        "&pluginId=" +
        $("#plugin-iframe").attr("data-plugin-id") +
        "&timestamp=" +
        new Date().getTime() +
        "&eventType=pluginOpen",
      true
    );
  }
};

//window.trackPluginInteraction = function (event) {

//	if (SalesToolkit.CrossPlatform.enabled) {
//		SalesToolkit.CrossPlatform.rewriteURLPromise(
//			SalesToolkit.API.BASE_URL
//			+ '/tracking/generic/placeholder?apikey=' + SalesToolkit.User.apikey
//			+ '&username=' + SalesToolkit.User.username
//			+ '&pluginId=' + $('#plugin-iframe').attr('data-plugin-id')
//			+ '&timestamp=' + new Date().getTime()
//			+ '&eventType=' + event.type
//			+ '&eventElement=' + event.element
//			, true);
//	}
//}

window.pluginSearch = function (searchText) {
  if (!window.location.href.contains("index.html")) {
    hidePluginIframe(undefined, function () {
      window.location = SalesToolkit.HttpUtils.appendQueryParamsToUrl(
        "index.html",
        { search: searchText, pluginBack: "true", from: "plugin" }
      );
    });
    return;
  }

  document.dispatchEvent(
    new CustomEvent(SalesToolkitApplication.Events.COLLECTION_BROWSER_SETPATH, {
      detail: { path: [] },
    })
  );

  var searchInput = document.getElementById("search");
  if (searchInput) searchInput.value = searchText;
  if (typeof showSearchBar === "function") showSearchBar();
  if (typeof onSearchBoxContentChange === "function")
    onSearchBoxContentChange();

  pluginBackEnabled = true;
  hidePluginIframe($("#search-icon"));
};

window.pluginOpenAsset = function (assetId, pathPrefix) {
  if (
    !SalesToolkit.Library.assets[assetId] ||
    typeof SalesToolkit.Library.assets[assetId] === "undefined"
  )
    return;

  if (SalesToolkit.Library.assets[assetId].mimetype == "asset/url") {
    SalesToolkit.Pages.openInNewTab(SalesToolkit.Library.assets[assetId].url);
    return;
  }

  hidePluginIframe(undefined, function () {
    if (pathPrefix == undefined) pathPrefix = "";

    if (window.location != window.parent.location)
      window.parent.location =
        pathPrefix +
        SalesToolkit.HttpUtils.appendQueryParamsToUrl("index.html", {
          startingModule: "previewAsset",
          assetId: assetId,
          from: "home",
        });
    else
      window.location = SalesToolkit.HttpUtils.appendQueryParamsToUrl(
        "index.html",
        { startingModule: "previewAsset", assetId: assetId, from: "home" }
      );
  });
};

window.pluginOpenCollection = function (collectionId, pathPrefix) {
  hidePluginIframe(undefined, function () {
    if (pathPrefix == undefined) pathPrefix = "";

    if (window.location != window.parent.location)
      window.parent.location =
        pathPrefix +
        SalesToolkit.HttpUtils.appendQueryParamsToUrl("index.html", {
          collectionId: collectionId,
          pluginBack: "true",
          from: "home",
        });
    else
      window.location = SalesToolkit.HttpUtils.appendQueryParamsToUrl(
        "index.html",
        { collectionId: collectionId, pluginBack: "true", from: "home" }
      );
  });
};

window.contactEmail = "";
window.contactPhone = "";

window.pluginOpenContact = function (phone, email) {
  window.contactEmail = email;
  window.contactPhone = phone;

  if (
    window.contactEmail == null ||
    window.contactEmail == undefined ||
    window.contactEmail.trim() == ""
  ) {
    $("#contactLaunchModalEmailButton").hide();
  } else {
    $("#contactLaunchModalEmailButton").show();
  }

  if (
    window.contactPhone == null ||
    window.contactPhone == undefined ||
    window.contactPhone.trim() == ""
  ) {
    $("#contactLaunchModalPhoneButton").hide();
  } else {
    $("#contactLaunchModalPhoneButton").show();
  }

  $("#contactLaunchModal").modal("show");
};

window.addEventListener("message", function (event) {
  if (event && event.data && event.data.event_id === "pluginRequest") {
    console.log(event.data.data);
    var requestObj = event.data.data;
    var operation = requestObj.operation;
    if (operation == undefined || operation == null) return;

    if (operation == "pluginOpenContact") {
      pluginOpenContact(requestObj.contactPhone, requestObj.contactEmail);
    } else if (operation == "pluginOpenCollection") {
      pluginOpenCollection(requestObj.collectionId, requestObj.pathPrefix);
    } else if (operation == "pluginOpenAsset") {
      pluginOpenAsset(requestObj.assetId, requestObj.pathPrefix);
    } else if (operation == "pluginSearch") {
      pluginSearch(requestObj.searchText);
    } else if (operation == "hidePluginIframe") {
      hidePluginIframe();
    } else if (operation == "showPluginIframe") {
      showPluginIframe();
    } else if (operation == "updatePluginParameters") {
      updatePluginParameters(requestObj.params);
    } else if (operation == "pluginTracking") {
      pluginTracking(requestObj.eventProperties);
    } else if (operation == "getPluginParameters") {
      let params = getPluginParameters();
      try {
        let iframeWindow = $("#plugin-iframe")[0];
        if (iframeWindow) {
          iframeWindow = iframeWindow.contentWindow;
        }
        iframeWindow.postMessage(params, "*");
      } catch (err) {}
    }
  }

  if (event && event.data && event.data.event_id === "presentationRequest") {
    console.log(event.data.data);
    var requestObj = event.data.data;
    var operation = requestObj.operation;
    if (operation == undefined || operation == null) return;

    var status = SalesToolkit.Tracking.Status.ONLINE;
    if (
      SalesToolkit.CrossPlatform.enabled &&
      !SalesToolkit.CrossPlatform.isOnline()
    ) {
      status = SalesToolkit.Tracking.Status.OFFLINE;
    }
    var assetId = $("iframe.presentation").attr("data-assetId");
    if (operation == "PresentationOpened") {
      SalesToolkit.Tracking.trackGeneric(
        requestObj,
        SalesToolkit.Tracking.Type.PRESENTATION,
        SalesToolkit.Tracking.PresentationSubtype.OPENED,
        assetId,
        status,
        new Date().getTime()
      );
      resetScreensaver();
    } else if (operation == "PresentationClosed") {
      SalesToolkit.Tracking.trackGeneric(
        requestObj,
        SalesToolkit.Tracking.Type.PRESENTATION,
        SalesToolkit.Tracking.PresentationSubtype.CLOSED,
        assetId,
        status,
        new Date().getTime()
      );
      resetScreensaver();
    } else if (operation == "PresentationContentInteraction") {
      SalesToolkit.Tracking.trackGeneric(
        requestObj,
        SalesToolkit.Tracking.Type.PRESENTATION,
        SalesToolkit.Tracking.PresentationSubtype.CONTENT_INTERACTION,
        assetId,
        status,
        new Date().getTime()
      );
      resetScreensaver();
    } else if (operation == "PresentationTimeoutReset") {
      resetScreensaver();
      /*} else if (operation == 'PresentationLoaded'){
			var iframe = $('iframe.presentation')[0];
				if (iframe) {

					iframe.contentWindow.postMessage(
						{
							event_id: 'loadData',
							data: JSON.stringify(SalesToolkit)
						},
						"*"
					);
				} */
    } else if (operation == "PresentationShareRequest") {
      //SalesToolkit.Tracking.trackGeneric(requestObj, SalesToolkit.Tracking.Type.PRESENTATION, SalesToolkit.Tracking.PresentationSubtype.CONTENT_INTERACTION, assetId, status, new Date().getTime());
      let assetIds = new Array(requestObj.assetId);
      //let cartArr = new Array ({"storyId":requestObj.collectionId,"assetIds":JSON.stringify(assetIds)});

      var emailAddresses = [];

      /*if (atheneum.User.preferences.email)
				fields['email_replyTo'] = atheneum.User.preferences.email;*/

      var callbacks = {
        success: function (nShared) {},

        failure: function (reason, httpStatus, errorCode) {
          var errorCodeHex = undefined;
          if (typeof errorCode == "number") {
            errorCodeHex = errorCode.toString(16);
            while (errorCodeHex.length < 8) {
              errorCodeHex = "0" + errorCodeHex;
            }
          }

          if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {
            atheneum.Cart.empty();
          }
        },
      };

      emailAddresses[0] = requestObj.email;
      SalesToolkit.Cart.addAssets(assetIds);
      SalesToolkit.Cart.share(
        emailAddresses,
        JSON.parse(requestObj.formData),
        callbacks
      );
      SalesToolkit.Cart.empty();
    }
  }
  if (event && event.data && event.data.event_id === "modalInteraction") {
    console.log(event.data.data);
    var requestObj = event.data.data;
    var operation = requestObj.operation;
    if (operation == undefined || operation == null) return;

    if (operation == "openModal") {
      link.setAttribute("src", requestObj.link);
      container.setAttribute("class", "show");
    } else if (operation == "closeModal") {
      container.removeAttribute("class", "show");
    }
  }
});

function openMailApp() {
  window.location.href = "mailto:" + window.contactEmail;
}

function openPhoneApp() {
  window.location.href = "tel:" + window.contactPhone;
}

function enableClicks() {
  $("body").css("pointer-events", "auto");
}

function trackLoginFromParams(fromLoginPage = false) {
  const eventKey = "trackingLoginFromParameters";
  const eventProperties = {
    eventType: "parameter_login",
    eventDescriptionKey: eventKey,
    eventDescription: SalesToolkit.Translation.get(eventKey, eventKey),
  };

  try {
    const url = new URL(window.location.href);
    const path = url.pathname;
    const wwwrootIndex = path.indexOf("/wwwroot/");
    if (wwwrootIndex !== -1) {
      eventProperties.eventTarget = path.substring(wwwrootIndex);
    } else {
      eventProperties.eventTarget = url.href;
    }
  } catch (error) {
    console.error("Could not parse window.location.href:", error);
    eventProperties.eventTarget = window.location.href;
  }

  console.log("Tracking Event:", eventProperties);

  SalesToolkit.Tracking.trackGeneric(
    eventProperties,
    SalesToolkit.Tracking.Type.APP,
    SalesToolkit.Tracking.AppSubtype.AUTO_LOGIN,
    null,
    SalesToolkit.Tracking.Status.ONLINE,
    Date.now()
  );
}

/**
 * Tracks the start of a PDF page view event.
 * @param {object} [additionalProperties={}] - Optional properties to merge into the event object.
 */
function trackPDFPageViewStart(additionalProperties = {}) {
  const eventKey = "trackingPDFPageViewStart";
  const eventProperties = {
    eventType: "pdf_page_start",
    eventDescriptionKey: eventKey,
    eventDescription: SalesToolkit.Translation.get(eventKey, eventKey),
    // Merge any additional properties passed into the function.
    ...additionalProperties,
  };

  try {
    const url = new URL(window.location.href);
    const path = url.pathname;
    const wwwrootIndex = path.indexOf("/wwwroot/");
    if (wwwrootIndex !== -1) {
      eventProperties.eventTarget = path.substring(wwwrootIndex);
    } else {
      eventProperties.eventTarget = url.href;
    }
  } catch (error) {
    console.error("Could not parse window.location.href:", error);
    eventProperties.eventTarget = window.location.href;
  }

  console.log("Tracking Event:", eventProperties);

  SalesToolkit.Tracking.trackGeneric(
    eventProperties,
    SalesToolkit.Tracking.Type.APP,
    SalesToolkit.Tracking.AppSubtype.CONTENT_INTERACTION,
    null,
    SalesToolkit.Tracking.Status.ONLINE,
    Date.now()
  );
}

/**
 * Tracks the start of a PDF page view event.
 * @param {object} [additionalProperties={}] - Optional properties to merge into the event object.
 */
function trackPDFPageViewEnd(additionalProperties = {}) {
  const eventKey = "trackingPDFPageViewEnd";
  const eventProperties = {
    eventType: "pdf_page_end",
    eventDescriptionKey: eventKey,
    eventDescription: SalesToolkit.Translation.get(eventKey, eventKey),
    // Merge any additional properties passed into the function.
    ...additionalProperties,
  };

  try {
    const url = new URL(window.location.href);
    const path = url.pathname;
    const wwwrootIndex = path.indexOf("/wwwroot/");
    if (wwwrootIndex !== -1) {
      eventProperties.eventTarget = path.substring(wwwrootIndex);
    } else {
      eventProperties.eventTarget = url.href;
    }
  } catch (error) {
    console.error("Could not parse window.location.href:", error);
    eventProperties.eventTarget = window.location.href;
  }

  console.log("Tracking Event:", eventProperties);

  SalesToolkit.Tracking.trackGeneric(
    eventProperties,
    SalesToolkit.Tracking.Type.APP,
    SalesToolkit.Tracking.AppSubtype.CONTENT_INTERACTION,
    null,
    SalesToolkit.Tracking.Status.ONLINE,
    Date.now()
  );
}

function trackPageLoad() {
  let eventProperties = {
    eventType: "page_load",
  };

  let eventTargetUrl = window.location.href;

  if (
    eventTargetUrl.includes("index.html") &&
    document.body.classList.contains("module-cart")
  ) {
    eventTargetUrl = eventTargetUrl.replace("index.html", "cart.html");
  }

  if (eventTargetUrl.includes("wwwroot")) {
    eventProperties.eventTarget = eventTargetUrl.substring(
      eventTargetUrl.indexOf("wwwroot")
    );
  } else {
    eventProperties.eventTarget = eventTargetUrl;
  }

  eventProperties.eventDescription = SalesToolkit.Translation.get(
    "trackingPageLoad",
    "trackingPageLoad"
  );
  eventProperties.eventDescriptionKey = "trackingPageLoad";

  console.log("tracking - " + JSON.stringify(eventProperties));

  SalesToolkit.Tracking.trackGeneric(
    eventProperties,
    SalesToolkit.Tracking.Type.APP,
    SalesToolkit.Tracking.AppSubtype.CONTENT_INTERACTION,
    null,
    SalesToolkit.Tracking.Status.ONLINE,
    new Date().getTime()
  );
}

function trackContactSessionStart(startFrom) {
  if (typeof SalesToolkit.Forms.userDetails === "undefined") return false;

  let eventProperties = {
    eventType: "contact_session_start",
  };

  eventProperties.eventTarget = startFrom;

  //eventProperties.eventContact = SalesToolkit.Forms.userDetails;

  let userLanguage =
    SalesToolkit.User.getLanguage() ||
    SalesToolkit.Language.getBrowserPreferred() ||
    SalesToolkit.Language.getDefault();
  eventProperties.eventUILanguage = userLanguage.iso_code;

  eventProperties.eventDescription = SalesToolkit.Translation.get(
    "trackingContactSessionStart",
    "trackingContactSessionStart"
  );
  eventProperties.eventDescriptionKey = "trackingContactSessionStart";

  console.log("tracking Session Start - " + JSON.stringify(eventProperties));

  SalesToolkit.Tracking.trackGeneric(
    eventProperties,
    SalesToolkit.Tracking.Type.APP,
    SalesToolkit.Tracking.AppSubtype.CONTENT_INTERACTION,
    null,
    SalesToolkit.Tracking.Status.ONLINE,
    new Date().getTime()
  );
}

function trackContactSessionEnd(endFrom) {

  if (typeof SalesToolkit.Forms.userDetails === "undefined") return false;

  let eventProperties = {
    eventType: "contact_session_end",
  };

  eventProperties.eventTarget = endFrom;

  //eventProperties.eventContact = SalesToolkit.Forms.userDetails;

  let userLanguage =
    SalesToolkit.User.getLanguage() ||
    SalesToolkit.Language.getBrowserPreferred() ||
    SalesToolkit.Language.getDefault();
  eventProperties.eventUILanguage = userLanguage.iso_code;

  eventProperties.eventDescription = SalesToolkit.Translation.get(
    "trackingContactSessionEnd",
    "trackingContactSessionEnd"
  );
  eventProperties.eventDescriptionKey = "trackingContactSessionEnd";

  console.log("tracking Session Start - " + JSON.stringify(eventProperties));

  SalesToolkit.Tracking.trackGeneric(
    eventProperties,
    SalesToolkit.Tracking.Type.APP,
    SalesToolkit.Tracking.AppSubtype.CONTENT_INTERACTION,
    null,
    SalesToolkit.Tracking.Status.ONLINE,
    new Date().getTime()
  );
}

function trackWebsocketMessageReceived(username,password,clientId,ip,port,topicName,payload) {
  let eventProperties = {
    eventType: "websocket_message_received",
  };

  eventProperties.username = username;
  eventProperties.password = password;
  eventProperties.clientId = clientId;
  eventProperties.ip = ip;
  eventProperties.port = port;
  eventProperties.topicName = topicName;
  eventProperties.payload = JSON.stringify(payload);
  eventProperties.eventDescriptionKey = "trackingWebsocketMessageReceived";

  console.log("tracking - " + JSON.stringify(eventProperties));

  SalesToolkit.Tracking.trackGeneric(
    eventProperties,
    SalesToolkit.Tracking.Type.APP,
    SalesToolkit.Tracking.AppSubtype.MESSAGE_RECEIVED,
    null,
    SalesToolkit.Tracking.Status.ONLINE,
    new Date().getTime()
  );
}

trackPageLoad();

$(document).on("click", "a.fullscreen", function (e) {
  var $element = $(this);
  var elementId = $element.attr("id");
  while (typeof elementId === "undefined") {
    $element = $element.parent();
    elementId = $element.attr("id");
  }

  try {
    if (elementId === "main-panel") {
      setTimeout(function () {
        document.dispatchEvent(
          new CustomEvent(SalesToolkitApplication.Events.CALVIEW_RESIZE, {
            detail: {
              path: [],
              isFullScreen: $("body").hasClass("page-portlet-fullscreen"),
            },
          })
        );
      }, 100);
    }
    if (window.location.href.contains("viewForm")) {
      $(".suggestion-list").hide();
      hideAllSuggestionLists();
    }
  } catch (err) {}

  //Page was already in fullscreen so this click will be going back to normal
  if ($("body").hasClass("page-portlet-fullscreen")){
    
    trackAppClick(
      $("#" + elementId + " a.fullscreen"),
      "#" + elementId + " a.fullscreen",
      "trackingFullScreenToggleOn",
      SalesToolkit.Translation.get(
        "trackingFullScreenToggleOn",
        "trackingFullScreenToggleOn"
      )
    );
    var videos = document.querySelectorAll("#viewAssetWrapper video");

    if (window.location.href.contains("viewAsset") && videos.length > 0) {
      var event = e || window.event;
      if ($(event.target).parents("#tree-view-panel").length > 0) return true;
      if ($(event.target).parents("#related-assets-panel").length > 0)
        return true;

      event.preventDefault();
      event.stopPropagation();

      var video = videos[0];
      if (video.requestFullscreen) video.requestFullscreen();
      else if (video.webkitRequestFullscreen) video.webkitRequestFullscreen();
      else if (video.msRequestFullScreen) video.msRequestFullScreen();
      else if (video.enterFullscreen) video.enterFullscreen();
      else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();

      return true;
    }
  }
  else{
    trackAppClick(
      $("#" + elementId + " a.fullscreen"),
      "#" + elementId + " a.fullscreen",
      "trackingFullScreenToggleOff",
      SalesToolkit.Translation.get(
        "trackingFullScreenToggleOff",
        "trackingFullScreenToggleOff"
      )
    );
  }
});

function trackAppSearch(searchText) {
  let eventProperties = {
    eventType: "search",
  };

  eventProperties.eventTarget = searchText;

  if (window.location.href.indexOf("wwwroot") >= 0)
    eventProperties.eventPageLocation = window.location.href.substring(
      window.location.href.indexOf("wwwroot")
    );
  else eventProperties.eventPageLocation = window.location.href;

  eventProperties.eventDescription = SalesToolkit.Translation.get(
    "trackingPageSearch",
    "trackingPageSearch"
  );
  eventProperties.eventDescriptionKey = "trackingPageSearch";

  console.log("tracking - " + JSON.stringify(eventProperties));

  SalesToolkit.Tracking.trackGeneric(
    eventProperties,
    SalesToolkit.Tracking.Type.APP,
    SalesToolkit.Tracking.AppSubtype.CONTENT_INTERACTION,
    null,
    SalesToolkit.Tracking.Status.ONLINE,
    new Date().getTime()
  );
}

function trackTiming(target, time) {
  let eventProperties = {
    eventType: "timer",
  };

  eventProperties.eventTarget = target;

  eventProperties.time = time;

  eventProperties.eventDescription = SalesToolkit.Translation.get(
    "trackingTimer",
    "trackingTimer"
  );
  eventProperties.eventDescriptionKey = "trackingTimer";

  console.log("tracking - " + JSON.stringify(eventProperties));

  SalesToolkit.Tracking.trackGeneric(
    eventProperties,
    SalesToolkit.Tracking.Type.APP,
    SalesToolkit.Tracking.AppSubtype.CONTENT_INTERACTION,
    null,
    SalesToolkit.Tracking.Status.ONLINE,
    new Date().getTime()
  );
}

function trackAppClick(element, selector, key, description, info) {
  if (typeof SalesToolkit.Tracking === "undefined") return;
  let eventProperties = {
    eventType: "click",
  };

  if (typeof properties === "object") {
    eventProperties.info = info;
  }

  let parsedSelector =
    selector && $(selector).length == 0
      ? selector.replaceAll(".", "\\.").replaceAll(" ", "\\ ")
      : false;
  if (selector && !parsedSelector) parsedSelector = selector;
  eventProperties.eventTarget = parsedSelector
    ? parsedSelector
    : $(element).attr("id");

  let eventLocation = parsedSelector
    ? $(parsedSelector).offset()
    : $(element).offset();
  eventProperties.eventLocationTop = eventLocation ? eventLocation.top : -1;
  eventProperties.eventLocationLeft = eventLocation ? eventLocation.left : -1;

  if (window.location.href.indexOf("wwwroot") >= 0)
    eventProperties.eventPageLocation = window.location.href.substring(
      window.location.href.indexOf("wwwroot")
    );
  else eventProperties.eventPageLocation = window.location.href;
  eventProperties.eventDescription = description;
  eventProperties.eventDescriptionKey = key;

  console.log("tracking - " + JSON.stringify(eventProperties));

  SalesToolkit.Tracking.trackGeneric(
    eventProperties,
    SalesToolkit.Tracking.Type.APP,
    SalesToolkit.Tracking.AppSubtype.CONTENT_INTERACTION,
    null,
    SalesToolkit.Tracking.Status.ONLINE,
    new Date().getTime()
  );
}

function trackAppClickForEntity(element, selector, key, description, entity) {
  if (typeof SalesToolkit.Tracking === "undefined") return;

  let eventProperties = {
    eventType: "click",
  };

  let parsedSelector =
    selector && $(selector).length == 0
      ? selector.replaceAll(".", "\\.").replaceAll(" ", "\\ ")
      : false;
  if (selector && !parsedSelector) parsedSelector = selector;
  eventProperties.eventTarget = parsedSelector
    ? parsedSelector
    : $(element).attr("id");

  let eventLocation = parsedSelector
    ? $(parsedSelector).offset()
    : $(element).offset();
  eventProperties.eventLocationTop = eventLocation ? eventLocation.top : -1;
  eventProperties.eventLocationLeft = eventLocation ? eventLocation.left : -1;

  if (window.location.href.indexOf("wwwroot") >= 0)
    eventProperties.eventPageLocation = window.location.href.substring(
      window.location.href.indexOf("wwwroot")
    );
  else eventProperties.eventPageLocation = window.location.href;
  eventProperties.eventDescription = description;
  eventProperties.eventDescriptionKey = key;

  console.log("tracking - " + JSON.stringify(eventProperties));

  SalesToolkit.Tracking.trackGeneric(
    eventProperties,
    SalesToolkit.Tracking.Type.APP,
    SalesToolkit.Tracking.AppSubtype.CONTENT_INTERACTION,
    entity,
    SalesToolkit.Tracking.Status.ONLINE,
    new Date().getTime()
  );
}

function appEnteredForeground() {
  try {
    console.log("tracking - foreground");
    SalesToolkit.Tracking.trackGeneric(
      {},
      SalesToolkit.Tracking.Type.APP,
      SalesToolkit.Tracking.AppSubtype.FOREGROUND,
      null,
      SalesToolkit.Tracking.Status.ONLINE,
      new Date().getTime()
    );
  } catch (err) {}
}

function appEnteredBackground() {
  try {
    console.log("tracking - background");
    SalesToolkit.Tracking.trackGeneric(
      {},
      SalesToolkit.Tracking.Type.APP,
      SalesToolkit.Tracking.AppSubtype.BACKGROUND,
      null,
      SalesToolkit.Tracking.Status.ONLINE,
      new Date().getTime()
    );
  } catch (err) {}
}

function fallbackCopyTextToClipboard(text) {
  var textArea = document.createElement("textarea");
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    var successful = document.execCommand("copy");
    var msg = successful ? "successful" : "unsuccessful";
    console.log("Fallback: Copying text command was " + msg);
    showCopySuccess();
  } catch (err) {
    console.error("Fallback: Oops, unable to copy", err);
    showCopyFailed(err);
  }

  document.body.removeChild(textArea);
}

function showCopySuccess() {
  let message = SalesToolkit.Translation.get(
    "copiedToClipboardMessage",
    "Text copied to clipboard"
  );
  let title = SalesToolkit.Translation.get("copiedToClipboardTitle", "Success");

  SalesToolkit.UI.Notifications.showCustomNotification("info", message, title);
}

function showCopyFailed(err) {
  let message = SalesToolkit.Translation.get(
    "copiedToClipboardFailedMessage",
    "Error copying to clipboard: {0}".replaceAll("{0}", err)
  );
  let title = SalesToolkit.Translation.get(
    "copiedToClipboardFailedTitle",
    "Failed"
  );

  SalesToolkit.UI.Notifications.showCustomNotification("info", message, title);
}

function copyTextToClipboard() {
  var text = $("#downloadInput").val() || "";
  if (SalesToolkit.CrossPlatform.enabled) {
    SalesToolkit.CrossPlatform.copyToClipboard(text);
    showCopySuccess();
    return;
  }

  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(
    function () {
      console.log("Async: Copying to clipboard was successful!");
      showCopySuccess();
    },
    function (err) {
      console.error("Async: Could not copy text: ", err);
      showCopyFailed(err);
    }
  );
}

function showInformationForItem(item) {
  if ($("body").hasClass("loadingDB")) return;
  $("#documentInfoModalBodyInfoGroups").html("");
  $("#documentInfoModalBody .loading-wheel").remove();

  let wrapper = $("#documentInfoModalBodyInfoGroups")[0];

  let infoToInclude = SalesToolkit.Translation.get(
    "documentInformationPopupProperties",
    '[{ "name": "doiNumber", "label" : "DOI:", "type":"text"},' +
      '{ "name": "fullTitle", "label" : "Full Title:", "type":"text"},' +
      '{ "name": "publicationName", "label" : "Publication Name:", "type":"text"},' +
      '{ "name": "publishDate", "label" : "Publish Date:", "type":"date"},' +
      '{ "name": "authors", "label" : "Authors:", "type":"text"}]'
    //NOT NEEDED'{ "name": "copyright", "label" : "Copyright:", "type":"text"}]'
  );

  infoToInclude = JSON.parse(infoToInclude);

  let asset = SalesToolkit.Library.assets[item.id];
  if (!asset) return;

  item = asset;

  infoToInclude.forEach((property) => {
    if (!item.hasOwnProperty(property.name)) return;

    let infoGroup = htmlToElement('<div class="infoGroup"></div>');
    let name = property.name;

    let infoLabel = htmlToElement(
      '<label for="' +
        name +
        '"class="infoLabel">' +
        property.label +
        "</label>"
    );
    let infoInput = htmlToElement(
      '<label name="' + name + '" class="infoLabelValue" ></label>'
    );

    let value = item[name];

    if (property.type === "date") {
      value = new Date(value);
      value.setHours(0, 0, 0, 0);
      //value =  value.getTime() - (value.getTimezoneOffset() * 1000 * 60);
      infoInput.innerHTML = value.toLocaleDateString();
    } else if (property.type.indexOf("datetime") >= 0) {
      value = new Date(value);
      infoInput.innerHTML =
        value.toLocaleDateString() + " " + value.toLocaleTimeString();
    } else {
      infoInput.innerHTML = value;
    }

    infoGroup.appendChild(infoLabel);
    infoGroup.appendChild(infoInput);
    wrapper.appendChild(infoGroup);
  });

  //let relatedInfoGroup;
  //let relatedTitle;
  //let relatedDesc;

  let headingColor = SalesToolkit.Theme.getColourProperty(
    "infoPopupHeaderColor",
    "#ff3300"
  );
  if (headingColor) {
    headingColor = colourString(headingColor);
  }

  if (item.title || item.description) {
    let infoGroup = htmlToElement('<div class="infoGroup"></div>');
    let heading = htmlToElement(
      '<h2 style="color:' +
        headingColor +
        ';" class="infoHeader">' +
        SalesToolkit.Translation.get(
          "relatedAssetInformation",
          "Related Asset Information"
        ) +
        "</h2>"
    );
    infoGroup.appendChild(heading);
    wrapper.appendChild(infoGroup);
  }

  if (item.title) {
    let relatedInfoGroup = htmlToElement('<div class="infoGroup"></div>');

    let relatedTitleLabel = htmlToElement(
      '<label class="infoLabel">' +
        SalesToolkit.Translation.get("infoPopupRelatedTitle", "Title:") +
        "</label>"
    );
    let relatedTitle = htmlToElement("<label>" + item.title + "</label> <br>");

    relatedInfoGroup.appendChild(relatedTitleLabel);
    relatedInfoGroup.appendChild(relatedTitle);
    wrapper.appendChild(relatedInfoGroup);
  }

  if (item.description) {
    let relatedInfoGroup = htmlToElement('<div class="infoGroup"></div>');

    let relatedDescLabel = htmlToElement(
      '<label class="infoLabel">' +
        SalesToolkit.Translation.get(
          "infoPopupRelatedDescription",
          "Description:"
        ) +
        "</label>"
    );
    let relatedDesc = htmlToElement("<label>" + item.description + "</label>");

    relatedInfoGroup.appendChild(relatedDescLabel);
    relatedInfoGroup.appendChild(relatedDesc);

    wrapper.appendChild(relatedInfoGroup);
  }

  if (document.body.classList.contains("sharedCart")) {
    let cart = SalesToolkit.Cart.getLoadedCart();
    let infoGroup = htmlToElement('<div class="infoGroup"></div>');
    let heading = htmlToElement(
      '<h2 style="color:' +
        headingColor +
        ';" class="infoHeader">' +
        SalesToolkit.Translation.get("inboxShared", "Share Information:") +
        "</h2>"
    );
    infoGroup.appendChild(heading);
    wrapper.appendChild(infoGroup);
    let atheneum = SalesToolkit;

    for (let j = 0; j < cart.cart.length; j++) {
      let cartItems = cart.cart[j];
      let collection = atheneum.Library.collections[cartItems.storyId];

      if (
        (cartItems.assetIds === "all" &&
          collection &&
          collection.assets.includes(item.id)) ||
        cartItems.assetIds.includes(item.id)
      ) {
        try {
          if (!cart.myCart) {
            let sharedByInfoGroup = htmlToElement(
              '<div class="infoGroup"></div>'
            );
            let sharedByTitle = htmlToElement(
              '<label class="infoLabel">' +
                SalesToolkit.Translation.get(
                  "inboxSharedByTitle",
                  "Shared by:"
                ) +
                "</label>"
            );
            let sharedByLabel = htmlToElement(
              "<label>" + cart.sharedBy?.email + "</label> <br>"
            );

            sharedByInfoGroup.appendChild(sharedByTitle);
            sharedByInfoGroup.appendChild(sharedByLabel);
            wrapper.appendChild(sharedByInfoGroup);
          }
        } catch (err) {}
        if (cart.hasOwnProperty("sharedDate")) {
          let sharedDateInfoGroup = htmlToElement(
            '<div class="infoGroup"></div>'
          );
          let sharedDateTitle = htmlToElement(
            '<label class="infoLabel">' +
              SalesToolkit.Translation.get(
                "inboxSharedDateTitle",
                "Shared on:"
              ) +
              "</label>"
          );
          let sharedDateLabel = htmlToElement(
            "<label>" +
              new Date(cart.sharedDate).toLocaleString() +
              "</label> <br>"
          );

          sharedDateInfoGroup.appendChild(sharedDateTitle);
          sharedDateInfoGroup.appendChild(sharedDateLabel);
          wrapper.appendChild(sharedDateInfoGroup);
        } else if (
          cart.hasOwnProperty("sharedWith") &&
          Array.isArray(cart.sharedWith) &&
          SalesToolkit.Theme.getBooleanProperty("showSharedWith", true)
        ) {
          for (let y = 0; y < cart.sharedWith.length; y++) {
            let sharedWith = cart.sharedWith[y];

            let sharedByInfoGroup = htmlToElement(
              '<div class="infoGroup"></div>'
            );
            let sharedByTitle = htmlToElement(
              '<label class="infoLabel">' +
                SalesToolkit.Translation.get(
                  "inboxSharedWithTitle",
                  "Shared with:"
                ) +
                "</label>"
            );
            let sharedByLabel = htmlToElement(
              "<label>" + sharedWith.name + "</label> <br>"
            );

            sharedByInfoGroup.appendChild(sharedByTitle);
            sharedByInfoGroup.appendChild(sharedByLabel);
            wrapper.appendChild(sharedByInfoGroup);

            let sharedDateInfoGroup = htmlToElement(
              '<div class="infoGroup"></div>'
            );
            let sharedDateTitle = htmlToElement(
              '<label class="infoLabel">' +
                SalesToolkit.Translation.get(
                  "inboxSharedDateTitle",
                  "Shared on:"
                ) +
                "</label>"
            );
            let sharedDateLabel = htmlToElement(
              "<label>" +
                new Date(sharedWith.date).toLocaleString() +
                "</label> <br>"
            );

            sharedDateInfoGroup.appendChild(sharedDateTitle);
            sharedDateInfoGroup.appendChild(sharedDateLabel);
            wrapper.appendChild(sharedDateInfoGroup);

            if (
              y + 1 >=
              SalesToolkit.Theme.getIntegerProperty("maxShareWithInfo", 5)
            ) {
              break;
            }
          }
        }
      }
    }
  }

  if (window.location.href.indexOf("inbox") >= 0) {
    let allCarts = SalesToolkit.Cart.carts;
    let atheneum = SalesToolkit;
    allCarts = allCarts
      .filter((x) => x.myCart === false)
      .sort((a, b) => {
        return new Date(b.sharedDate) - new Date(a.sharedDate);
      });

    let infoGroup = htmlToElement('<div class="infoGroup"></div>');
    let heading = htmlToElement(
      '<h2 style="color:' +
        headingColor +
        ';" class="infoHeader">' +
        SalesToolkit.Translation.get("inboxShared", "Share Information:") +
        "</h2>"
    );
    infoGroup.appendChild(heading);
    wrapper.appendChild(infoGroup);

    for (let i = 0; i < allCarts.length; i++) {
      let cart = allCarts[i];

      for (let j = 0; j < cart.cart.length; j++) {
        let cartItems = cart.cart[j];
        let collection = atheneum.Library.collections[cartItems.storyId];

        if (
          (cartItems.assetIds === "all" &&
            collection &&
            collection.assets.includes(item.id)) ||
          cartItems.assetIds.includes(item.id)
        ) {
          try {
            if (!cart.myCart) {
              let sharedByInfoGroup = htmlToElement(
                '<div class="infoGroup"></div>'
              );
              let sharedByTitle = htmlToElement(
                '<label class="infoLabel">' +
                  SalesToolkit.Translation.get(
                    "inboxSharedByTitle",
                    "Shared by:"
                  ) +
                  "</label>"
              );
              let sharedByLabel = htmlToElement(
                "<label>" + cart.sharedBy.email + "</label> <br>"
              );

              sharedByInfoGroup.appendChild(sharedByTitle);
              sharedByInfoGroup.appendChild(sharedByLabel);
              wrapper.appendChild(sharedByInfoGroup);
            }
          } catch (err) {}

          if (cart.hasOwnProperty("sharedDate")) {
            let sharedDateInfoGroup = htmlToElement(
              '<div class="infoGroup"></div>'
            );
            let sharedDateTitle = htmlToElement(
              '<label class="infoLabel">' +
                SalesToolkit.Translation.get(
                  "inboxSharedDateTitle",
                  "Shared on:"
                ) +
                "</label>"
            );
            let sharedDateLabel = htmlToElement(
              "<label>" +
                new Date(cart.sharedDate).toLocaleString() +
                "</label> <br>"
            );

            sharedDateInfoGroup.appendChild(sharedDateTitle);
            sharedDateInfoGroup.appendChild(sharedDateLabel);
            wrapper.appendChild(sharedDateInfoGroup);
          } else if (
            cart.hasOwnProperty("sharedWith") &&
            Array.isArray(cart.sharedWith) &&
            SalesToolkit.Theme.getBooleanProperty("showSharedWith", true)
          ) {
            for (let y = 0; y < cart.sharedWith.length; y++) {
              let sharedWith = cart.sharedWith[y];

              let sharedByInfoGroup = htmlToElement(
                '<div class="infoGroup"></div>'
              );
              let sharedByTitle = htmlToElement(
                '<label class="infoLabel">' +
                  SalesToolkit.Translation.get(
                    "inboxSharedWithTitle",
                    "Shared with:"
                  ) +
                  "</label>"
              );
              let sharedByLabel = htmlToElement(
                "<label>" + sharedWith.name + "</label> <br>"
              );

              sharedByInfoGroup.appendChild(sharedByTitle);
              sharedByInfoGroup.appendChild(sharedByLabel);
              wrapper.appendChild(sharedByInfoGroup);

              let sharedDateInfoGroup = htmlToElement(
                '<div class="infoGroup"></div>'
              );
              let sharedDateTitle = htmlToElement(
                '<label class="infoLabel">' +
                  SalesToolkit.Translation.get(
                    "inboxSharedDateTitle",
                    "Shared on:"
                  ) +
                  "</label>"
              );
              let sharedDateLabel = htmlToElement(
                "<label>" +
                  new Date(sharedWith.date).toLocaleString() +
                  "</label> <br>"
              );

              sharedDateInfoGroup.appendChild(sharedDateTitle);
              sharedDateInfoGroup.appendChild(sharedDateLabel);
              wrapper.appendChild(sharedDateInfoGroup);

              if (
                y + 1 >=
                SalesToolkit.Theme.getIntegerProperty("maxShareWithInfo", 5)
              ) {
                break;
              }
            }
          }
        }
      }
    }
  }

  $("#documentInfoModal").modal("show");

  if (SalesToolkit.Theme.getBooleanProperty("includeTagReasons", true)) {
    $("#documentInfoModal").toggleClass("loading", true);
    $("#documentInfoModalBody").append(
      '<div class="loading-wheel"><div class="lds-roller infoModal"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div></div>'
    );

    SalesToolkit.Admin.getTagReasonsForAsset(item.id, {
      success: function (json) {
        let i;

        json.tags.sort(function (a, b) {
          let aTag =
            SalesToolkit.Filters.getFilters().find(
              (x) => x.name === a.filterName
            ) || null;
          let bTag =
            SalesToolkit.Filters.getFilters().find(
              (x) => x.name === b.filterName
            ) || null;

          if (aTag === null || bTag === null)
            return (
              a.filterName.localeCompare(b.filterName) ||
              a.optionName.localeCompare(b.optionName)
            );

          let aOption =
            aTag.options.find((x) => x.name === a.optionName) || null;
          let bOption =
            bTag.options.find((x) => x.name === b.optionName) || null;

          if (aOption === null || bOption === null) {
            return (
              aTag.sortOrder - bTag.sortOrder ||
              a.optionName.localeCompare(b.optionName)
            );
          }

          return (
            aTag.sortOrder - bTag.sortOrder ||
            aOption.label.localeCompare(bOption.label)
          );
        });

        let lastFilterName = "";

        for (i = 0; i < json.tags?.length; i++) {
          let tag = json.tags[i];
          let filterName = tag.filterName;
          let optionName = tag.optionName;
          let type =
            tag.type ||
            SalesToolkit.Translation.get("noTypeDetected", "Uknown type");
          let reason = tag.reason;

          if (
            type !== "AUTOMATIC" &&
            SalesToolkit.Theme.getBooleanProperty(
              "onlyShowAutomaticTags",
              false
            )
          ) {
            continue;
          }

          if (
            SalesToolkit.Theme.getBooleanProperty("showTagsWithoutReason", true)
          ) {
            if (reason == null)
              reason = SalesToolkit.Translation.get(
                "noReasonGiven",
                "No reason has been provided"
              );
          } else {
            continue;
          }

          if (
            type !== "AUTOMATIC" &&
            SalesToolkit.Theme.getBooleanProperty(
              "onlyShowReasonsForAutomaticTags",
              true
            )
          ) {
            reason = "";
          }

          let storedTag = SalesToolkit.Filters.getFilters().filter(
            (x) => x.name === filterName
          );
          if (storedTag.length > 0) {
            storedTag = storedTag[0];
            filterName = storedTag.label;
            let storedOption = storedTag.options.filter(
              (x) => x.name === optionName
            );
            if (storedOption.length > 0) {
              storedOption = storedOption[0];
              optionName = storedOption.label;
            } else {
              storedOption = storedTag.options.filter(
                (x) =>
                  x.hasOwnProperty("options") &&
                  x.options.filter((y) => y.name == optionName).length > 0
              );
              if (storedOption.length > 0) {
                storedOption = storedOption[0].options.find(
                  (x) => x.name === optionName
                );
                optionName = storedOption.label;
              }
            }
          }

          let infoGroup = htmlToElement('<div class="infoGroup"></div>');

          if (lastFilterName !== filterName) {
            let infoHeader = htmlToElement(
              '<h2 style="color:' +
                headingColor +
                ';" class="infoHeader">' +
                filterName +
                "</h2>"
            );
            infoGroup.appendChild(infoHeader);
            lastFilterName = filterName;
          }

          let labelText = optionName;
          if (SalesToolkit.Theme.getBooleanProperty("includeTagType", true)) {
            labelText = labelText + " (" + type + ")";
          }

          let infoLabel = htmlToElement(
            '<label for="' +
              filterName +
              '"class="infoLabel">' +
              labelText +
              "</label>"
          );
          let infoInput = htmlToElement(
            '<label name="' +
              filterName +
              '" class="infoLabelValue" >' +
              reason +
              "</label>"
          );

          infoGroup.appendChild(infoLabel);
          infoGroup.appendChild(infoInput);
          wrapper.appendChild(infoGroup);
        }

        $("#documentInfoModal").toggleClass("loading", false);
        $("#documentInfoModalBody .loading-wheel").remove();
      },
      failure: function (reason, httpStatus, errorCode) {
        //TODO change this to show the error on the popup itself
        SalesToolkit.UI.Notifications.showCustomNotification(
          "info",
          SalesToolkit.Translation.get(
            "tagReasonsFailed",
            "Obtaining tagging reasons requires a connection to the server."
          ),
          SalesToolkit.Translation.get("tagReasonsFailedTitle", "Error")
        );
        $("#documentInfoModal").toggleClass("loading", false);
        $("#documentInfoModalBody .loading-wheel").remove();
      },
    });
  } else {
    $("#documentInfoModal").modal("show");
  }
}

function htmlToElement(html) {
  var template = document.createElement("template");
  html = html.trim(); // Never return a text node of whitespace as the result
  template.innerHTML = html;
  return template.content.firstChild;
}

function iOSMinHeightCorrection() {
  if (
    !SalesToolkit.CrossPlatform.enabled ||
    !SalesToolkit.CrossPlatform.isIOS()
  )
    return;

  if (
    window.location.href.indexOf("viewForm.html") >= 0 ||
    document.body.classList.contains("module-previewForm")
  )
    return;

  // --- Calculate Heights, defaulting to 0 if element is missing or undefined. ---
  const pageContentHeight = $(".page-content").height() || 0;
  const pageFooterHeight = $(".page-footer").height() || 0;
  const portletTitleHeight =
    $("#main-panel .portlet.light > .portlet-title").height() || 0;
  const breadcrumbsHeight =
    $(
      "#main-panel .portlet.light > .portlet-body > .breadcrumbsBackButton"
    ).height() || 0;

  let panelMinHeight =
    pageContentHeight -
    pageFooterHeight -
    portletTitleHeight -
    breadcrumbsHeight -
    10; // Base constant offset

  // Check if current page is the Favourites module
  const isFavouritesModule =
    window.location.href.indexOf("favourites.html") >= 0 ||
    document.body.classList.contains("module-favourites");

  // Check if current page is the Index module with Cart active
  const isIndexModuleCart =
    window.location.href.indexOf("startingModule=cart") >= 0;

  // --- Initial Offset Adjustment ---
  // The original check was complex, simplify with direct conditions:
  if (window.location.href.indexOf("index.html") < 0 && !isIndexModuleCart) {
    // This is for non-index/non-cart pages like Favourites or Profile
    panelMinHeight -= 20;
  }

  try {
    if (screen.width > 767) {
      panelMinHeight -= 50;
    }

    // --- Apply Correction to Main Panel ---
    $("#main-div-center > .row .portlet.light .portlet-body > .row").attr(
      "style",
      "min-height:" + panelMinHeight + "px !important"
    );
    $("#main-div-center > .row .portlet.light .portlet-body").attr(
      "style",
      "min-height: unset !important"
    );

    // --- Module-Specific Adjustments ---

    if (!document.body.classList.contains("kioskMode") && (document.body.classList.contains("module-previewAsset") ||
      window.location.href.indexOf("viewAsset.html") >= 0)
    ) {
      panelMinHeight += 20;
      $("#main-div-center > .row .portlet.light .portlet-body > .row").attr(
        "style",
        "min-height:" +
          panelMinHeight +
          "px !important; height:" +
          panelMinHeight +
          "px !important"
      );
    }

    // Favourites Screen Specific Logic (Use the determined flag)
    if (isFavouritesModule) {
      panelMinHeight -= 50;
      $("#main-div-center > .row .portlet.light .portlet-body > .row").attr(
        "style",
        "min-height:" + panelMinHeight + "px !important"
      );
    }

    if (window.location.href.indexOf("extra_profile.html") >= 0) {
      panelMinHeight -= 110;
      $(
        "#main-div-center > .row .portlet.light .portlet-body .tab-content"
      ).attr("style", "min-height: " + panelMinHeight + "px !important");
    }
  } catch (err) {
    console.error("Error applying iOS Min Height correction:", err);
  }
}

$(function () {
  if (
    SalesToolkit.CrossPlatform.enabled &&
    SalesToolkit.CrossPlatform.isIOS()
  ) {
    iOSMinHeightCorrection();

    window.addEventListener(
      "resize",
      function (event) {
        setTimeout(function () {
          iOSMinHeightCorrection();
        }, 500);
      },
      true
    );
  }
});

function setKioskMode() {
  if (document.body.classList.contains("module-index")) {
    document.dispatchEvent(
      new CustomEvent(SalesToolkitApplication.Events.SET_KIOSK_MODE)
    );
    return;
  }

  if (typeof salestoolkitAsset !== "undefined") {
    setKioskModeForCollection(
      SalesToolkit.Library.assets[salestoolkitAssetId].containedBy
    );
    return;
  }

  setKioskModeForHome();
}

function setKioskModeForHome() {
  if (SalesToolkit.Theme.getBooleanProperty("kioskMode", false)) {
    enableKioskMode();
  } else {
    disableKioskMode();
  }
}

function setKioskModeForCollection(collectionId) {
  if (collectionId) {
    if (
      SalesToolkit.Library.collections[collectionId].theme &&
      SalesToolkit.Library.collections[collectionId].theme.properties.kioskMode
    ) {
      if (
        SalesToolkit.Library.collections[collectionId].theme.properties
          .kioskMode == "true"
      ) {
        enableKioskMode();
      } else {
        disableKioskMode();
      }
      return;
    }
  }

  setKioskModeForHome();
}

function isKioskMode() {
  return $("body").hasClass("kioskMode");
}

// enabling kiosk mode
function enableKioskMode() {
  $("body").addClass("kioskMode");

  $("body").removeClass("showTitleOnKiosk");
  $("body").removeClass("showTopBarOnKiosk");
  $("body").removeClass("showMenuOnKiosk");
  $("body").removeClass("showTreeViewOnKiosk");
  $("body").removeClass("showBreadcrumbsOnKiosk");
  $("body").removeClass("showFooterOnKiosk");
  //$(".closeKioskModeWrapper").hide();
  $("#closeKioskMode").removeClass("show");

  if (SalesToolkit.Theme.getBooleanProperty("showTitleOnKiosk", false)) {
    $("body").addClass("showTitleOnKiosk");
  }

  if (SalesToolkit.Theme.getBooleanProperty("showTopBarOnKiosk", false)) {
    $("body").addClass("showTopBarOnKiosk");
  }

  if (SalesToolkit.Theme.getBooleanProperty("showMenuOnKiosk", false)) {
    $("body").addClass("showMenuOnKiosk");
  }

  if (SalesToolkit.Theme.getBooleanProperty("showTreeViewOnKiosk", false)) {
    $("body").addClass("showTreeViewOnKiosk");
  }

  if (SalesToolkit.Theme.getBooleanProperty("showBreadcrumbsOnKiosk", false)) {
    $("body").addClass("showBreadcrumbsOnKiosk");
  }

  if (SalesToolkit.Theme.getBooleanProperty("showFooterOnKiosk", false)) {
    $("body").addClass("showFooterOnKiosk");
  }

  if (SalesToolkit.Theme.getBooleanProperty("showExitKioskButton", false)) {
    $(".closeKioskModeWrapper").show();
    $("#closeKioskMode").addClass("show");
  }

  //Show actions for Cart screen

  if (
    (window.location.href.indexOf("index.html") > 0 &&
      $("body").hasClass("module-cart")) ||
    window.location.href.indexOf("cart.html") > 0 ||
    window.location.href.indexOf("viewForm.html") >= 0 ||
    document.body.classList.contains("module-previewForm")
  ) {
    $("body").addClass("showActionsOnKiosk");
  }
}

// disabling kiosk mode
function disableKioskMode() {
  if (!isKioskMode()) {
    return;
  }

  if (SalesToolkit.Theme.getBooleanProperty("autoPreviewSingleAssets", false)) {
    if (window.location.href.indexOf("viewAsset.html") >= 0) {
      window.location.href = "index.html?viewAssetBackButton=true";
    } else if (document.body.classList.contains("module-previewAsset")) {
      SalesToolkitApplication.navigator.loadIndexScreen();
    }
  }

  $("body").removeClass("kioskMode");
  $("body").removeClass("showTitleOnKiosk");
  $("body").removeClass("showTopBarOnKiosk");
  $("body").removeClass("showTreeViewOnKiosk");
  $("body").removeClass("showBreadcrumbsOnKiosk");
  $("body").removeClass("showFooterOnKiosk");

  //$(".closeKioskModeWrapper").hide();
  $("#closeKioskMode").removeClass("show");
  $(".kiosk-override").removeClass("kiosk-override");
}

//hidden button for disabling kiosk mode
var onlongtouch;
var timer;
var touchduration = 5000;
var exitKioskButton = document.getElementById("closeKioskMode");

function touchstart() {
  //e.preventDefault();
  if (!timer) {
    timer = setTimeout(onlongtouch, touchduration);
  }
}

function touchend() {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
}

onlongtouch = function () {
  timer = null;
  disableKioskMode();
};

var eventsIn = ["mousedown", "touchstart"];
var eventsOut = ["mouseup", "touchend"];

eventsIn.forEach(function (name) {
  if (exitKioskButton) {
    exitKioskButton.addEventListener(name, touchstart, false);
  }
});

eventsOut.forEach(function (name) {
  if (exitKioskButton) {
    exitKioskButton.addEventListener(name, touchend, false);
  }
});

//navigate to asset popup
var tree = document.createDocumentFragment();

var container = document.createElement("div");
container.setAttribute("id", "assetModal");
//container.setAttribute("display", "none");

var closeButton = document.createElement("span");
closeButton.setAttribute("id", "assetModalClose");
// closeButton.setAttribute("width", "100%");
// closeButton.setAttribute("height", "5%");
//closeButton.setAttribute("display", "none");
closeButton.appendChild(document.createTextNode("Close"));

var link = document.createElement("embed");
link.setAttribute("width", "100%");
link.setAttribute("height", "100%");
//link.setAttribute("display", "none");

container.appendChild(closeButton);
container.appendChild(link);
tree.appendChild(container);
document.body.appendChild(tree);

$("#assetModalClose").click(function () {
  link.setAttribute("src", "");
  container.removeAttribute("class", "show");
});

//Screen saver functionality
var attractorShown = false;
var secondsSinceLastActivity = 0;
var myInterval;

$(document).on(
  "mousedown mousemove mouseup click  touchend touchmove keydown keyup wheel",
  function () {
    resetScreensaver();
  }
);

function resetScreensaver() {
  secondsSinceLastActivity = 0;

  if (
    attractorShown &&
    !SalesToolkit.Theme.getBooleanProperty(
      "requireBadgeScanToExitAttractor",
      false
    )
  ) {
    // normally any kind of activity is enough to exit the attractor
    hideFullScreenAttractor();
    attractorShown = false;
  } else if (
    SalesToolkit.Theme.getBooleanProperty(
      "requireBadgeScanToExitAttractor",
      false
    )
  ) {
    $("#attractorControls").css("display", "flex");
  }
}

function handleInactivityTriggered() {
  if (
      SalesToolkit.Theme.getBooleanProperty("alwaysGoBackHomeOnTimeout", true)
    ) {
      if (!document.URL.includes("index.html")) {
        SalesToolkitApplication.navigator.loadIndexScreen(false, false, undefined, true, false, false, undefined, true);
      }
    }

    var currentAsset;
    if (typeof salestoolkitAssetId !== "undefined") {
      currentAsset = SalesToolkit.Library.assets[salestoolkitAssetId];
      if (currentAsset != null && currentAsset.contentMimetype == "text/html") {
        var iframe = $("iframe.presentation")[0];
        if (iframe) {
          iframe.contentWindow.postMessage(
            {
              event_id: "trackTimeout",
            },
            "*"
          );
        }
      }
    }

    secondsSinceLastActivity = 0;

    removeUserDetails();

    trackContactSessionEnd(
      SalesToolkit.Translation.get(
        "sessionEndFromTimeout",
        "sessionEndFromTimeout"
      )
    );

    try {
      SalesToolkit.Cart.assetIds = [];
      SalesToolkit.Cart.collectionIds = [];
      SalesToolkit.Cart.saveToStorage();
      SalesToolkit.UI.Cart.updateMenuCartBadge();

      SalesToolkit.Cart.empty(function () {
        SalesToolkit.UI.Cart.updateMenuCartBadge();
      });
    } catch (err) {}

     if (
      SalesToolkit.Session.sessionId &&
      ["activity", "auto", "automatic", "on"].indexOf(
        SalesToolkit.Theme.getStringProperty("sessionTracking", "off")
      ) != -1
    ) {
      endSession();
    }
}

function handleInactivity(forceInactivity = false) {
  if (SalesToolkit.debug) $("#debugText").empty();

  if (!SalesToolkit.User.isLoggedIn) {
    return;
    // if not logged in, return early as we can't get to the home screen
  }

  var showAttractor = false;
  var homeScreenTimeout = -1;

  homeScreenTimeout = parseInt(
    SalesToolkit.Theme.getProperty("idleTimeout", "-1")
  );
  showAttractor = SalesToolkit.Theme.getBooleanProperty(
    "showAttractorOnTimeout",
    true
  );

  if (isNaN(homeScreenTimeout)) {
    homeScreenTimeout = -1;
    showAttractor = false;
  }

  if (
    $(".currentSection").is("#videoSection") &&
    $("#videoSection .assetPreviewMedia.media-playing").length > 0
  ) {
    // do not time out to the home screen while the video is playing
    homeScreenTimeout = -1;
    showAttractor = false;
    if (
      SalesToolkit.Theme.getBooleanProperty(
        "hideAttractorControlsOnInactivity",
        true
      )
    ) {
      $("#attractorControls").css("display", "none");
    }
  }

  if ($("#syncInfo").is(":visible")) {
    // do not time out to the home screen while syncing
    homeScreenTimeout = -1;
    showAttractor = false;
  }

  if (
    forceInactivity ||
    (homeScreenTimeout > 0 &&
      secondsSinceLastActivity >= homeScreenTimeout)
  ) {
    

    if ($(".fullscreen-video").length == 0 && showAttractor) {
      transitionAttractor("default");
    }else if(!showAttractor){
      handleInactivityTriggered();
    }
  }

  if (SalesToolkit.debug) {
    console.log(
      "Time Since Last Activity: " +
        (secondsSinceLastActivity >= 60
          ? parseInt(secondsSinceLastActivity / 60) + "m "
          : "") +
        (secondsSinceLastActivity % 60) +
        "s"
    );

    $("#debugText").append(
      "<span>Time Since Last Activity: " +
        (secondsSinceLastActivity >= 60
          ? parseInt(secondsSinceLastActivity / 60) + "m "
          : "") +
        (secondsSinceLastActivity % 60) +
        "s"
    );
  }

  secondsSinceLastActivity += 1;
}

function setupMQTTWebSocket(username,password,clientId,ip,port,topicName, mqttProximityAttractorDelay){
      const url = `wss://${ip}:${port}`;
      const keepalive = 20; // seconds


      if(!url){ 
        console.error('Broker WebSocket URL is required');
        return;
      }

      try{ 
        if(client) { 
          client.end(true); 
          client = null; 
        } 
      } catch(_){

      }

      client = mqtt.connect(url, {
        clientId,
        keepalive,
        username,
        password,
        clean: true,
        reconnectPeriod: 3000, // ms
        connectTimeout: 10_000,
      });

      client.on('connect', () => {
        client.subscribe(topicName, { qos: 0 }, (err)=>{
          if(err){ 
            setStatus(true, ''); 
            console.error('Connection error:'+err); 
          }
        });
      });

      client.on('reconnect', ()=> console.log('Reconnecting…'));
      
      client.on('close', ()=> { 
        console.log('Disconnected'); 
      });

      client.on('error', (e)=> { 
        console.error(e); 
      });

      client.on('offline', () => {
        console.error('MQTT Client is offline. Check network connection or broker status.');
    });

      client.on('message', async (topic, payloadBuf, packet)=>{
        const payload = parseMQTTPayloadToJson(payloadBuf);

        console.log("Message received--> Topic:" + topic + " payload: " + JSON.stringify(payload));
        if(payload.occupancy===true){
          if (mqttProximityAttractorDelay >0) {
            setTimeout(function() {
                showProximityAttractor();
                if (SalesToolkit.debug) {
                  console.log("Show Attractor after delay of " + mqttProximityAttractorDelay + " ms");
                }
            }, mqttProximityAttractorDelay);
          } else {
            showProximityAttractor();
            if (SalesToolkit.debug) {
              console.log("Show Attractor immediately");
            }
          }
        } else if (payload.action=="1_single"){
          showDefaultAttractor();
        } else if (payload.action=="2_single") {
          showProximityAttractor();
        } else if (payload.action=="3_single") {
          hideFullScreenAttractor();
        }
        trackWebsocketMessageReceived(username,password,clientId,ip,port,topicName,payload)


      });
}

function parseMQTTPayloadToJson(payload){
  const text = new TextDecoder().decode(payload);
      try { 
        return JSON.parse(text); 
      } catch(_) { 
        return text;
      }
}

document.addEventListener("DOMContentLoaded", function() {
    let inactivity = SalesToolkit.Pages.CurrentPage.getQueryParam("triggerAttractor");
    if (typeof inactivity === "string" && inactivity == "true") {
        handleInactivity(true);
    }
});
//window.setInterval(handleInactivity, 1000);

if (SalesToolkit.Theme.getBooleanProperty("detectInactivity", false))
  if (myInterval) {
    clearInterval(myInterval); // Stop the old interval
  }
  myInterval = setInterval(handleInactivity, 1000);
  if (SalesToolkit.debug){
    console.log('setting interval for handleInactivity in readyfunction()');
  }

if (SalesToolkit.Theme.getBooleanProperty("enableMQTTSocket", false)) {
  const mqttIP = SalesToolkit.Theme.getStringProperty("mqttBrokerIP", "localhost");
  const mqttPort = SalesToolkit.Theme.getStringProperty("mqttBrokerPort", "8083");
  const mqttTopic = SalesToolkit.Theme.getStringProperty("mqttTopicName", "attractor/control");
  const mqttUsername = SalesToolkit.Theme.getStringProperty("mqttUsername", "");
  const mqttPassword = SalesToolkit.Theme.getStringProperty("mqttPassword", "");
  const mqttClientId = SalesToolkit.Theme.getStringProperty("mqttClientId", "");
  const mqttProximityAttractorDelay = SalesToolkit.Theme.getStringProperty("mqttProximityAttractorDelay", "0");;
  setupMQTTWebSocket(mqttUsername, mqttPassword, mqttClientId, mqttIP, mqttPort, mqttTopic, mqttProximityAttractorDelay);
}

function setupAttractorControls() {
  //TODO SETUP QR SCANNER
  // --- MODIFIED LINE ---
  let fullscreenAttractorHolder = $(".fullscreen-attractor");
  if (fullscreenAttractorHolder.length === 0) return;

  let holderStyleOverrides = SalesToolkit.Theme.getStringProperty(
    "attractorControlsWrapperStyle",
    "width:auto; padding:20px; height:auto; background:white; border-radius:10px"
  );
  let holderStyle = " style='" + holderStyleOverrides + "'";

  // --- MODIFIED LINE ---
  fullscreenAttractorHolder.append(
    "<div id='attractorControls'><div id='attractorControlsWrapper' " +
      holderStyle +
      "></div></div>"
  );

  let buttonStyleOverrides = SalesToolkit.Theme.getStringProperty(
    "attractorButtonStyle",
    "width:100%; height:auto; font-size:3rem"
  );

  let buttonStyle = " style='" + buttonStyleOverrides + "'";

  if (SalesToolkit.Theme.getBooleanProperty("allowQRCodeAttractorEnd", true)) {
    $("#attractorControlsWrapper").append(
      "<button class='btn salestoolkit-blue btn-primary' " +
        buttonStyle +
        " onclick='openPrefillQRModal()'>" +
        SalesToolkit.Translation.get("qrAttractorButton", "Scan User QR") +
        "</button>"
    );
  }

  if (
    SalesToolkit.Theme.getBooleanProperty("allowGuestAccessAttractorEnd", true)
  ) {
    $("#attractorControlsWrapper").append(
      "<button class='btn salestoolkit-blue btn-primary' " +
        buttonStyle +
        " onclick='accessAsGuest()'>" +
        SalesToolkit.Translation.get(
          "guestAccessAttractorButton",
          "Browse as a guest"
        ) +
        "</button>"
    );
  }
}

function accessAsGuest() {
  hideFullScreenAttractor();
  attractorShown = false;
}

function showFullScreenMutedLoopingVideo(src, withInvisibleTextBoxOverlay) {
  $(":focus").blur();
  $("body").append(
    '<div class="fullscreen fullscreen-video" style="opacity: 0">' +
      '<video playsinline autoplay muted loop preload="auto" src="' +
      src +
      '" oncontextmenu="return false;" controlsList="nodownload"></video>' +
      (withInvisibleTextBoxOverlay
        ? '<div class="invisible-textbox" style="opacity:0.00001; position: absolute; top: 50%; left: 50%; width: 100vw; height: 100vw; cursor: default; transform: translate(-50%,-50%);"></div>'
        : "") +
      "</div>"
  );
  $(".fullscreen-video").animate({ opacity: 1 }, 250);
  if (withInvisibleTextBoxOverlay) {
    invisibleTextBoxEventHandlerEnabled = true;
    setupAttractorControls();
  }
}

var bufferedAttractors = {};

/**
 * Fetches and buffers a single attractor file.
 * @param {string} themeKey - The theme property key (e.g., 'attractorSrc').
 * @param {string} storageKey - The key to store this file under (e.g., 'default').
 * @param {function} callback - A function to call on completion.
 */
function bufferSingleAttractor(themeKey, storageKey, callback) {
  let attractorSrc = SalesToolkit.Theme.getCollectionProperty(null, themeKey);
  if (!attractorSrc) {
    if (callback) callback(false);
    return;
  }

  // Check if it's already buffered
  if (
    bufferedAttractors[storageKey] &&
    bufferedAttractors[storageKey].src === attractorSrc
  ) {
    if (callback) callback(true);
    return;
  }

  console.log("Buffering attractor: " + storageKey);
  var xhr = new XMLHttpRequest();
  if (SalesToolkit.CrossPlatform && SalesToolkit.CrossPlatform.enabled)
    xhr.open("GET", SalesToolkit.CrossPlatform.rewriteURL(attractorSrc));
  else xhr.open("GET", SalesToolkit.Proxy.rewriteURL(attractorSrc));
  xhr.responseType = "blob";

  xhr.onload = function () {
    const blobUrl = URL.createObjectURL(xhr.response);
    const mimetype = xhr.response.type;
    bufferedAttractors[storageKey] = { src: attractorSrc, blobUrl, mimetype };
    console.log("Attractor buffered: " + storageKey);
    if (callback) callback(true);
  };

  xhr.onerror = function () {
    console.error("Failed to buffer attractor: " + storageKey);
    if (callback) callback(false);
  };

  xhr.send();
}

/**
 * Kicks off the buffering for all configured attractors on page load.
 * We add 'attractorProximity' as the new theme key for the sensor.
 */
function initializeAttractorBuffers() {
  if (window.location.href.indexOf("login") >= 0) {
    console.log("Skipping attractor buffering on login page.");
    return;
  }
  // Buffers the main inactivity attractor
  bufferSingleAttractor("attractorSrc", "default", () => {});

  // Buffers the new proximity sensor attractor
  // (You will need to add this 'attractorProximity' key to your theme)
  bufferSingleAttractor("attractorProximity", "proximity", () => {});
}

/**
 * Helper to get data for a buffered attractor.
 * @param {string} storageKey - The key of the attractor to get (e.g., 'default').
 */
function getBufferedAttractor(storageKey) {
  return bufferedAttractors[storageKey] || null;
}

/**
 * Gets the correct CSS class for a given mimetype.
 * @param {string} mimetype
 * @returns {string}
 */
function getAttractorClass(mimetype) {
  if (mimetype.startsWith("video/")) {
    return "attractor-video";
  } else if (mimetype.startsWith("image/")) {
    return "attractor-image";
  } else if (mimetype === "text/html") {
    return "attractor-html";
  }
  return "attractor-unknown";
}

/**
 * Creates the HTML string for a given attractor media.
 * @param {string} src
 * @param {string} mimetype
 * @returns {string}
 */
function createAttractorMedia(src, mimetype) {
  if (mimetype.startsWith("video/")) {
    return `<video class="attractor-media" playsinline autoplay muted loop preload="auto" src="${src}" oncontextmenu="return false;" controlsList="nodownload"></video>`;
  } else if (mimetype.startsWith("image/")) {
    return `<img class="attractor-media" src="${src}" alt="Attractor Screen" />`;
  } else if (mimetype === "text/html") {
    return `<iframe class="attractor-media" src="${src}" frameborder="0" oncontextmenu="return false;"></iframe>`;
  }
  return "";
}

/**
 * Shows the attractor screen. This can be a video, image, or HTML file.
 * @param {string} src - The blob URL of the content to display.
 * @param {string} mimetype - The mimetype of the content (e.g., 'video/mp4', 'image/gif', 'text/html').
 * @param {boolean} withInvisibleTextBoxOverlay - Whether to add the overlay for badge scanning.
 * @param {string} attractorType - The key for this attractor (e.g., 'default', 'proximity').
 */
function showFullScreenAttractor(
  src,
  mimetype,
  withInvisibleTextBoxOverlay,
  attractorType
) {
  $(":focus").blur();

  const mediaTypeClass = getAttractorClass(mimetype);
  const contentHtml = createAttractorMedia(src, mimetype);

  const overlayHtml = withInvisibleTextBoxOverlay
    ? '<div class="invisible-textbox" style="opacity:0.00001; position: absolute; top: 50%; left: 50%; width: 100vw; height: 100vw; cursor: default; transform: translate(-50%,-50%);"></div>'
    : "";

  // Add the data-attractor-type attribute
  const newAttractorHtml = 
      `<div class="fullscreen fullscreen-attractor ${mediaTypeClass}" data-attractor-type="${attractorType}" style="opacity: 0">
          ${contentHtml}
          ${overlayHtml}
      </div>`;
  
  $("body").append(newAttractorHtml);

  const $newAttractor = $(`.fullscreen-attractor[data-attractor-type="${attractorType}"]`).last();
  if (attractorType === 'proximity') {
      $newAttractor.data('attractor-shown-at', Date.now());
  }

  $(".fullscreen-attractor").animate({ opacity: 1 }, 250);

  const hasControls = SalesToolkit.Theme.getBooleanProperty(
    "attractorHasControls",
    false
  );
  const isHtml = mimetype === "text/html";

  if (hasControls && isHtml) {
    // Add class to body to allow CSS to re-enable pointer events
    $("body").addClass("allowAttractorControls");
    //The attractor is responsible for its own cleanup / closing itself by calling window.parent.hideFullScreenAttractor()
  } else {
    $(".fullscreen-attractor").on(
      "mousedown mousemove mouseup click touchstart touchend touchmove keydown keyup wheel",
      resetScreensaver
    );
  }

  if (withInvisibleTextBoxOverlay) {
    invisibleTextBoxEventHandlerEnabled = true;
    setupAttractorControls();
  }
}

/**
 * Handles the logic of showing or transitioning between attractors.
 * @param {string} toType - The key of the attractor to show ('default' or 'proximity').
 */
function transitionAttractor(toType, forceTransition = false) {
    const $existing = $(".fullscreen-attractor");
    const existingType = $existing.data('attractor-type');

    if (toType === 'default' && existingType === 'proximity' && !forceTransition) {
        
        // 1. Get the new theme key. Default to 0 (immediate override) if not set.
        const proximityTimeout = SalesToolkit.Theme.getIntegerProperty("proximityAttractorTimeoutMS", -1);

        if(proximityTimeout == -1)
        {
          console.log("Proximity is showing - transition to default attractor is up to proximity controller.");
          return;
        }
        // 2. Get the timestamp when the proximity attractor was shown.
        const proximityShownAt = $existing.data('attractor-shown-at');

        if (proximityShownAt) {
            // 3. Check if enough time has passed.
            const elapsed = Date.now() - proximityShownAt;
            if (elapsed < proximityTimeout) {
                // Not enough time has passed. ABORT the transition to 'default'.
                console.log(`Inactivity timer blocked. Proximity attractor has only been active for ${elapsed}ms (timeout is ${proximityTimeout}ms).`);
                return; // Stop the function here.
            }
            // Enough time has passed. Log it and let the function proceed.
            console.log(`Inactivity timer overriding proximity. Proximity was active for ${elapsed}ms.`);
        }
        // If proximityShownAt is missing for some reason, just let it proceed.
    }
    // 1. Don't do anything if the correct attractor is already showing
    if (existingType === toType) {
        return;
    }

    if (toType === 'default') {
        handleInactivityTriggered();
    }

    // 2. Get the buffered data for the attractor we want to show
    const attractorData = getBufferedAttractor(toType);
    if (!attractorData) {
        console.warn('No attractor buffered for: ' + toType);
        return;
    }

    // 3. Determine control state for the NEW attractor
    const newHasControls = SalesToolkit.Theme.getBooleanProperty("attractorHasControls", false);
    const newIsHtml = (attractorData.mimetype === 'text/html');
    const newRequiresControls = (newHasControls && newIsHtml);


    if ($existing.length > 0) {
        // --- CASE A: An attractor is already visible. Transition seamlessly. ---
        
        // Find the old media and fade it out
        $existing.find('.attractor-media').animate({ opacity: 0 }, 150, function() {
            $(this).remove(); // Remove old media after it's invisible
            
            // Update wrapper's data and classes
            $existing.data('attractor-type', toType);

            if (toType === 'proximity') {
                $existing.data('attractor-shown-at', Date.now());
            } else {
                // We're switching to 'default', so clear the timestamp.
                $existing.removeData('attractor-shown-at');
            }
            
            $existing.removeClass('attractor-video attractor-image attractor-html attractor-unknown');
            
            // Get and add new media
            const mediaTypeClass = getAttractorClass(attractorData.mimetype);
            const contentHtml = createAttractorMedia(attractorData.blobUrl, attractorData.mimetype);
            
            $existing.addClass(mediaTypeClass);
            
            // Add new media and fade it in
            const $newMedia = $(contentHtml).css('opacity', 0);
            $existing.prepend($newMedia);
            $newMedia.animate({ opacity: 1 }, 150);

            // Now, update the body class and event listeners for the wrapper
            if (newRequiresControls) {
                // New attractor IS interactive HTML
                $("body").addClass("allowAttractorControls");
                $existing.off("mousedown mousemove mouseup click touchstart touchend touchmove keydown keyup wheel", resetScreensaver);
            } else {
                // New attractor is NOT interactive (e.g., video)
                $("body").removeClass("allowAttractorControls");
                // Re-bind the listener, making sure to remove any old one first
                $existing.off("mousedown mousemove mouseup click touchstart touchend touchmove keydown keyup wheel", resetScreensaver) 
                         .on("mousedown mousemove mouseup click touchstart touchend touchmove keydown keyup wheel", resetScreensaver);
            }
            // --- END CRITICAL NEW LOGIC ---
        });
    } else {
        // --- CASE B: No attractor is visible. Just show the new one. ---
        // This case is already handled correctly by showFullScreenAttractor
        showFullScreenAttractor(
            attractorData.blobUrl,
            attractorData.mimetype,
            SalesToolkit.Theme.getBooleanProperty("requireBadgeScanToExitAttractor", false),
            toType // Pass the type
        );
    }
    
    // Make sure the global state is set
    attractorShown = true;
}

/**
 * PUBLIC FUNCTION: Call this to trigger the proximity attractor.
 */
function showProximityAttractor() {
  if (isDefaultAttractorShowing()){
      transitionAttractor("proximity");
  }
}
// Make the function globally available
window.showProximityAttractor = showProximityAttractor;

/**
 * PUBLIC FUNCTION: Call this to trigger the proximity attractor.
 */
function showDefaultAttractor() {
  transitionAttractor("default", true);
}
// Make the function globally available
window.showDefaultAttractor = showDefaultAttractor;

/**
 * Hides the full screen attractor and cleans up.
 */
function hideFullScreenAttractor() {
  $("body").removeClass("allowAttractorControls");
  if (myInterval) {
    clearInterval(myInterval); // Stop the old interval
  }
  myInterval = setInterval(handleInactivity, 1000);
  if (SalesToolkit.debug){
    console.log('setting interval for handleInactivity in HideFullScreenAttractor()');
  }
  // Target the new base class
  $(".fullscreen-attractor")
    .css("pointer-events", "none")
    .animate({ opacity: 0 }, 250);
  setTimeout(function () {
    $(".fullscreen-attractor").remove(); // Target new base class
    valueInInvisibleTextBox = "";
    refreshOnTimeout();
  }, 250);
  valueInInvisibleTextBox = "";
  invisibleTextBoxEventHandlerEnabled = false;
}

function hideFullScreenVideo() {
  if (myInterval) {
    clearInterval(myInterval); // Stop the old interval
  }
  myInterval = setInterval(handleInactivity, 1000);
  if (SalesToolkit.debug){
    console.log('setting interval for handleInactivity in HideFullSreenVideo()');
  }
  $(".fullscreen-video")
    .css("pointer-events", "none")
    .animate({ opacity: 0 }, 250);
  setTimeout(function () {
    $(".fullscreen-video").remove();
    valueInInvisibleTextBox = "";
    refreshOnTimeout();
  }, 250);
  valueInInvisibleTextBox = "";
  invisibleTextBoxEventHandlerEnabled = false;
}

function isDefaultAttractorShowing(){
  const $existing = $(".fullscreen-attractor");
  const existingType = $existing.data('attractor-type');
  return existingType === 'default';

}

function isProximityAttractorShowing(){
  const $existing = $(".fullscreen-attractor");
  const existingType = $existing.data('attractor-type');
  return existingType === 'proximity';

}

function refreshOnTimeout() {
  //TODO maybe, add this to a theme key so it can be configure if you have to refresh
  //on timeout. For now, for html presentations we are going to refresh to the current presentation.
  var currentAsset;
  if (typeof salestoolkitAssetId !== "undefined") {
    currentAsset = SalesToolkit.Library.assets[salestoolkitAssetId];
    if (currentAsset != null && currentAsset.contentMimetype == "text/html") {
      location.reload();
    }
  }
}

function removeUserDetails() {
  let detailsLoaded = SalesToolkit.Forms.userDetails !== undefined;
  if(!detailsLoaded){
    return;
  }
  SalesToolkit.Forms.unloadUserDetails();
  try {
    trackContactSessionEnd(
      SalesToolkit.Translation.get(
        "sessionEndFromTopBar",
        "sessionEndFromTopBar"
      )
    );
    SalesToolkit.Cart.assetIds = [];
    SalesToolkit.Cart.collectionIds = [];
    SalesToolkit.Cart.saveToStorage();
    SalesToolkit.UI.Cart.updateMenuCartBadge();

    SalesToolkit.Cart.empty(function () {
      SalesToolkit.UI.Cart.updateMenuCartBadge();
    });

    if (
      SalesToolkit.Theme.getBooleanProperty(
        "returnUserToHomeOnUserDetailsRemoval",
        true
      )
    ) {
      let isHome =
        window.location.href.indexOf("index.html") >= 0 ||
        window.location.pathname == "/";
      if (!isHome) {
        let message = SalesToolkit.Translation.get(
          "prefillUnloadQRSuccessMessage",
          "Prefill details removed"
        );
        let title = SalesToolkit.Translation.get(
          "prefillUnloadQRSuccessTitle",
          "Goodbye!"
        );

        localStorage["notificationsToShow"] = JSON.stringify([
          { body: message, title: title, type: "info" },
        ]);
        SalesToolkitApplication.navigator.loadIndexScreen(false, false, undefined, true, false, false, undefined);
      } else {
        try {
          document.dispatchEvent(
            new CustomEvent(SalesToolkitApplication.Events.CLEAR_ALL_FILTERS, {
              detail: { hideFilters: false },
            })
          );
          document.dispatchEvent(
            new CustomEvent(SalesToolkitApplication.Events.CLEAR_SEARCH)
          );
          document.dispatchEvent(
            new CustomEvent(SalesToolkitApplication.Events.CALVIEW_BACK)
          );
          document.dispatchEvent(
            new CustomEvent(
              SalesToolkitApplication.Events.COLLECTION_BROWSER_SETPATH,
              {
                detail: { path: [] },
              }
            )
          );
        } catch (err) {}
      }
    }
  } catch (err) {}

  let message = SalesToolkit.Translation.get(
    "prefillUnloadQRSuccessMessage",
    "Prefill details removed"
  );
  let title = SalesToolkit.Translation.get(
    "prefillUnloadQRSuccessTitle",
    "Goodbye!"
  );

  applyThemeToImage(
    "salestoolkitHeaderIconQRPrefill",
    "#headerPrefillQRCode img.qr-prefill-icon",
    "img/default/Form_QR.svg"
  );

  SalesToolkit.UI.Notifications.showCustomNotification("info", message, title);

  if (typeof SalesToolkitApplication !== "undefined") {
    SalesToolkitApplication.userDetailsRemoved();
  }

  if (
    SalesToolkit.Theme.getBooleanProperty("disableScanningUserQRCodes", true)
  ) {
    $("body").addClass("userQRScanDisabled");
  }

  updateContactSessionInfoPopup();
}

async function openPrefillQRModal(backgroundReading = false) {
  if (typeof window.qrPrefillReader === "undefined") {
    window.prefillHtml5QrCode = new Html5Qrcode(
      /* element id */ "prefill-barqrcode"
    );
  }

  trackAppClick(
    $("#headerPrefillQRCode"),
    "#headerPrefillQRCode",
    "trackingPrefillCameraModal",
    SalesToolkit.Translation.get(
      "trackingPrefillCameraModal",
      "trackingPrefillCameraModal"
    )
  );

  if (typeof SalesToolkit.Forms.userDetails !== "undefined") {
    if (
      typeof vPopup !== "undefined" &&
      SalesToolkit.Theme.getBooleanProperty(
        "showConfirmationForSessionEnd",
        true
      )
    ) {
      let message = SalesToolkit.Translation.getOrGetThemeKey(
        "endSessionAreYouSureMessage",
        "This will end the current session."
      );

      if (!SalesToolkit.Cart.isEmpty()) {
        message = SalesToolkit.Translation.getOrGetThemeKey(
          "endSessionAreYouSureCartMessage",
          "Cart is not empty! This will end the current session and remove all cart items."
        );
      }

      vPopup.create({
        title: SalesToolkit.Translation.getOrGetThemeKey(
          "endSessionAreYouSureTitle",
          "Are you sure?"
        ),
        message: message,
        buttons: [
          {
            action: "YES",
            text: atheneumInstance.Translation.getOrGetThemeKey("yes", "Yes"),
            callback: function () {
              removeUserDetails();
            },
          },
          {
            action: "NO",
            text: atheneumInstance.Translation.getOrGetThemeKey("no", "No"),
            callback: function () {},
          },
        ],
      });
    } else {
      removeUserDetails();
    }

    return;
  }

  $("#prefill-scan-info").hide();
  $("#prefill-scan-info").text("");

  let prefillQrCodeSuccessCallback = async (
    decodedText,
    decodedResult,
    error = false
  ) => {
    /* handle success */
    try {
      if (error) {
        var notificationBody = SalesToolkit.Translation.get(
          "notificationPrefillError",
          "No camera found or error ocurred starting the reader. " +
            (decodedText?.message || "")
        );
        SalesToolkit.UI.Notifications.showCustomNotification(
          "info",
          notificationBody
        );
        $("#prefillCameraModal").modal("hide");
        return;
      }
      let userDetails = JSON.parse(atob(decopreloadUdedText));

      let result = SalesToolkit.Forms.preloadUserDetails(userDetails);

      hideFullScreenAttractor();

      attractorShown = false;

      if (!result) {
        let message = SalesToolkit.Translation.get(
          "prefillQRNotValidErrorMessage",
          "Details could not be loaded, the scanned qr code does not seems to be the right format."
        );
        $("#prefill-scan-info").html(message);
        $("#prefill-scan-info").css("display", "block");
        return;
      }

      trackContactSessionStart(
        SalesToolkit.Translation.get("sessionStartFromQR", "sessionStartFromQR")
      );

      let message = SalesToolkit.Translation.get(
        "prefillQRSuccessMessage",
        "Details loaded succesfully"
      );
      let title = SalesToolkit.Translation.get(
        "prefillQRSuccessTitle",
        "Welcome!"
      );

      SalesToolkit.UI.Notifications.showCustomNotification(
        "info",
        message,
        title
      );

      applyThemeToImage(
        "salestoolkitHeaderIconQRPrefillCancel",
        "#headerPrefillQRCode img.qr-prefill-icon",
        "img/default/Form_QR.svg"
      );

      stopPrefillCamera();
    } catch (err) {
      let message = SalesToolkit.Translation.get(
        "prefillQRErrorMessage",
        "Details could not be loaded, please check with a representative and try again or browse as a guest."
      );

      $("#prefill-scan-info").html(message);
      $("#prefill-scan-info").css("display", "block");
    }
  };

  const config = {
    fps: 10,
    qrbox: {
      width: SalesToolkit.Theme.getIntegerProperty("prefillScanAreaWidth", 300),
      height: SalesToolkit.Theme.getIntegerProperty(
        "prefillScanAreaHeight",
        300
      ),
    },
  };
  let cameraMode = SalesToolkit.Theme.getStringProperty(
    "attractorQRCameraMode",
    "environment"
  );
  // If you want to prefer front camera
  prefillHtml5QrCode.start(
    { facingMode: cameraMode },
    config,
    prefillQrCodeSuccessCallback
  );

  if (backgroundReading) {
    prefillHtml5QRCode.backgroundScanning = true;
    return;
  }

  prefillHtml5QRCode.backgroundScanning = false;

  $("#prefillCameraModal").modal("show");

  setTimeout(function () {
    if (SalesToolkit.Theme.getBooleanProperty("usePrefillScanOverlay", false)) {
      $("#prefillScanAreaDark").width($("#prefillCameraFeedVideo").width());
      $("#prefillScanAreaDark").height($("#prefillCameraFeedVideo").height());
      $("#prefillScanAreaDark").offset($("#prefillCameraFeedVideo").offset());

      $("#prefillScanAreaLight").width(
        SalesToolkit.Theme.getIntegerProperty("prefillScanAreaWidth", 300) +
          "px"
      );
      $("#prefillScanAreaLight").height(
        SalesToolkit.Theme.getIntegerProperty("prefillScanAreaHeight", 300) +
          "px"
      );

      $("#prefillScanAreaDark").show();
    }
  }, 500);
}

// TODO test background scanning if(SalesToolkit.Theme.getBooleanProperty('backgroundScanQRCodes', true)){
// 	openPrefillQRModal(true);
// }

function stopPrefillCamera() {
  $("#prefill-scan-info").hide();
  $("#prefill-scan-info").text("");
  $("#prefillCameraModal").modal("hide");
  try {
    prefillHtml5QrCode.stop();
  } catch (err) {}
}

async function scanFormPrefillQRCode() {
  try {
    let imageCrop = cardReader.getCropAreaImage(
      SalesToolkit.Theme.getIntegerProperty("scanAreaWidth", 300),
      SalesToolkit.Theme.getIntegerProperty("scanAreaHeight", 300)
    );
    let blob = await fetch(imageCrop).then((it) => it.blob());
    let imageFile = new File([blob], "scan", { type: "image/jpeg" });
    //attempt to scan the image file for qr codes or barcodes
    var decodedText = await html5QrCode.scanFile(imageFile, true);
    if (decodedText !== undefined && decodedText.length > 0) {
      var autoScanning = autoScan;

      SalesToolkit.Badges.lookup(decodedText, {
        success: function (badge) {
          $("#cameraModal").modal("hide");
          openShareModal();
          $("#basic").modal("show");

          populateFormWithBadgeData(
            $("#salestoolkit-email-addresses-div"),
            badge
          );
          populateFormWithBadgeData($("#salestoolkit-form-fields-div"), badge);

          $("#salestoolkit-form-fields-div")
            .find('input[data-type="BADGE"]')
            .val(decodedText);

          var notificationBody = SalesToolkit.Translation.get(
            "notificationCardReaderShareFilled",
            "Share form information updated"
          );
          SalesToolkit.UI.Notifications.showCustomNotification(
            "cart",
            notificationBody
          );
          stopCamera();
        },
        failure: function (reason, httpStatus, errorCode) {
          Atheneum.Callbacks.logFailureDetails(
            reason,
            httpStatus,
            errorCode,
            "Atheneum.Badges.lookup"
          );

          if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {
            var popupText = SalesToolkit.Theme.getStringProperty(
              "badgeScanOffline",
              "No internet connection available, please try again once a connection " +
                "has been established or complete the form manually. Thank you"
            );

            $("#scan-info").text(popupText);
            $("#scan-info").css("display", "block");
          } else {
            var errorCodeHex = undefined;
            if (typeof errorCode == "number") {
              errorCodeHex = errorCode.toString(16);
              while (errorCodeHex.length < 8) {
                errorCodeHex = "0" + errorCodeHex;
              }
            }
            var message = SalesToolkit.Translation.getOrGetThemeKey(
              "error" + errorCodeHex,
              SalesToolkit.Translation.get(
                "badgeScanError",
                "Ran into an error while scanning badge"
              )
            );
            if (
              SalesToolkit.Theme.getBooleanProperty(
                "includeErrorCodeForBadgeScan",
                true
              ) &&
              message ===
                SalesToolkit.Translation.get(
                  "badgeScanError",
                  "Ran into an error while scanning badge"
                )
            ) {
              message += " - " + errorCode;
            }

            $("#scan-info").text(message);
            $("#scan-info").css("display", "block");
          }

          if (autoScanning) {
            setTimeout(
              takeScan,
              SalesToolkit.Theme.getIntegerProperty(
                "timeBetweenAutoscans",
                100
              ),
              true
            );
          }
        },
        offline: function (reason, httpstatus, errorCode) {
          Atheneum.Callbacks.logFailureDetails(
            reason,
            httpStatus,
            errorCode,
            "Atheneum.Badges.lookup"
          );

          var popupText = SalesToolkit.Theme.getStringProperty(
            "badgeScanOffline",
            "No internet connection available, please try again once a connection " +
              "has been established or complete the form manually. Thank you"
          );

          $("#scan-info").text(popupText);
          $("#scan-info").css("display", "block");
          if (autoScanning) {
            setTimeout(
              takeScan,
              SalesToolkit.Theme.getIntegerProperty(
                "timeBetweenAutoscans",
                100
              ),
              true
            );
          }
        },
      });
    }

    return;
  } catch (err) {
    console.log("error trying to decode qr / bar code");
  }
}

$(function () {
  renderPendingNotifications();
});

function renderPendingNotifications() {
  let notifications = localStorage["notificationsToShow"];
  try {
    if (typeof notifications === "string")
      notifications = JSON.parse(notifications);
  } catch (err) {}
  if (!Array.isArray(notifications)) return;

  for (let i = 0; i < notifications.length; i++) {
    let notification = notifications[i];
    if (Array.isArray(notification)) notification = notification[0];
    if (notification.type == "cart") {
      SalesToolkit.UI.Notifications.showCustomNotification(
        "cart",
        notification.body
      );
    } else {
      SalesToolkit.UI.Notifications.showCustomNotification(
        "info",
        notification.body,
        notification.title
      );
    }
  }

  localStorage["notificationsToShow"] = "";
}

console.log(
  "salestoolkit.js startup time = " +
    (new Date() - salestoolkitStartTime) +
    "ms"
);
console.log("salestoolkit.js - loaded");

initializeAttractorBuffers();

function setupContactInfoButton() {
  const shouldShowButton =
    SalesToolkit.Theme.getBooleanProperty(
      "showContactSessionInfoButton",
      false
    ) && window.location.href.indexOf("login") < 0;

  const existingIcon = document.getElementById("contactSessionIcon");

  if (shouldShowButton) {
    if (!existingIcon) {
      let infoIcon = htmlToElement(
        '<div id="contactSessionIcon"><img class="regular" src="img/default/info_cs_icon.svg" /><img class="testMode" src="img/default/info_cs_tm_icon.svg" /></div>'
      );
      // The user clicking the icon should still toggle the popup
      infoIcon.onclick = () => {
        toggleContactSessionInfo();
      };

      document.body.appendChild(infoIcon);
      applyThemeToImage(
        "salestoolkitContactSessionInfoIcon",
        "#contactSessionIcon img.regular",
        "img/default/info_cs_icon.svg"
      );
      applyThemeToImage(
        "salestoolkitContactSessionInfoIconTestMode",
        "#contactSessionIcon img.testMode",
        "img/default/info_cs_tm_icon.svg"
      );

      let isHome =
        window.location.href.indexOf("index.html") >= 0 ||
        window.location.pathname == "/";
      let manuallyToggledOff =
        localStorage["manuallyTurnedSessionPopupOff"] == "true";
      if (
        SalesToolkit.Theme.getBooleanProperty(
          "openContactSessionInfoOnHomeIgnoreUserToggledOff",
          false
        )
      )
        manuallyToggledOff = false;

      // This condition automatically opens the popup on the home page
      if (
        isHome &&
        !manuallyToggledOff &&
        SalesToolkit.Theme.getBooleanProperty(
          "openContactSessionInfoOnHomeUnlessManuallyToggleOff",
          true
        )
      ) {
        // *** CHANGE IS HERE: Call 'open' instead of 'toggle' ***
        openContactSessionInfo();
      }
    }
  } else {
    // If the button should NOT be shown...
    if (existingIcon) {
      existingIcon.remove();
    }

    const popup = document.querySelector("#contactSessionStatus");
    if (popup && popup.style.display !== "none") {
      popup.style.display = "none";
    }
  }
}

setupContactInfoButton();

/**
 * Ensures the contact session info popup is visible.
 */
function openContactSessionInfo() {
  updateContactSessionInfoPopup();

  const popup = document.querySelector("#contactSessionStatus");
  // Only change the display if it's not already 'block'
  if (popup && popup.style.display !== "block") {
    popup.style.display = "block";
    delete localStorage["manuallyTurnedSessionPopupOff"];
  }
}

function toggleContactSessionInfo() {
  updateContactSessionInfoPopup();

  let popup = document.querySelector("#contactSessionStatus");
  if (popup.style.display === "none") {
    popup.style.display = "block";
    delete localStorage["manuallyTurnedSessionPopupOff"];
  } else {
    popup.style.display = "none";
    localStorage["manuallyTurnedSessionPopupOff"] = "true";
  }
}

function updateContactSessionInfoPopup() {
  let popup = document.querySelector("#contactSessionStatus");
  if (!popup) {
    popup = htmlToElement('<div id="contactSessionStatus"></div>');
    popup.style.display = "none";
    document.body.appendChild(popup);
  }

  let testMode = document.querySelector("#contactSessionInfoTestMode");
  if (!testMode) {
    testMode = htmlToElement(
      '<div id="contactSessionInfoTestMode" class="contactSessionInfoGroup">' +
        SalesToolkit.Translation.get(
          "contactSessionInfoPopupTestModeText",
          "TEST MODE ACTIVE"
        ) +
        "</div>"
    );
    popup.appendChild(testMode);
  }

  let name = document.querySelector("#contactSessionInfoName");
  if (!name) {
    name = htmlToElement(
      '<div id="contactSessionInfoName" class="contactSessionInfoGroup"><label></label><span></span></div>'
    );
    popup.appendChild(name);
  }

  let email = document.querySelector("#contactSessionInfoEmail");
  if (!email) {
    email = htmlToElement(
      '<div id="contactSessionInfoEmail" class="contactSessionInfoGroup"><label></label><span></span></div>'
    );
    popup.appendChild(email);
  }

  let nextStep = document.querySelector("#contactSessionInfoNextStep");
  if (!nextStep) {
    nextStep = htmlToElement(
      '<div id="contactSessionInfoNextStep" class="contactSessionInfoGroup"><label></label><span></span></div>'
    );
    popup.appendChild(nextStep);
  }

  if (typeof SalesToolkit.Forms.userDetails === "undefined") {
    $(name).hide();
    $(email).hide();
    $(nextStep)
      .find("label")
      .html(
        SalesToolkit.Translation.get("contactSessionStepLabel", "Next Step:")
      );
    $(nextStep)
      .find("span")
      .html(
        SalesToolkit.Translation.get(
          "contactSessionNoSessionStep",
          "Start session"
        )
      );
    return;
  } else {
    $(nextStep)
      .find("label")
      .html(
        SalesToolkit.Translation.get("contactSessionStepLabel", "Next Step:")
      );
    $(nextStep)
      .find("span")
      .html(
        SalesToolkit.Translation.get(
          "contactSessionSessionStep",
          "Select documents and share!"
        )
      );
  }

  if (SalesToolkit.Forms.userDetails.hasOwnProperty("firstName")) {
    $(name)
      .find("label")
      .html(SalesToolkit.Translation.get("contactSessionNameLabel", "Name:"));
    $(name)
      .find("span")
      .html(
        SalesToolkit.Forms.userDetails.firstName +
          " " +
          SalesToolkit.Forms.userDetails.lastName
      );
      $(name).show();
  } else {
    $(name).hide();
  }

  if (SalesToolkit.Forms.userDetails.hasOwnProperty("to")) {
    $(email)
      .find("label")
      .html(SalesToolkit.Translation.get("contactSessionEmailLabel", "Email:"));
    $(email).find("span").html(SalesToolkit.Forms.userDetails.to);
    $(email).show();
  } else if (SalesToolkit.Forms.userDetails.hasOwnProperty("email")) {
    $(email)
      .find("label")
      .html(SalesToolkit.Translation.get("contactSessionEmailLabel", "Email:"));
    $(email).find("span").html(SalesToolkit.Forms.userDetails.email);
    $(email).show();
  } else {
    $(email).hide();
  }
}

if (SalesToolkit.Theme.getBooleanProperty("useDynamicProfile", false)) {
  let regCode = SalesToolkit.Theme.getStringProperty(
    "adminRegistrationCode",
    "failure"
  );
  let regForm = localStorage["registrationForm_" + regCode];
  if (typeof regForm !== "undefined" && regForm !== "undefined") {
    window.registrationForm = JSON.parse(regForm);
  }

  $.ajax({
    method: "GET",
    url: SalesToolkit.API.BASE_URL + "/forms/selfregistration/" + regCode + "/",
    success: function (result) {
      if (result.errorCode !== 0) return;

      window.registrationForm = result.form;
      localStorage["registrationForm_" + regCode] = JSON.stringify(
        window.registrationForm
      );
      if (typeof renderProfileFormIfNeeded === "function")
        renderProfileFormIfNeeded();
    },
    error: function (error) {},
  });
}

/**
 * Rewrites a URL to be SPA-compliant if necessary.
 * Converts old filenames (e.g., viewAsset.html) to index.html?startingModule=...
 * Preserves original query parameters (except 'startingModule').
 * Handles CrossPlatform wwwroot stripping.
 *
 * @param {string | null | undefined} urlString The URL string to process.
 * @returns {string} The potentially rewritten URL string, or a default (e.g., "index.html") if input is invalid.
 */
function rewriteSpaUrl(urlString) {
  let processedUrl = urlString; // Start with the input URL

  // 1. Handle invalid inputs or login URLs (default to index.html)
  if (!processedUrl || processedUrl.includes("login")) {
    return null;
  }

   if(processedUrl.startsWith("/")) {
        processedUrl = processedUrl.substring(1);
    }
    
  let originalParams = new URLSearchParams(); // Initialize

  // 2. Extract original filename and query parameters
  const urlParts = processedUrl.split("?");
  const fileName = urlParts[0];
  if (urlParts.length > 1) {
    try {
      originalParams = new URLSearchParams(urlParts[1]);
    } catch (err) {
      console.error("Error parsing original params in rewriteSpaUrl:", err);
      originalParams = new URLSearchParams(); // Reset on error
    }
  }

  // 3. Define the SPA mappings (keep this consistent)
  const spaMappings = {
    "inbox.html": "inbox",
    "viewAsset.html": "previewAsset",
    "viewForm.html": "previewForm",
    "cart.html": "cart",
    "favourites.html": "favourites",
    "faqs.html": "faqs",
    // Add any other mappings as needed
  };

  // 4. Check if the filename needs rewriting
  if (spaMappings[fileName]) {
    const startingModule = spaMappings[fileName];

    // Remove any existing startingModule from originalParams
    originalParams.delete("startingModule");

    // Construct the new base URL
    processedUrl = `index.html?startingModule=${startingModule}`;

    // Convert remaining params back to string
    const remainingParamsString = originalParams.toString();

    // Append remaining original parameters only if there are any left
    if (remainingParamsString) {
      processedUrl += `&${remainingParamsString}`;
    }
  } else if (fileName !== "index.html") {
    // Handle unmapped files (Defaulting to index.html as discussed)
    console.warn(
      `Unmapped URL in rewriteSpaUrl: ${urlString}. Defaulting to index.html.`
    );

    originalParams.delete("startingModule");
    const remainingParamsString = originalParams.toString();

    processedUrl = "index.html";
    if (remainingParamsString) {
      processedUrl += `?${remainingParamsString}`;
    }
  }
  // If fileName was index.html, processedUrl remains unchanged (originalParams are preserved)

  // 5. Handle CrossPlatform wwwroot stripping
  if (SalesToolkit.CrossPlatform.enabled && processedUrl.includes("wwwroot")) {
    processedUrl = processedUrl.substring(processedUrl.indexOf("wwwroot") + 8);
  }

  return processedUrl; // Return the final URL
}

function clearAllFilters(){
  document.dispatchEvent(
    new CustomEvent(SalesToolkitApplication.Events.CLEAR_ALL_FILTERS, {
      detail: { hideFilters: false },
    })
  );
}

function applyFilters(){
  document.dispatchEvent(new CustomEvent(SalesToolkitApplication.Events.APPLY_FILTERS));
}

document.addEventListener("DOMContentLoaded", function() {
    var ua = navigator.userAgent.toLowerCase();
    var isAndroid = ua.indexOf("android") > -1;
    
    if (isAndroid) {
        document.body.classList.add('android');
    }
});